
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("luNAU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $kSwu1 = parcelRequire("kSwu1");


var $kyKWe = parcelRequire("kyKWe");


var $9DHhW = parcelRequire("9DHhW");





var $gtMdU = parcelRequire("gtMdU");








var $5msm2 = parcelRequire("5msm2");

const $2944089282b24b5b$var$Context = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2944089282b24b5b$export$f413f968bd5eda1d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $5msm2.getBackendExperimentConfig)();
        $[0] = t1;
    } else t1 = $[0];
    const config = t1;
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2944089282b24b5b$var$Context.Provider, {
            value: config
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    const config = (0, $cozmU.useMemo)(()=>(0, $5msm2.getBackendExperimentConfig)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2944089282b24b5b$var$Context.Provider, {
        value: config
    }, children);
};
const $2944089282b24b5b$export$284401669662f77b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($2944089282b24b5b$var$Context);
} : ()=>{
    return (0, $cozmU.useContext)($2944089282b24b5b$var$Context);
};



var $lt6Lx = parcelRequire("lt6Lx");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");


var $3tUdX = parcelRequire("3tUdX");


var $dppWL = parcelRequire("dppWL");


var $bQm3c = parcelRequire("bQm3c");


var $dIdGO = parcelRequire("dIdGO");














var $9UcmI = parcelRequire("9UcmI");


var $hdBxM = parcelRequire("hdBxM");


var $bXh4X = parcelRequire("bXh4X");


var $6iWVH = parcelRequire("6iWVH");


var $amW67 = parcelRequire("amW67");








var $mfdwv = parcelRequire("mfdwv");




const $acf42091f21d5b64$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    findRelatedPagesMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.find-related-pages",
        defaultMessage: "Find pages related to {query} owned by my team"
    },
    summarizeTopResultsMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.summarize-top-results",
        defaultMessage: "Summarize top results about: {query}"
    },
    whoHasRecentlyWorkedMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.who-has-recently-worked",
        defaultMessage: "Who has recently worked on {query} across my org?"
    },
    nudgeToQueryStartersTitle: {
        id: "search-page-rovo-config-common.nudge.title.nudge-to-query-starters",
        defaultMessage: "Can I help you find something?"
    },
    truncatedFindRelatedPagesMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.truncated-find-related-pages",
        defaultMessage: "Find pages related to my search query that are owned by my team"
    },
    truncatedSummarizeTopResultsMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.truncated-summarize-top-results",
        defaultMessage: "Summarize top results about my search query"
    },
    truncatedWhoHasRecentlyWorkedMenuItemLabel: {
        id: "search-page-rovo-config-common.menu.item.label.truncated-who-has-recently-worked",
        defaultMessage: "Who has recently worked on items related to my search query across my org?"
    }
});
const $acf42091f21d5b64$export$e336dc06ffbdf437 = (query)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const formattedQuery = `'${query}'`;
    const useTruncatedLabels = formattedQuery.length > 52;
    // Find related pages action
    const findRelatedPagesAction = (0, $cozmU.useCallback)(()=>({
            id: 'find-related-pages-action',
            title: useTruncatedLabels ? formatMessage($acf42091f21d5b64$export$defe85febe8b728c.truncatedFindRelatedPagesMenuItemLabel) : formatMessage($acf42091f21d5b64$export$defe85febe8b728c.findRelatedPagesMenuItemLabel, {
                query: formattedQuery
            }),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: "",
                    testId: "find-related-pages-action.icon"
                }),
            handleType: (0, $6iWVH.HandleActionType).Chat,
            staticPrompt: formatMessage($acf42091f21d5b64$export$defe85febe8b728c.findRelatedPagesMenuItemLabel, {
                query: formattedQuery
            }),
            type: 'convo-starter-action',
            starterType: 'static'
        }), [
        formatMessage,
        formattedQuery,
        useTruncatedLabels
    ]);
    // Summarize top results action
    const summarizeTopResultsAction = (0, $cozmU.useCallback)(()=>({
            id: 'summarize-top-results-action',
            title: useTruncatedLabels ? formatMessage($acf42091f21d5b64$export$defe85febe8b728c.truncatedSummarizeTopResultsMenuItemLabel) : formatMessage($acf42091f21d5b64$export$defe85febe8b728c.summarizeTopResultsMenuItemLabel, {
                query: formattedQuery
            }),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: "",
                    testId: "summarize-top-results-action.icon"
                }),
            handleType: (0, $6iWVH.HandleActionType).Chat,
            staticPrompt: formatMessage($acf42091f21d5b64$export$defe85febe8b728c.summarizeTopResultsMenuItemLabel, {
                query: formattedQuery
            }),
            type: 'convo-starter-action',
            starterType: 'static'
        }), [
        formatMessage,
        formattedQuery,
        useTruncatedLabels
    ]);
    // Who has recently worked action
    const whoHasRecentlyWorkedAction = (0, $cozmU.useCallback)(()=>({
            id: 'who-has-recently-worked-action',
            title: useTruncatedLabels ? formatMessage($acf42091f21d5b64$export$defe85febe8b728c.truncatedWhoHasRecentlyWorkedMenuItemLabel) : formatMessage($acf42091f21d5b64$export$defe85febe8b728c.whoHasRecentlyWorkedMenuItemLabel, {
                query: formattedQuery
            }),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                    label: "",
                    testId: "who-has-recently-worked-action.icon"
                }),
            handleType: (0, $6iWVH.HandleActionType).Chat,
            staticPrompt: formatMessage($acf42091f21d5b64$export$defe85febe8b728c.whoHasRecentlyWorkedMenuItemLabel, {
                query: formattedQuery
            }),
            type: 'convo-starter-action',
            starterType: 'static'
        }), [
        formatMessage,
        formattedQuery,
        useTruncatedLabels
    ]);
    return (0, $cozmU.useCallback)(()=>{
        if (!query) return [];
        return [
            {
                id: 'find-related-pages-action',
                action: findRelatedPagesAction()
            },
            {
                id: 'summarize-top-results-action',
                action: summarizeTopResultsAction()
            },
            {
                id: 'who-has-recently-worked-action',
                action: whoHasRecentlyWorkedAction()
            }
        ];
    }, [
        findRelatedPagesAction,
        summarizeTopResultsAction,
        whoHasRecentlyWorkedAction,
        query
    ]);
};





var $0999e712b12b931e$exports = {};
$0999e712b12b931e$exports = new URL("search-icon-colorized-dark.8306f628.svg", import.meta.url).toString();


var $b6b97724fa677391$exports = {};
$b6b97724fa677391$exports = new URL("search-icon-colorized-light.d26567fa.svg", import.meta.url).toString();


const $29498a66b37ef077$var$messages = (0, $kSwu1.defineMessages)({
    searchAssistanceGreetingTitle: {
        id: "advanced-search.rovo-config-provider.search-assistance-greeting-title",
        defaultMessage: "Can I help you find something{name, select, undefined {} other {, {name}}}?"
    },
    searchAssistanceNudgeSubheaderLabel: {
        id: "advanced-search.rovo-config-provider.search-assistance-nudge-subheader",
        defaultMessage: "Search across your work to find what you need"
    }
});
const $29498a66b37ef077$var$EMPTY_ROVO_CONFIG = {
    getActions: async ()=>[]
};
const $29498a66b37ef077$export$f87ff91cbdaa6153 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { setConfiguration: setConfiguration } = t0;
    const props = (0, $amW67.useRovoConfigProviderProps)();
    const { getSearchQuery: getSearchQuery, shouldUseSearchPageRovoConfig: shouldUseSearchPageRovoConfig, shouldNudgeToQueryStarters: shouldNudgeToQueryStarters, shouldNudgeToSummarizeQuery: shouldNudgeToSummarizeQuery } = props;
    let t1;
    if ($[0] !== getSearchQuery) {
        t1 = (getSearchQuery?.() ?? "").toString();
        $[0] = getSearchQuery;
        $[1] = t1;
    } else t1 = $[1];
    const query = t1;
    const getSearchPageRovoActions = (0, $acf42091f21d5b64$export$e336dc06ffbdf437)(query);
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const publishRovo = (0, $hdBxM.usePublish)("ai-mate");
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[2] !== displayName || $[3] !== intl) {
        const firstName = displayName?.split(" ")[0];
        t2 = intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceGreetingTitle, {
            name: firstName ?? undefined
        });
        $[2] = displayName;
        $[3] = intl;
        $[4] = t2;
    } else t2 = $[4];
    const title = t2;
    const useSearchPageConfig = shouldUseSearchPageRovoConfig ?? false;
    let t3;
    if ($[5] !== getSearchPageRovoActions || $[6] !== query || $[7] !== title || $[8] !== useSearchPageConfig) {
        t3 = useSearchPageConfig && query !== "" ? {
            getActions: async ()=>{
                const actionEntries = getSearchPageRovoActions();
                const actions = actionEntries.map($29498a66b37ef077$var$_temp);
                return Promise.resolve(actions);
            },
            customGreeting: {
                title: title,
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($b6b97724fa677391$exports))),
                iconSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($0999e712b12b931e$exports))),
                truncateGreeting: false
            },
            prioritizeCustomActionResults: true,
            shouldShowGreeting: true
        } : $29498a66b37ef077$var$EMPTY_ROVO_CONFIG;
        $[5] = getSearchPageRovoActions;
        $[6] = query;
        $[7] = title;
        $[8] = useSearchPageConfig;
        $[9] = t3;
    } else t3 = $[9];
    const config = t3;
    let t4;
    let t5;
    if ($[10] !== config || $[11] !== getSearchPageRovoActions || $[12] !== intl || $[13] !== publishRovo || $[14] !== setConfiguration || $[15] !== setNudges || $[16] !== shouldNudgeToQueryStarters || $[17] !== shouldNudgeToSummarizeQuery || $[18] !== title) {
        t4 = ()=>{
            setConfiguration(config);
            if (shouldNudgeToQueryStarters) {
                const openSearchChat = ()=>{
                    publishRovo({
                        type: "chat-new",
                        source: "advanced-search-confluence",
                        openChat: true,
                        openChatMode: "mini-modal",
                        data: {
                            dialogues: []
                        }
                    });
                };
                const baseQueryStartersNudge = {
                    id: "nudge-to-query-starters-ai-action",
                    title: title,
                    secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                    icon: $29498a66b37ef077$var$_temp2,
                    handleType: (0, $6iWVH.HandleActionType).Base,
                    type: "ai-action",
                    nudgeContext: {
                        id: "nudge-to-query-starters"
                    },
                    onClick: openSearchChat
                };
                setNudges([
                    {
                        ...baseQueryStartersNudge
                    }
                ]);
            }
            if (shouldNudgeToSummarizeQuery) {
                const actionsEntries = getSearchPageRovoActions();
                const actions_0 = actionsEntries.map($29498a66b37ef077$var$_temp3);
                const summarizeTopResultsAction = actions_0.find($29498a66b37ef077$var$_temp4);
                const transformedAction = summarizeTopResultsAction ? {
                    ...summarizeTopResultsAction,
                    secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                    nudgeContext: {
                        id: "nudge-to-summarize-query"
                    }
                } : null;
                setNudges(transformedAction ? [
                    transformedAction
                ] : []);
            }
        };
        t5 = [
            config,
            setConfiguration,
            shouldNudgeToQueryStarters,
            shouldNudgeToSummarizeQuery,
            getSearchPageRovoActions,
            setNudges,
            intl,
            publishRovo,
            title
        ];
        $[10] = config;
        $[11] = getSearchPageRovoActions;
        $[12] = intl;
        $[13] = publishRovo;
        $[14] = setConfiguration;
        $[15] = setNudges;
        $[16] = shouldNudgeToQueryStarters;
        $[17] = shouldNudgeToSummarizeQuery;
        $[18] = title;
        $[19] = t4;
        $[20] = t5;
    } else {
        t4 = $[19];
        t5 = $[20];
    }
    (0, $cozmU.useEffect)(t4, t5);
    return null;
} : ({ setConfiguration: setConfiguration })=>{
    const props = (0, $amW67.useRovoConfigProviderProps)();
    const { getSearchQuery: getSearchQuery, shouldUseSearchPageRovoConfig: shouldUseSearchPageRovoConfig, shouldNudgeToQueryStarters: shouldNudgeToQueryStarters, shouldNudgeToSummarizeQuery: shouldNudgeToSummarizeQuery } = props;
    const query = (getSearchQuery?.() ?? '').toString();
    const getSearchPageRovoActions = (0, $acf42091f21d5b64$export$e336dc06ffbdf437)(query);
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const publishRovo = (0, $hdBxM.usePublish)('ai-mate');
    const intl = (0, $kSwu1.useIntl)();
    // Use first name for greeting when available; fallback for anonymous or missing displayName
    const firstName = displayName?.split(' ')[0];
    const title = intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceGreetingTitle, {
        name: firstName ?? undefined
    });
    // When undefined (e.g. prop not passed), use empty config for backward compatibility
    const useSearchPageConfig = shouldUseSearchPageRovoConfig ?? false;
    const config = (0, $cozmU.useMemo)(()=>useSearchPageConfig && query !== '' ? {
            getActions: async ()=>{
                const actionEntries = getSearchPageRovoActions();
                const actions = actionEntries.map(({ action: action })=>action);
                return Promise.resolve(actions);
            },
            customGreeting: {
                title: title,
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($b6b97724fa677391$exports))),
                iconSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($0999e712b12b931e$exports))),
                truncateGreeting: false
            },
            prioritizeCustomActionResults: true,
            shouldShowGreeting: true
        } : $29498a66b37ef077$var$EMPTY_ROVO_CONFIG, [
        useSearchPageConfig,
        getSearchPageRovoActions,
        title,
        query
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(config);
        //If user is in the nudge to query starters cohort, set the nudge to query starters action
        if (shouldNudgeToQueryStarters) {
            const openSearchChat = ()=>{
                publishRovo({
                    type: 'chat-new',
                    source: 'advanced-search-confluence',
                    openChat: true,
                    openChatMode: 'mini-modal',
                    data: {
                        dialogues: []
                    }
                });
            };
            const baseQueryStartersNudge = {
                id: 'nudge-to-query-starters-ai-action',
                title: title,
                secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9UcmI))), {
                        label: ""
                    }),
                handleType: (0, $6iWVH.HandleActionType).Base,
                type: 'ai-action',
                nudgeContext: {
                    id: 'nudge-to-query-starters'
                },
                onClick: openSearchChat
            };
            setNudges([
                {
                    ...baseQueryStartersNudge
                }
            ]);
        }
        //If user is in the nudge to summarize query cohort, set the summarize top results action
        if (shouldNudgeToSummarizeQuery) {
            const actionsEntries = getSearchPageRovoActions();
            const actions_0 = actionsEntries.map(({ action: action_0 })=>action_0);
            const summarizeTopResultsAction = actions_0.find((a)=>a.id === 'summarize-top-results-action');
            const transformedAction = summarizeTopResultsAction ? {
                ...summarizeTopResultsAction,
                secondaryTitle: intl.formatMessage($29498a66b37ef077$var$messages.searchAssistanceNudgeSubheaderLabel),
                nudgeContext: {
                    id: 'nudge-to-summarize-query'
                }
            } : null;
            setNudges(transformedAction ? [
                transformedAction
            ] : []);
        }
    }, [
        config,
        setConfiguration,
        shouldNudgeToQueryStarters,
        shouldNudgeToSummarizeQuery,
        getSearchPageRovoActions,
        setNudges,
        intl,
        publishRovo,
        title
    ]);
    return null;
};
function $29498a66b37ef077$var$_temp(t0) {
    const { action: action } = t0;
    return action;
}
function $29498a66b37ef077$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9UcmI))), {
        label: ""
    });
}
function $29498a66b37ef077$var$_temp3(t0) {
    const { action: action_0 } = t0;
    return action_0;
}
function $29498a66b37ef077$var$_temp4(a) {
    return a.id === "summarize-top-results-action";
}












var $2ot3O = parcelRequire("2ot3O");























var $ePNCU = parcelRequire("ePNCU");


var $4TB09 = parcelRequire("4TB09");

const $5d0f8354a84fe01a$export$ce35a99c900a2a66 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { searchSessionId: searchSessionId, fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    let t0;
    let t1;
    if ($[0] !== fireAnalytics || $[1] !== searchSessionId) {
        t0 = ()=>{
            if (searchSessionId) {
                const eventData = $5d0f8354a84fe01a$var$buildEventData(searchSessionId);
                (0, $ePNCU.getDwellTimeTracker)().then((tracker)=>{
                    tracker.startAny(eventData, (callbackData)=>{
                        const { dwellTime: dwellTime, finalDwellEvent: finalDwellEvent } = callbackData.attributes;
                        if (finalDwellEvent && !dwellTime) return;
                        fireAnalytics({
                            type: "sendTrackEvent",
                            action: "dwelled",
                            actionSubject: callbackData.actionSubject,
                            additionalAttributes: callbackData.attributes
                        });
                    });
                });
            }
            return $5d0f8354a84fe01a$var$_temp2;
        };
        t1 = [
            searchSessionId,
            fireAnalytics
        ];
        $[0] = fireAnalytics;
        $[1] = searchSessionId;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : ()=>{
    const { searchSessionId: searchSessionId, fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        if (searchSessionId) {
            const eventData = $5d0f8354a84fe01a$var$buildEventData(searchSessionId);
            (0, $ePNCU.getDwellTimeTracker)().then((tracker)=>{
                tracker.startAny(eventData, (callbackData)=>{
                    // When leaving the page and using browser-back to reenter, we get a second invalid finalDwellEvent
                    // It is unclear how this is happening, and the pattern here already matches recommended implementation in import { useDwellTime } from "@confluence/dwell"
                    // We can safely ignore this event
                    const { dwellTime: dwellTime, finalDwellEvent: finalDwellEvent } = callbackData.attributes;
                    if (finalDwellEvent && !dwellTime) return;
                    fireAnalytics({
                        type: 'sendTrackEvent',
                        action: 'dwelled',
                        actionSubject: callbackData.actionSubject,
                        additionalAttributes: callbackData.attributes
                    });
                });
            });
        }
        return ()=>{
            (0, $ePNCU.getDwellTimeTracker)().then((tracker_0)=>{
                tracker_0.stop();
            });
        };
    }, [
        searchSessionId,
        fireAnalytics
    ]);
};
const $5d0f8354a84fe01a$var$buildEventData = (searchSessionId)=>({
        source: 'advancedSearchScreen',
        actionSubject: 'searchPage',
        attributes: {
            searchSessionId: searchSessionId,
            isFullPageSearch: false
        }
    });
function $5d0f8354a84fe01a$var$_temp(tracker_0) {
    tracker_0.stop();
}
function $5d0f8354a84fe01a$var$_temp2() {
    (0, $ePNCU.getDwellTimeTracker)().then($5d0f8354a84fe01a$var$_temp);
}



var $dmHCt = parcelRequire("dmHCt");











var $hekY6 = parcelRequire("hekY6");

const $7adf2f9ada840466$export$1c7ad7ad25850bd5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "main" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2hwx1wug _18u01wug _10qf1e2i _10yz1yw0 _1wf9idpf _xy6b1oqx _79xfidpf _bcgv1oqx _s7ko1f2o _13f9idpf _1nlv68cl _1hzoidpf _1ro068cl _1nqx6fgy _d69bidpf _1m2i68cl _to10idpf _139y68cl _cb401fra _16oz1fra _1oje1e2i",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "main", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2hwx1wug _18u01wug _10qf1e2i _10yz1yw0 _1wf9idpf _xy6b1oqx _79xfidpf _bcgv1oqx _s7ko1f2o _13f9idpf _1nlv68cl _1hzoidpf _1ro068cl _1nqx6fgy _d69bidpf _1m2i68cl _to10idpf _139y68cl _cb401fra _16oz1fra _1oje1e2i",
            __cmplp.className
        ])
    });
});
const $7adf2f9ada840466$export$cb4aeb4aba07ad10 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _19pkidpf _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _19pkidpf _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7adf2f9ada840466$export$6e4640db3f243f9f = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _16jlkb7n _2lx21bp4 _1ul91vif _n3td1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _16jlkb7n _2lx21bp4 _1ul91vif _n3td1ul9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7adf2f9ada840466$export$4538ac878c0b3606 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7adf2f9ada840466$export$8a2b6afa02539da2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_kqswstnw _1ltvp3fh",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_kqswstnw _1ltvp3fh",
            __cmplp.className
        ])
    });
});






var $jmjWc = parcelRequire("jmjWc");


var $b3j2Y = parcelRequire("b3j2Y");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");














var $fGkN6 = parcelRequire("fGkN6");







/**
 * @generated SignedSource<<8bbf7c09c0a4696f1762938e4e1ab4ca>>
 * @relayHash e68741e9aa55c22f15fb45988e20f49c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e9841b592e24f4fe2f48f0cd28d8ceee782653f661bb001b3beae451fa106b
const $f8c5981925c238e7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "analytics"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLivePagesEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "analytics",
            "variableName": "analytics"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "experimentContext",
            "variableName": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "url"
    }, v13 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v16 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "webUiLink"
    }, v19 = {
        "concreteType": "SearchConfluenceResultSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "spaceId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ ,
            v11 /*: any*/ ,
            {
                "condition": "isLivePagesEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    }
                ]
            },
            {
                "concreteType": "ConfluencePage",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    v9 /*: any*/ ,
                    {
                        "concreteType": "ConfluencePageLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "webUi"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceContentTitleEmoji",
                        "kind": "LinkedField",
                        "name": "titleEmojiPublished",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ConfluencePage"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconPath"
            },
            v18 /*: any*/ 
        ],
        "type": "SearchConfluenceSpace"
    }, v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = {
        "concreteType": "SearchAbTest",
        "kind": "LinkedField",
        "name": "abTest",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "abTestId"
            },
            {
                "kind": "ScalarField",
                "name": "controlId"
            },
            {
                "kind": "ScalarField",
                "name": "experimentId"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useResultSupplierAdvancedAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useResultSupplierAdvancedAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v9 /*: any*/ 
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e68741e9aa55c22f15fb45988e20f49c",
            "id": "44e9841b592e24f4fe2f48f0cd28d8ceee782653f661bb001b3beae451fa106b",
            "metadata": {},
            "name": "useResultSupplierAdvancedAGGSearchQuery",
            "operationKind": "query",
            "text": "query useResultSupplierAdvancedAGGSearchQuery($experience:String!,$analytics:SearchAnalyticsInput,$query:String!,$first:Int,$after:String,$filters:SearchFilterInput!,$experimentContext:SearchExperimentContextInput,$isLivePagesEnabled:Boolean!){search{search(experience:$experience,analytics:$analytics,query:$query,first:$first,after:$after,filters:$filters,experimentContext:$experimentContext){edges{node{__typename,id,title,type,url,...on SearchConfluencePageBlogAttachment{entityId,excerpt,isVerified,lastModified,space{id,spaceId,name,key,webUiLink},confluenceEntity{__typename,...on ConfluencePage{id,type,subtype@include(if:$isLivePagesEnabled),ancestors{title,id,links{webUi}},metadata{titleEmojiPublished{id,key,value}}},...on Node{__isNode:__typename,id}}},...on SearchConfluenceSpace{entityId,key,iconPath,webUiLink}}},pageInfo{endCursor},abTest{abTestId,controlId,experimentId},totalCount}}}"
        }
    };
}();
$f8c5981925c238e7$var$node.hash = "fdb63333f98d16f9fffdf0161967f496";
var $f8c5981925c238e7$export$2e2bcd8739ae039 = $f8c5981925c238e7$var$node;


/**
 * @generated SignedSource<<112856930fa128017d38fefaeab720cf>>
 * @relayHash 25d0e10d688d30e93b8445b211278591
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 93cbefe71fefe31a319254ba4dbc6ddacf9e21160a8224fcef17c37ba27d7cf1
const $4ff2c0b2ff8c3a1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "alias": "webUi",
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "entityType"
                        },
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "excerpt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastModified"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "KeyValueHierarchyMap",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v8 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useResultSupplierAdvancedSearchCQLQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useResultSupplierAdvancedSearchCQLQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "25d0e10d688d30e93b8445b211278591",
            "id": "93cbefe71fefe31a319254ba4dbc6ddacf9e21160a8224fcef17c37ba27d7cf1",
            "metadata": {},
            "name": "useResultSupplierAdvancedSearchCQLQuery",
            "operationKind": "query",
            "text": "query useResultSupplierAdvancedSearchCQLQuery($cql:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,first:$first,after:$after){nodes{entityType,title,excerpt,url,lastModified,content{id,type,ancestors{id,title,links{webUi:webui}},space{id,key,name,links{webUi:webui},status},extensions{key,value}},space{id,name,type,icon{path}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$4ff2c0b2ff8c3a1f$var$node.hash = "67a35c51a1f67fc0a0672cfb84296594";
var $4ff2c0b2ff8c3a1f$export$2e2bcd8739ae039 = $4ff2c0b2ff8c3a1f$var$node;












var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9eE57 = parcelRequire("9eE57");


var $yuLaV = parcelRequire("yuLaV");


var $kDja4 = parcelRequire("kDja4");








var $1HFOS = parcelRequire("1HFOS");


var $jghB4 = parcelRequire("jghB4");


var $iD4ky = parcelRequire("iD4ky");

const $74fb5df0686fb3e5$export$5224e5b54073ec2c = (cql)=>{
    if (Array.isArray(cql)) cql = cql[0];
    return {
        variables: {
            cql: cql,
            first: (0, $jghB4.PAGE_SIZE)
        }
    };
};
const $74fb5df0686fb3e5$export$2625640bc44129f6 = ({ searchQueryText: searchQueryText, selectedFilters: selectedFilters, confluenceInstance: confluenceInstance, searchSessionId: searchSessionId, activationId: activationId, isWhiteboardsEnabled: isWhiteboardsEnabled = false, isDatabasesEnabled: isDatabasesEnabled = false, isSlidesEnabled: isSlidesEnabled = false, isLivePagesEnabled: isLivePagesEnabled = false, experimentId: experimentId, experimentLayers: experimentLayers })=>{
    return {
        variables: {
            experience: (0, $jghB4.CONFLUENCE_AS_EXPERIENCE),
            analytics: {
                searchSessionId: searchSessionId
            },
            query: searchQueryText || '',
            first: (0, $jghB4.PAGE_SIZE),
            filters: {
                entities: $74fb5df0686fb3e5$export$e2e3f9f64b249105({
                    filters: selectedFilters,
                    isDatabasesEnabled: isDatabasesEnabled,
                    isWhiteboardsEnabled: isWhiteboardsEnabled,
                    isSlidesEnabled: isSlidesEnabled
                }),
                locations: [
                    confluenceInstance
                ],
                confluenceFilters: (0, $iD4ky.createAggFilters)(selectedFilters, activationId)
            },
            experimentContext: {
                experimentId: experimentId,
                experimentLayers: experimentLayers
            },
            isLivePagesEnabled: isLivePagesEnabled
        }
    };
};
const $74fb5df0686fb3e5$export$e2e3f9f64b249105 = ({ filters: filters, isDatabasesEnabled: isDatabasesEnabled, isWhiteboardsEnabled: isWhiteboardsEnabled, isSlidesEnabled: isSlidesEnabled })=>{
    let entities = (0, $jghB4.DEFAULT_ENTITIES);
    if (isWhiteboardsEnabled) entities = entities.concat([
        (0, $jghB4.ConfluenceATIs).WHITEBOARD
    ]);
    if (isDatabasesEnabled) entities = entities.concat([
        (0, $jghB4.ConfluenceATIs).DATABASE
    ]);
    if (isSlidesEnabled) entities = entities.concat([
        (0, $jghB4.ConfluenceATIs).SLIDE
    ]);
    // https://hello.atlassian.net/wiki/spaces/~638712e7f48fbd9b62d80f9a/pages/2353884324/Confluence+Search+Filter+by+Content+Type
    // shows how entities need to be set for Confluence and special content types
    const selectedTypeFilters = filters[(0, $jghB4.FilterIds).TYPE].filter((typeOption)=>typeOption.isSelected);
    if (selectedTypeFilters.length > 0) {
        // only one type can be selected at a time
        const selectedFilter = selectedTypeFilters[0];
        switch(selectedFilter.value){
            case 'page':
                entities = [
                    (0, $jghB4.ConfluenceATIs).PAGE
                ];
                break;
            case 'blogpost':
                entities = [
                    (0, $jghB4.ConfluenceATIs).BLOG
                ];
                break;
            case 'attachment':
                entities = [
                    (0, $jghB4.ConfluenceATIs).ATTACHMENT
                ];
                break;
            case 'space':
                entities = [
                    (0, $jghB4.ConfluenceATIs).SPACE
                ];
                break;
            case 'whiteboard':
                if (isWhiteboardsEnabled) entities = [
                    (0, $jghB4.ConfluenceATIs).WHITEBOARD
                ];
                break;
            case 'database':
                if (isDatabasesEnabled) entities = [
                    (0, $jghB4.ConfluenceATIs).DATABASE
                ];
                break;
            case 'slide':
                if (isSlidesEnabled) entities = [
                    (0, $jghB4.ConfluenceATIs).SLIDE
                ];
                break;
            case 'embed':
                entities = [
                    (0, $jghB4.ConfluenceATIs).EMBED
                ];
                break;
            case 'folder':
                entities = [
                    (0, $jghB4.ConfluenceATIs).FOLDER
                ];
                break;
            case 'comment':
                entities = [
                    (0, $jghB4.ConfluenceATIs).COMMENT
                ];
                break;
            default:
                // special content types are populated dynamically in type filter drop down pane
                // by the cgraphQL ContentTypesQuery and need 'confluence.' prepended
                const specialContentType = `confluence.${selectedFilter.value}`;
                entities = [
                    specialContentType
                ];
        }
    }
    return entities;
};






var $jlIaF = parcelRequire("jlIaF");

const $52721e76b9522f41$export$71690642bed3c02b = (ancestors, baseSpace)=>{
    const transformedAncestors = ancestors.map((ancestor)=>({
            id: ancestor?.id || '',
            title: ancestor?.title || '',
            href: ancestor?.links?.webUi ? `${0, $jlIaF.CONTEXT_PATH}${ancestor.links.webUi}` : ''
        }));
    // The first breadcrumb ancestor does not contain the correct space name so need to replace by the base space the result comes from
    // Also, non-page results don't have ancestors so we need to make sure it includes the space as its only ancestor
    return baseSpace ? [
        {
            ...baseSpace,
            href: `${(0, $jlIaF.CONTEXT_PATH)}${baseSpace.href}`
        },
        ...transformedAncestors.slice(1)
    ] : transformedAncestors;
};





const $ee3cd531a9283c07$export$8671a7176e88846c = (cqlData)=>{
    const nodes = cqlData?.search?.nodes || [];
    return nodes.map((node)=>{
        const baseAncestor = node?.content?.space ? {
            id: node.content.space.id || '',
            title: node.content.space.name || '',
            href: node.content.space.links?.webUi || ''
        } : null;
        return {
            entityType: node?.entityType || '',
            title: node?.title || '',
            excerpt: node?.excerpt || '',
            url: node?.url || '',
            lastModified: node?.lastModified || '',
            content: {
                id: node?.content?.id || '',
                type: (node?.content?.type || '').toLowerCase(),
                space: {
                    id: node?.content?.space?.id || '',
                    key: node?.content?.space?.key || '',
                    name: node?.content?.space?.name || '',
                    links: {
                        webui: node?.content?.space?.links?.webUi || ''
                    }
                }
            },
            space: {
                id: node?.space?.id || '',
                icon: {
                    path: node?.space?.icon?.path || ''
                },
                webui: node?.url || ''
            },
            ancestors: (0, $52721e76b9522f41$export$71690642bed3c02b)((node?.content?.ancestors || []).map((a)=>a ?? null), baseAncestor)
        };
    });
};
const $ee3cd531a9283c07$export$d449648a99616a75 = (url)=>{
    try {
        return url.replace(`${new URL(url).origin + (0, $jghB4.CONTEXT_PATH)}`, '');
    } catch  {
        return url;
    }
};
const $ee3cd531a9283c07$export$6c388bd8b7d94f1c = (aggData)=>{
    const edges = aggData?.search?.search?.edges || [];
    return edges.map((edge)=>{
        const node = edge.node;
        const baseAncestor = node?.space ? {
            id: node.space.spaceId || '',
            title: node.space.name || '',
            href: node.space.webUiLink || ''
        } : null;
        return {
            entityType: node?.type || '',
            subtype: node?.confluenceEntity?.subtype || '',
            title: node?.title || '',
            excerpt: node?.excerpt || '',
            url: $ee3cd531a9283c07$export$d449648a99616a75(node?.url || ''),
            lastModified: node?.lastModified?.toString() || '',
            isVerified: node?.isVerified || false,
            content: {
                id: node?.entityId || '',
                type: (node?.type || '').toLowerCase(),
                space: {
                    id: node?.space?.spaceId || '',
                    key: node?.space?.key || '',
                    name: node?.space?.name || '',
                    links: {
                        webui: node?.space?.webUiLink || ''
                    }
                }
            },
            space: {
                id: node?.entityId || '',
                icon: {
                    path: node?.iconPath || ''
                },
                webui: node?.webUiLink || ''
            },
            ancestors: (0, $52721e76b9522f41$export$71690642bed3c02b)((node?.confluenceEntity?.ancestors || []).map((a)=>a ?? null), baseAncestor),
            emoji: node?.confluenceEntity?.metadata?.titleEmojiPublished?.value || ''
        };
    });
};



var $jMyy4 = parcelRequire("jMyy4");

/**
 * This error can be reproduced when a user is searching in a stale container & aren't authenticated.
 * To reproduce, open two tabs on Advanced Search. Log out of confluence from one of the tabs, and search in the other.
 * You should get a network call with a 200 status code and an error message 403 forbidden.
 * It is thrown by api_search intentionally and counted as user errors, and thus is expected and should not affect our reliability metrics.
 */ const $6e8ed5702282fcbb$var$isExpected403Error = (error)=>error.message.includes('Problem while calling endpoint api_search: HTTP 403 Forbidden');
const $6e8ed5702282fcbb$var$loadMoreData = (fetchMore, after, aggSearchQueryEnabled = false)=>{
    (0, $9eE57.perfMarkStart)({
        subject: 'advancedSearchLoadMoreResult'
    });
    fetchMore({
        variables: {
            first: (0, $jghB4.PAGE_SIZE),
            after: after
        },
        updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
            if (aggSearchQueryEnabled) {
                const prevAGGResults = prev?.search?.search?.edges || [];
                const nextAGGResults = fetchMoreResult?.search?.search?.edges || [];
                return {
                    search: {
                        __typename: prev.search.__typename,
                        search: {
                            ...fetchMoreResult.search.search,
                            edges: [
                                ...prevAGGResults,
                                ...nextAGGResults
                            ]
                        }
                    }
                };
            }
            const prevResults = prev?.search?.nodes || [];
            const nextResults = fetchMoreResult?.search?.nodes || [];
            return {
                search: {
                    ...fetchMoreResult.search,
                    nodes: [
                        ...prevResults,
                        ...nextResults
                    ]
                }
            };
        }
    });
};
const $6e8ed5702282fcbb$var$isCustomerAccountError = (error)=>error.message.includes('Service search does not support customer accounts');
const $6e8ed5702282fcbb$export$a3bd2c7cebafe892 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { queryType: queryType, searchQueryText: searchQueryText, cql: cql, searchFilters: searchFilters, searchSessionId: searchSessionId, sessionHasUserInput: sessionHasUserInput } = t0;
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled("whiteboardsEnabled");
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database");
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("slide");
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluenceInstance = (0, $jghB4.CONFLUENCE_ARI).concat(cloudId);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t1 = cql ?? "";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $74fb5df0686fb3e5$export$5224e5b54073ec2c)(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = queryType !== "CQLQuery";
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            ...t2,
            skip: t3,
            notifyOnNetworkStatusChange: true,
            errorPolicy: "all"
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: cqlData, loading: cqlLoading, error: cqlError, fetchMore: cqlFetchMore } = (0, $jMyy4.useQueryInterop)((0, $4ff2c0b2ff8c3a1f$export$2e2bcd8739ae039), {
        ...t4,
        __callerPackage__: "advanced-search"
    });
    const entities = (0, $74fb5df0686fb3e5$export$e2e3f9f64b249105)({
        filters: searchFilters,
        isWhiteboardsEnabled: isWhiteboardsEnabledAS,
        isDatabasesEnabled: isDatabasesEnabledAS,
        isSlidesEnabled: isSlidesEnabledAS
    });
    const { backendExperiment: dynamicBackendExperiment, loading: dynamicBackendExperimentLoading, productEdition: productEdition } = (0, $1HFOS.useDynamicBackendExperiment)({
        cloudId: cloudId,
        entities: entities,
        userId: userId || undefined,
        experience: "advanced-search"
    }) || {};
    const backendExperiment = dynamicBackendExperiment;
    const t5 = (0, $74fb5df0686fb3e5$export$2625640bc44129f6)({
        searchQueryText: searchQueryText,
        selectedFilters: searchFilters,
        confluenceInstance: confluenceInstance,
        searchSessionId: searchSessionId,
        activationId: activationId,
        userId: userId,
        isWhiteboardsEnabled: isWhiteboardsEnabledAS,
        isDatabasesEnabled: isDatabasesEnabledAS,
        isSlidesEnabled: isSlidesEnabledAS,
        isLivePagesEnabled: (0, $9wGTI.fg)("confluence_live_pages_open_beta_trait_opted_in"),
        experimentId: backendExperiment?.experimentId,
        experimentLayers: backendExperiment?.experimentLayers?.map($6e8ed5702282fcbb$var$_temp)
    });
    const t6 = Boolean(queryType !== "AGGQuery" || !sessionHasUserInput || dynamicBackendExperimentLoading);
    let t7;
    if ($[5] !== t5 || $[6] !== t6) {
        t7 = {
            ...t5,
            skip: t6,
            notifyOnNetworkStatusChange: true,
            errorPolicy: "all",
            interopApolloAggClient: true
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const { data: aggData, loading: aggLoading, error: aggError, fetchMore: aggFetchMore } = (0, $jMyy4.useQueryInterop)((0, $f8c5981925c238e7$export$2e2bcd8739ae039), {
        ...t7,
        __callerPackage__: "advanced-search"
    });
    if (aggError) {
        if ($6e8ed5702282fcbb$var$isCustomerAccountError(aggError) || (0, $aMcHK.isStatusCodeError)(aggError, "401") || $6e8ed5702282fcbb$var$isExpected403Error(aggError)) {
            (0, $7Sm4c.markErrorAsHandled)(aggError);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: "user not authorized"
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: aggError
        });
    }
    let t8;
    if ($[8] !== aggData || $[9] !== aggError || $[10] !== aggFetchMore || $[11] !== aggLoading || $[12] !== backendExperiment?.experimentLayers || $[13] !== cqlData || $[14] !== cqlError || $[15] !== cqlFetchMore || $[16] !== cqlLoading || $[17] !== productEdition || $[18] !== queryType) {
        t8 = queryType === "CQLQuery" ? {
            results: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData),
            loading: cqlLoading,
            error: cqlError,
            loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(cqlFetchMore, cqlData?.search?.pageInfo?.endCursor || ""),
            hasNextPage: cqlData?.search?.pageInfo?.hasNextPage || false,
            numResults: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData).length || 0,
            abTest: null
        } : {
            results: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData),
            loading: aggLoading,
            error: aggError,
            loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(aggFetchMore, aggData?.search?.search?.pageInfo?.endCursor || "", true),
            hasNextPage: !!aggData?.search?.search?.pageInfo?.endCursor,
            totalCount: aggData?.search?.search?.totalCount,
            numResults: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData).length || 0,
            abTest: null,
            experimentLayers: backendExperiment?.experimentLayers?.map($6e8ed5702282fcbb$var$_temp2),
            productEdition: productEdition
        };
        $[8] = aggData;
        $[9] = aggError;
        $[10] = aggFetchMore;
        $[11] = aggLoading;
        $[12] = backendExperiment?.experimentLayers;
        $[13] = cqlData;
        $[14] = cqlError;
        $[15] = cqlFetchMore;
        $[16] = cqlLoading;
        $[17] = productEdition;
        $[18] = queryType;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ queryType: queryType, searchQueryText: searchQueryText, cql: cql, searchFilters: searchFilters, searchSessionId: searchSessionId, sessionHasUserInput: sessionHasUserInput })=>{
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluenceInstance = (0, $jghB4.CONFLUENCE_ARI).concat(cloudId);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { data: cqlData, loading: cqlLoading, error: cqlError, fetchMore: cqlFetchMore } = (0, $jMyy4.useQueryInterop)(/** @schema cc */ (0, $4ff2c0b2ff8c3a1f$export$2e2bcd8739ae039), {
        ...(0, $74fb5df0686fb3e5$export$5224e5b54073ec2c)(cql ?? ''),
        skip: queryType !== 'CQLQuery',
        notifyOnNetworkStatusChange: true,
        errorPolicy: 'all',
        __callerPackage__: "advanced-search"
    });
    const entities = (0, $74fb5df0686fb3e5$export$e2e3f9f64b249105)({
        filters: searchFilters,
        isWhiteboardsEnabled: isWhiteboardsEnabledAS,
        isDatabasesEnabled: isDatabasesEnabledAS,
        isSlidesEnabled: isSlidesEnabledAS
    });
    const { backendExperiment: dynamicBackendExperiment, loading: dynamicBackendExperimentLoading, productEdition: productEdition } = (0, $1HFOS.useDynamicBackendExperiment)({
        cloudId: cloudId,
        entities: entities,
        userId: userId || undefined,
        experience: 'advanced-search'
    }) || {};
    const backendExperiment = dynamicBackendExperiment;
    const { data: aggData, loading: aggLoading, error: aggError, fetchMore: aggFetchMore } = (0, $jMyy4.useQueryInterop)(/** @schema agg */ (0, $f8c5981925c238e7$export$2e2bcd8739ae039), {
        ...(0, $74fb5df0686fb3e5$export$2625640bc44129f6)({
            searchQueryText: searchQueryText,
            selectedFilters: searchFilters,
            confluenceInstance: confluenceInstance,
            searchSessionId: searchSessionId,
            activationId: activationId,
            userId: userId,
            isWhiteboardsEnabled: isWhiteboardsEnabledAS,
            isDatabasesEnabled: isDatabasesEnabledAS,
            isSlidesEnabled: isSlidesEnabledAS,
            isLivePagesEnabled: (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in'),
            experimentId: backendExperiment?.experimentId,
            experimentLayers: backendExperiment?.experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                    name: name,
                    layerId: layerId,
                    shadowId: shadowId,
                    definitions: definitions
                }))
        }),
        skip: Boolean(queryType !== 'AGGQuery' || !sessionHasUserInput || dynamicBackendExperimentLoading),
        notifyOnNetworkStatusChange: true,
        errorPolicy: 'all',
        interopApolloAggClient: true,
        __callerPackage__: "advanced-search"
    });
    if (aggError) {
        if ($6e8ed5702282fcbb$var$isCustomerAccountError(aggError) || (0, $aMcHK.isStatusCodeError)(aggError, '401') || $6e8ed5702282fcbb$var$isExpected403Error(aggError)) {
            (0, $7Sm4c.markErrorAsHandled)(aggError);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: 'user not authorized'
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: aggError
        });
    }
    return queryType === 'CQLQuery' ? {
        results: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData),
        loading: cqlLoading,
        error: cqlError,
        loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(cqlFetchMore, cqlData?.search?.pageInfo?.endCursor || ''),
        hasNextPage: cqlData?.search?.pageInfo?.hasNextPage || false,
        numResults: (0, $ee3cd531a9283c07$export$8671a7176e88846c)(cqlData).length || 0,
        abTest: null
    } : {
        results: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData),
        loading: aggLoading,
        error: aggError,
        loadMore: ()=>$6e8ed5702282fcbb$var$loadMoreData(aggFetchMore, aggData?.search?.search?.pageInfo?.endCursor || '', true),
        hasNextPage: !!aggData?.search?.search?.pageInfo?.endCursor,
        totalCount: aggData?.search?.search?.totalCount,
        numResults: (0, $ee3cd531a9283c07$export$6c388bd8b7d94f1c)(aggData).length || 0,
        abTest: null,
        experimentLayers: backendExperiment?.experimentLayers?.map((layer)=>{
            const { analyticsDefinitions: analyticsDefinitions, definitions: _definitions, ...rest } = layer;
            return {
                ...rest,
                definitions: analyticsDefinitions
            };
        }),
        productEdition: productEdition
    };
};
function $6e8ed5702282fcbb$var$_temp(t0) {
    const { name: name, layerId: layerId, shadowId: shadowId, definitions: definitions } = t0;
    return {
        name: name,
        layerId: layerId,
        shadowId: shadowId,
        definitions: definitions
    };
}
function $6e8ed5702282fcbb$var$_temp2(layer) {
    const { analyticsDefinitions: analyticsDefinitions, definitions: _definitions, ...rest } = layer;
    return {
        ...rest,
        definitions: analyticsDefinitions
    };
}


const $e002af62c9e690dc$export$b798fd863f55912e = {
    en: [
        'i',
        'me',
        'my',
        'myself',
        'we',
        'our',
        'ours',
        'ourselves',
        'you',
        "you're",
        "you've",
        "you'll",
        "you'd",
        'your',
        'yours',
        'yourself',
        'yourselves',
        'he',
        'him',
        'his',
        'himself',
        'she',
        "she's",
        'her',
        'hers',
        'herself',
        'it',
        "it's",
        'its',
        'itself',
        'they',
        'them',
        'their',
        'theirs',
        'themselves',
        'what',
        'which',
        'who',
        'whom',
        'this',
        'that',
        "that'll",
        'these',
        'those',
        'am',
        'is',
        'are',
        'was',
        'were',
        'be',
        'been',
        'being',
        'have',
        'has',
        'had',
        'having',
        'do',
        'does',
        'did',
        'doing',
        'a',
        'an',
        'the',
        'and',
        'but',
        'if',
        'or',
        'because',
        'as',
        'until',
        'while',
        'of',
        'at',
        'by',
        'for',
        'with',
        'about',
        'against',
        'between',
        'into',
        'through',
        'during',
        'before',
        'after',
        'above',
        'below',
        'to',
        'from',
        'up',
        'down',
        'in',
        'out',
        'on',
        'off',
        'over',
        'under',
        'again',
        'further',
        'then',
        'once',
        'here',
        'there',
        'when',
        'where',
        'why',
        'how',
        'all',
        'any',
        'both',
        'each',
        'few',
        'more',
        'most',
        'other',
        'some',
        'such',
        'no',
        'nor',
        'not',
        'only',
        'own',
        'same',
        'so',
        'than',
        'too',
        'very',
        'can',
        'will',
        'just',
        'don',
        "don't",
        'should',
        "should've",
        'now',
        'ain',
        'aren',
        "aren't",
        'couldn',
        "couldn't",
        'didn',
        "didn't",
        'doesn',
        "doesn't",
        'hadn',
        "hadn't",
        'hasn',
        "hasn't",
        'haven',
        "haven't",
        'isn',
        "isn't",
        'ma',
        'mightn',
        "mightn't",
        'mustn',
        "mustn't",
        'needn',
        "needn't",
        'shan',
        "shan't",
        'shouldn',
        "shouldn't",
        'wasn',
        "wasn't",
        'weren',
        "weren't",
        'won',
        "won't",
        'wouldn',
        "wouldn't"
    ],
    de: [
        'de',
        'en',
        'van',
        'ik',
        'te',
        'dat',
        'die',
        'in',
        'een',
        'hij',
        'het',
        'niet',
        'zijn',
        'is',
        'was',
        'op',
        'aan',
        'met',
        'als',
        'voor',
        'had',
        'er',
        'maar',
        'om',
        'hem',
        'dan',
        'zou',
        'of',
        'wat',
        'mijn',
        'men',
        'dit',
        'zo',
        'door',
        'over',
        'ze',
        'zich',
        'bij',
        'ook',
        'tot',
        'je',
        'mij',
        'uit',
        'der',
        'daar',
        'haar',
        'naar',
        'heb',
        'hoe',
        'heeft',
        'hebben',
        'deze',
        'u',
        'want',
        'nog',
        'zal',
        'me',
        'zij',
        'nu',
        'ge',
        'geen',
        'omdat',
        'iets',
        'worden',
        'toch',
        'al',
        'waren',
        'veel',
        'meer',
        'doen',
        'toen',
        'moet',
        'ben',
        'zonder',
        'kan',
        'hun',
        'dus',
        'alles',
        'onder',
        'ja',
        'eens',
        'hier',
        'wie',
        'werd',
        'altijd',
        'doch',
        'wordt',
        'wezen',
        'kunnen',
        'ons',
        'zelf',
        'tegen',
        'na',
        'reeds',
        'wil',
        'kon',
        'niets',
        'uw',
        'iemand',
        'geweest',
        'andere'
    ],
    ru: [
        "\u0438",
        "\u0432",
        "\u0432\u043E",
        "\u043D\u0435",
        "\u0447\u0442\u043E",
        "\u043E\u043D",
        "\u043D\u0430",
        "\u044F",
        "\u0441",
        "\u0441\u043E",
        "\u043A\u0430\u043A",
        "\u0430",
        "\u0442\u043E",
        "\u0432\u0441\u0435",
        "\u043E\u043D\u0430",
        "\u0442\u0430\u043A",
        "\u0435\u0433\u043E",
        "\u043D\u043E",
        "\u0434\u0430",
        "\u0442\u044B",
        "\u043A",
        "\u0443",
        "\u0436\u0435",
        "\u0432\u044B",
        "\u0437\u0430",
        "\u0431\u044B",
        "\u043F\u043E",
        "\u0442\u043E\u043B\u044C\u043A\u043E",
        "\u0435\u0435",
        "\u043C\u043D\u0435",
        "\u0431\u044B\u043B\u043E",
        "\u0432\u043E\u0442",
        "\u043E\u0442",
        "\u043C\u0435\u043D\u044F",
        "\u0435\u0449\u0435",
        "\u043D\u0435\u0442",
        "\u043E",
        "\u0438\u0437",
        "\u0435\u043C\u0443",
        "\u0442\u0435\u043F\u0435\u0440\u044C",
        "\u043A\u043E\u0433\u0434\u0430",
        "\u0434\u0430\u0436\u0435",
        "\u043D\u0443",
        "\u0432\u0434\u0440\u0443\u0433",
        "\u043B\u0438",
        "\u0435\u0441\u043B\u0438",
        "\u0443\u0436\u0435",
        "\u0438\u043B\u0438",
        "\u043D\u0438",
        "\u0431\u044B\u0442\u044C",
        "\u0431\u044B\u043B",
        "\u043D\u0435\u0433\u043E",
        "\u0434\u043E",
        "\u0432\u0430\u0441",
        "\u043D\u0438\u0431\u0443\u0434\u044C",
        "\u043E\u043F\u044F\u0442\u044C",
        "\u0443\u0436",
        "\u0432\u0430\u043C",
        "\u0432\u0435\u0434\u044C",
        "\u0442\u0430\u043C",
        "\u043F\u043E\u0442\u043E\u043C",
        "\u0441\u0435\u0431\u044F",
        "\u043D\u0438\u0447\u0435\u0433\u043E",
        "\u0435\u0439",
        "\u043C\u043E\u0436\u0435\u0442",
        "\u043E\u043D\u0438",
        "\u0442\u0443\u0442",
        "\u0433\u0434\u0435",
        "\u0435\u0441\u0442\u044C",
        "\u043D\u0430\u0434\u043E",
        "\u043D\u0435\u0439",
        "\u0434\u043B\u044F",
        "\u043C\u044B",
        "\u0442\u0435\u0431\u044F",
        "\u0438\u0445",
        "\u0447\u0435\u043C",
        "\u0431\u044B\u043B\u0430",
        "\u0441\u0430\u043C",
        "\u0447\u0442\u043E\u0431",
        "\u0431\u0435\u0437",
        "\u0431\u0443\u0434\u0442\u043E",
        "\u0447\u0435\u0433\u043E",
        "\u0440\u0430\u0437",
        "\u0442\u043E\u0436\u0435",
        "\u0441\u0435\u0431\u0435",
        "\u043F\u043E\u0434",
        "\u0431\u0443\u0434\u0435\u0442",
        "\u0436",
        "\u0442\u043E\u0433\u0434\u0430",
        "\u043A\u0442\u043E",
        "\u044D\u0442\u043E\u0442",
        "\u0442\u043E\u0433\u043E",
        "\u043F\u043E\u0442\u043E\u043C\u0443",
        "\u044D\u0442\u043E\u0433\u043E",
        "\u043A\u0430\u043A\u043E\u0439",
        "\u0441\u043E\u0432\u0441\u0435\u043C",
        "\u043D\u0438\u043C",
        "\u0437\u0434\u0435\u0441\u044C",
        "\u044D\u0442\u043E\u043C",
        "\u043E\u0434\u0438\u043D",
        "\u043F\u043E\u0447\u0442\u0438",
        "\u043C\u043E\u0439",
        "\u0442\u0435\u043C",
        "\u0447\u0442\u043E\u0431\u044B",
        "\u043D\u0435\u0435",
        "\u0441\u0435\u0439\u0447\u0430\u0441",
        "\u0431\u044B\u043B\u0438",
        "\u043A\u0443\u0434\u0430",
        "\u0437\u0430\u0447\u0435\u043C",
        "\u0432\u0441\u0435\u0445",
        "\u043D\u0438\u043A\u043E\u0433\u0434\u0430",
        "\u043C\u043E\u0436\u043D\u043E",
        "\u043F\u0440\u0438",
        "\u043D\u0430\u043A\u043E\u043D\u0435\u0446",
        "\u0434\u0432\u0430",
        "\u043E\u0431",
        "\u0434\u0440\u0443\u0433\u043E\u0439",
        "\u0445\u043E\u0442\u044C",
        "\u043F\u043E\u0441\u043B\u0435",
        "\u043D\u0430\u0434",
        "\u0431\u043E\u043B\u044C\u0448\u0435",
        "\u0442\u043E\u0442",
        "\u0447\u0435\u0440\u0435\u0437",
        "\u044D\u0442\u0438",
        "\u043D\u0430\u0441",
        "\u043F\u0440\u043E",
        "\u0432\u0441\u0435\u0433\u043E",
        "\u043D\u0438\u0445",
        "\u043A\u0430\u043A\u0430\u044F",
        "\u043C\u043D\u043E\u0433\u043E",
        "\u0440\u0430\u0437\u0432\u0435",
        "\u0442\u0440\u0438",
        "\u044D\u0442\u0443",
        "\u043C\u043E\u044F",
        "\u0432\u043F\u0440\u043E\u0447\u0435\u043C",
        "\u0445\u043E\u0440\u043E\u0448\u043E",
        "\u0441\u0432\u043E\u044E",
        "\u044D\u0442\u043E\u0439",
        "\u043F\u0435\u0440\u0435\u0434",
        "\u0438\u043D\u043E\u0433\u0434\u0430",
        "\u043B\u0443\u0447\u0448\u0435",
        "\u0447\u0443\u0442\u044C",
        "\u0442\u043E\u043C",
        "\u043D\u0435\u043B\u044C\u0437\u044F",
        "\u0442\u0430\u043A\u043E\u0439",
        "\u0438\u043C",
        "\u0431\u043E\u043B\u0435\u0435",
        "\u0432\u0441\u0435\u0433\u0434\u0430",
        "\u043A\u043E\u043D\u0435\u0447\u043D\u043E",
        "\u0432\u0441\u044E",
        "\u043C\u0435\u0436\u0434\u0443"
    ],
    fr: [
        'au',
        'aux',
        'avec',
        'ce',
        'ces',
        'dans',
        'de',
        'des',
        'du',
        'elle',
        'en',
        'et',
        'eux',
        'il',
        'ils',
        'je',
        'la',
        'le',
        'les',
        'leur',
        'lui',
        'ma',
        'mais',
        'me',
        "m\xeame",
        'mes',
        'moi',
        'mon',
        'ne',
        'nos',
        'notre',
        'nous',
        'on',
        'ou',
        'par',
        'pas',
        'pour',
        'qu',
        'que',
        'qui',
        'sa',
        'se',
        'ses',
        'son',
        'sur',
        'ta',
        'te',
        'tes',
        'toi',
        'ton',
        'tu',
        'un',
        'une',
        'vos',
        'votre',
        'vous',
        'c',
        'd',
        'j',
        'l',
        "\xe0",
        'm',
        'n',
        's',
        't',
        'y',
        "\xe9t\xe9",
        "\xe9t\xe9e",
        "\xe9t\xe9es",
        "\xe9t\xe9s",
        "\xe9tant",
        "\xe9tante",
        "\xe9tants",
        "\xe9tantes",
        'suis',
        'es',
        'est',
        'sommes',
        "\xeates",
        'sont',
        'serai',
        'seras',
        'sera',
        'serons',
        'serez',
        'seront',
        'serais',
        'serait',
        'serions',
        'seriez',
        'seraient',
        "\xe9tais",
        "\xe9tait",
        "\xe9tions",
        "\xe9tiez",
        "\xe9taient",
        'fus',
        'fut',
        "f\xfbmes",
        "f\xfbtes",
        'furent',
        'sois',
        'soit',
        'soyons',
        'soyez',
        'soient',
        'fusse',
        'fusses',
        "f\xfbt",
        'fussions',
        'fussiez',
        'fussent',
        'ayant',
        'ayante',
        'ayantes',
        'ayants',
        'eu',
        'eue',
        'eues',
        'eus',
        'ai',
        'as',
        'avons',
        'avez',
        'ont',
        'aurai',
        'auras',
        'aura',
        'aurons',
        'aurez',
        'auront',
        'aurais',
        'aurait',
        'aurions',
        'auriez',
        'auraient',
        'avais',
        'avait',
        'avions',
        'aviez',
        'avaient',
        'eut',
        "e\xfbmes",
        "e\xfbtes",
        'eurent',
        'aie',
        'aies',
        'ait',
        'ayons',
        'ayez',
        'aient',
        'eusse',
        'eusses',
        "e\xfbt",
        'eussions',
        'eussiez',
        'eussent'
    ],
    pt: [
        'a',
        "\xe0",
        'ao',
        'aos',
        'aquela',
        'aquelas',
        'aquele',
        'aqueles',
        'aquilo',
        'as',
        "\xe0s",
        "at\xe9",
        'com',
        'como',
        'da',
        'das',
        'de',
        'dela',
        'delas',
        'dele',
        'deles',
        'depois',
        'do',
        'dos',
        'e',
        "\xe9",
        'ela',
        'elas',
        'ele',
        'eles',
        'em',
        'entre',
        'era',
        'eram',
        "\xe9ramos",
        'essa',
        'essas',
        'esse',
        'esses',
        'esta',
        "est\xe1",
        'estamos',
        "est\xe3o",
        'estar',
        'estas',
        'estava',
        'estavam',
        "est\xe1vamos",
        'este',
        'esteja',
        'estejam',
        'estejamos',
        'estes',
        'esteve',
        'estive',
        'estivemos',
        'estiver',
        'estivera',
        'estiveram',
        "estiv\xe9ramos",
        'estiverem',
        'estivermos',
        'estivesse',
        'estivessem',
        "estiv\xe9ssemos",
        'estou',
        'eu',
        'foi',
        'fomos',
        'for',
        'fora',
        'foram',
        "f\xf4ramos",
        'forem',
        'formos',
        'fosse',
        'fossem',
        "f\xf4ssemos",
        'fui',
        "h\xe1",
        'haja',
        'hajam',
        'hajamos',
        "h\xe3o",
        'havemos',
        'haver',
        'hei',
        'houve',
        'houvemos',
        'houver',
        'houvera',
        "houver\xe1",
        'houveram',
        "houv\xe9ramos",
        "houver\xe3o",
        'houverei',
        'houverem',
        'houveremos',
        'houveria',
        'houveriam',
        "houver\xedamos",
        'houvermos',
        'houvesse',
        'houvessem',
        "houv\xe9ssemos",
        'isso',
        'isto',
        "j\xe1",
        'lhe',
        'lhes',
        'mais',
        'mas',
        'me',
        'mesmo',
        'meu',
        'meus',
        'minha',
        'minhas',
        'muito',
        'na',
        "n\xe3o",
        'nas',
        'nem',
        'no',
        'nos',
        "n\xf3s",
        'nossa',
        'nossas',
        'nosso',
        'nossos',
        'num',
        'numa',
        'o',
        'os',
        'ou',
        'para',
        'pela',
        'pelas',
        'pelo',
        'pelos',
        'por',
        'qual',
        'quando',
        'que',
        'quem',
        "s\xe3o",
        'se',
        'seja',
        'sejam',
        'sejamos',
        'sem',
        'ser',
        "ser\xe1",
        "ser\xe3o",
        'serei',
        'seremos',
        'seria',
        'seriam',
        "ser\xedamos",
        'seu',
        'seus',
        "s\xf3",
        'somos',
        'sou',
        'sua',
        'suas',
        "tamb\xe9m",
        'te',
        'tem',
        "t\xe9m",
        'temos',
        'tenha',
        'tenham',
        'tenhamos',
        'tenho',
        "ter\xe1",
        "ter\xe3o",
        'terei',
        'teremos',
        'teria',
        'teriam',
        "ter\xedamos",
        'teu',
        'teus',
        'teve',
        'tinha',
        'tinham',
        "t\xednhamos",
        'tive',
        'tivemos',
        'tiver',
        'tivera',
        'tiveram',
        "tiv\xe9ramos",
        'tiverem',
        'tivermos',
        'tivesse',
        'tivessem',
        "tiv\xe9ssemos",
        'tu',
        'tua',
        'tuas',
        'um',
        'uma',
        "voc\xea",
        "voc\xeas",
        'vos'
    ],
    cs: [
        'a',
        'aby',
        'ahoj',
        'aj',
        'ale',
        'anebo',
        'ani',
        "ani\u017E",
        'ano',
        'asi',
        "aspo\u0148",
        'atd',
        'atp',
        'az',
        "a\u010Dkoli",
        "a\u017E",
        'bez',
        'beze',
        "bl\xedzko",
        "bohu\u017Eel",
        'brzo',
        'bude',
        'budem',
        'budeme',
        'budes',
        'budete',
        "bude\u0161",
        'budou',
        'budu',
        'by',
        'byl',
        'byla',
        'byli',
        'bylo',
        'byly',
        'bys',
        'byt',
        "b\xfdt",
        "b\u011Bhem",
        'chce',
        'chceme',
        'chcete',
        "chce\u0161",
        'chci',
        "cht\xedt",
        "cht\u011Bj\xed",
        "chut'",
        'chuti',
        'ci',
        'clanek',
        'clanku',
        'clanky',
        'co',
        'coz',
        "co\u017E",
        'cz',
        'daleko',
        'dalsi',
        "dal\u0161\xed",
        'den',
        'deset',
        'design',
        "devaten\xe1ct",
        "dev\u011Bt",
        'dnes',
        'do',
        "dobr\xfd",
        'docela',
        'dva',
        'dvacet',
        "dvan\xe1ct",
        "dv\u011B",
        "d\xe1l",
        "d\xe1le",
        "d\u011Bkovat",
        "d\u011Bkujeme",
        "d\u011Bkuji",
        'email',
        'ho',
        "hodn\u011B",
        'i',
        'jak',
        'jakmile',
        'jako',
        "jako\u017E",
        'jde',
        'je',
        'jeden',
        "jeden\xe1ct",
        'jedna',
        'jedno',
        'jednou',
        'jedou',
        'jeho',
        "jeho\u017E",
        'jej',
        'jeji',
        'jejich',
        "jej\xed",
        "jeliko\u017E",
        'jemu',
        'jen',
        'jenom',
        "jen\u017E",
        'jeste',
        'jestli',
        "jestli\u017Ee",
        "je\u0161t\u011B",
        "je\u017E",
        'ji',
        'jich',
        'jimi',
        'jinak',
        'jine',
        "jin\xe9",
        'jiz',
        "ji\u017E",
        'jsem',
        'jses',
        "jse\u0161",
        'jsi',
        'jsme',
        'jsou',
        'jste',
        "j\xe1",
        "j\xed",
        "j\xedm",
        "j\xed\u017E",
        "j\u0161te",
        'k',
        'kam',
        "ka\u017Ed\xfd",
        'kde',
        'kdo',
        'kdy',
        'kdyz',
        "kdy\u017E",
        'ke',
        'kolik',
        "krom\u011B",
        'ktera',
        'ktere',
        'kteri',
        'kterou',
        'ktery',
        "kter\xe1",
        "kter\xe9",
        "kter\xfd",
        "kte\u0159i",
        "kte\u0159\xed",
        'ku',
        "kv\u016Fli",
        'ma',
        "maj\xed",
        'mate',
        'me',
        'mezi',
        'mi',
        'mit',
        'mne',
        'mnou',
        "mn\u011B",
        'moc',
        'mohl',
        'mohou',
        'moje',
        'moji',
        "mo\u017En\xe1",
        'muj',
        "mus\xed",
        'muze',
        'my',
        "m\xe1",
        "m\xe1lo",
        "m\xe1m",
        "m\xe1me",
        "m\xe1te",
        "m\xe1\u0161",
        "m\xe9",
        "m\xed",
        "m\xedt",
        "m\u011B",
        "m\u016Fj",
        "m\u016F\u017Ee",
        'na',
        'nad',
        'nade',
        'nam',
        'napiste',
        "napi\u0161te",
        'naproti',
        'nas',
        'nasi',
        "na\u010De\u017E",
        "na\u0161e",
        "na\u0161i",
        'ne',
        'nebo',
        'nebyl',
        'nebyla',
        'nebyli',
        'nebyly',
        "nech\u0165",
        "ned\u011Blaj\xed",
        "ned\u011Bl\xe1",
        "ned\u011Bl\xe1m",
        "ned\u011Bl\xe1me",
        "ned\u011Bl\xe1te",
        "ned\u011Bl\xe1\u0161",
        'neg',
        'nejsi',
        'nejsou',
        "nemaj\xed",
        "nem\xe1me",
        "nem\xe1te",
        "nem\u011Bl",
        'neni',
        "nen\xed",
        "nesta\u010D\xed",
        "nevad\xed",
        'nez',
        "ne\u017E",
        'nic',
        'nich',
        'nimi',
        'nove',
        'novy',
        "nov\xe9",
        "nov\xfd",
        'nula',
        "n\xe1",
        "n\xe1m",
        "n\xe1mi",
        "n\xe1s",
        "n\xe1\u0161",
        "n\xed",
        "n\xedm",
        "n\u011B",
        "n\u011Bco",
        "n\u011Bjak",
        "n\u011Bkde",
        "n\u011Bkdo",
        "n\u011Bmu",
        "n\u011Bmu\u017E",
        'o',
        'od',
        'ode',
        'on',
        'ona',
        'oni',
        'ono',
        'ony',
        'osm',
        "osmn\xe1ct",
        'pak',
        "patn\xe1ct",
        'po',
        'pod',
        'podle',
        'pokud',
        'potom',
        'pouze',
        "pozd\u011B",
        "po\u0159\xe1d",
        'prave',
        "prav\xe9",
        'pred',
        'pres',
        'pri',
        'pro',
        'proc',
        "prost\u011B",
        "pros\xedm",
        'proti',
        'proto',
        'protoze',
        "proto\u017Ee",
        "pro\u010D",
        'prvni',
        "prvn\xed",
        "pr\xe1ve",
        'pta',
        "p\u011Bt",
        "p\u0159ed",
        "p\u0159ede",
        "p\u0159es",
        "p\u0159ese",
        "p\u0159i",
        "p\u0159i\u010Dem\u017E",
        're',
        "rovn\u011B",
        's',
        'se',
        'sedm',
        "sedmn\xe1ct",
        'si',
        'sice',
        'skoro',
        "sm\xed",
        "sm\u011Bj\xed",
        'snad',
        'spolu',
        'sta',
        'sto',
        'strana',
        "st\xe9",
        'sve',
        'svych',
        'svym',
        'svymi',
        "sv\xe9",
        "sv\xfdch",
        "sv\xfdm",
        "sv\xfdmi",
        "sv\u016Fj",
        'ta',
        'tady',
        'tak',
        'take',
        'takhle',
        'taky',
        'takze',
        "tak\xe9",
        "tak\u017Ee",
        'tam',
        'tamhle',
        'tamhleto',
        'tamto',
        'tato',
        'te',
        'tebe',
        'tebou',
        "ted'",
        'tedy',
        'tema',
        'ten',
        'tento',
        'teto',
        'ti',
        'tim',
        'timto',
        'tipy',
        "tis\xedc",
        "tis\xedce",
        'to',
        "tob\u011B",
        'tohle',
        'toho',
        'tohoto',
        'tom',
        'tomto',
        'tomu',
        'tomuto',
        'toto',
        "tro\u0161ku",
        'tu',
        'tuto',
        'tvoje',
        "tv\xe1",
        "tv\xe9",
        "tv\u016Fj",
        'ty',
        'tyto',
        "t\xe9ma",
        "t\xe9to",
        "t\xedm",
        "t\xedmto",
        "t\u011B",
        "t\u011Bm",
        "t\u011Bma",
        "t\u011Bmu",
        "t\u0159eba",
        "t\u0159i",
        "t\u0159in\xe1ct",
        'u',
        "ur\u010Dit\u011B",
        'uz',
        "u\u017E",
        'v',
        'vam',
        'vas',
        'vase',
        "va\u0161e",
        "va\u0161i",
        've',
        'vedle',
        "ve\u010Der",
        'vice',
        "vlastn\u011B",
        'vsak',
        'vy',
        "v\xe1m",
        "v\xe1mi",
        "v\xe1s",
        "v\xe1\u0161",
        "v\xedce",
        "v\u0161ak",
        "v\u0161echen",
        "v\u0161echno",
        "v\u0161ichni",
        "v\u016Fbec",
        "v\u017Edy",
        'z',
        'za',
        "zat\xedmco",
        "za\u010D",
        'zda',
        'zde',
        'ze',
        'zpet',
        'zpravy',
        "zpr\xe1vy",
        "zp\u011Bt",
        "\u010Dau",
        "\u010Di",
        "\u010Dl\xe1nek",
        "\u010Dl\xe1nku",
        "\u010Dl\xe1nky",
        "\u010Dtrn\xe1ct",
        "\u010Dty\u0159i",
        "\u0161est",
        "\u0161estn\xe1ct",
        "\u017Ee"
    ],
    el: [
        "\u03B1\u03BB\u03BB\u03B1",
        "\u03B1\u03BD",
        "\u03B1\u03BD\u03C4\u03B9",
        "\u03B1\u03C0\u03BF",
        "\u03B1\u03C5\u03C4\u03B1",
        "\u03B1\u03C5\u03C4\u03B5\u03C3",
        "\u03B1\u03C5\u03C4\u03B7",
        "\u03B1\u03C5\u03C4\u03BF",
        "\u03B1\u03C5\u03C4\u03BF\u03B9",
        "\u03B1\u03C5\u03C4\u03BF\u03C3",
        "\u03B1\u03C5\u03C4\u03BF\u03C5\u03C3",
        "\u03B1\u03C5\u03C4\u03C9\u03BD",
        "\u03B1\u1F31",
        "\u03B1\u1F33",
        "\u03B1\u1F35",
        "\u03B1\u1F50\u03C4\u03CC\u03C3",
        "\u03B1\u1F50\u03C4\u1F78\u03C2",
        "\u03B1\u1F56",
        "\u03B3\u03AC\u03C1",
        "\u03B3\u03B1",
        "\u03B3\u03B5",
        "\u03B3\u03B9\u03B1",
        "\u03B3\u03BF\u1FE6\u03BD",
        "\u03B3\u1F70\u03C1",
        "\u03B4'",
        "\u03B4\u03AD",
        "\u03B4\u03AE",
        "\u03B4\u03B1\u03AF",
        "\u03B4\u03B1\u03AF\u03C3",
        "\u03B4\u03B1\u1F76",
        "\u03B4\u03B1\u1F76\u03C2",
        "\u03B4\u03B5",
        "\u03B4\u03B5\u03BD",
        "\u03B4\u03B9'",
        "\u03B4\u03B9\u03AC",
        "\u03B4\u03B9\u1F70",
        "\u03B4\u1F72",
        "\u03B4\u1F74",
        "\u03B4\u2019",
        "\u03B5\u03B1\u03BD",
        "\u03B5\u03B9\u03BC\u03B1\u03B9",
        "\u03B5\u03B9\u03BC\u03B1\u03C3\u03C4\u03B5",
        "\u03B5\u03B9\u03BD\u03B1\u03B9",
        "\u03B5\u03B9\u03C3\u03B1\u03B9",
        "\u03B5\u03B9\u03C3\u03C4\u03B5",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03B1",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03B5\u03C3",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03B7",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF\u03B9",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF\u03C3",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03BF\u03C5\u03C3",
        "\u03B5\u03BA\u03B5\u03B9\u03BD\u03C9\u03BD",
        "\u03B5\u03BD\u03C9",
        "\u03B5\u03C0",
        "\u03B5\u03C0\u03B9",
        "\u03B5\u1F30",
        "\u03B5\u1F30\u03BC\u03AF",
        "\u03B5\u1F30\u03BC\u1F76",
        "\u03B5\u1F30\u03C2",
        "\u03B5\u1F30\u03C3",
        "\u03B5\u1F34",
        "\u03B5\u1F34\u03BC\u03B9",
        "\u03B5\u1F34\u03C4\u03B5",
        "\u03B7",
        "\u03B8\u03B1",
        "\u03B9\u03C3\u03C9\u03C3",
        "\u03BA",
        "\u03BA\u03B1\u03AF",
        "\u03BA\u03B1\u03AF\u03C4\u03BF\u03B9",
        "\u03BA\u03B1\u03B8",
        "\u03BA\u03B1\u03B9",
        "\u03BA\u03B1\u03C4",
        "\u03BA\u03B1\u03C4\u03AC",
        "\u03BA\u03B1\u03C4\u03B1",
        "\u03BA\u03B1\u03C4\u1F70",
        "\u03BA\u03B1\u1F76",
        "\u03BA\u03B9",
        "\u03BA\u1F00\u03BD",
        "\u03BA\u1F02\u03BD",
        "\u03BC\u03AD\u03BD",
        "\u03BC\u03AE",
        "\u03BC\u03AE\u03C4\u03B5",
        "\u03BC\u03B1",
        "\u03BC\u03B5",
        "\u03BC\u03B5\u03B8",
        "\u03BC\u03B5\u03C4",
        "\u03BC\u03B5\u03C4\u03AC",
        "\u03BC\u03B5\u03C4\u03B1",
        "\u03BC\u03B5\u03C4\u1F70",
        "\u03BC\u03B7",
        "\u03BC\u03B7\u03BD",
        "\u03BC\u1F10\u03BD",
        "\u03BC\u1F72\u03BD",
        "\u03BC\u1F74",
        "\u03BC\u1F74\u03BD",
        "\u03BD\u03B1",
        "\u03BF",
        "\u03BF\u03B9",
        "\u03BF\u03BC\u03C9\u03C3",
        "\u03BF\u03C0\u03C9\u03C3",
        "\u03BF\u03C3\u03BF",
        "\u03BF\u03C4\u03B9",
        "\u03BF\u1F31",
        "\u03BF\u1F33",
        "\u03BF\u1F37\u03C2",
        "\u03BF\u1F50",
        "\u03BF\u1F50\u03B4",
        "\u03BF\u1F50\u03B4\u03AD",
        "\u03BF\u1F50\u03B4\u03B5\u03AF\u03C3",
        "\u03BF\u1F50\u03B4\u03B5\u1F76\u03C2",
        "\u03BF\u1F50\u03B4\u1F72",
        "\u03BF\u1F50\u03B4\u1F72\u03BD",
        "\u03BF\u1F50\u03BA",
        "\u03BF\u1F50\u03C7",
        "\u03BF\u1F50\u03C7\u1F76",
        "\u03BF\u1F53\u03C2",
        "\u03BF\u1F54\u03C4\u03B5",
        "\u03BF\u1F55\u03C4\u03C9",
        "\u03BF\u1F55\u03C4\u03C9\u03C2",
        "\u03BF\u1F55\u03C4\u03C9\u03C3",
        "\u03BF\u1F56\u03BD",
        "\u03BF\u1F57",
        "\u03BF\u1F57\u03C4\u03BF\u03C2",
        "\u03BF\u1F57\u03C4\u03BF\u03C3",
        "\u03C0\u03B1\u03C1",
        "\u03C0\u03B1\u03C1\u03AC",
        "\u03C0\u03B1\u03C1\u03B1",
        "\u03C0\u03B1\u03C1\u1F70",
        "\u03C0\u03B5\u03C1\u03AF",
        "\u03C0\u03B5\u03C1\u1F76",
        "\u03C0\u03BF\u03B9\u03B1",
        "\u03C0\u03BF\u03B9\u03B5\u03C3",
        "\u03C0\u03BF\u03B9\u03BF",
        "\u03C0\u03BF\u03B9\u03BF\u03B9",
        "\u03C0\u03BF\u03B9\u03BF\u03C3",
        "\u03C0\u03BF\u03B9\u03BF\u03C5\u03C3",
        "\u03C0\u03BF\u03B9\u03C9\u03BD",
        "\u03C0\u03BF\u03C4\u03B5",
        "\u03C0\u03BF\u03C5",
        "\u03C0\u03BF\u1FE6",
        "\u03C0\u03C1\u03BF",
        "\u03C0\u03C1\u03BF\u03C3",
        "\u03C0\u03C1\u03CC\u03C3",
        "\u03C0\u03C1\u1F78",
        "\u03C0\u03C1\u1F78\u03C2",
        "\u03C0\u03C9\u03C2",
        "\u03C0\u03C9\u03C3",
        "\u03C3\u03B5",
        "\u03C3\u03C4\u03B7",
        "\u03C3\u03C4\u03B7\u03BD",
        "\u03C3\u03C4\u03BF",
        "\u03C3\u03C4\u03BF\u03BD",
        "\u03C3\u03CC\u03C3",
        "\u03C3\u03CD",
        "\u03C3\u03CD\u03BD",
        "\u03C3\u1F78\u03C2",
        "\u03C3\u1F7A",
        "\u03C3\u1F7A\u03BD",
        "\u03C4\u03AC",
        "\u03C4\u03AE\u03BD",
        "\u03C4\u03AF",
        "\u03C4\u03AF\u03C2",
        "\u03C4\u03AF\u03C3",
        "\u03C4\u03B1",
        "\u03C4\u03B1\u1FD6\u03C2",
        "\u03C4\u03B5",
        "\u03C4\u03B7\u03BD",
        "\u03C4\u03B7\u03C3",
        "\u03C4\u03B9",
        "\u03C4\u03B9\u03BD\u03B1",
        "\u03C4\u03B9\u03C2",
        "\u03C4\u03B9\u03C3",
        "\u03C4\u03BF",
        "\u03C4\u03BF\u03AF",
        "\u03C4\u03BF\u03B9",
        "\u03C4\u03BF\u03B9\u03BF\u1FE6\u03C4\u03BF\u03C2",
        "\u03C4\u03BF\u03B9\u03BF\u1FE6\u03C4\u03BF\u03C3",
        "\u03C4\u03BF\u03BD",
        "\u03C4\u03BF\u03C4\u03B5",
        "\u03C4\u03BF\u03C5",
        "\u03C4\u03BF\u03CD\u03C3",
        "\u03C4\u03BF\u1F7A\u03C2",
        "\u03C4\u03BF\u1FD6\u03C2",
        "\u03C4\u03BF\u1FE6",
        "\u03C4\u03C9\u03BD",
        "\u03C4\u03CC",
        "\u03C4\u03CC\u03BD",
        "\u03C4\u03CC\u03C4\u03B5",
        "\u03C4\u1F70",
        "\u03C4\u1F70\u03C2",
        "\u03C4\u1F74\u03BD",
        "\u03C4\u1F78",
        "\u03C4\u1F78\u03BD",
        "\u03C4\u1FC6\u03C2",
        "\u03C4\u1FC6\u03C3",
        "\u03C4\u1FC7",
        "\u03C4\u1FF6\u03BD",
        "\u03C4\u1FF7",
        "\u03C9\u03C3",
        "\u1F00\u03BB\u03BB'",
        "\u1F00\u03BB\u03BB\u03AC",
        "\u1F00\u03BB\u03BB\u1F70",
        "\u1F00\u03BB\u03BB\u2019",
        "\u1F00\u03C0",
        "\u1F00\u03C0\u03CC",
        "\u1F00\u03C0\u1F78",
        "\u1F00\u03C6",
        "\u1F02\u03BD",
        "\u1F03",
        "\u1F04\u03BB\u03BB\u03BF\u03C2",
        "\u1F04\u03BB\u03BB\u03BF\u03C3",
        "\u1F04\u03BD",
        "\u1F04\u03C1\u03B1",
        "\u1F05\u03BC\u03B1",
        "\u1F10\u03AC\u03BD",
        "\u1F10\u03B3\u03CE",
        "\u1F10\u03B3\u1F7C",
        "\u1F10\u03BA",
        "\u1F10\u03BC\u03CC\u03C3",
        "\u1F10\u03BC\u1F78\u03C2",
        "\u1F10\u03BD",
        "\u1F10\u03BE",
        "\u1F10\u03C0\u03AF",
        "\u1F10\u03C0\u03B5\u1F76",
        "\u1F10\u03C0\u1F76",
        "\u1F10\u03C3\u03C4\u03B9",
        "\u1F10\u03C6",
        "\u1F10\u1F70\u03BD",
        "\u1F11\u03B1\u03C5\u03C4\u03BF\u1FE6",
        "\u1F14\u03C4\u03B9",
        "\u1F21",
        "\u1F22",
        "\u1F23",
        "\u1F24",
        "\u1F25",
        "\u1F27\u03C2",
        "\u1F35\u03BD\u03B1",
        "\u1F41",
        "\u1F43",
        "\u1F43\u03BD",
        "\u1F43\u03C2",
        "\u1F45",
        "\u1F45\u03B4\u03B5",
        "\u1F45\u03B8\u03B5\u03BD",
        "\u1F45\u03C0\u03B5\u03C1",
        "\u1F45\u03C2",
        "\u1F45\u03C3",
        "\u1F45\u03C3\u03C4\u03B9\u03C2",
        "\u1F45\u03C3\u03C4\u03B9\u03C3",
        "\u1F45\u03C4\u03B5",
        "\u1F45\u03C4\u03B9",
        "\u1F51\u03BC\u03CC\u03C3",
        "\u1F51\u03C0",
        "\u1F51\u03C0\u03AD\u03C1",
        "\u1F51\u03C0\u03CC",
        "\u1F51\u03C0\u1F72\u03C1",
        "\u1F51\u03C0\u1F78",
        "\u1F61\u03C2",
        "\u1F61\u03C3",
        "\u1F65\u03C2",
        "\u1F65\u03C3\u03C4\u03B5",
        "\u1F66",
        "\u1FA7"
    ],
    ja: [
        "\u3042\u305D\u3053",
        "\u3042\u306E",
        "\u3042\u306E\u4EBA",
        "\u3042\u308A\u307E\u3059",
        "\u3042\u308B",
        "\u3042\u308C",
        "\u3044\u3046",
        "\u3044\u307E\u3059",
        "\u3044\u308B",
        "\u3044\u3064",
        "\u3046\u3061",
        "\u304A\u3088\u3073",
        "\u304A\u308A",
        "\u304A\u308A\u307E\u3059",
        "\u304B\u3064\u3066",
        "\u304B\u3089",
        "\u3053\u3053",
        "\u3053\u3061\u3089",
        "\u3053\u3068",
        "\u3053\u306E",
        "\u3053\u308C",
        "\u3053\u308C\u3089",
        "\u3055\u3089\u306B",
        "\u3057\u304B\u3057",
        "\u3059\u308B",
        "\u305B\u308B",
        "\u305D\u3053",
        "\u305D\u3057\u3066",
        "\u305D\u306E",
        "\u305D\u306E\u4ED6",
        "\u305D\u306E\u5F8C",
        "\u305D\u308C",
        "\u305D\u308C\u305E\u308C",
        "\u305D\u308C\u3067",
        "\u305F\u3060\u3057",
        "\u305F\u3061",
        "\u305F\u3081",
        "\u305F\u308A",
        "\u3060\u3063",
        "\u3060\u308C",
        "\u3067\u304D",
        "\u3067\u304D\u308B",
        "\u3067\u3059",
        "\u3067\u306F",
        "\u3067\u3082",
        "\u3068\u3044\u3046",
        "\u3068\u3044\u3063\u305F",
        "\u3068\u304D",
        "\u3068\u3053\u308D",
        "\u3068\u3057\u3066",
        "\u3068\u3068\u3082\u306B",
        "\u3068\u3082",
        "\u3068\u5171\u306B",
        "\u3069\u3053",
        "\u3069\u306E",
        "\u306A\u3044",
        "\u306A\u304A",
        "\u306A\u304B\u3063",
        "\u306A\u304C\u3089",
        "\u306A\u304F",
        "\u306A\u3063",
        "\u306A\u3069",
        "\u306A\u306B",
        "\u306A\u3089",
        "\u306A\u308A",
        "\u306A\u308B",
        "\u306A\u3093",
        "\u306B\u304A\u3044\u3066",
        "\u306B\u304A\u3051\u308B",
        "\u306B\u3064\u3044\u3066",
        "\u306B\u3066",
        "\u306B\u3088\u3063\u3066",
        "\u306B\u3088\u308A",
        "\u306B\u3088\u308B",
        "\u306B\u5BFE\u3057\u3066",
        "\u306B\u5BFE\u3059\u308B",
        "\u306B\u95A2\u3059\u308B",
        "\u306E\u3067",
        "\u306E\u307F",
        "\u307B\u304B",
        "\u307B\u3068\u3093\u3069",
        "\u307B\u3069",
        "\u307E\u3059",
        "\u307E\u305F",
        "\u307E\u305F\u306F",
        "\u307E\u3067",
        "\u3082\u306E",
        "\u3088\u3046",
        "\u3088\u308A",
        "\u3089\u308C",
        "\u3089\u308C\u308B",
        "\u308C\u308B",
        "\u4F55"
    ],
    zh: [
        "\u4E00\u4E0B",
        "\u4E00\u4E9B",
        "\u4E00\u5207",
        "\u4E00\u5219",
        "\u4E00\u5929",
        "\u4E00\u5B9A",
        "\u4E00\u65B9\u9762",
        "\u4E00\u65E6",
        "\u4E00\u65F6",
        "\u4E00\u6765",
        "\u4E00\u6837",
        "\u4E00\u6B21",
        "\u4E00\u7247",
        "\u4E00\u76F4",
        "\u4E00\u81F4",
        "\u4E00\u822C",
        "\u4E00\u8D77",
        "\u4E00\u8FB9",
        "\u4E00\u9762",
        "\u4E07\u4E00",
        "\u4E0A\u4E0B",
        "\u4E0A\u5347",
        "\u4E0A\u53BB",
        "\u4E0A\u6765",
        "\u4E0A\u8FF0",
        "\u4E0A\u9762",
        "\u4E0B\u5217",
        "\u4E0B\u53BB",
        "\u4E0B\u6765",
        "\u4E0B\u9762",
        "\u4E0D\u4E00",
        "\u4E0D\u4E45",
        "\u4E0D\u4EC5",
        "\u4E0D\u4F1A",
        "\u4E0D\u4F46",
        "\u4E0D\u5149",
        "\u4E0D\u5355",
        "\u4E0D\u53D8",
        "\u4E0D\u53EA",
        "\u4E0D\u53EF",
        "\u4E0D\u540C",
        "\u4E0D\u591F",
        "\u4E0D\u5982",
        "\u4E0D\u5F97",
        "\u4E0D\u6015",
        "\u4E0D\u60DF",
        "\u4E0D\u6210",
        "\u4E0D\u62D8",
        "\u4E0D\u6562",
        "\u4E0D\u65AD",
        "\u4E0D\u662F",
        "\u4E0D\u6BD4",
        "\u4E0D\u7136",
        "\u4E0D\u7279",
        "\u4E0D\u72EC",
        "\u4E0D\u7BA1",
        "\u4E0D\u80FD",
        "\u4E0D\u8981",
        "\u4E0D\u8BBA",
        "\u4E0D\u8DB3",
        "\u4E0D\u8FC7",
        "\u4E0D\u95EE",
        "\u4E0E\u5176",
        "\u4E0E\u5426",
        "\u4E0E\u6B64\u540C\u65F6",
        "\u4E13\u95E8",
        "\u4E24\u8005",
        "\u4E25\u683C",
        "\u4E25\u91CD",
        "\u4E2A\u4EBA",
        "\u4E2A\u522B",
        "\u4E2D\u5C0F",
        "\u4E2D\u95F4",
        "\u4E30\u5BCC",
        "\u4E3A\u4E3B",
        "\u4E3A\u4E86",
        "\u4E3A\u4EC0\u4E48",
        "\u4E3A\u4EC0\u9EBD",
        "\u4E3A\u4F55",
        "\u4E3A\u7740",
        "\u4E3B\u5F20",
        "\u4E3B\u8981",
        "\u4E3E\u884C",
        "\u4E43\u81F3",
        "\u4E4B\u4E00",
        "\u4E4B\u524D",
        "\u4E4B\u540E",
        "\u4E4B\u5F8C",
        "\u4E4B\u6240\u4EE5",
        "\u4E4B\u7C7B",
        "\u4E4C\u4E4E",
        "\u4E5F\u597D",
        "\u4E5F\u662F",
        "\u4E5F\u7F62",
        "\u4E86\u89E3",
        "\u4E89\u53D6",
        "\u4E8E\u662F",
        "\u4E8E\u662F\u4E4E",
        "\u4E91\u4E91",
        "\u4E92\u76F8",
        "\u4EA7\u751F",
        "\u4EBA\u4EEC",
        "\u4EBA\u5BB6",
        "\u4EC0\u4E48",
        "\u4EC0\u4E48\u6837",
        "\u4EC0\u9EBD",
        "\u4ECA\u540E",
        "\u4ECA\u5929",
        "\u4ECA\u5E74",
        "\u4ECA\u5F8C",
        "\u4ECD\u7136",
        "\u4ECE\u4E8B",
        "\u4ECE\u800C",
        "\u4ED6\u4EBA",
        "\u4ED6\u4EEC",
        "\u4ED6\u7684",
        "\u4EE3\u66FF",
        "\u4EE5\u4E0A",
        "\u4EE5\u4E0B",
        "\u4EE5\u4E3A",
        "\u4EE5\u4FBF",
        "\u4EE5\u514D",
        "\u4EE5\u524D",
        "\u4EE5\u53CA",
        "\u4EE5\u540E",
        "\u4EE5\u5916",
        "\u4EE5\u5F8C",
        "\u4EE5\u6765",
        "\u4EE5\u81F3",
        "\u4EE5\u81F3\u4E8E",
        "\u4EE5\u81F4",
        "\u4EFB\u4F55",
        "\u4EFB\u51ED",
        "\u4EFB\u52A1",
        "\u4F01\u56FE",
        "\u4F1F\u5927",
        "\u4F3C\u4E4E",
        "\u4F3C\u7684",
        "\u4F46\u662F",
        "\u4F55",
        "\u4F55\u51B5",
        "\u4F55\u5904",
        "\u4F55\u65F6",
        "\u4F5C\u4E3A",
        "\u4F60\u4EEC",
        "\u4F60\u7684",
        "\u4F7F\u5F97",
        "\u4F7F\u7528",
        "\u4F8B\u5982",
        "\u4F9D\u7167",
        "\u4F9D\u9760",
        "\u4FC3\u8FDB",
        "\u4FDD\u6301",
        "\u4FFA\u4EEC",
        "\u5018\u4F7F",
        "\u5018\u6216",
        "\u5018\u7136",
        "\u5018\u82E5",
        "\u5047\u4F7F",
        "\u5047\u5982",
        "\u5047\u82E5",
        "\u505A\u5230",
        "\u5141\u8BB8",
        "\u5145\u5206",
        "\u5148\u540E",
        "\u5148\u5F8C",
        "\u5148\u751F",
        "\u5168\u90E8",
        "\u5168\u9762",
        "\u5171\u540C",
        "\u5173\u4E8E",
        "\u5176\u4E00",
        "\u5176\u4E2D"
    ],
    ko: [
        "\uAC00\uAE4C\uC2A4\uB85C",
        "\uAC00\uB839",
        "\uAC01\uAC01",
        "\uAC01\uC790",
        "\uAC01\uC885",
        "\uAC16\uACE0\uB9D0\uD558\uC790\uBA74",
        "\uAC19\uB2E4",
        "\uAC19\uC774",
        "\uAC1C\uC758\uCE58\uC54A\uACE0",
        "\uAC70\uB2C8\uC640",
        "\uAC70\uBC14",
        "\uAC70\uC758",
        "\uAC83\uB4E4",
        "\uAC8C\uB2E4\uAC00",
        "\uAC8C\uC6B0\uB2E4",
        "\uACA8\uC6B0",
        "\uACAC\uC9C0\uC5D0\uC11C",
        "\uACB0\uAD6D",
        "\uACB8\uC0AC\uACB8\uC0AC",
        "\uACE0\uB824\uD558\uBA74",
        "\uACE0\uB85C",
        "\uACF5\uB3D9\uC73C\uB85C",
        "\uACFC\uC5F0",
        "\uAD00\uACC4\uC5C6\uC774",
        "\uAD00\uD558\uC5EC",
        "\uAD00\uD55C",
        "\uAD00\uD574\uC11C\uB294",
        "\uAD6C\uCCB4\uC801\uC73C\uB85C",
        "\uAD6C\uD1A0\uD558\uB2E4",
        "\uADF8\uB4E4",
        "\uADF8\uB54C",
        "\uADF8\uB798",
        "\uADF8\uB798\uB3C4",
        "\uADF8\uB798\uC11C",
        "\uADF8\uB7EC\uB098",
        "\uADF8\uB7EC\uB2C8",
        "\uADF8\uB7EC\uB2C8\uAE4C",
        "\uADF8\uB7EC\uBA74",
        "\uADF8\uB7EC\uBBC0\uB85C",
        "\uADF8\uB7EC\uD55C\uC989",
        "\uADF8\uB7F0\uB370",
        "\uADF8\uB7F0\uC989",
        "\uADF8\uB7FC",
        "\uADF8\uB807\uC9C0",
        "\uADF8\uB807\uC9C0\uB9CC",
        "\uADF8\uB807\uC9C0\uC54A\uC73C\uBA74",
        "\uADF8\uB9AC\uACE0",
        "\uADF8\uB9AC\uD558\uC5EC",
        "\uADF8\uB9CC\uC774\uB2E4",
        "\uADF8\uC704\uC5D0",
        "\uADF8\uC800",
        "\uADF8\uC911\uC5D0\uC11C",
        "\uADFC\uAC70\uB85C",
        "\uADFC\uAC70\uD558\uC5EC",
        "\uAE30\uB300\uC5EC",
        "\uAE30\uC810\uC73C\uB85C",
        "\uAE30\uC900\uC73C\uB85C",
        "\uAE30\uD0C0",
        "\uAE4C\uB2ED\uC73C\uB85C",
        "\uAE4C\uC545",
        "\uAE4C\uC9C0",
        "\uAE4C\uC9C0\uB3C4",
        "\uAF48\uB2F9"
    ]
};
const $e002af62c9e690dc$export$bd2c824c45156b2b = [
    'en',
    'de',
    'ru',
    'fr',
    'pt',
    'cs',
    'el'
];
const $e002af62c9e690dc$export$175fffd27b9ba43e = [
    'zh',
    'ja',
    'ko'
];


const $d2a34a77c4375f0a$export$6400d1662a02abfb = ({ query: query, locale: locale })=>{
    const language = locale.split('-')[0].toLowerCase();
    const stopWords = (0, $e002af62c9e690dc$export$b798fd863f55912e)[language];
    const text = query.replace(/[.,\/#!$?%\^&\*;:{}=\-_`~()]/g, '');
    if ((0, $e002af62c9e690dc$export$175fffd27b9ba43e).includes(language)) {
        const processedQuery = stopWords.reduce((result, word)=>result.replace(word, ''), text);
        return processedQuery;
    }
    if ((0, $e002af62c9e690dc$export$bd2c824c45156b2b).includes(language)) {
        const lowerText = text.toLocaleLowerCase(locale);
        const queryWords = lowerText.split(' ');
        const processedQuery = queryWords.filter((word)=>!stopWords.includes(word)).join(' ');
        return processedQuery;
    }
    return query;
};


var $ebe98f756f87ec8a$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["PREQUERY"] = "PreQuery";
    QueryState["ERROR"] = "Error";
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["LOADING"] = "Loading";
    return QueryState;
}({});
const $ebe98f756f87ec8a$export$14442ac05bc0c222 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    queryState: "PreQuery",
    results: [],
    searchSessionId: '',
    loading: false,
    hasNextPage: false,
    loadMore: ()=>{},
    error: undefined,
    numResults: 0,
    abTest: null,
    experimentLayers: undefined,
    productEdition: undefined
});
const $ebe98f756f87ec8a$export$717d616a26dcb8b9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($ebe98f756f87ec8a$export$14442ac05bc0c222);
} : ()=>(0, $cozmU.useContext)($ebe98f756f87ec8a$export$14442ac05bc0c222);
const $ebe98f756f87ec8a$export$62570eb54a58c251 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { searchSessionId: searchSessionId, children: children } = t0;
    const { cql: cql, queryType: queryType, searchQuery: searchQuery, filters: filters, sessionHasUserInput: sessionHasUserInput, showSearchAI: showSearchAI } = (0, $fGkN6.useSearchInputContext)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== locale || $[1] !== searchQuery || $[2] !== showSearchAI) {
        t1 = showSearchAI ? (0, $d2a34a77c4375f0a$export$6400d1662a02abfb)({
            query: searchQuery,
            locale: locale
        }) : searchQuery;
        $[0] = locale;
        $[1] = searchQuery;
        $[2] = showSearchAI;
        $[3] = t1;
    } else t1 = $[3];
    const processedQuery = t1;
    let t2;
    if ($[4] !== cql || $[5] !== filters || $[6] !== processedQuery || $[7] !== queryType || $[8] !== searchSessionId || $[9] !== sessionHasUserInput) {
        t2 = {
            queryType: queryType,
            searchQueryText: processedQuery,
            cql: cql,
            searchFilters: filters,
            searchSessionId: searchSessionId,
            sessionHasUserInput: sessionHasUserInput
        };
        $[4] = cql;
        $[5] = filters;
        $[6] = processedQuery;
        $[7] = queryType;
        $[8] = searchSessionId;
        $[9] = sessionHasUserInput;
        $[10] = t2;
    } else t2 = $[10];
    const resultSupplierContext = (0, $6e8ed5702282fcbb$export$a3bd2c7cebafe892)(t2);
    const queryState = (sessionHasUserInput || cql) && !resultSupplierContext.loading && !resultSupplierContext.error ? "PostQuery" : resultSupplierContext.loading ? "Loading" : resultSupplierContext.error ? "Error" : "PreQuery";
    let t3;
    if ($[11] !== queryState || $[12] !== resultSupplierContext || $[13] !== searchSessionId) {
        t3 = {
            ...resultSupplierContext,
            queryState: queryState,
            searchSessionId: searchSessionId
        };
        $[11] = queryState;
        $[12] = resultSupplierContext;
        $[13] = searchSessionId;
        $[14] = t3;
    } else t3 = $[14];
    const contextValue = t3;
    let t4;
    if ($[15] !== children || $[16] !== contextValue) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebe98f756f87ec8a$export$14442ac05bc0c222.Provider, {
            value: contextValue
        }, children);
        $[15] = children;
        $[16] = contextValue;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ searchSessionId: searchSessionId, children: children })=>{
    const { cql: cql, queryType: queryType, searchQuery: searchQuery, filters: filters, sessionHasUserInput: sessionHasUserInput, showSearchAI: showSearchAI } = (0, $fGkN6.useSearchInputContext)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const processedQuery = showSearchAI ? (0, $d2a34a77c4375f0a$export$6400d1662a02abfb)({
        query: searchQuery,
        locale: locale
    }) : searchQuery;
    const resultSupplierContext = (0, $6e8ed5702282fcbb$export$a3bd2c7cebafe892)({
        queryType: queryType,
        searchQueryText: processedQuery,
        cql: cql,
        searchFilters: filters,
        searchSessionId: searchSessionId,
        sessionHasUserInput: sessionHasUserInput
    });
    const queryState = (sessionHasUserInput || cql) && !resultSupplierContext.loading && !resultSupplierContext.error ? "PostQuery" : resultSupplierContext.loading ? "Loading" : resultSupplierContext.error ? "Error" : "PreQuery";
    const contextValue = (0, $cozmU.useMemo)(()=>({
            ...resultSupplierContext,
            queryState: queryState,
            searchSessionId: searchSessionId
        }), [
        queryState,
        resultSupplierContext,
        searchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebe98f756f87ec8a$export$14442ac05bc0c222.Provider, {
        value: contextValue
    }, children);
};






var $cacu1 = parcelRequire("cacu1");








var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $4aRua = parcelRequire("4aRua");








var $6Igo2 = parcelRequire("6Igo2");

var $91577fb8751a0193$exports = {};
$91577fb8751a0193$exports = new URL("Search.1de50555.svg", import.meta.url).toString();


var $c8e6542983fe54e2$exports = {};
$c8e6542983fe54e2$exports = new URL("SearchDark.c639e3c8.svg", import.meta.url).toString();


const $5762a0d820ceeb6a$export$192d2d3653f9ca9d = ()=>{
    const { fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics({
            type: 'sendTrackEvent',
            action: 'shown',
            actionSubject: 'advancedSearchPreQuery'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchMessagesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($91577fb8751a0193$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($c8e6542983fe54e2$exports))),
        width: "200",
        height: "200",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium",
        as: "h6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dIdGO.i18n).landingPageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dIdGO.i18n).landingPageText,
        "data-test-id": "search-result-landing-text"
    })));
};


















var $dOBRD = parcelRequire("dOBRD");


var $8Vm5v = parcelRequire("8Vm5v");



var $cb6fO = parcelRequire("cb6fO");


var $1AV5C = parcelRequire("1AV5C");




// unlike __types__/AdvancedSearchCQLQuery.ts, this file is not autogenerated
// as the AGG client in CFE isn't set up yet to autogenerate types
var $d0fd843c5e8ebef1$export$ff14a801544d24f3 = /*#__PURE__*/ function(AdvancedAGGSearchQueryFilterRangeField) {
    AdvancedAGGSearchQueryFilterRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    return AdvancedAGGSearchQueryFilterRangeField;
}({});
var $d0fd843c5e8ebef1$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $d0fd843c5e8ebef1$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["ATTACHMENT"] = "ATTACHMENT";
    ConfluenceContentType["BLOG_POST"] = "BLOG_POST";
    ConfluenceContentType["COMMENT"] = "COMMENT";
    ConfluenceContentType["PAGE"] = "PAGE";
    return ConfluenceContentType;
}({});
var $d0fd843c5e8ebef1$export$2607d60870895ed3 = /*#__PURE__*/ function(ConfluenceSpaceStatus) {
    ConfluenceSpaceStatus["ARCHIVED"] = "ARCHIVED";
    ConfluenceSpaceStatus["CURRENT"] = "CURRENT";
    return ConfluenceSpaceStatus;
}({});
var $d0fd843c5e8ebef1$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["GLOBAL"] = "GLOBAL";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    return ConfluenceSpaceType;
}({});





















var $4ez2K = parcelRequire("4ez2K");





var $d2UzA = parcelRequire("d2UzA");


var $hl1Kw = parcelRequire("hl1Kw");





var $8lYIw = parcelRequire("8lYIw");














var $33jh4 = parcelRequire("33jh4");


var $6cA3O = parcelRequire("6cA3O");










/**
 * @generated SignedSource<<e74e9b1ff9a73f7404d58b1c7febaf27>>
 * @relayHash 3f8e98ff1bfe9218f6906dc5497946e1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eaf104582cf6f0995e1967b3eeddc5229f4c0c06df1eef28c8abb2bd71edeaa7
const $24a4e733c0b1b3ac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKeys"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKeys",
                    "variableName": "spaceKeys"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "contentIds"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-title-published\")"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchBreadcrumbsProviderSearchBreadcrumbsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SearchBreadcrumbsProviderSearchBreadcrumbsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "3f8e98ff1bfe9218f6906dc5497946e1",
            "id": "eaf104582cf6f0995e1967b3eeddc5229f4c0c06df1eef28c8abb2bd71edeaa7",
            "metadata": {},
            "name": "SearchBreadcrumbsProviderSearchBreadcrumbsQuery",
            "operationKind": "query",
            "text": "query SearchBreadcrumbsProviderSearchBreadcrumbsQuery($spaceKeys:[String],$contentIds:[ID]){spaces(spaceKeys:$spaceKeys){nodes{alias,id,key,name,homepage{id}}},content(ids:$contentIds){nodes{id,status,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},ancestors{id,title,links{webui}}}}}"
        }
    };
}();
$24a4e733c0b1b3ac$var$node.hash = "e2c4f1f83bdd890f090adaf1360b5994";
var $24a4e733c0b1b3ac$export$2e2bcd8739ae039 = $24a4e733c0b1b3ac$var$node;









var $1NBp8 = parcelRequire("1NBp8");










const $df779b0c01cd26c0$export$160727d69d86321d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    getAncestors: ()=>[],
    getEmoji: ()=>'',
    loading: false,
    error: undefined
});
const $df779b0c01cd26c0$var$resultsTransformer = (results)=>{
    const contentIds = new Set();
    const spaceKeys = new Set();
    results.forEach((result)=>{
        if (result?.content?.id && result.content.type !== 'space') contentIds.add(result.content.id);
        if (result?.content?.space?.key) spaceKeys.add(result.content.space.key);
    });
    return [
        [
            ...contentIds
        ],
        [
            ...spaceKeys
        ]
    ];
};
const $df779b0c01cd26c0$var$ancestorsTransformer = (ancestors)=>{
    return Array.from(ancestors).map((ancestor)=>{
        return {
            id: ancestor?.id || '',
            title: ancestor?.title || '',
            href: ancestor?.links?.webui ? `${0, $jlIaF.CONTEXT_PATH}${ancestor.links.webui}` : ''
        };
    });
};
const $df779b0c01cd26c0$export$67718d2b33e2bf0b = (t0)=>{
    const $ = (0, $bDgLe.c)(47);
    const { results: results, searchLoading: searchLoading, children: children } = t0;
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [loading, setLoading] = (0, $cozmU.useState)(searchLoading);
    const contentCountRef = (0, $cozmU.useRef)(0);
    const spaceCountRef = (0, $cozmU.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Map();
        $[0] = t1;
    } else t1 = $[0];
    const [contentMap, setContentMap] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Map();
        $[1] = t2;
    } else t2 = $[1];
    const [spaceMap, setSpaceMap] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Map();
        $[2] = t3;
    } else t3 = $[2];
    const [emojiMap, setEmojiMap] = (0, $cozmU.useState)(t3);
    let contentIds;
    let contentIdsToFetchBreadcrumbs;
    let t4;
    if ($[3] !== contentMap || $[4] !== results || $[5] !== spaceMap) {
        const [t5, spaceKeys] = $df779b0c01cd26c0$var$resultsTransformer(results);
        contentIds = t5;
        let t6;
        if ($[9] !== contentMap) {
            t6 = (id)=>!contentMap.has(id);
            $[9] = contentMap;
            $[10] = t6;
        } else t6 = $[10];
        contentIdsToFetchBreadcrumbs = contentIds.filter(t6);
        let t7;
        if ($[11] !== spaceMap) {
            t7 = (key)=>!spaceMap.has(key);
            $[11] = spaceMap;
            $[12] = t7;
        } else t7 = $[12];
        t4 = spaceKeys.filter(t7);
        $[3] = contentMap;
        $[4] = results;
        $[5] = spaceMap;
        $[6] = contentIds;
        $[7] = contentIdsToFetchBreadcrumbs;
        $[8] = t4;
    } else {
        contentIds = $[6];
        contentIdsToFetchBreadcrumbs = $[7];
        t4 = $[8];
    }
    const spaceKeysToFetchBreadcrumbs = t4;
    const skipBreadcrumbsQuery = !results.length || !contentIds.length || !contentIdsToFetchBreadcrumbs.length || !spaceKeysToFetchBreadcrumbs.length;
    let t5;
    if ($[13] !== contentMap.size || $[14] !== spaceMap) {
        t5 = ()=>{
            if (contentMap.size !== contentCountRef.current || spaceMap.size !== spaceCountRef.current) {
                setLoading(false);
                contentCountRef.current = contentMap.size;
                spaceCountRef.current = spaceMap.size;
            }
        };
        $[13] = contentMap.size;
        $[14] = spaceMap;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== contentMap || $[17] !== spaceMap) {
        t6 = [
            contentMap,
            spaceMap,
            contentCountRef,
            spaceCountRef
        ];
        $[16] = contentMap;
        $[17] = spaceMap;
        $[18] = t6;
    } else t6 = $[18];
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== contentMap || $[20] !== emojiMap || $[21] !== spaceMap || $[22] !== toUrl) {
        t7 = (data)=>{
            const contentData = data?.content?.nodes;
            const spaceData = data?.spaces?.nodes;
            const newContentMap = new Map();
            const newEmojiMap = new Map();
            const newSpaceMap = new Map();
            contentData?.forEach((item)=>{
                if (item?.id && item.ancestors) {
                    const ancestors = $df779b0c01cd26c0$var$ancestorsTransformer(item.ancestors);
                    newContentMap.set(item.id, ancestors);
                }
                if (item?.id) {
                    const emoji = (item?.emoji?.nodes?.[0]?.value || "").replace(/['"]+/g, "").replace(/null/, "");
                    if (emoji) newEmojiMap.set(item.id, emoji);
                    if (item.ancestors) {
                        const ancestors_0 = $df779b0c01cd26c0$var$ancestorsTransformer(item.ancestors);
                        newContentMap.set(item.id, ancestors_0);
                    }
                }
            });
            setEmojiMap(new Map([
                ...emojiMap,
                ...newEmojiMap
            ]));
            setContentMap(new Map([
                ...contentMap,
                ...newContentMap
            ]));
            spaceData?.forEach((item_0)=>{
                if (item_0?.key) {
                    const spaceOverviewLink = toUrl((0, $1NBp8.SPACE_OVERVIEW).name, {
                        spaceKey: item_0.alias || item_0.key,
                        query: {
                            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: item_0?.homepage?.id || undefined
                        }
                    });
                    const spaceAncestor = {
                        id: item_0.id || item_0.key,
                        href: spaceOverviewLink,
                        title: item_0.name || item_0.key
                    };
                    newSpaceMap.set(item_0.key, spaceAncestor);
                }
            });
            setSpaceMap(new Map([
                ...spaceMap,
                ...newSpaceMap
            ]));
        };
        $[19] = contentMap;
        $[20] = emojiMap;
        $[21] = spaceMap;
        $[22] = toUrl;
        $[23] = t7;
    } else t7 = $[23];
    const onQueryComplete = t7;
    let t8;
    if ($[24] !== contentIdsToFetchBreadcrumbs || $[25] !== spaceKeysToFetchBreadcrumbs) {
        t8 = {
            contentIds: contentIdsToFetchBreadcrumbs,
            spaceKeys: spaceKeysToFetchBreadcrumbs
        };
        $[24] = contentIdsToFetchBreadcrumbs;
        $[25] = spaceKeysToFetchBreadcrumbs;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== onQueryComplete || $[28] !== skipBreadcrumbsQuery || $[29] !== t8) {
        t9 = {
            variables: t8,
            skip: skipBreadcrumbsQuery,
            errorPolicy: "all",
            onCompleted: onQueryComplete
        };
        $[27] = onQueryComplete;
        $[28] = skipBreadcrumbsQuery;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    const { error: error } = (0, $jMyy4.useQueryInterop)((0, $24a4e733c0b1b3ac$export$2e2bcd8739ae039), {
        ...t9,
        __callerPackage__: "search-breadcrumbs"
    });
    let t10;
    if ($[31] !== contentMap || $[32] !== spaceMap) {
        t10 = (id_0, key_0)=>{
            const ancestors_1 = contentMap.get(id_0);
            const spaceAncestor_0 = spaceMap.get(key_0);
            if (spaceAncestor_0) {
                if (ancestors_1) {
                    if (ancestors_1.length === 0) ancestors_1.push(spaceAncestor_0);
                    else ancestors_1[0] = spaceAncestor_0;
                    return ancestors_1;
                } else return [
                    spaceAncestor_0
                ];
            }
            return [];
        };
        $[31] = contentMap;
        $[32] = spaceMap;
        $[33] = t10;
    } else t10 = $[33];
    const getAncestors = t10;
    let t11;
    if ($[34] !== emojiMap) {
        t11 = (id_1)=>emojiMap.get(id_1) || "";
        $[34] = emojiMap;
        $[35] = t11;
    } else t11 = $[35];
    const getEmoji = t11;
    const breadcrumbsLoading = results.length > 0 && !error ? loading : false;
    let t12;
    if ($[36] !== breadcrumbsLoading || $[37] !== error || $[38] !== getAncestors || $[39] !== getEmoji) {
        t12 = {
            getAncestors: getAncestors,
            getEmoji: getEmoji,
            loading: breadcrumbsLoading,
            error: error
        };
        $[36] = breadcrumbsLoading;
        $[37] = error;
        $[38] = getAncestors;
        $[39] = getEmoji;
        $[40] = t12;
    } else t12 = $[40];
    const searchBreadcrumbContextValue = t12;
    let t13;
    if ($[41] !== error) {
        t13 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[41] = error;
        $[42] = t13;
    } else t13 = $[42];
    let t14;
    if ($[43] !== children || $[44] !== searchBreadcrumbContextValue || $[45] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df779b0c01cd26c0$export$160727d69d86321d.Provider, {
            value: searchBreadcrumbContextValue
        }, children, t13);
        $[43] = children;
        $[44] = searchBreadcrumbContextValue;
        $[45] = t13;
        $[46] = t14;
    } else t14 = $[46];
    return t14;
};
const $df779b0c01cd26c0$export$2535d2f5bb2bcb34 = ()=>{
    return (0, $cozmU.useContext)($df779b0c01cd26c0$export$160727d69d86321d);
};


const $b74d421c87f9e13e$var$SearchBreadcrumbsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_ymgvotz2 _1iev1y44 _1q1gazsu _vj2rwadc _euwiazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $b74d421c87f9e13e$export$725c9be8a2ae4e69 = (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { index: index, contentId: contentId, spaceKey: spaceKey, ancestors: ancestors } = t0;
    const [t1] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let pageAncestors;
    const { getAncestors: getAncestors } = (0, $df779b0c01cd26c0$export$2535d2f5bb2bcb34)();
    if (ancestors) pageAncestors = ancestors;
    else pageAncestors = getAncestors(contentId, spaceKey);
    pageAncestors;
    const t2 = pageAncestors.length + 1;
    let t3;
    if ($[0] !== contentId || $[1] !== index || $[2] !== searchSessionId || $[3] !== spaceKey || $[4] !== t2) {
        t3 = {
            navVersion: 3,
            origin: "advancedSearch",
            breadcrumbsTotal: t2,
            searchResultIndex: index,
            searchResultId: contentId,
            searchResultSpaceKey: spaceKey,
            searchSessionId: searchSessionId
        };
        $[0] = contentId;
        $[1] = index;
        $[2] = searchSessionId;
        $[3] = spaceKey;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const analyticsContext = t3;
    let t4;
    if ($[6] !== analyticsContext || $[7] !== createAnalyticsEvent) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "expanded",
                    actionSubject: "searchBreadcrumbs",
                    source: "containerNavigation",
                    attributes: {
                        ...analyticsContext
                    }
                }
            }).fire();
        };
        $[6] = analyticsContext;
        $[7] = createAnalyticsEvent;
        $[8] = t4;
    } else t4 = $[8];
    const onExpand = t4;
    let t5;
    if ($[9] !== analyticsContext || $[10] !== createAnalyticsEvent) {
        t5 = (itemIndex, title)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "breadcrumbsItem",
                        source: "containerNavigation",
                        attributes: {
                            ...analyticsContext,
                            ancestorIndex: itemIndex,
                            destination: itemIndex === 0 ? "SPACE" : "ANCESTOR",
                            titleLength: title.length
                        }
                    }
                }).fire();
            };
        $[9] = analyticsContext;
        $[10] = createAnalyticsEvent;
        $[11] = t5;
    } else t5 = $[11];
    const onBreadcrumbItemClick = t5;
    let t6;
    if ($[12] !== analyticsContext || $[13] !== createAnalyticsEvent) {
        t6 = (itemIndex_0, title_0)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "displayed",
                        actionSubject: "searchBreadcrumbsTooltip",
                        source: "containerNavigation",
                        attributes: {
                            ...analyticsContext,
                            ancestorIndex: itemIndex_0,
                            destination: itemIndex_0 === 0 ? "SPACE" : "ANCESTOR",
                            titleLength: title_0.length
                        }
                    }
                }).fire();
            };
        $[12] = analyticsContext;
        $[13] = createAnalyticsEvent;
        $[14] = t6;
    } else t6 = $[14];
    const onBreadcrumbItemTooltipShown = t6;
    let t7;
    if ($[15] !== searchSessionId) {
        t7 = (href)=>searchSessionId ? (0, $cb6fO.addQueryParams)(href, {
                search_id: searchSessionId
            }) : href;
        $[15] = searchSessionId;
        $[16] = t7;
    } else t7 = $[16];
    const addSearchSessionToURL = t7;
    let t8;
    if ($[17] !== addSearchSessionToURL || $[18] !== onBreadcrumbItemClick || $[19] !== onBreadcrumbItemTooltipShown || $[20] !== pageAncestors) {
        let t9;
        if ($[22] !== addSearchSessionToURL || $[23] !== onBreadcrumbItemClick || $[24] !== onBreadcrumbItemTooltipShown || $[25] !== pageAncestors.length) {
            t9 = (t10, itemIndex_1)=>{
                const { href: href_0, id: id, title: title_1 } = t10;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cA3O.default), {
                    key: id,
                    truncationWidth: itemIndex_1 === pageAncestors.length - 1 || itemIndex_1 === 0 ? 192 : 50,
                    testId: id,
                    text: title_1,
                    href: addSearchSessionToURL(href_0),
                    onClick: onBreadcrumbItemClick(itemIndex_1, title_1),
                    onTooltipShown: onBreadcrumbItemTooltipShown(itemIndex_1, title_1)
                });
            };
            $[22] = addSearchSessionToURL;
            $[23] = onBreadcrumbItemClick;
            $[24] = onBreadcrumbItemTooltipShown;
            $[25] = pageAncestors.length;
            $[26] = t9;
        } else t9 = $[26];
        t8 = pageAncestors.map(t9);
        $[17] = addSearchSessionToURL;
        $[18] = onBreadcrumbItemClick;
        $[19] = onBreadcrumbItemTooltipShown;
        $[20] = pageAncestors;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[27] !== onExpand || $[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b74d421c87f9e13e$var$SearchBreadcrumbsWrapper, {
            "data-testid": "search-breadcrumbs-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33jh4.default), {
            maxItems: 3,
            onExpand: onExpand
        }, t8));
        $[27] = onExpand;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    return t9;
};



var $1YXTQ = parcelRequire("1YXTQ");


var $6p02T = parcelRequire("6p02T");














var $bmowW = parcelRequire("bmowW");





var $5SGpQ = parcelRequire("5SGpQ");


var $3DisR = parcelRequire("3DisR");

const $9a47e03ae9a38d16$export$8bc6ebae82b71102 = ({ summarizeText: summarizeText, buttonStyles: buttonStyles = {} })=>{
    const customTheme = (currentTheme, theme)=>{
        const existingTheme = currentTheme(theme);
        const defaultStyles = {
            buttonStyles: {
                ...existingTheme.buttonStyles,
                alignItems: 'center',
                gap: "var(--ds-space-025, 2px)",
                padding: buttonStyles?.padding || `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
                border: buttonStyles?.border || existingTheme.buttonStyles.border,
                borderRadius: buttonStyles?.borderRadius || existingTheme.buttonStyles.borderRadius
            }
        };
        return {
            ...existingTheme,
            ...defaultStyles
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        theme: customTheme,
        spacing: "none",
        appearance: "subtle",
        isDisabled: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DisR.QuickSummaryIcon), {
            label: ""
        }),
        testId: "ai-summarize-button-placeholder"
    }, summarizeText);
};


const $e7c24b6f3e31fd37$export$e6971f9d0321afc9 = ({ summarizeText: summarizeText, buttonStyles: buttonStyles })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const buttonText = summarizeText ?? formatMessage((0, $bmowW.i18n).quickSummaryToolTipText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9a47e03ae9a38d16$export$8bc6ebae82b71102), {
        summarizeText: buttonText,
        buttonStyles: buttonStyles
    });
};



const $514dda4d5b510fec$export$e82b88b8e9b29fb6 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IpVSe",
    name: "QuickSummaryPopup",
    loader: async ()=>(await (parcelRequire("dqROc"))).QuickSummaryPopup,
    loading: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e7c24b6f3e31fd37$export$e6971f9d0321afc9), {
            buttonStyles: buttonStyles
        })
});



















var $di8q4 = parcelRequire("di8q4");


var $bCECL = parcelRequire("bCECL");


var $iKskQ = parcelRequire("iKskQ");


var $8WOej = parcelRequire("8WOej");





const $a5a38d4575b6a35c$export$f04a61298a47a40f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { contentType: contentType, subType: t1, resultTitle: resultTitle, emojiValue: emojiValue, iconPath: iconPath } = t0;
    const subType = t1 === undefined ? "" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment) {
        let t2;
        if ($[0] !== resultTitle) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8WOej.AttachmentIcon), {
                title: resultTitle,
                size: "medium"
            });
            $[0] = resultTitle;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space) {
        let t2;
        if ($[2] !== formatMessage || $[3] !== resultTitle) {
            t2 = formatMessage((0, $dIdGO.i18n).spaceIconLabel, {
                spaceName: resultTitle
            });
            $[2] = formatMessage;
            $[3] = resultTitle;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== iconPath || $[6] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKskQ.SpaceIcon), {
                size: "small",
                src: iconPath,
                label: t2
            });
            $[5] = iconPath;
            $[6] = t2;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (emojiValue && !subType) {
        let t2;
        if ($[8] !== emojiValue) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: emojiValue,
                context: "AdvancedSearchResultView",
                height: 24
            });
            $[8] = emojiValue;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    }
    let t2;
    if ($[10] !== contentType || $[11] !== subType) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            height: 24
        });
        $[10] = contentType;
        $[11] = subType;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ contentType: contentType, subType: subType = '', resultTitle: resultTitle, emojiValue: emojiValue, iconPath: iconPath })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Handle attachment type - AttachmentIcon is different than ContentIcon
    // in that it will render icon based on attachment extension
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment) return(// @ts-expect-error FIXME: legacy ignore after migration; don't add new ones. Error: "label" must be specified for accessibility purposes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8WOej.AttachmentIcon), {
        title: resultTitle,
        size: "medium"
    }));
    // Handle space type - SpaceIcon will render space image
    if (contentType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKskQ.SpaceIcon), {
        size: "small",
        src: iconPath,
        label: formatMessage((0, $dIdGO.i18n).spaceIconLabel, {
            spaceName: resultTitle
        })
    });
    // Handle emoji value without subType
    if (emojiValue && !subType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiValue,
        context: "AdvancedSearchResultView",
        height: 24
    });
    // Default fallback to ContentIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
        type: contentType,
        subType: subType,
        height: 24
    });
};




















const $95343f1bcab811d5$export$56e008c8bd1ccf7c = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _n3tdu2gc _2lx21bp4 _1sy5u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _n3tdu2gc _2lx21bp4 _1sy5u2gc",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$5c12c8af6ba308d8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8wadc _syazi7uo _s7n41q9y",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _syazi7uo _s7n41q9y",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$b4a9cddf74daca12 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _4cvr4jg8 _1bj31b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr4jg8 _1bj31b66",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$e0842d67f8c161b5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_p12f1tcg _yajw1ato _n7opgktf _na3lgktf _1jsj1tcg _whn51tcg _lr2ngktf _10n8gktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_p12f1tcg _yajw1ato _n7opgktf _na3lgktf _1jsj1tcg _whn51tcg _lr2ngktf _10n8gktf",
            __cmplp.className
        ])
    });
});
const $95343f1bcab811d5$export$c46635e0b5c4943 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4171m _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4171m _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$d971b98a124cabfc = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _o5721q9c _1reo15vq _1bto1l2s _n3tdv77o _1b1edv2p _1ctf1r31 _1hex8stv _xildnqa1 _irlsdv2p",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _o5721q9c _1reo15vq _1bto1l2s _n3tdv77o _1b1edv2p _1ctf1r31 _1hex8stv _xildnqa1 _irlsdv2p",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$6acd8eb1223875ed = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18s8sb0y _11c8wadc _syaz1lj7 _1e0c1txw _4cvr1q9y _1n261g80 _1msji7uo _1dtci7uo _5xy1u3tg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8sb0y _11c8wadc _syaz1lj7 _1e0c1txw _4cvr1q9y _1n261g80 _1msji7uo _1dtci7uo _5xy1u3tg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$3daa6119b619c70c = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1yt4dqld _16jlkb7n _1i4q1hna",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1yt4dqld _16jlkb7n _1i4q1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$87791440d5143001 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_otyrpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$160e94802e028924 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbmko7 _4t3i7vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbmko7 _4t3i7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$c31c29c2535484c5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbuxkd _4t3i1crf _19pk12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsbuxkd _4t3i1crf _19pk12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$68bc5b3ff8349c5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$35a9671a565aeb08 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsb1osq _4t3i7vkz _19pk12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1mok _11q7izff _1e0c1txw _1bsb1osq _4t3i7vkz _19pk12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $95343f1bcab811d5$export$5e67fe52e2a75774 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11q7izff _2rko1rr0 _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q7izff _2rko1rr0 _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});


const $4073f849b8cb22a9$export$9e118db64676565a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(66);
    const { searchResult: searchResult, searchResultIdx: searchResultIdx, onClickResult: onClickResult, onContextClickResult: onContextClickResult } = t0;
    const { entityType: entityType, title: title, subtype: subtype, excerpt: excerpt, url: url, lastModified: lastModified, content: t1, ancestors: ancestors, emoji: emoji, isVerified: isVerified } = searchResult;
    const { id: contentId, type: contentType, space: t2 } = t1;
    const { key: spaceKey } = t2;
    const [isHovered, setHovered] = (0, $cozmU.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const [t3] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId } = t3;
    const lastModifiedText = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment ? (0, $dIdGO.i18n).resultLastModifiedAttachment : (0, $dIdGO.i18n).resultLastModifiedContent;
    let t4;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== edition || $[3] !== isAdminHubAIEnabled || $[4] !== searchResultIdx || $[5] !== searchSessionId) {
        t4 = ()=>{
            setIsPopupOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "advancedSearch",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "quickSummaryAdvancedSearchButton",
                    attributes: {
                        contentId: contentId,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        rowIndex: searchResultIdx,
                        searchSessionId: searchSessionId
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = edition;
        $[3] = isAdminHubAIEnabled;
        $[4] = searchResultIdx;
        $[5] = searchSessionId;
        $[6] = t4;
    } else t4 = $[6];
    const onOpen = t4;
    const t5 = `${(0, $jghB4.CONTEXT_PATH)}${url}`;
    let t6;
    if ($[7] !== title) {
        t6 = (0, $6p02T.enrichExcerpt)(title);
        $[7] = title;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== onClickResult || $[10] !== onContextClickResult || $[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: t5,
            onClick: onClickResult,
            onContextMenu: onContextClickResult,
            className: "searchResultLink"
        }, t6));
        $[9] = onClickResult;
        $[10] = onContextClickResult;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    const ResultTitleWithLink = t7;
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, "\u30FB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            label: "verified",
            color: "var(--ds-icon-accent-blue, #357DE8)"
        }));
        $[14] = t8;
    } else t8 = $[14];
    const VerifiedBadge = t8;
    let t10;
    let t11;
    let t12;
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>setHovered(true);
        t10 = ()=>setHovered(true);
        t11 = ()=>setHovered(false);
        t12 = ()=>setHovered(false);
        $[15] = t10;
        $[16] = t11;
        $[17] = t12;
        $[18] = t9;
    } else {
        t10 = $[15];
        t11 = $[16];
        t12 = $[17];
        t9 = $[18];
    }
    let t13;
    if ($[19] !== title) {
        t13 = (0, $6p02T.cleanExcerpt)(title);
        $[19] = title;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== emoji || $[22] !== entityType || $[23] !== subtype || $[24] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
            contentType: entityType,
            subType: subtype,
            resultTitle: t13,
            emojiValue: emoji
        }));
        $[21] = emoji;
        $[22] = entityType;
        $[23] = subtype;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    const t15 = spaceKey || "";
    let t16;
    if ($[26] !== ancestors || $[27] !== contentId || $[28] !== searchResultIdx || $[29] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b74d421c87f9e13e$export$725c9be8a2ae4e69), {
            index: searchResultIdx,
            contentId: contentId,
            spaceKey: t15,
            ancestors: ancestors
        });
        $[26] = ancestors;
        $[27] = contentId;
        $[28] = searchResultIdx;
        $[29] = t15;
        $[30] = t16;
    } else t16 = $[30];
    let t17;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, "\u30FB");
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== lastModifiedText) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), lastModifiedText);
        $[32] = lastModifiedText;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== lastModified) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
            date: lastModified
        });
        $[34] = lastModified;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== t18 || $[37] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$5c12c8af6ba308d8), null, t17, t18, " ", t19);
        $[36] = t18;
        $[37] = t19;
        $[38] = t20;
    } else t20 = $[38];
    const t21 = isVerified && VerifiedBadge;
    let t22;
    if ($[39] !== t16 || $[40] !== t20 || $[41] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$6acd8eb1223875ed), null, t16, t20, t21);
        $[39] = t16;
        $[40] = t20;
        $[41] = t21;
        $[42] = t22;
    } else t22 = $[42];
    let t23;
    if ($[43] !== ResultTitleWithLink || $[44] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, ResultTitleWithLink, t22);
        $[43] = ResultTitleWithLink;
        $[44] = t22;
        $[45] = t23;
    } else t23 = $[45];
    let t24;
    if ($[46] !== contentId || $[47] !== contentType || $[48] !== isHovered || $[49] !== isPopupOpen || $[50] !== lastModified || $[51] !== onOpen || $[52] !== spaceKey || $[53] !== url) {
        t24 = (isHovered || isPopupOpen) && (0, $9wGTI.fg)("central_ai_quick_summary_in_advanced_search") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $514dda4d5b510fec$export$e82b88b8e9b29fb6), {
            source: "advancedSearch",
            contentPath: `${(0, $jghB4.CONTEXT_PATH)}${url}`,
            contentId: contentId,
            spaceKey: spaceKey || undefined,
            contentType: contentType,
            lastModifiedDate: lastModified,
            onOpen: ()=>onOpen(),
            onClose: ()=>setIsPopupOpen(false)
        });
        $[46] = contentId;
        $[47] = contentType;
        $[48] = isHovered;
        $[49] = isPopupOpen;
        $[50] = lastModified;
        $[51] = onOpen;
        $[52] = spaceKey;
        $[53] = url;
        $[54] = t24;
    } else t24 = $[54];
    let t25;
    if ($[55] !== t14 || $[56] !== t23 || $[57] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, t14, t23, t24);
        $[55] = t14;
        $[56] = t23;
        $[57] = t24;
        $[58] = t25;
    } else t25 = $[58];
    let t26;
    if ($[59] !== excerpt) {
        t26 = (0, $6p02T.processExcerpt)(excerpt);
        $[59] = excerpt;
        $[60] = t26;
    } else t26 = $[60];
    let t27;
    if ($[61] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$3daa6119b619c70c), null, t26);
        $[61] = t26;
        $[62] = t27;
    } else t27 = $[62];
    let t28;
    if ($[63] !== t25 || $[64] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), {
            onMouseOver: t9,
            onFocus: t10,
            onMouseLeave: t11,
            onBlur: t12
        }, t25, t27);
        $[63] = t25;
        $[64] = t27;
        $[65] = t28;
    } else t28 = $[65];
    return t28;
} : ({ searchResult: searchResult, searchResultIdx: searchResultIdx, onClickResult: onClickResult, onContextClickResult: onContextClickResult })=>{
    const { entityType: entityType, title: title, subtype: subtype, excerpt: excerpt, url: url, lastModified: lastModified, content: { id: contentId, type: contentType, space: { key: spaceKey } }, ancestors: ancestors, emoji: emoji, isVerified: isVerified } = searchResult;
    const [isHovered, setHovered] = (0, $cozmU.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const lastModifiedText = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).attachment ? (0, $dIdGO.i18n).resultLastModifiedAttachment : (0, $dIdGO.i18n).resultLastModifiedContent;
    const onOpen = ()=>{
        setIsPopupOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'advancedSearch',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'quickSummaryAdvancedSearchButton',
                attributes: {
                    contentId: contentId,
                    isAIOptedIn: isAdminHubAIEnabled,
                    edition: edition,
                    rowIndex: searchResultIdx,
                    searchSessionId: searchSessionId
                }
            }
        }).fire();
    };
    const ResultTitleWithLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
        href: `${(0, $jghB4.CONTEXT_PATH)}${url}`,
        onClick: onClickResult,
        onContextMenu: onContextClickResult,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "searchResultLink"
    }, (0, $6p02T.enrichExcerpt)(title)));
    const VerifiedBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, "\u30FB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        label: "verified",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), {
        onMouseOver: ()=>setHovered(true),
        onFocus: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        onBlur: ()=>setHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
        contentType: entityType,
        subType: subtype,
        resultTitle: (0, $6p02T.cleanExcerpt)(title),
        emojiValue: emoji
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, ResultTitleWithLink, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$6acd8eb1223875ed), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b74d421c87f9e13e$export$725c9be8a2ae4e69), {
        index: searchResultIdx,
        contentId: contentId,
        spaceKey: spaceKey || '',
        ancestors: ancestors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$5c12c8af6ba308d8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, "\u30FB"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), lastModifiedText), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
        date: lastModified
    })), isVerified && VerifiedBadge)), (isHovered || isPopupOpen) && (0, $9wGTI.fg)('central_ai_quick_summary_in_advanced_search') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $514dda4d5b510fec$export$e82b88b8e9b29fb6), {
        source: "advancedSearch",
        contentPath: `${(0, $jghB4.CONTEXT_PATH)}${url}`,
        contentId: contentId,
        spaceKey: spaceKey || undefined,
        contentType: contentType,
        lastModifiedDate: lastModified,
        onOpen: ()=>onOpen(),
        onClose: ()=>setIsPopupOpen(false)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$3daa6119b619c70c), null, (0, $6p02T.processExcerpt)(excerpt)));
};






















const $439e7e41942ee3ce$export$2f06d33b3afe23bc = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { searchResult: searchResult, onClickResult: onClickResult, onContextClickResult: onContextClickResult } = t0;
    const { title: spaceName, entityType: entityType, space: t1 } = searchResult;
    const { webui: spaceUrl, icon: t2 } = t1;
    const { path: iconPath } = t2;
    let t3;
    if ($[0] !== spaceName) {
        t3 = (0, $6p02T.cleanExcerpt)(spaceName);
        $[0] = spaceName;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== entityType || $[3] !== iconPath || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
            contentType: entityType,
            iconPath: iconPath,
            resultTitle: t3
        }));
        $[2] = entityType;
        $[3] = iconPath;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const t5 = `${(0, $jghB4.CONTEXT_PATH)}${spaceUrl}`;
    let t6;
    if ($[6] !== spaceName) {
        t6 = (0, $6p02T.enrichExcerpt)(spaceName);
        $[6] = spaceName;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== onClickResult || $[9] !== onContextClickResult || $[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: t5,
            onClick: onClickResult,
            onContextMenu: onContextClickResult,
            className: "searchResultLink"
        }, t6)));
        $[8] = onClickResult;
        $[9] = onContextClickResult;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t4 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, t4, t7));
        $[13] = t4;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ searchResult: searchResult, onClickResult: onClickResult, onContextClickResult: onContextClickResult })=>{
    const { title: spaceName, entityType: entityType, space: { webui: spaceUrl, icon: { path: iconPath } } } = searchResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$e0842d67f8c161b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5a38d4575b6a35c$export$f04a61298a47a40f), {
        contentType: entityType,
        iconPath: iconPath,
        resultTitle: (0, $6p02T.cleanExcerpt)(spaceName)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$d971b98a124cabfc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
        href: `${(0, $jghB4.CONTEXT_PATH)}${spaceUrl}`,
        onClick: onClickResult,
        onContextMenu: onContextClickResult,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "searchResultLink"
    }, (0, $6p02T.enrichExcerpt)(spaceName))))));
};



const $8b2f8ca9f1e3af8c$export$7311ff7a59e7e743 = (0, $dOBRD.default)((result, url)=>({
        ...result,
        url: url
    }));
const $8b2f8ca9f1e3af8c$export$44f273bad5d5a020 = ({ searchResult: searchResult, searchSessionId: searchSessionId, searchQuery: searchQuery })=>{
    let url = (0, $cb6fO.addQueryParams)(`${searchResult.url}`, {
        search_id: searchSessionId
    });
    if (searchQuery) {
        const analyticsFormattedForUrlParsing = `queryHash${(0, $8Vm5v.valueSeparator)}${(0, $1AV5C.hashData)(searchQuery)}`;
        // manually doing the query params instead of using the helper function from search common due to lack of
        // addqueryparams support/overlap
        url = (0, $cb6fO.addQueryParams)(`${searchResult.url}`, {
            search_id: searchSessionId,
            additional_analytics: analyticsFormattedForUrlParsing
        });
    }
    return url;
};
const $8b2f8ca9f1e3af8c$export$a2def421b23768aa = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { searchResult: searchResult, searchResultIdx: searchResultIdx } = t0;
    const { fireAnalytics: fireAnalytics, searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    const { entityType: entityType, content: content, space: space } = searchResult;
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    const { searchQuery: searchQuery } = searchInputs;
    const backendExperiment = (0, $2944089282b24b5b$export$284401669662f77b)();
    let t1;
    if ($[0] !== backendExperiment || $[1] !== content || $[2] !== entityType || $[3] !== fireAnalytics || $[4] !== searchResultIdx || $[5] !== space?.id) {
        t1 = ()=>{
            fireAnalytics({
                type: "sendUIEvent",
                actionSubject: "advancedSearchResultLink",
                action: "clicked",
                additionalAttributes: {
                    abTest: backendExperiment,
                    position: searchResultIdx,
                    metadata: {
                        entityType: entityType !== "space" ? "content" : "space",
                        contentType: entityType !== "space" && content.type,
                        contentId: entityType !== "space" && content.id,
                        spaceId: entityType !== "space" && content.space.id,
                        containerId: entityType !== "space" ? content.space?.id : space?.id
                    }
                }
            });
        };
        $[0] = backendExperiment;
        $[1] = content;
        $[2] = entityType;
        $[3] = fireAnalytics;
        $[4] = searchResultIdx;
        $[5] = space?.id;
        $[6] = t1;
    } else t1 = $[6];
    const fireClickEvent = t1;
    let t2;
    if ($[7] !== backendExperiment || $[8] !== content || $[9] !== entityType || $[10] !== fireAnalytics || $[11] !== searchResultIdx || $[12] !== space?.id) {
        t2 = ()=>{
            fireAnalytics({
                type: "sendUIEvent",
                actionSubject: "advancedSearchResultLink",
                action: "contextMenuClicked",
                additionalAttributes: {
                    abTest: backendExperiment,
                    position: searchResultIdx,
                    metadata: {
                        entityType: entityType !== "space" ? "content" : "space",
                        contentType: entityType !== "space" && content.type,
                        contentId: entityType !== "space" && content.id,
                        spaceId: entityType !== "space" && content.space.id,
                        containerId: entityType !== "space" ? content.space?.id : space?.id
                    }
                }
            });
        };
        $[7] = backendExperiment;
        $[8] = content;
        $[9] = entityType;
        $[10] = fireAnalytics;
        $[11] = searchResultIdx;
        $[12] = space?.id;
        $[13] = t2;
    } else t2 = $[13];
    const fireContextClickEvent = t2;
    let t3;
    if ($[14] !== searchQuery || $[15] !== searchResult || $[16] !== searchSessionId) {
        const url = $8b2f8ca9f1e3af8c$export$44f273bad5d5a020({
            searchQuery: searchQuery,
            searchSessionId: searchSessionId,
            searchResult: searchResult
        });
        t3 = $8b2f8ca9f1e3af8c$export$7311ff7a59e7e743(searchResult, url);
        $[14] = searchQuery;
        $[15] = searchResult;
        $[16] = searchSessionId;
        $[17] = t3;
    } else t3 = $[17];
    const processedSearchResult = t3;
    let t4;
    if ($[18] !== entityType || $[19] !== fireClickEvent || $[20] !== fireContextClickEvent || $[21] !== processedSearchResult || $[22] !== searchResultIdx) {
        const searchResultTypeComponent = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $439e7e41942ee3ce$export$2f06d33b3afe23bc), {
            searchResult: processedSearchResult,
            onClickResult: fireClickEvent,
            onContextClickResult: fireContextClickEvent
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4073f849b8cb22a9$export$9e118db64676565a), {
            searchResult: processedSearchResult,
            searchResultIdx: searchResultIdx,
            onClickResult: fireClickEvent,
            onContextClickResult: fireContextClickEvent
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$56e008c8bd1ccf7c), null, searchResultTypeComponent);
        $[18] = entityType;
        $[19] = fireClickEvent;
        $[20] = fireContextClickEvent;
        $[21] = processedSearchResult;
        $[22] = searchResultIdx;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ searchResult: searchResult, searchResultIdx: searchResultIdx })=>{
    const { fireAnalytics: fireAnalytics, searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    const { entityType: entityType, content: content, space: space } = searchResult;
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    const { searchQuery: searchQuery } = searchInputs;
    const backendExperiment = (0, $2944089282b24b5b$export$284401669662f77b)();
    const fireClickEvent = (0, $cozmU.useCallback)(()=>{
        fireAnalytics({
            type: 'sendUIEvent',
            actionSubject: 'advancedSearchResultLink',
            action: 'clicked',
            additionalAttributes: {
                abTest: backendExperiment,
                position: searchResultIdx,
                metadata: {
                    entityType: entityType !== 'space' ? 'content' : 'space',
                    contentType: entityType !== 'space' && content.type,
                    contentId: entityType !== 'space' && content.id,
                    spaceId: entityType !== 'space' && content.space.id,
                    containerId: entityType !== 'space' ? content.space?.id : space?.id
                }
            }
        });
    }, [
        fireAnalytics,
        entityType,
        content,
        space,
        searchResultIdx,
        backendExperiment
    ]);
    const fireContextClickEvent = (0, $cozmU.useCallback)(()=>{
        fireAnalytics({
            type: 'sendUIEvent',
            actionSubject: 'advancedSearchResultLink',
            action: 'contextMenuClicked',
            additionalAttributes: {
                abTest: backendExperiment,
                position: searchResultIdx,
                metadata: {
                    entityType: entityType !== 'space' ? 'content' : 'space',
                    contentType: entityType !== 'space' && content.type,
                    contentId: entityType !== 'space' && content.id,
                    spaceId: entityType !== 'space' && content.space.id,
                    containerId: entityType !== 'space' ? content.space?.id : space?.id
                }
            }
        });
    }, [
        fireAnalytics,
        entityType,
        content,
        space,
        searchResultIdx,
        backendExperiment
    ]);
    const url = $8b2f8ca9f1e3af8c$export$44f273bad5d5a020({
        searchQuery: searchQuery,
        searchSessionId: searchSessionId,
        searchResult: searchResult
    });
    const processedSearchResult = $8b2f8ca9f1e3af8c$export$7311ff7a59e7e743(searchResult, url);
    const searchResultTypeComponent = entityType === (0, $d0fd843c5e8ebef1$export$95cacd63dfd98bee).space ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $439e7e41942ee3ce$export$2f06d33b3afe23bc), {
        searchResult: processedSearchResult,
        onClickResult: fireClickEvent,
        onContextClickResult: fireContextClickEvent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4073f849b8cb22a9$export$9e118db64676565a), {
        searchResult: processedSearchResult,
        searchResultIdx: searchResultIdx,
        onClickResult: fireClickEvent,
        onContextClickResult: fireContextClickEvent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$56e008c8bd1ccf7c), null, searchResultTypeComponent);
};





























const $c99b6989418b2e33$export$f72733f14b99288b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8wadc _kqswh2mm _1e0c1txw _4t3igktf _ca0q1b66 _n3tdu2gc _syaz1rpy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _kqswh2mm _1e0c1txw _4t3igktf _ca0q1b66 _n3tdu2gc _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $c99b6989418b2e33$export$bfe738f2aaa065ec = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _4t3igktf _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _4t3igktf _syazazsu",
            __cmplp.className
        ])
    });
});


const $455256aee5342c37$export$1087c4e3145b9e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { numberOfResults: numberOfResults, totalCount: totalCount } = t0;
    let t1;
    if ($[0] !== numberOfResults || $[1] !== totalCount) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c99b6989418b2e33$export$f72733f14b99288b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c99b6989418b2e33$export$bfe738f2aaa065ec), {
            "data-testid": "advanced-search-result-count",
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dIdGO.i18n).numberOfResults,
            values: {
                numberOfResults: numberOfResults,
                totalCount: totalCount
            }
        })));
        $[0] = numberOfResults;
        $[1] = totalCount;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ numberOfResults: numberOfResults, totalCount: totalCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c99b6989418b2e33$export$f72733f14b99288b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c99b6989418b2e33$export$bfe738f2aaa065ec), {
        "data-testid": "advanced-search-result-count",
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dIdGO.i18n).numberOfResults,
        values: {
            numberOfResults: numberOfResults,
            totalCount: totalCount
        }
    })));
};
























var $vIR70 = parcelRequire("vIR70");







const $7aa5cf5ed4869a63$export$d60800e41134dc74 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { loading: loading, hasNextPage: hasNextPage, loadMore: loadMore } = t0;
    let t1;
    if ($[0] !== hasNextPage || $[1] !== loadMore || $[2] !== loading) {
        t1 = hasNextPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchPaginationContainer), {
            loading: loading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
            onClick: loadMore,
            isLoading: loading,
            "data-test-id": "load-more-button",
            testId: "load-more-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dIdGO.i18n).paginationLoadMoreButton))) : null;
        $[0] = hasNextPage;
        $[1] = loadMore;
        $[2] = loading;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ loading: loading, hasNextPage: hasNextPage, loadMore: loadMore })=>{
    return hasNextPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchPaginationContainer), {
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
        onClick: loadMore,
        isLoading: loading,
        "data-test-id": "load-more-button",
        testId: "load-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dIdGO.i18n).paginationLoadMoreButton))) : null;
};



const $bd73bcb24d697b93$var$SearchResultListNoResults = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WhPJA",
    name: "SearchResultListNoResults",
    loader: async ()=>(await (parcelRequire("ckNg0"))).SearchResultListNoResults
});
const $bd73bcb24d697b93$export$e569ab70e8964a2c = ({ results: results, numResults: numResults, totalCount: totalCount, hasNextPage: hasNextPage, loadMore: loadMore, isStale: isStale, queryState: queryState, abTest: abTest, experimentLayers: experimentLayers, productEdition: productEdition })=>{
    const { sessionHasAppliedFilters: sessionHasAppliedFilters, clearFilters: clearFilters } = (0, $fGkN6.useSearchInputContext)();
    const { fireAnalytics: fireAnalytics } = (0, $4TB09.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        if (!isStale && results.length) fireAnalytics({
            type: 'sendTrackEvent',
            action: 'shown',
            actionSubject: 'advancedSearchResults',
            additionalAttributes: {
                queryState: queryState,
                numResults: numResults,
                abTest: abTest,
                numberOfResultsShown: numResults,
                noResultsFetched: numResults === 0,
                numberOfDocs: numResults,
                pageNumber: numResults ? Math.ceil(numResults / (0, $jghB4.PAGE_SIZE)) : 1,
                backendExperiments: {
                    experimentLayers: experimentLayers
                },
                productEdition: productEdition
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isStale,
        results
    ]);
    return results.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "post-query-with-results-test"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $455256aee5342c37$export$1087c4e3145b9e), {
        numberOfResults: numResults,
        totalCount: totalCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        "data-testid": "advanced-search-resultlist"
    }, results.map((result, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b2f8ca9f1e3af8c$export$a2def421b23768aa), {
            key: result.url,
            searchResult: result,
            searchResultIdx: idx
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aa5cf5ed4869a63$export$d60800e41134dc74), {
        loading: false,
        hasNextPage: hasNextPage,
        loadMore: loadMore
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "post-query-no-results-test"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd73bcb24d697b93$var$SearchResultListNoResults, {
        clearFilters: clearFilters,
        withFiltersSelected: sessionHasAppliedFilters,
        queryState: queryState,
        abTest: abTest,
        experimentLayers: experimentLayers
    }));
};





















const $ff95fda3da3c99bb$export$28f1f0e024879df8 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$5e67fe52e2a75774), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$87791440d5143001), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$160e94802e028924), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c31c29c2535484c5), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null)))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$87791440d5143001), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$ab35601bed9ca017), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$b4a9cddf74daca12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$5e67fe52e2a75774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c46635e0b5c4943), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$160e94802e028924), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$c31c29c2535484c5), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95343f1bcab811d5$export$35a9671a565aeb08), null)))));





const $250b8dadfdbee347$export$b84e0366c3edb9f0 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchResultListLoadingContainer), null, [
            ...Array(8)
        ].map($250b8dadfdbee347$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchResultListLoadingContainer), null, [
        ...Array(8)
    ].map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff95fda3da3c99bb$export$28f1f0e024879df8), {
            key: idx
        })));
function $250b8dadfdbee347$var$_temp(_, idx) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff95fda3da3c99bb$export$28f1f0e024879df8), {
        key: idx
    });
}






const $04d8fc43a3f6d394$var$SearchResultListError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hyud8",
    name: "SearchResultListError",
    loader: async ()=>(await (parcelRequire("kdE8o"))).SearchResultListError
});
const $04d8fc43a3f6d394$export$4ad5822afca02684 = ({ resultsRef: resultsRef })=>{
    const { queryState: queryState, loading: loading, error: error, results: results, numResults: numResults, totalCount: totalCount, hasNextPage: hasNextPage, loadMore: loadMore, abTest: abTest, experimentLayers: experimentLayers, productEdition: productEdition } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    const { showSearchAI: showSearchAI } = (0, $fGkN6.useSearchInputContext)();
    const prevResultsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(results);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        prevResultsRef.current = results;
    }, [
        results
    ]);
    const resultListRenderer = (0, $cozmU.useCallback)(()=>{
        switch(queryState){
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).ERROR:
                // error is guaranteed non-undefined when queryState === QueryState.ERROR (see SearchResultsProvider.tsx)
                const err = error;
                experienceTracker.fail({
                    error: err,
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: err
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($04d8fc43a3f6d394$var$SearchResultListError, null)));
            // prevQueryStateRef to show the previous results while loading (if they exist),
            // otherwise show the no input state in a loading state
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).LOADING:
                experienceTracker.start({
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                });
                if (prevResultsRef.current.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd73bcb24d697b93$export$e569ab70e8964a2c), {
                    results: prevResultsRef.current,
                    numResults: numResults,
                    totalCount: totalCount,
                    hasNextPage: hasNextPage,
                    loadMore: loadMore,
                    queryState: queryState,
                    abTest: abTest,
                    isStale: true
                }));
                else if (showSearchAI) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $250b8dadfdbee347$export$b84e0366c3edb9f0), null);
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5762a0d820ceeb6a$export$192d2d3653f9ca9d), null));
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).POSTQUERY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd73bcb24d697b93$export$e569ab70e8964a2c), {
                    results: results,
                    numResults: numResults,
                    totalCount: totalCount,
                    hasNextPage: hasNextPage,
                    loadMore: loadMore,
                    resultListRef: resultsRef,
                    queryState: queryState,
                    abTest: abTest,
                    experimentLayers: experimentLayers,
                    isStale: false,
                    productEdition: productEdition
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                }));
            case (0, $ebe98f756f87ec8a$export$15029b2eda44c6a7).PREQUERY:
                return(// <SearchResultListLoading />
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Igo2.SearchResultListContainer), {
                    loading: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5762a0d820ceeb6a$export$192d2d3653f9ca9d), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)
                })));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numResults,
        queryState,
        resultsRef,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, resultListRenderer(), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cacu1.PageLoadEndEvent), null));
};












var $4cW8x = parcelRequire("4cW8x");


var $5wttV = parcelRequire("5wttV");






























var $1B9Aq = parcelRequire("1B9Aq");

const $57d15da5f882e220$export$a1a841ed4806404b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $57d15da5f882e220$export$bc822a7c8e6d6ae2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $57d15da5f882e220$export$1820cc0a1da47a5f = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $57d15da5f882e220$var$tooltipStyles = null;
const $57d15da5f882e220$export$7574cd0e3a4be128 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? function ToolTipOverride(t0, ref) {
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_11q71aqn _2rkofajl _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12fpd6w _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function ToolTipOverride({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            "_11q71aqn _2rkofajl _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12fpd6w _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, children);
});
const $57d15da5f882e220$export$1f1fe8a95db75cad = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_p12f1vno",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_p12f1vno",
            __cmplp.className
        ])
    });
});


const $fa8ad2e599580b9e$export$ba5404e9c41a327c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(32);
    const { filters: filters } = (0, $fGkN6.useSearchInputContext)();
    const { cloudId: cloudId, userId: userId, displayName: displayName, edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, showSearchAI: showSearchAI, aiTriggeredByAskAI: aiTriggeredByAskAI, aiSearchConfig: aiSearchConfig, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    let t0;
    if ($[0] !== filters) {
        t0 = (0, $iD4ky.mapFiltersToAggregator)(filters);
        $[0] = filters;
        $[1] = t0;
    } else t0 = $[1];
    const parsedFilters = t0;
    const { results: results, loading: resultsLoading } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    let t1;
    if ($[2] !== results[0]) {
        t1 = results[0] ?? {};
        $[2] = results[0];
        $[3] = t1;
    } else t1 = $[3];
    const { content: firstResultContent } = t1;
    let t2;
    if ($[4] !== firstResultContent) {
        t2 = firstResultContent ?? {};
        $[4] = firstResultContent;
        $[5] = t2;
    } else t2 = $[5];
    const { id: firstResultId, type: firstResultType } = t2;
    const showAITopicsCard = !resultsLoading && !parsedFilters.length && isAdminHubAIEnabled;
    if (showSearchAI && aiSearchConfig && searchQuery) {
        const t3 = displayName || "";
        const t4 = userId || "";
        let t5;
        if ($[6] !== t3 || $[7] !== t4) {
            t5 = {
                name: t3,
                id: t4
            };
            $[6] = t3;
            $[7] = t4;
            $[8] = t5;
        } else t5 = $[8];
        const t6 = aiTriggeredByAskAI ? "askAIButton" : "questionDetection";
        let t7;
        if ($[9] !== t6) {
            t7 = {
                triggeredBy: t6
            };
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        let t8;
        if ($[11] !== edition) {
            t8 = edition?.toString();
            $[11] = edition;
            $[12] = t8;
        } else t8 = $[12];
        let t9;
        if ($[13] !== aiSearchConfig.aiSearchQueryFunction || $[14] !== aiTriggeredByAskAI || $[15] !== cloudId || $[16] !== isAdminHubAIEnabled || $[17] !== onSearchQueryChange || $[18] !== parsedFilters || $[19] !== searchQuery || $[20] !== searchSessionId || $[21] !== t5 || $[22] !== t7 || $[23] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cW8x.SearchAIDialog), {
                query: searchQuery,
                setQuery: onSearchQueryChange,
                cloudId: cloudId,
                getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
                followUpsEnabled: true,
                onNavigate: $fa8ad2e599580b9e$var$_temp,
                searchSessionId: searchSessionId,
                userDetails: t5,
                source: "advancedSearch",
                sourceProduct: "confluence",
                extraAnalyticsAttributes: t7,
                wrapper: $fa8ad2e599580b9e$var$_temp2,
                loadingWrapper: $fa8ad2e599580b9e$var$_temp3,
                parsedFilters: parsedFilters,
                edition: t8,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                userGeneratedAI: aiTriggeredByAskAI
            });
            $[13] = aiSearchConfig.aiSearchQueryFunction;
            $[14] = aiTriggeredByAskAI;
            $[15] = cloudId;
            $[16] = isAdminHubAIEnabled;
            $[17] = onSearchQueryChange;
            $[18] = parsedFilters;
            $[19] = searchQuery;
            $[20] = searchSessionId;
            $[21] = t5;
            $[22] = t7;
            $[23] = t8;
            $[24] = t9;
        } else t9 = $[24];
        return t9;
    }
    if (showAITopicsCard && (0, $9wGTI.fg)("ai_topics_card_advanced_search")) {
        const t3 = userId ?? "";
        const t4 = displayName ?? "";
        let t5;
        if ($[25] !== cloudId || $[26] !== firstResultId || $[27] !== firstResultType || $[28] !== searchQuery || $[29] !== t3 || $[30] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wttV.AITopicsCardByDocument), {
                documentId: firstResultId,
                documentType: firstResultType,
                searchQuery: searchQuery,
                cloudId: cloudId,
                userId: t3,
                userName: t4
            });
            $[25] = cloudId;
            $[26] = firstResultId;
            $[27] = firstResultType;
            $[28] = searchQuery;
            $[29] = t3;
            $[30] = t4;
            $[31] = t5;
        } else t5 = $[31];
        return t5;
    }
    return null;
} : ()=>{
    const { filters: filters } = (0, $fGkN6.useSearchInputContext)();
    const { cloudId: cloudId, userId: userId, displayName: displayName, edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, showSearchAI: showSearchAI, aiTriggeredByAskAI: aiTriggeredByAskAI, aiSearchConfig: aiSearchConfig, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { searchSessionId: searchSessionId } = (0, $4TB09.useAnalytics)();
    const parsedFilters = (0, $iD4ky.mapFiltersToAggregator)(filters);
    const { results: results, loading: resultsLoading } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    const { content: firstResultContent } = results[0] ?? {};
    const { id: firstResultId, type: firstResultType } = firstResultContent ?? {};
    const showAITopicsCard = !resultsLoading && !parsedFilters.length && isAdminHubAIEnabled;
    if (showSearchAI && aiSearchConfig && searchQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cW8x.SearchAIDialog), {
        query: searchQuery,
        setQuery: onSearchQueryChange,
        cloudId: cloudId,
        getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
        followUpsEnabled: true,
        onNavigate: ()=>{},
        searchSessionId: searchSessionId,
        userDetails: {
            name: displayName || '',
            id: userId || ''
        },
        source: "advancedSearch",
        sourceProduct: "confluence",
        extraAnalyticsAttributes: {
            triggeredBy: aiTriggeredByAskAI ? 'askAIButton' : 'questionDetection'
        },
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57d15da5f882e220$export$a1a841ed4806404b), null, children),
        loadingWrapper: ({ children: children_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57d15da5f882e220$export$bc822a7c8e6d6ae2), null, children_0),
        parsedFilters: parsedFilters,
        edition: edition?.toString(),
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        userGeneratedAI: aiTriggeredByAskAI
    });
    if (showAITopicsCard && (0, $9wGTI.fg)('ai_topics_card_advanced_search')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wttV.AITopicsCardByDocument), {
        documentId: firstResultId,
        documentType: firstResultType,
        searchQuery: searchQuery,
        cloudId: cloudId,
        userId: userId ?? '',
        userName: displayName ?? ''
    });
    return null;
};
function $fa8ad2e599580b9e$var$_temp() {}
function $fa8ad2e599580b9e$var$_temp2(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57d15da5f882e220$export$a1a841ed4806404b), null, children);
}
function $fa8ad2e599580b9e$var$_temp3(t0) {
    const { children: children_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57d15da5f882e220$export$bc822a7c8e6d6ae2), null, children_0);
}












var $8vZgd = parcelRequire("8vZgd");




















const $cdb54880576a1ba2$export$c349a6e4bcccfcee = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3igktf _19pk1b66 _ekv6wadc _1sc1wadc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4t3igktf _19pk1b66 _ekv6wadc _1sc1wadc",
            __cmplp.className
        ])
    });
});
const $cdb54880576a1ba2$export$37b56b123f6a7a7e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3igktf _19pk1b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4t3igktf _19pk1b66",
            __cmplp.className
        ])
    });
});


const $c1263d6fa2690005$export$74d1cc9467f91517 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdb54880576a1ba2$export$c349a6e4bcccfcee), {
            "data-testid": "autocorrect-wrapper"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdb54880576a1ba2$export$c349a6e4bcccfcee), {
        "data-testid": "autocorrect-wrapper"
    }, children);
const $c1263d6fa2690005$export$19d62de31dc08ace = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { loading: loading, results: results, searchSessionId: searchSessionId } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    let t0;
    if ($[0] !== onSearchQueryChange) {
        t0 = (correction)=>{
            onSearchQueryChange(correction);
        };
        $[0] = onSearchQueryChange;
        $[1] = t0;
    } else t0 = $[1];
    const onCorrectionClick = t0;
    let t1;
    if ($[2] !== cloudId || $[3] !== loading || $[4] !== onCorrectionClick || $[5] !== results || $[6] !== searchQuery || $[7] !== searchSessionId) {
        t1 = !!searchQuery && (!loading || results.length > 0) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8vZgd.Autocorrection), {
            query: searchQuery,
            onCorrectionSelect: onCorrectionClick,
            cloudId: cloudId,
            searchSessionId: searchSessionId,
            source: "advancedSearch",
            productId: "confluence",
            container: $c1263d6fa2690005$export$74d1cc9467f91517,
            noCorrectionPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), null)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), {
            "data-testid": "autocorrect-placeholder"
        });
        $[2] = cloudId;
        $[3] = loading;
        $[4] = onCorrectionClick;
        $[5] = results;
        $[6] = searchQuery;
        $[7] = searchSessionId;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { searchQuery: searchQuery, onSearchQueryChange: onSearchQueryChange } = (0, $fGkN6.useSearchInputContext)();
    const { loading: loading, results: results, searchSessionId: searchSessionId } = (0, $ebe98f756f87ec8a$export$717d616a26dcb8b9)();
    const onCorrectionClick = (0, $cozmU.useCallback)((correction)=>{
        onSearchQueryChange(correction);
    }, [
        onSearchQueryChange
    ]);
    return !!searchQuery && (!loading || results.length > 0) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8vZgd.Autocorrection), {
        query: searchQuery,
        onCorrectionSelect: onCorrectionClick,
        cloudId: cloudId,
        searchSessionId: searchSessionId,
        source: "advancedSearch",
        productId: "confluence",
        container: $c1263d6fa2690005$export$74d1cc9467f91517,
        noCorrectionPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdb54880576a1ba2$export$37b56b123f6a7a7e), {
        "data-testid": "autocorrect-placeholder"
    });
};






const $359d431608e653dd$export$bcb179afe377d0c2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "J2YbF",
    name: "HorizontalFilters",
    loader: async ()=>(await (parcelRequire("2Ta1U"))).HorizontalFilters
});






var $1oLkX = parcelRequire("1oLkX");

const $91f77f209ee877f1$var$AdvancedSearchLayoutContent = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(14);
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== locale) {
        t0 = locale.split("-");
        $[0] = locale;
        $[1] = t0;
    } else t0 = $[1];
    const isAutocorrectionEnabled = t0[0] === "en";
    (0, $5d0f8354a84fe01a$export$ce35a99c900a2a66)();
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1oLkX.HorizontalFilterWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $359d431608e653dd$export$bcb179afe377d0c2), null));
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa8ad2e599580b9e$export$ba5404e9c41a327c), null);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isAutocorrectionEnabled) {
        t3 = !!isAutocorrectionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c1263d6fa2690005$export$19d62de31dc08ace), null);
        $[4] = isAutocorrectionEnabled;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    let t5;
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04d8fc43a3f6d394$export$4ad5822afca02684), null);
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cacu1.PageLoadEndEvent), null);
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else {
        t4 = $[6];
        t5 = $[7];
        t6 = $[8];
    }
    let t7;
    if ($[9] !== t3) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7adf2f9ada840466$export$6e4640db3f243f9f), null, t2, t3, t4, t5, t6);
        $[9] = t3;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
        });
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7adf2f9ada840466$export$1c7ad7ad25850bd5), {
            "data-testid": "advanced-search-page"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7adf2f9ada840466$export$cb4aeb4aba07ad10), null, t7, t8));
        $[12] = t7;
        $[13] = t9;
    } else t9 = $[13];
    return t9;
} : ()=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const isAutocorrectionEnabled = locale.split('-')[0] === 'en';
    (0, $5d0f8354a84fe01a$export$ce35a99c900a2a66)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7adf2f9ada840466$export$1c7ad7ad25850bd5), {
        "data-testid": "advanced-search-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1oLkX.HorizontalFilterWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $359d431608e653dd$export$bcb179afe377d0c2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7adf2f9ada840466$export$cb4aeb4aba07ad10), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7adf2f9ada840466$export$6e4640db3f243f9f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa8ad2e599580b9e$export$ba5404e9c41a327c), null), !!isAutocorrectionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c1263d6fa2690005$export$19d62de31dc08ace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04d8fc43a3f6d394$export$4ad5822afca02684), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cacu1.PageLoadEndEvent), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD)
    })));
};
const $91f77f209ee877f1$export$341d77456cd3484f = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "advanced-search-layout"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91f77f209ee877f1$var$AdvancedSearchLayoutContent, null)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "advanced-search-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91f77f209ee877f1$var$AdvancedSearchLayoutContent, null)));









var $hY8sQ = parcelRequire("hY8sQ");











var $3YLTK = parcelRequire("3YLTK");

const $caddf55329a22602$export$89425ce979aa17b3 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($caddf55329a22602$var$_temp, t0);
    return null;
} : ()=>{
    (0, $cozmU.useEffect)(()=>{
        (0, $3YLTK.searchPageLoadUFOExperience).start();
    }, []);
    return null;
};
function $caddf55329a22602$var$_temp() {
    (0, $3YLTK.searchPageLoadUFOExperience).start();
}



const $0974987d69968440$export$67c540814f5fd6a4 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isRovoEnabled: isRovoEnabledInTCS } = (0, $bQm3c.useSessionData)();
    // A user sees Full Page Search from `@atlassian/search-page` if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    const isFullPageSearchEnabled = ((0, $9wGTI.fg)('unified_search_in_confluence') || isRovoEnabledInTCS) && !(0, $9wGTI.fg)('confluence_rovo_search_opt_out');
    const getFailedSearchJourneyTriggerRovoChatExperiment = (0, $cozmU.useCallback)(()=>{
        return (0, $6mKj3.expVal)('failed_search_journey_trigger_rovo_chat', 'cohort', 'control');
    }, []);
    const [shouldShowSearchPageRovoConfig, setShouldShowSearchPageRovoConfig] = (0, $cozmU.useState)(false);
    const [shouldSetNudge, setShouldSetNudge] = (0, $cozmU.useState)(false);
    const [shouldNudgeToQueryStarters, setShouldNudgeToQueryStarters] = (0, $cozmU.useState)(false);
    const [shouldNudgeToSummarizeQuery, setShouldNudgeToSummarizeQuery] = (0, $cozmU.useState)(false);
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const queryParams = getQueryParams();
    const currentQuery = queryParams?.text?.toString() ?? '';
    const searchReferrerId = (0, $cozmU.useRef)(queryParams.search_id?.toString()).current;
    const searchSessionId = (0, $cozmU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()).current;
    const sendSessionStartedEvent = (0, $cozmU.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'advancedSearchScreen',
                action: 'started',
                actionSubject: 'advancedSearchSession',
                attributes: {
                    searchSessionId: searchSessionId,
                    searchReferrerId: searchReferrerId,
                    version: 2
                }
            }
        });
        analyticsEvent.fire();
    }, [
        createAnalyticsEvent,
        searchSessionId,
        searchReferrerId
    ]);
    const changeSearchIdInQueryParams = (0, $cozmU.useCallback)(()=>{
        setQueryParams({
            search_id: searchSessionId
        }, true);
    }, [
        setQueryParams,
        searchSessionId
    ]);
    const handleRedirect = (0, $cozmU.useCallback)(()=>{
        const { redirect: redirect, unsupportedFields: unsupportedFields, doubleFields: doubleFields } = getQueryParams();
        if (redirect) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirected',
                    actionSubject: 'advancedSearch',
                    source: 'advancedSearchScreen',
                    attributes: {
                        unsupportedFields: unsupportedFields,
                        doubleFields: doubleFields
                    }
                }
            }).fire();
            setQueryParams({
                redirect: null
            });
        }
        if (unsupportedFields) setQueryParams({
            unsupportedFields: null
        });
        if (doubleFields) setQueryParams({
            doubleFields: null
        });
    }, [
        createAnalyticsEvent,
        setQueryParams,
        getQueryParams
    ]);
    (0, $cozmU.useEffect)(()=>{
        sendSessionStartedEvent();
        changeSearchIdInQueryParams();
        handleRedirect();
    }, [
        sendSessionStartedEvent,
        changeSearchIdInQueryParams,
        handleRedirect
    ]);
    //Failed Search Journey Trigger Rovo Chat Experiment
    // Control: use the empty AdvancedSearchRovoConfig option
    // Query Starters Only Cohort: use the AdvancedSearchRovoConfig option, do not nudge the user after 20s dwell
    // Nudge to Query Starters Cohort: use the AdvancedSearchRovoConfig option, nudge the user after 20s dwell, nudge redirects user to mini modal
    // Nudge to Summarize Query Cohort: use the AdvancedSearchRovoConfig option, nudge the user after 20s dwell, nudge redirects user to conversation where Rovo will summarize the query results
    (0, $cozmU.useEffect)(()=>{
        //Only run the experiment if the user is on the full page search page or the query is non-empty
        if (!isFullPageSearchEnabled || currentQuery.length === 0) return;
        //Evaluate the experiment cohort
        const experimentCohort = getFailedSearchJourneyTriggerRovoChatExperiment();
        //If user is in control cohort, do nothing
        if (experimentCohort === 'control') {
            setShouldSetNudge(false);
            return;
        }
        //If user is in query starters only cohort, set the config and return
        if (experimentCohort === 'query-starters-only') {
            setShouldShowSearchPageRovoConfig(true);
            setShouldSetNudge(false);
        }
        //If user is in the nudge to query starters cohort, set the original search page rovo config initially, then set the config with the nudge after 20s dwell
        if (experimentCohort === 'nudge-to-query-starters') {
            setShouldShowSearchPageRovoConfig(true);
            setShouldSetNudge(true);
        }
        //If user is in the nudge to summarize query actioncohort, set the original search page rovo config initially, then set the config with the nudge after 20s dwell
        if (experimentCohort === 'nudge-to-summarize-query') {
            setShouldShowSearchPageRovoConfig(true);
            setShouldSetNudge(true);
        }
        const timeoutId = setTimeout(()=>{
            //If a nudge should be set, do so after 20s dwell time
            if (shouldSetNudge) {
                if (experimentCohort === 'nudge-to-query-starters') setShouldNudgeToQueryStarters(true);
                if (experimentCohort === 'nudge-to-summarize-query') setShouldNudgeToSummarizeQuery(true);
                setShouldSetNudge(false);
            }
        }, 20000);
        return ()=>clearTimeout(timeoutId);
    }, [
        getFailedSearchJourneyTriggerRovoChatExperiment,
        isFullPageSearchEnabled,
        currentQuery,
        createAnalyticsEvent,
        shouldSetNudge
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "advanced-search-controller"
    }, isFullPageSearchEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: (0, $dppWL.RegisteredExperience).SEARCH_PAGE,
        provider: (0, $29498a66b37ef077$export$f87ff91cbdaa6153),
        getSearchQuery: ()=>getQueryParams()?.text?.toString(),
        shouldUseSearchPageRovoConfig: shouldShowSearchPageRovoConfig,
        shouldNudgeToQueryStarters: shouldNudgeToQueryStarters,
        shouldNudgeToSummarizeQuery: shouldNudgeToSummarizeQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caddf55329a22602$export$89425ce979aa17b3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hY8sQ.SearchPage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: intl.formatMessage((0, $dIdGO.i18n).header)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGkN6.SearchInputProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: intl.formatMessage((0, $dIdGO.i18n).header)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2944089282b24b5b$export$f413f968bd5eda1d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebe98f756f87ec8a$export$62570eb54a58c251), {
        searchSessionId: searchSessionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4TB09.AnalyticsProvider), {
        searchSessionId: searchSessionId,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91f77f209ee877f1$export$341d77456cd3484f), null))))));
};





const $836ed73f3faf26ab$export$2709da4acd7d0aec = (0, $3u0dr.isReactCompilerActiveV2)() ? function AdvancedSearch() {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "advanced-search"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0974987d69968440$export$67c540814f5fd6a4), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function AdvancedSearch() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "advanced-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0974987d69968440$export$67c540814f5fd6a4), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD)
    })));
};
module.exports["AdvancedSearch"] = $836ed73f3faf26ab$export$2709da4acd7d0aec;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $3PNw6.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l6Cdg = parcelRequire("l6Cdg");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("5msm2", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $59jY5 = parcelRequire("59jY5");


var $cc6x1 = parcelRequire("cc6x1");


var $3XLuW = parcelRequire("3XLuW");


var $hUO8p = parcelRequire("hUO8p");

const $7cb247512fa6c12a$export$2f6c9ab85be44d1a = (onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    if (shouldNotGetBackendExperiment) return;
    return $7cb247512fa6c12a$var$getParallelBackendExperimentsConfig(onErrorFn, getLayerValuesFn ?? $7cb247512fa6c12a$export$3178593b0bf95121);
};
const $7cb247512fa6c12a$export$3178593b0bf95121 = (layerName, options)=>{
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        ...options?.fireLayerExposure === false ? {
            fireLayerExposure: false
        } : {}
    });
    const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
    return {
        name: layerNameWithoutSuffix,
        layerId: layer.get('layerId', 'default'),
        shadowId: layer.get('shadowId', null),
        // The below values might not be sent to the backend but we can still track them in the frontend
        controlId: layer.get('controlId', null),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        armId: layer.get('armId', null),
        ...(0, $cXtTj.default).checkGate('search-experiment-overrides-backend') && {
            testId: layer.get('testId', null)
        }
    };
};
const $7cb247512fa6c12a$export$f0d0c69a221c32ee = (onError, fireLayerExposure = true, getLayerValuesFn)=>{
    try {
        const layer = (0, $cXtTj.default).getLayer((0, $3XLuW.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
            fireLayerExposure: false
        });
        let abTestId;
        let armId;
        let rawLayerFunctions;
        if (getLayerValuesFn) {
            const layerResult = getLayerValuesFn((0, $3XLuW.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
                fireLayerExposure: false
            });
            abTestId = layerResult.abTestId ?? 'no_ab_test_id';
            armId = layerResult.armId;
            rawLayerFunctions = layerResult.layerFunctions ?? [];
        } else {
            abTestId = layer.get('abTestId', 'no_ab_test_id');
            rawLayerFunctions = layer.get('layerFunctions', []);
            armId = layer.get('armId', null);
        }
        const layerFunctions = (0, $cc6x1.mutuallyExclusiveBackendSearchLogicParametersSchema).safeParse(rawLayerFunctions).data;
        return {
            layerFunctions: layerFunctions || [],
            abTestId: abTestId,
            armId: armId,
            // The get 'mutualExclusion' is breaking in Jira when retrieving a boolean value from layer,
            // so for the compatibility, we use the abTestId to determine if it's a mutually exclusive experiment
            mutualExclusion: abTestId !== 'no_ab_test_id'
        };
    } catch (error) {
        onError?.(error);
    }
};
const $7cb247512fa6c12a$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName, resolveLayerValues = $7cb247512fa6c12a$export$3178593b0bf95121)=>{
    const isPremium = (0, $cXtTj.default).checkGate(featureGateName);
    if (isPremium) return resolveLayerValues(premiumLayerName);
    return resolveLayerValues(standardLayerName);
};
const $7cb247512fa6c12a$var$getParallelBackendExperimentsConfig = (onErrorFn, resolveLayerValues = $7cb247512fa6c12a$export$3178593b0bf95121)=>{
    try {
        const allLayers = [];
        const layer1 = $7cb247512fa6c12a$var$getStandardOrPremiumLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer1);
        const layer2 = $7cb247512fa6c12a$var$getStandardOrPremiumLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, $3XLuW.STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer2);
        const layer2Blending = resolveLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
        allLayers.push(layer2Blending);
        const isLayer3Enabled = (0, $cXtTj.default).checkGate((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
        if (isLayer3Enabled) {
            const layer3 = resolveLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_L3_LAYER));
            allLayers.push(layer3);
        }
        const isQueryExpansionLayerEnabled = (0, $cXtTj.default).checkGate((0, $3XLuW.STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
        if (isQueryExpansionLayerEnabled) {
            const layerQueryExpansion = resolveLayerValues((0, $3XLuW.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
            allLayers.push(layerQueryExpansion);
        }
        const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
        const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
        return {
            experimentId: concatenatedExperimentId,
            shadowExperimentId: concatenatedShadowExperimentId,
            experimentLayers: allLayers
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return 0, $3XLuW.DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};
const $7cb247512fa6c12a$var$isEnrolledInMutuallyExclusiveUIExperiment = (experience)=>{
    const isEnrolledInQuickFindUIExperiment = (0, $cXtTj.default).getLayerValue((0, $3XLuW.STATSIG_QUICK_FIND_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    const isEnrolledInSearchPageUIExperiment = (0, $cXtTj.default).getLayerValue((0, $3XLuW.STATSIG_FULL_PAGE_SEARCH_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    return experience === 'quick-find' && isEnrolledInQuickFindUIExperiment || experience === 'search-page' && isEnrolledInSearchPageUIExperiment;
};
const $7cb247512fa6c12a$var$applyBackendExperimentOverrides = (backendExperiment, backendExperimentOverrides)=>{
    // Handle undefined backendExperiment by creating a minimal experiment with empty layers
    const experiment = backendExperiment || {
        experimentLayers: []
    };
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const shouldApplyOverrides = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return backendExperiment;
    return {
        ...experiment,
        experimentLayers: (0, $hUO8p.mergeBackendExperimentLayerOverrides)(experiment.experimentLayers ?? [], backendExperimentOverrides ?? [])
    };
};
/**
 * Helper function to apply overrides when normal experiment flow is not applicable.
 * Returns undefined if no overrides are provided, otherwise applies overrides to the backend experiment.
 */ const $7cb247512fa6c12a$var$applyOverridesOrReturnUndefined = (experimentConfig, backendExperimentOverrides)=>{
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const shouldApplyOverrides = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return undefined;
    return $7cb247512fa6c12a$var$applyBackendExperimentOverrides(experimentConfig.backendExperiment, backendExperimentOverrides);
};
const $7cb247512fa6c12a$export$9009723727c24828 = ({ experimentConfig: experimentConfig, entities: entities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, backendExperimentOverrides: backendExperimentOverrides, getLayerValuesFn: getLayerValuesFn })=>{
    if (!experimentConfig.dynamicExperiments) return $7cb247512fa6c12a$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    if ($7cb247512fa6c12a$var$isEnrolledInMutuallyExclusiveUIExperiment(experience)) return $7cb247512fa6c12a$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    const requestedEntities = entities.flatMap((entity)=>{
        try {
            const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $59jY5.Ati).parse(entity);
            return [
                {
                    entity: resourceOwner,
                    subEntity: resourceType.toUpperCase()
                }
            ];
        } catch  {
            return [];
        }
    });
    // Skip layer exposure when overrides are enabled and there are overrides.
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const skipLayerExposure = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    const fireLayerExposure = !skipLayerExposure;
    const experimentParams = $7cb247512fa6c12a$export$f0d0c69a221c32ee(undefined, fireLayerExposure, getLayerValuesFn);
    if (experimentParams?.mutualExclusion) return $7cb247512fa6c12a$var$applyBackendExperimentOverrides((0, $hUO8p.mapMutuallyExclusiveExperiment)({
        experimentParams: experimentParams,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    }), backendExperimentOverrides);
    return $7cb247512fa6c12a$var$applyBackendExperimentOverrides((0, $hUO8p.mapDynamicExperiments)({
        dynamicExperiments: experimentConfig.dynamicExperiments,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters,
        fireLayerExposure: fireLayerExposure,
        getLayerValuesFn: getLayerValuesFn
    }), backendExperimentOverrides);
};
module.exports["getBackendExperimentConfig"] = $7cb247512fa6c12a$export$2f6c9ab85be44d1a;
module.exports["getLayerValues"] = $7cb247512fa6c12a$export$3178593b0bf95121;
module.exports["getBackendExperiment"] = $7cb247512fa6c12a$export$9009723727c24828;

});

parcelRegister("cc6x1", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $71e7a9f55d82afd8$var$experimentExperienceEnum = (0, $87Lnp.z).enum([
    'search-page',
    'quick-find',
    'search-page-space-filter',
    'quick-search',
    'advanced-search',
    'sain'
]);
const $71e7a9f55d82afd8$var$linkedEntityGranularityEnum = (0, $87Lnp.z).enum([
    'ALL_MATCHING_MESSAGES',
    'DEFAULT',
    'FULL_THREAD',
    'ONLY_LINKED_ENTITIES'
]);
const $71e7a9f55d82afd8$var$layerFunctionBaseSchema = {
    layerType: (0, $87Lnp.z).string().startsWith('search_platform_layer_').optional(),
    entity: (0, $87Lnp.z).string().optional(),
    subEntity: (0, $87Lnp.z).string().optional(),
    hello: (0, $87Lnp.z).boolean().optional(),
    isJiraIssueIndexed: (0, $87Lnp.z).boolean().optional(),
    linkedEntityGranularity: $71e7a9f55d82afd8$var$linkedEntityGranularityEnum.optional(),
    confluenceTier: (0, $87Lnp.z).string().array().optional(),
    productDataRegions: (0, $87Lnp.z).record((0, $87Lnp.z).string(), (0, $87Lnp.z).string().array()).optional(),
    experiences: $71e7a9f55d82afd8$var$experimentExperienceEnum.array().optional(),
    tenantIds: (0, $87Lnp.z).string().array().optional(),
    targetingGateId: (0, $87Lnp.z).string().optional(),
    providerId: (0, $87Lnp.z).string().optional(),
    connectorSources: (0, $87Lnp.z).array((0, $87Lnp.z).string()).optional(),
    integrationAri: (0, $87Lnp.z).string().optional()
};
const $71e7a9f55d82afd8$var$layerFunction = (0, $87Lnp.z).object($71e7a9f55d82afd8$var$layerFunctionBaseSchema);
const $71e7a9f55d82afd8$var$dynamicConfigSchema = (0, $87Lnp.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $87Lnp.z).NEVER;
    }
}).pipe((0, $87Lnp.z).object({
    ...$71e7a9f55d82afd8$var$layerFunctionBaseSchema,
    statsigLayerId: (0, $87Lnp.z).string().startsWith('search_platform_')
}));
const $71e7a9f55d82afd8$var$mutuallyExclusiveDynamicConfigSchema = (0, $87Lnp.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $87Lnp.z).NEVER;
    }
}).pipe((0, $87Lnp.z).object({
    ...$71e7a9f55d82afd8$var$layerFunctionBaseSchema,
    layerId: (0, $87Lnp.z).string(),
    controlId: (0, $87Lnp.z).string().optional()
}));
const $71e7a9f55d82afd8$export$4b5312b6cfd0d20a = (0, $87Lnp.z).array((0, $87Lnp.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$71e7a9f55d82afd8$var$dynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
const $71e7a9f55d82afd8$export$e1f2182538b46e4b = (0, $87Lnp.z).array((0, $87Lnp.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$71e7a9f55d82afd8$var$mutuallyExclusiveDynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
module.exports["dynamicExperimentsSchema"] = $71e7a9f55d82afd8$export$4b5312b6cfd0d20a;
module.exports["mutuallyExclusiveBackendSearchLogicParametersSchema"] = $71e7a9f55d82afd8$export$e1f2182538b46e4b;

});

parcelRegister("hUO8p", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $5msm2 = parcelRequire("5msm2");

const $90f2e5a1f458955f$var$WILDCARD = '*';
const $90f2e5a1f458955f$var$JIRA_ENTITY = 'jira';
const $90f2e5a1f458955f$var$mapExperimentsToSearchMatchingLayerExperimentsMetadata = (experiments)=>{
    const matchingLayers = experiments.reduce((metadata, { layerType: layerType, statsigLayerId: statsigLayerId })=>{
        if (!layerType) return metadata;
        if (metadata.some((metadataEntry)=>metadataEntry.layerType === layerType)) return metadata;
        return [
            ...metadata,
            {
                layerType: layerType,
                layerName: statsigLayerId
            }
        ];
    }, []);
    return matchingLayers.length ? {
        matchingLayers: matchingLayers
    } : undefined;
};
const $90f2e5a1f458955f$var$getLayersRelevantToSearchRequest = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    return dynamicExperiments.filter($90f2e5a1f458955f$var$containsTenantId(tenantId)).filter($90f2e5a1f458955f$export$647cb61786ce5ae0(productEdition)).filter($90f2e5a1f458955f$var$containsExperience(experience)).filter($90f2e5a1f458955f$var$isHelloTenant(isHello)).filter($90f2e5a1f458955f$var$containsRequestedEntities(requestedEntities)).filter($90f2e5a1f458955f$var$containsRequestedSubEntities(requestedEntities)).filter($90f2e5a1f458955f$export$273a58382ea22085(thirdPartyFilters)).filter($90f2e5a1f458955f$var$isJiraIssueIndexedConditionSatisfied(isJiraIssueIndexed)).filter($90f2e5a1f458955f$var$isLinkedEntityGranularityConditionSatisfied(linkedEntityGranularity)).filter($90f2e5a1f458955f$var$passesTargetingGate()).filter($90f2e5a1f458955f$var$satisfiesProductDataRegions(productDataRegions)).reduce((layerFunctions, currentLayerFunction)=>{
        // IF there are more than one definitions with the same definition
        // THEN only add the first one defined, (do not add this one)
        const containsCollision = layerFunctions.find((layerFunction)=>{
            /**
       * This isn't perfect either because there can be some edge cases where
       * an experiment definition is included, but not used. e.g.
       * - Defitions we have are:
       * 			[entity: confluence, subEntity: page],
       * 			[entity: confluence, subEntity: *]
       * - The request is for entity: confluence, subEntity: page
       *
       * Both definitions would be included in the final list, but only the
       * first would ever be used, but we fire exposures for both.
       *
       * To fix this, we would need to do one of the following:
       * - Replicate all of the fan out logic here (ugly and hard to maintain),
       *   so we know exactly which experiment definitions will get used
       * - Fire experiment exposures in the backend
       */ return layerFunction.layerType === currentLayerFunction.layerType && layerFunction.entity === currentLayerFunction.entity && layerFunction.subEntity === currentLayerFunction.subEntity && layerFunction.integrationAri === currentLayerFunction.integrationAri && layerFunction.providerId === currentLayerFunction.providerId && JSON.stringify(layerFunction.connectorSources?.sort()) === JSON.stringify(currentLayerFunction.connectorSources?.sort());
        });
        return containsCollision ? layerFunctions : [
            ...layerFunctions,
            currentLayerFunction
        ];
    }, []);
};
const $90f2e5a1f458955f$var$mapExperimentsToExperimentDefinitions = (experiments)=>{
    return experiments.reduce((experimentLayers, definitionWithLayerType)=>{
        const existingLayer = experimentLayers.find((layer)=>layer.name === definitionWithLayerType.layerType);
        const { controlId: _controlId, statsigLayerId: statsigLayerId, ...baseDefinition } = definitionWithLayerType.definition;
        const definition = (0, $iDrrr.fg)('search_send_statsig_layer_id') ? {
            ...baseDefinition,
            statsigLayerId: statsigLayerId
        } : baseDefinition;
        const analyticsDefinition = {
            ...definitionWithLayerType.definition
        };
        if (!existingLayer) {
            experimentLayers.push({
                name: definitionWithLayerType.layerType,
                layerId: null,
                // TODO QS-6283: Remove this once scalable statsig layers are rolled out
                shadowId: null,
                // TODO QS-6283: Remove this once scalable statsig layers are rolled out
                definitions: [
                    definition
                ],
                analyticsDefinitions: [
                    analyticsDefinition
                ]
            });
            return experimentLayers;
        }
        existingLayer.definitions?.push(definition);
        existingLayer.analyticsDefinitions?.push(analyticsDefinition);
        return experimentLayers;
    }, []);
};
const $90f2e5a1f458955f$export$10532bc904a76c69 = ({ experimentParams: experimentParams, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    const dynamicExperiments = experimentParams?.layerFunctions || [];
    const { abTestId: abTestId, armId: armId } = experimentParams || {
        abTestId: null,
        armId: null
    };
    const relevantExperiments = $90f2e5a1f458955f$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        return {
            definition: {
                layerId: dynamicExp.layerId,
                shadowId: null,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                armId: armId,
                controlId: dynamicExp.controlId ?? null,
                statsigLayerId: null,
                providerId: dynamicExp.providerId,
                integrationARI: dynamicExp.integrationAri,
                connectorSources: dynamicExp.connectorSources
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $90f2e5a1f458955f$var$mapExperimentsToExperimentDefinitions(experiments)
    };
};
const $90f2e5a1f458955f$export$b9a99705ca4e42b9 = (experimentLayers, overrides)=>{
    const mergedLayers = experimentLayers.map((l)=>({
            ...l,
            // ensure that definitions and analyticsDefinitions have an array
            definitions: l.definitions ? [
                ...l.definitions
            ] : [],
            analyticsDefinitions: l.analyticsDefinitions ? [
                ...l.analyticsDefinitions
            ] : []
        }));
    for (const override of overrides){
        const overrideDefinitions = override.analyticsDefinitions ?? [];
        if (overrideDefinitions.length === 0) continue;
        const layer = mergedLayers.find((l)=>l.name === override.name);
        if (!layer) {
            // Remove controlId from definitions since they're for request payloads
            const requestDefinitions = overrideDefinitions.map(({ controlId: _controlId, ...def })=>def);
            mergedLayers.push({
                name: override.name,
                layerId: null,
                shadowId: null,
                definitions: requestDefinitions,
                analyticsDefinitions: [
                    ...overrideDefinitions
                ]
            });
            continue;
        }
        for (const overrideDef of overrideDefinitions){
            const keyEntity = overrideDef.entity ?? null;
            const keySubEntity = overrideDef.subEntity ?? null;
            const analyticsIndex = layer.analyticsDefinitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (analyticsIndex >= 0) layer.analyticsDefinitions[analyticsIndex] = overrideDef;
            else layer.analyticsDefinitions.push(overrideDef);
            const { controlId: _controlId, ...requestDef } = overrideDef;
            const requestIndex = layer.definitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (requestIndex >= 0) layer.definitions[requestIndex] = requestDef;
            else layer.definitions.push(requestDef);
        }
    }
    return mergedLayers;
};
const $90f2e5a1f458955f$export$37bc8313287bf4ea = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, fireLayerExposure: fireLayerExposure = true, getLayerValuesFn: getLayerValuesFn = (0, $5msm2.getLayerValues) })=>{
    const relevantExperiments = $90f2e5a1f458955f$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        const { layerId: layerId, shadowId: shadowId, abTestId: abTestId, armId: armId, controlId: controlId } = getLayerValuesFn(dynamicExp.statsigLayerId, fireLayerExposure ? undefined : {
            fireLayerExposure: false
        });
        return {
            definition: {
                layerId: layerId,
                shadowId: shadowId,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                armId: armId,
                controlId: controlId,
                statsigLayerId: dynamicExp.statsigLayerId,
                providerId: dynamicExp.providerId,
                integrationARI: dynamicExp.integrationAri,
                connectorSources: dynamicExp.connectorSources
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $90f2e5a1f458955f$var$mapExperimentsToExperimentDefinitions(experiments),
        matchingLayerExperimentsMetadata: $90f2e5a1f458955f$var$mapExperimentsToSearchMatchingLayerExperimentsMetadata(relevantExperiments)
    };
};
const $90f2e5a1f458955f$export$647cb61786ce5ae0 = (productEdition)=>(dynamicExp)=>{
        // Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
        if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) return true;
        return !!dynamicExp.confluenceTier?.find((experimentTier)=>productEdition?.['confluence'] === experimentTier);
    };
const $90f2e5a1f458955f$var$isHelloTenant = (isHello)=>(dynamicExp)=>{
        if (dynamicExp.hello === undefined || dynamicExp.hello === null) return true;
        return dynamicExp.hello === isHello;
    };
const $90f2e5a1f458955f$var$passesTargetingGate = ()=>(dynamicExp)=>{
        if (dynamicExp.targetingGateId === undefined || dynamicExp.targetingGateId === null) return true;
        // eslint-disable-next-line @atlaskit/platform/static-feature-flags
        return (0, $iDrrr.fg)(dynamicExp.targetingGateId);
    };
/**
 * This is specifically used for targeting based on indexing status of the tenant.
 * This might NOT be needed once Jira indexed and ROVO in Jira is shipped to 100%
 */ const $90f2e5a1f458955f$var$isJiraIssueIndexedConditionSatisfied = (isJiraIssueIndexed)=>(dynamicExp)=>{
        if (isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === null || dynamicExp?.entity !== $90f2e5a1f458955f$var$JIRA_ENTITY) return true;
        return dynamicExp.isJiraIssueIndexed === isJiraIssueIndexed;
    };
const $90f2e5a1f458955f$var$isLinkedEntityGranularityConditionSatisfied = (linkedEntityGranularity)=>(dynamicExp)=>{
        if (linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === null) return true;
        return dynamicExp.linkedEntityGranularity === linkedEntityGranularity;
    };
const $90f2e5a1f458955f$var$containsRequestedEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.entity || dynamicExp.entity === $90f2e5a1f458955f$var$WILDCARD) return true;
        const isFilteredEntity = entityFilter.find((filteredEntity)=>dynamicExp.entity === filteredEntity.entity);
        return isFilteredEntity ?? false;
    };
const $90f2e5a1f458955f$var$containsRequestedSubEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.subEntity || dynamicExp.subEntity === $90f2e5a1f458955f$var$WILDCARD) return true;
        const isFilteredSubEntity = entityFilter.find((filteredEntity)=>dynamicExp.subEntity === filteredEntity.subEntity);
        return isFilteredSubEntity ?? false;
    };
/**
 * Determines whether the provided data regions (dataRegions) are defined in
 * the dynamic configuration (dynamicExp). Every data region for a given product
 * in the dynamic configuration must be specified  in order for the given
 * experiment layer to be eligible.
 *
 * @param dataRegions Represents where the data comes from comes from for
 * each product.
 * ```
 * { 'confluence': ["us-west-2"], 'compass': ["us-east-1"] }`
 * ```
 *
 * @returns a boolean that indicates whether or not the provided data regions
 * (dataRegions) are specified in the dynamic configuration (dynamicExp).
 */ const $90f2e5a1f458955f$var$satisfiesProductDataRegions = (dataRegions)=>(dynamicExp)=>{
        if (!dynamicExp.productDataRegions) return true;
        return Object.keys(dynamicExp.productDataRegions).map((product)=>{
            const productDataRegions = dynamicExp.productDataRegions?.[product];
            const isProductEligible = dataRegions?.[product]?.every((dataRegion)=>{
                return productDataRegions?.includes(dataRegion);
            });
            return !!isProductEligible;
        }).reduce((prev, curr)=>prev && curr);
    };
const $90f2e5a1f458955f$var$containsExperience = (experience)=>(dynamicExp)=>{
        if (!dynamicExp.experiences || dynamicExp.experiences.length === 0) return true;
        return dynamicExp.experiences?.find((dynamicExpExperience)=>experience === dynamicExpExperience);
    };
const $90f2e5a1f458955f$var$containsTenantId = (tenantId)=>(dynamicExp)=>{
        if (!dynamicExp.tenantIds || dynamicExp.tenantIds.length === 0) return true;
        return dynamicExp.tenantIds?.find((dynamicExpTenantId)=>tenantId === dynamicExpTenantId);
    };
const $90f2e5a1f458955f$export$273a58382ea22085 = (thirdPartyFilters)=>(dynamicExp)=>{
        if (!dynamicExp.connectorSources?.length && !dynamicExp.providerId && !dynamicExp.integrationAri) return true;
        if (!thirdPartyFilters?.thirdPartyProducts) return false;
        const providerIdExp = dynamicExp.providerId ?? $90f2e5a1f458955f$var$WILDCARD;
        const integrationAriExp = dynamicExp.integrationAri ?? $90f2e5a1f458955f$var$WILDCARD;
        const connectorSourceExp = dynamicExp.connectorSources;
        const matches3pTarget = thirdPartyFilters.thirdPartyProducts.find((thirdPartyProduct)=>{
            // https://atlassian.slack.com/archives/C08CGNZTMC2/p1756690283247959
            const containsConnectorSource = thirdPartyProduct.connectorSources?.find((connectorSourceFromConfig)=>connectorSourceExp?.find((connectorSourceFromExp)=>connectorSourceFromExp === connectorSourceFromConfig));
            const matchesProviderId = providerIdExp === $90f2e5a1f458955f$var$WILDCARD || providerIdExp === thirdPartyProduct.providerId;
            const matchesIntegrationAri = integrationAriExp === $90f2e5a1f458955f$var$WILDCARD || integrationAriExp === thirdPartyProduct.integrationId;
            return(// !connectorSources = wildcard
            matchesProviderId && matchesIntegrationAri && (!connectorSourceExp || Boolean(containsConnectorSource)));
        });
        return Boolean(matches3pTarget);
    };
module.exports["mapMutuallyExclusiveExperiment"] = $90f2e5a1f458955f$export$10532bc904a76c69;
module.exports["mergeBackendExperimentLayerOverrides"] = $90f2e5a1f458955f$export$b9a99705ca4e42b9;
module.exports["mapDynamicExperiments"] = $90f2e5a1f458955f$export$37bc8313287bf4ea;

});

parcelRegister("lt6Lx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $kSwu1.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { siteTitle: siteTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("3tUdX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dppWL = parcelRequire("dppWL");


var $amW67 = parcelRequire("amW67");


var $8hjAS = parcelRequire("8hjAS");

const $f4bf02d66e85d52a$export$44a9046b553a8167 = (props)=>{
    if (props.experience === (0, $dppWL.RegisteredExperience).WHITEBOARD && !(0, $dppWL.isWhiteboardRovoConfigProviderProps)(props)) return null;
    if ((props.experience === (0, $dppWL.RegisteredExperience).VIEW_PAGE || props.experience === (0, $dppWL.RegisteredExperience).EDIT_PAGE) && !(0, $dppWL.isPageRovoConfigProviderProps)(props)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $amW67.RovoConfigProviderContextProvider), {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8hjAS.RovoCurrentConfigProvider), {
        provider: props.provider
    }));
};
module.exports["RovoConfigProvider"] = $f4bf02d66e85d52a$export$44a9046b553a8167;

});

parcelRegister("dppWL", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ var $56fbda2769629a59$export$50526ee9b1846f6c = /*#__PURE__*/ function(RegisteredExperience) {
    RegisteredExperience["VIEW_PAGE"] = "view-page";
    RegisteredExperience["EDIT_PAGE"] = "edit-page";
    RegisteredExperience["WHITEBOARD"] = "whiteboard";
    RegisteredExperience["SEARCH_PAGE"] = "search-page";
    return RegisteredExperience;
}({});
const $56fbda2769629a59$export$1e3f84bae31640f2 = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$9fdd72360ade08c0 = (props)=>'contentType' in props;
const $56fbda2769629a59$export$b8a252bbcf90a2cb = (props)=>'getSearchQuery' in props;
module.exports["RegisteredExperience"] = $56fbda2769629a59$export$50526ee9b1846f6c;
module.exports["isWhiteboardRovoConfigProviderProps"] = $56fbda2769629a59$export$1e3f84bae31640f2;
module.exports["isPageRovoConfigProviderProps"] = $56fbda2769629a59$export$9fdd72360ade08c0;

});

parcelRegister("amW67", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $23a8183fa434531d$var$RovoConfigProviderContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $23a8183fa434531d$export$3ae1f97e9390a638 = ()=>{
    const context = (0, $cozmU.useContext)($23a8183fa434531d$var$RovoConfigProviderContext);
    if (!context) throw new Error('useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider');
    return context;
};
const $23a8183fa434531d$export$45b0916bb24b31be = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23a8183fa434531d$var$RovoConfigProviderContext.Provider, {
        value: value
    }, children);
};
module.exports["useRovoConfigProviderProps"] = $23a8183fa434531d$export$3ae1f97e9390a638;
module.exports["RovoConfigProviderContextProvider"] = $23a8183fa434531d$export$45b0916bb24b31be;

});

parcelRegister("8hjAS", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $8MKuN = parcelRequire("8MKuN");


var $6mKj3 = parcelRequire("6mKj3");


var $5ruin = parcelRequire("5ruin");

const $4d3968fc98119c84$export$9ef355ca939f0be9 = ({ provider: provider })=>{
    const { resetConfiguration: resetConfiguration, setConfiguration: setConfiguration } = (0, $5ruin.useRovoCurrentConfigStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        if (!provider) resetConfiguration();
        return ()=>{
            resetConfiguration();
        };
    }, [
        resetConfiguration,
        provider
    ]);
    if (!provider) return null;
    const ActiveProviderComponent = provider;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "rovo-current-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ActiveProviderComponent, {
        setConfiguration: setConfiguration
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
};
module.exports["RovoCurrentConfigProvider"] = $4d3968fc98119c84$export$9ef355ca939f0be9;

});

parcelRegister("8MKuN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $jb2gB = parcelRequire("jb2gB");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $cozmU.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $a33Aa.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("5ruin", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $8s9DV.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $kBr4q.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
const $2b71e6bc29f732db$export$77b1364ae13e9bf5 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.numStartersToShow
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;
module.exports["useRovoConfigNumStartersToShow"] = $2b71e6bc29f732db$export$77b1364ae13e9bf5;

});

parcelRegister("dIdGO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");

const $74bc7b529e0c42f5$var$i18nBase = (0, $kSwu1.defineMessages)({
    header: {
        id: "advanced-search.header",
        defaultMessage: "Search"
    },
    textFieldLabel: {
        id: "advanced-search.textfield.label",
        defaultMessage: "Search in Confluence"
    },
    textFieldPlaceholder: {
        id: "advanced-search.textfield.placeholder",
        defaultMessage: "Enter keywords to find pages, attachments, and more"
    },
    searchIconLabel: {
        id: "advanced-search.textfield.search.icon.label",
        defaultMessage: "Search icon"
    },
    crossIconLabel: {
        id: "advanced-search.textfield.cross.icon.label",
        defaultMessage: "Clear search bar"
    },
    clearFilterButtonText: {
        id: "advanced-search.clear.filter.button.text",
        defaultMessage: "Clear all"
    },
    skipToSearchField: {
        id: "advanced-search.search.skip.text.link",
        defaultMessage: "Jump back to search field"
    },
    landingPageHeader: {
        id: "advanced-search.search.result.landing.page.header",
        defaultMessage: "Find what you need in Confluence"
    },
    landingPageText: {
        id: "advanced-search.search.result.landing.page.text",
        defaultMessage: "Ask a question and get an answer in search"
    },
    resultNoResultHeader: {
        id: "advanced-search.search.result.no.result.header",
        defaultMessage: "We couldn\u2019t find any matches for your search."
    },
    resultNoResultSuggestion: {
        id: "advanced-search.search.result.no.result.suggestion",
        defaultMessage: "Try different keywords, fewer of them, or ones that are more general."
    },
    resultLastModifiedContent: {
        id: "advanced-search.search.result.content.lastmodified",
        defaultMessage: "Updated"
    },
    resultLastModifiedAttachment: {
        id: "advanced-search.search.result.attachment.lastmodified",
        defaultMessage: "Uploaded"
    },
    searchFilterSpace: {
        id: "advanced-search.filter.space.label",
        defaultMessage: "Space"
    },
    searchFilterContentUnderAncestor: {
        id: "advanced-search.filter.content.ancestor.label",
        defaultMessage: "Content under"
    },
    searchFilterMore: {
        id: "advanced-search.filter.more.label",
        defaultMessage: "More filters"
    },
    searchFilterArchivedContent: {
        id: "advanced-search.filter.archivedContent.label",
        defaultMessage: "Archived content"
    },
    searchContentFilterAncestorPlaceholder: {
        id: "advanced-search.filter.ancestor.placeholder",
        defaultMessage: "Select content nested under"
    },
    searchFilterAncestorRecentPages: {
        id: "advanced-search.filter.ancestor.recentpages",
        defaultMessage: "Recent pages"
    },
    searchFilterContributor: {
        id: "advanced-search.filter.contributor.label",
        defaultMessage: "Edited or created by"
    },
    searchFilterLabels: {
        id: "advanced-search.filter.labels.label",
        defaultMessage: "Labels"
    },
    searchFilterType: {
        id: "advanced-search.filter.type.label",
        defaultMessage: "Type"
    },
    searchFilterVerified: {
        id: "advanced-search.filter.verified.label",
        defaultMessage: "Verified"
    },
    typePlaceholder: {
        id: "advanced-search.type.placeholder",
        defaultMessage: "Filter by type"
    },
    typePage: {
        id: "advanced-search.type.page",
        defaultMessage: "Pages"
    },
    typeBlogpost: {
        id: "advanced-search.type.blogpost",
        defaultMessage: "Blog posts"
    },
    typeAttachment: {
        id: "advanced-search.type.attachment",
        defaultMessage: "Attachments"
    },
    typeSpace: {
        id: "advanced-search.type.space",
        defaultMessage: "Spaces"
    },
    typeWhiteboard: {
        id: "advanced-search.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    typeDatabase: {
        id: "advanced-search.type.database",
        defaultMessage: "Databases"
    },
    typeSlide: {
        id: "advanced-search.type.slide",
        defaultMessage: "Slides"
    },
    typeEmbed: {
        id: "advanced-search.type.embed",
        defaultMessage: "Smart Links"
    },
    typeComments: {
        id: "advanced-search.type.comments",
        defaultMessage: "Comments"
    },
    typeFolder: {
        id: "advanced-search.type.folders",
        defaultMessage: "Folders"
    },
    searchFilterTitle: {
        id: "advanced-search.filter.title.label",
        defaultMessage: "Search titles only"
    },
    searchFilterArchived: {
        id: "advanced-search.filter.archived.label",
        defaultMessage: "Show archived content"
    },
    paginationLoadMoreButton: {
        id: "advanced-search.load.more.text",
        defaultMessage: "Load more"
    },
    spaceFilterPlaceholder: {
        id: "advanced-search.space.filter.placeholder",
        defaultMessage: "Find a space"
    },
    userFilterPlaceholder: {
        id: "advanced-search.user.filter.placeholder",
        defaultMessage: "Find a person"
    },
    labelFilterPlaceholder: {
        id: "advanced-search.label.filter.placeholder",
        defaultMessage: "Find a label"
    },
    ancestorFilterPlaceholder: {
        id: "advanced-search.label.content.placeholder",
        defaultMessage: "Search content"
    },
    verifiedFilterPlaceholder: {
        id: "advanced-search.verified.filter.placeholder",
        defaultMessage: "Find verified content"
    },
    numberOfResults: {
        id: "advanced-search.number.results",
        defaultMessage: "Showing {numberOfResults, number} of {totalCount, number} results"
    },
    searchFilterLabelsNoText: {
        id: "advanced-search.labels.filter.no.text",
        defaultMessage: "Start typing to search for a label"
    },
    dateFilterTitle: {
        id: "advanced-search.date.filter.title",
        defaultMessage: "Last updated"
    },
    dateFilterFromTitle: {
        id: "advanced-search.date.filter.from.title",
        defaultMessage: "From"
    },
    dateFilterToTitle: {
        id: "advanced-search.date.filter.to.title",
        defaultMessage: "To"
    },
    dateFilterDateInputPlaceholder: {
        id: "advanced-search.date.filter.input.placeholder",
        defaultMessage: "Choose a date"
    },
    dateFilterAnyTime: {
        id: "advanced-search.date.filter.any.time",
        defaultMessage: "Anytime"
    },
    dateFilterToday: {
        id: "advanced-search.date.filter.today",
        defaultMessage: "Today"
    },
    dateFilterYesterday: {
        id: "advanced-search.date.filter.yesterday",
        defaultMessage: "Yesterday"
    },
    dateFilterLastWeek: {
        id: "advanced-search.date.filter.last.week",
        defaultMessage: "Past 7 days"
    },
    dateFilterLastMonth: {
        id: "advanced-search.date.filter.last.month",
        defaultMessage: "Past 30 days"
    },
    dateFilterLastYear: {
        id: "advanced-search.date.filter.last.year",
        defaultMessage: "Past year"
    },
    dateFilterCustom: {
        id: "advanced-search.date.filter.custom",
        defaultMessage: "Custom"
    },
    dateFilterCustomInvalidDateAfterToday: {
        id: "advanced-search.date.filter.custom.invalid.after.today",
        defaultMessage: "The From date can\u2019t be in the future"
    },
    dateFilterCustomInvalidToDateAfterToday: {
        id: "advanced-search.date.filter.custom.invalid.to.after.today",
        defaultMessage: "The To date can\u2019t be in the future"
    },
    dateFilterCustomInvalidDateAfterEnd: {
        id: "advanced-search.date.filter.custom.invalid.after.end",
        defaultMessage: "The From date has to be before the To date"
    },
    dateFilterToRange: {
        id: "advanced-search.date.filter.to.range",
        defaultMessage: "to"
    },
    dateFilterUpdateButton: {
        id: "advanced-search.date.filter.update.button",
        defaultMessage: "Update"
    },
    dateFilterBeforeLabel: {
        id: "advanced-search.date.filter.before.label",
        defaultMessage: "before"
    },
    dateFilterAfterLabel: {
        id: "advanced-search.date.filter.after.label",
        defaultMessage: "after"
    },
    selectorErrorMessage: {
        id: "advanced-search.filter.generic.error-message",
        defaultMessage: "Something went wrong."
    },
    xpsErrorHeader: {
        id: "advanced-search.search.result.xps.error.header",
        defaultMessage: "We\u2019re having trouble getting your results"
    },
    xpsErrorSuggestion: {
        id: "advanced-search.search.result.xps.error.suggestion",
        defaultMessage: "{link} and try again."
    },
    xpsErrorSuggestionLink: {
        id: "advanced-search.search.result.xps.error.suggestion.link",
        defaultMessage: "Refresh the page"
    },
    feedbackButton: {
        id: "advanced-search.search.feedback.button",
        defaultMessage: "Give feedback"
    },
    selectedLabel: {
        id: "advanced-search.search.selected.label",
        defaultMessage: "Selected"
    },
    suggestedLabel: {
        id: "advanced-search.search.suggested.label",
        defaultMessage: "Suggested"
    },
    resultsLabel: {
        id: "advanced-search.search.results.label",
        defaultMessage: "Results"
    },
    recentLabel: {
        id: "advanced-search.search.recent.label",
        defaultMessage: "Recent"
    },
    disabledSearchTitleOnlyTooltipMessage: {
        id: "advanced-search.search.disabled.search.title.only.tooltip",
        defaultMessage: "To search by titles only, please input your search in the search bar."
    },
    askAIButton: {
        id: "advanced-search.search.askAI.button.text",
        defaultMessage: "Ask AI"
    },
    disabledAIButtonMessage: {
        id: "advanced-search.search.askAI.disabled.button.message",
        defaultMessage: "Ask a question in search to get an answer from Atlassian Intelligence"
    },
    spaceIconLabel: {
        id: "advanced-search.result.space.icon.label",
        defaultMessage: "Space logo for {spaceName}"
    }
});
const $74bc7b529e0c42f5$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    searchFilterAncestorRecentPages: {
        id: "advanced-search.filter.ancestor.recentpages.livedocs",
        defaultMessage: "Recent pages and live docs"
    },
    typePage: {
        id: "advanced-search.type.page.livedocs",
        defaultMessage: "Pages and live docs"
    }
});
const $74bc7b529e0c42f5$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($74bc7b529e0c42f5$var$i18nBase, $74bc7b529e0c42f5$var$i18nLiveDocs);
module.exports["i18n"] = $74bc7b529e0c42f5$export$a7357cdd1f0b0168;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("bXh4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $5251c9f91178493b$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null,
    isNudgeVisible: false
};
const $5251c9f91178493b$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        },
    setIsNudgeVisible: (isNudgeVisible)=>({ setState: setState })=>{
            setState({
                isNudgeVisible: isNudgeVisible
            });
        }
};
const $5251c9f91178493b$export$72552b26ebb37b2 = (0, $8s9DV.createStore)({
    initialState: $5251c9f91178493b$export$d4c72bab9d6cc13a,
    actions: $5251c9f91178493b$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $5251c9f91178493b$export$af36d029992e7a8c = (0, $kBr4q.createActionsHook)($5251c9f91178493b$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $5251c9f91178493b$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $5251c9f91178493b$export$af36d029992e7a8c;

});

parcelRegister("6iWVH", function(module, exports) {
var $b76a5cfcb2493fac$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $b76a5cfcb2493fac$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $b76a5cfcb2493fac$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_BOARD"] = "jira-board";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["FOCUS_FOCUS_AREA_FUNDS_VIEW"] = "focus-focus-area-funds-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $b76a5cfcb2493fac$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $b76a5cfcb2493fac$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $b76a5cfcb2493fac$export$c91e07269f22915a;
module.exports["PageContextType"] = $b76a5cfcb2493fac$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $b76a5cfcb2493fac$export$4f757e7d9540e8f9;

});

parcelRegister("2ot3O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $lqtHz = parcelRequire("lqtHz");

const $1deb345019a8d437$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
const $1deb345019a8d437$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)($1deb345019a8d437$var$FlagContext);
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)($1deb345019a8d437$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
const $1deb345019a8d437$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $1deb345019a8d437$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $1deb345019a8d437$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$var$FlagContext.Provider, {
            value: api
        }, children);
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($1deb345019a8d437$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent
        }, t5);
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t6);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $1deb345019a8d437$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag_1)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
        const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagType, {
            ...restProps,
            key: flag_1.id
        });
    })));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $1deb345019a8d437$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
const $1deb345019a8d437$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $1deb345019a8d437$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $1deb345019a8d437$export$a4270ab432ac8a58;

});

parcelRegister("ePNCU", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $04e9M = parcelRequire("04e9M");


var $j3rr0 = parcelRequire("j3rr0");

const $1421b08aaa3d561b$export$3f8d01317e97ea46 = (0, $dOBRD.default)(async (iframeDwell)=>{
    const DwellTimeHelper = await (0, $04e9M.getDwellTimeHelper)();
    const provideDwellTimeHelper = (sendDwellEvent, dwellData, searchSessionId)=>{
        return new DwellTimeHelper(sendDwellEvent, dwellData, searchSessionId, {}, {
            iframeDwell: iframeDwell
        });
    };
    return new (0, $j3rr0.DwellTimeTracker)(provideDwellTimeHelper);
});
module.exports["getDwellTimeTracker"] = $1421b08aaa3d561b$export$3f8d01317e97ea46;

});

parcelRegister("j3rr0", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $7W8i8 = parcelRequire("7W8i8");

const $c5cbdaf017f648e2$var$logger = (0, $7W8i8.getLogger)('DwellTimeTracker');
class $c5cbdaf017f648e2$export$3b0fcaf8cb0b1472 {
    /**
   *  Stops previous dwell timer if any and starts a new one.
   *  `callback` is called at every dwell milestones and when the timer is stopped
   **/ async startAny(data, callback) {
        this.startDwellTimeHelper(data, callback);
    }
    /**
   *  Same as `startAny()`, but for Confluence Page or Blog and other content types
   **/ async startContent(spaceId, contentId, contentType, callback, searchSessionId, additionalAnalytics) {
        const dwellData = this.getEventDataForContent(spaceId, contentId, contentType, additionalAnalytics);
        await this.startDwellTimeHelper(dwellData, callback, searchSessionId).catch((e)=>{
            throw e;
        });
    }
    /**
   *  Same as `startAny()`, but for Confluence Space Overview
   **/ async startSpace(spaceId, callback, searchSessionId, additionalAnalytics) {
        const dwellData = this.getEventDataForSpace(spaceId, additionalAnalytics);
        await this.startDwellTimeHelper(dwellData, callback, searchSessionId).catch((e)=>{
            throw e;
        });
    }
    /**
   *  Stops current timer and reports final dwell time
   **/ stop() {
        if (this.dwellTimeHelper) this.dwellTimeHelper.stop();
        else $c5cbdaf017f648e2$var$logger.error`Dwell was stopped before it can get started`;
    }
    async startDwellTimeHelper(dwellData, sendDwellEvent, searchSessionId) {
        // If a concurrent initialization is already in-flight, wait for it to complete
        // before proceeding. This prevents two simultaneous callers both seeing
        // dwellTimeHelper === null and creating duplicate DwellTimeHelper instances,
        // which would cause duplicate events at every interval.
        if (this.initializingPromise) await this.initializingPromise;
        try {
            if (!this.dwellTimeHelper) {
                let resolveInit;
                this.initializingPromise = new Promise((resolve)=>{
                    resolveInit = resolve;
                });
                this.dwellTimeHelper = this.provideDwellTimeHelper(this.onDwell, dwellData, searchSessionId);
                // We call stop just to make sure TimeMe.active is false and prevent the following error
                // "DwellTimeHelper should only be initialised once per page load.""
                // https://bitbucket.org/atlassian/analytics-web-client/src/aa020a05be67317714977ceed0221e5721f1a4eb/src/dwellTimeHelper.js#lines-78
                this.dwellTimeHelper.stop();
                this.dwellTimeHelper.start();
                this.initializingPromise = null;
                resolveInit();
            } else this.dwellTimeHelper.newPage(dwellData, searchSessionId);
            this.dwellTimeCallback = sendDwellEvent;
        } catch (e) {
            this.initializingPromise = null;
            $c5cbdaf017f648e2$var$logger.error`Failed to start dwell time`;
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: 'disco'
            });
            throw e;
        }
    }
    constructor(provideDwellTimeHelper){
        this.provideDwellTimeHelper = void 0;
        this.dwellTimeHelper = null;
        this.dwellTimeCallback = null;
        this.initializingPromise = null;
        this.onDwell = (data)=>{
            if (this.dwellTimeCallback) this.dwellTimeCallback(data);
        };
        this.getEventDataForContent = (spaceId, contentId, contentType, additionalAnalytics = {})=>{
            const analyticsContentType = contentType === 'blogpost' ? 'page' : contentType;
            return {
                containerType: 'space',
                containerId: spaceId,
                objectType: analyticsContentType,
                objectId: contentId,
                source: analyticsContentType,
                actionSubject: analyticsContentType,
                actionSubjectId: contentId,
                attributes: {
                    ...additionalAnalytics
                }
            };
        };
        this.getEventDataForSpace = (spaceId, additionalAnalytics = {})=>({
                containerType: 'space',
                containerId: spaceId,
                source: 'space',
                actionSubject: 'space',
                actionSubjectId: spaceId,
                attributes: {
                    ...additionalAnalytics
                }
            });
        this.provideDwellTimeHelper = provideDwellTimeHelper;
    }
}
module.exports["DwellTimeTracker"] = $c5cbdaf017f648e2$export$3b0fcaf8cb0b1472;

});

parcelRegister("4TB09", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $56QzY = parcelRequire("56QzY");


var $1AV5C = parcelRequire("1AV5C");


var $jghB4 = parcelRequire("jghB4");


var $iD4ky = parcelRequire("iD4ky");


var $fGkN6 = parcelRequire("fGkN6");

const $ca535cb9442e6251$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    fireAnalytics: ()=>{},
    searchSessionId: ''
});
const $ca535cb9442e6251$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { searchSessionId: searchSessionId, createAnalyticsEvent: createAnalyticsEvent, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [commonAttributes, setCommonAttributes] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[1] = t2;
    } else t2 = $[1];
    const [privateAttributes, setPrivateAttributes] = (0, $cozmU.useState)(t2);
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    let t3;
    let t4;
    if ($[2] !== activationId || $[3] !== searchInputs || $[4] !== searchSessionId) {
        t3 = ()=>{
            const { searchQuery: searchQuery, filters: filters, cql: cql } = searchInputs;
            const filterSelections = (0, $iD4ky.getOptionSelections)(filters);
            const filterCategories = (0, $iD4ky.transformFiltersForAnalytics)(filterSelections);
            const archivedStatus = filterSelections.some($ca535cb9442e6251$var$_temp) ? [
                (0, $jghB4.CURRENT),
                (0, $jghB4.ARCHIVED)
            ] : [
                (0, $jghB4.CURRENT)
            ];
            setCommonAttributes({
                searchSessionId: searchSessionId,
                numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
                queryLength: searchQuery.length,
                queryHash: (0, $1AV5C.hashData)(searchQuery),
                filters: filterCategories,
                filterSelections: filterSelections,
                containerStatuses: archivedStatus,
                contentStatuses: archivedStatus,
                activationId: activationId,
                version: 2,
                api: searchInputs.queryType === "CQLQuery" ? (0, $jghB4.CONFLUENCE_SEARCH_API) : (0, $jghB4.CROSSPRODUCT_SEARCH_API),
                navdexPointType: (0, $56QzY.TOUCH),
                wordCount: (searchQuery.match(/\w+/g) || []).length,
                isCQL: cql !== undefined
            });
            setPrivateAttributes({
                query: searchQuery
            });
        };
        t4 = [
            searchInputs,
            searchSessionId,
            activationId
        ];
        $[2] = activationId;
        $[3] = searchInputs;
        $[4] = searchSessionId;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== commonAttributes || $[8] !== createAnalyticsEvent || $[9] !== privateAttributes) {
        t5 = (t6)=>{
            const { type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, additionalAttributes: additionalAttributes } = t6;
            createAnalyticsEvent({
                type: type,
                data: {
                    source: "advancedSearchScreen",
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    nonPrivacySafeAttributes: privateAttributes,
                    attributes: {
                        ...commonAttributes,
                        ...additionalAttributes
                    }
                }
            }).fire();
        };
        $[7] = commonAttributes;
        $[8] = createAnalyticsEvent;
        $[9] = privateAttributes;
        $[10] = t5;
    } else t5 = $[10];
    const fireAnalytics = t5;
    let t6;
    if ($[11] !== fireAnalytics || $[12] !== searchSessionId) {
        t6 = {
            searchSessionId: searchSessionId,
            fireAnalytics: fireAnalytics
        };
        $[11] = fireAnalytics;
        $[12] = searchSessionId;
        $[13] = t6;
    } else t6 = $[13];
    const analyticsContextValue = t6;
    let t7;
    if ($[14] !== analyticsContextValue || $[15] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ca535cb9442e6251$export$83cd6c3eba7d8d9e.Provider, {
            value: analyticsContextValue
        }, children);
        $[14] = analyticsContextValue;
        $[15] = children;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ searchSessionId: searchSessionId, createAnalyticsEvent: createAnalyticsEvent, children: children })=>{
    const [commonAttributes, setCommonAttributes] = (0, $cozmU.useState)({});
    const [privateAttributes, setPrivateAttributes] = (0, $cozmU.useState)({});
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const searchInputs = (0, $fGkN6.useSearchInputContext)();
    (0, $cozmU.useEffect)(()=>{
        const { searchQuery: searchQuery, filters: filters, cql: cql } = searchInputs;
        const filterSelections = (0, $iD4ky.getOptionSelections)(filters);
        const filterCategories = (0, $iD4ky.transformFiltersForAnalytics)(filterSelections);
        const archivedStatus = filterSelections.some((selection)=>selection.value === (0, $jghB4.OptionIds).ARCHIVED) ? [
            (0, $jghB4.CURRENT),
            (0, $jghB4.ARCHIVED)
        ] : [
            (0, $jghB4.CURRENT)
        ];
        setCommonAttributes({
            searchSessionId: searchSessionId,
            numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
            queryLength: searchQuery.length,
            queryHash: (0, $1AV5C.hashData)(searchQuery),
            filters: filterCategories,
            filterSelections: filterSelections,
            containerStatuses: archivedStatus,
            contentStatuses: archivedStatus,
            activationId: activationId,
            version: 2,
            api: searchInputs.queryType === 'CQLQuery' ? (0, $jghB4.CONFLUENCE_SEARCH_API) : (0, $jghB4.CROSSPRODUCT_SEARCH_API),
            navdexPointType: (0, $56QzY.TOUCH),
            wordCount: (searchQuery.match(/\w+/g) || []).length,
            isCQL: cql !== undefined
        });
        setPrivateAttributes({
            query: searchQuery
        });
    }, [
        searchInputs,
        searchSessionId,
        activationId
    ]);
    const fireAnalytics = (0, $cozmU.useCallback)(({ type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, additionalAttributes: additionalAttributes })=>{
        createAnalyticsEvent({
            type: type,
            data: {
                source: 'advancedSearchScreen',
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                nonPrivacySafeAttributes: privateAttributes,
                attributes: {
                    ...commonAttributes,
                    ...additionalAttributes
                }
            }
        }).fire();
    }, [
        commonAttributes,
        privateAttributes,
        createAnalyticsEvent
    ]);
    const analyticsContextValue = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            fireAnalytics: fireAnalytics
        }), [
        searchSessionId,
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ca535cb9442e6251$export$83cd6c3eba7d8d9e.Provider, {
        value: analyticsContextValue
    }, children);
};
const $ca535cb9442e6251$export$e955abb82869dc84 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($ca535cb9442e6251$export$83cd6c3eba7d8d9e);
} : ()=>{
    return (0, $cozmU.useContext)($ca535cb9442e6251$export$83cd6c3eba7d8d9e);
};
function $ca535cb9442e6251$var$_temp(selection) {
    return selection.value === (0, $jghB4.OptionIds).ARCHIVED;
}
module.exports["AnalyticsProvider"] = $ca535cb9442e6251$export$1b581a2ec13e37f1;
module.exports["useAnalytics"] = $ca535cb9442e6251$export$e955abb82869dc84;

});

parcelRegister("jghB4", function(module, exports) {

var $dIdGO = parcelRequire("dIdGO");

const $29feb65a99c04950$export$aad07b8ec9031cb6 = 'default';
const $29feb65a99c04950$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $29feb65a99c04950$export$5e8718d49d6c8c22 = 'confluenceSearch';
var $29feb65a99c04950$export$67bed5d1bc1f6c29 = /*#__PURE__*/ function(FilterIds) {
    FilterIds["SPACES"] = "spaces";
    FilterIds["CONTRIBUTORS"] = "contributors";
    FilterIds["TYPE"] = "type";
    FilterIds["LABELS"] = "labels";
    FilterIds["VERIFIED"] = "verified";
    FilterIds["ANCESTOR"] = "ancestor";
    FilterIds["DATE"] = "date";
    FilterIds["MORE"] = "moreFilters";
    FilterIds["CONTENT_UNDER"] = "contentUnder";
    FilterIds["ARCHIVED_CONTENT"] = "archivedContent";
    FilterIds["SEARCH_TITLE_ONLY"] = "searchTitleOnly";
    return FilterIds;
}({});
var $29feb65a99c04950$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    OptionIds["VERIFIED"] = "verified";
    return OptionIds;
}({});
var $29feb65a99c04950$export$34af5fcca86fafea = /*#__PURE__*/ function(InputVariants) {
    InputVariants["SELECTOR_WITH_AVATAR"] = "selectorWithAvatar";
    InputVariants["SELECT"] = "select";
    InputVariants["CHECKBOX"] = "checkbox";
    InputVariants["USER_PICKER"] = "userPicker";
    InputVariants["BUTTON"] = "pillButton";
    InputVariants["SEARCH_BUTTON"] = "searchButton";
    InputVariants["DATE_PICKER"] = "datePicker";
    InputVariants["MORE"] = "more";
    InputVariants["TAG"] = "tag";
    return InputVariants;
}({});
const $29feb65a99c04950$export$8ec3d08588d2eeda = 25;
const $29feb65a99c04950$export$b014b1b85cc3561 = ',';
const $29feb65a99c04950$export$c94fdbf59dff15c8 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder'
];
const $29feb65a99c04950$export$529483abfcf12013 = 'confluence.advancedSearch';
const $29feb65a99c04950$export$1f960e9ecae3cb06 = 'ari:cloud:confluence::site/';
const $29feb65a99c04950$export$8c6bf2df244e6a99 = '/wiki';
const $29feb65a99c04950$export$eed19b551669af14 = 'CURRENT';
const $29feb65a99c04950$export$c936349447a77fe0 = 'ARCHIVED';
const $29feb65a99c04950$export$60114111d5b5f818 = [
    'CURRENT',
    'ARCHIVED'
];
var $29feb65a99c04950$export$2a1fb5b806348bf0 = /*#__PURE__*/ function(LastModifiedValues) {
    LastModifiedValues["ANY_TIME"] = "";
    LastModifiedValues["TODAY"] = "today";
    LastModifiedValues["YESTERDAY"] = "yesterday";
    LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
    LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
    LastModifiedValues["PAST_YEAR"] = "pastYear";
    LastModifiedValues["CUSTOM"] = "custom";
    LastModifiedValues["LAST_DAY"] = "lastDay";
    LastModifiedValues["LAST_WEEK"] = "lastWeek";
    LastModifiedValues["LAST_MONTH"] = "lastMonth";
    LastModifiedValues["LAST_YEAR"] = "lastYear";
    return LastModifiedValues;
}({});
const $29feb65a99c04950$export$167891dba63dc67b = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}/;
var $29feb65a99c04950$export$9da7f865fb841394 = /*#__PURE__*/ function(ConfluenceATIs) {
    ConfluenceATIs["PAGE"] = "ati:cloud:confluence:page";
    ConfluenceATIs["ATTACHMENT"] = "ati:cloud:confluence:attachment";
    ConfluenceATIs["BLOG"] = "ati:cloud:confluence:blogpost";
    ConfluenceATIs["SPACE"] = "ati:cloud:confluence:space";
    ConfluenceATIs["COMMENT"] = "ati:cloud:confluence:comment";
    ConfluenceATIs["WHITEBOARD"] = "ati:cloud:confluence:whiteboard";
    ConfluenceATIs["DATABASE"] = "ati:cloud:confluence:database";
    ConfluenceATIs["SLIDE"] = "ati:cloud:confluence:slide";
    ConfluenceATIs["EMBED"] = "ati:cloud:confluence:embed";
    ConfluenceATIs["FOLDER"] = "ati:cloud:confluence:folder";
    return ConfluenceATIs;
}({});
const $29feb65a99c04950$export$e7960fb7f4252d8 = [
    {
        value: $29feb65a99c04950$export$aad07b8ec9031cb6,
        label: {
            ...(0, $dIdGO.i18n).dateFilterAnyTime
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "today",
        label: {
            ...(0, $dIdGO.i18n).dateFilterToday
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "yesterday",
        label: {
            ...(0, $dIdGO.i18n).dateFilterYesterday
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "past7Days",
        label: {
            ...(0, $dIdGO.i18n).dateFilterLastWeek
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "past30Days",
        label: {
            ...(0, $dIdGO.i18n).dateFilterLastMonth
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "pastYear",
        label: {
            ...(0, $dIdGO.i18n).dateFilterLastYear
        },
        isSelected: false,
        optionId: "lastModified"
    },
    {
        value: "custom",
        label: {
            ...(0, $dIdGO.i18n).dateFilterCustom
        },
        isSelected: false,
        optionId: "lastModified"
    }
];
const $29feb65a99c04950$export$dbdd99aa72455639 = {
    label: {
        ...(0, $dIdGO.i18n).searchFilterTitle
    },
    value: 'title',
    isSelected: false
};
const $29feb65a99c04950$export$2f0eb3386fd9fe47 = {
    label: {
        ...(0, $dIdGO.i18n).searchFilterArchived
    },
    value: 'archived',
    isSelected: false
};
const $29feb65a99c04950$export$9d468108add3ddca = {
    value: '',
    label: '',
    isSelected: false,
    optionId: "to"
};
const $29feb65a99c04950$export$8fcd57e0ace11aa0 = {
    value: '',
    label: '',
    isSelected: false,
    optionId: "from"
};
const $29feb65a99c04950$export$3c7203d4013c68b9 = {
    value: 'verified',
    label: {
        ...(0, $dIdGO.i18n).searchFilterVerified
    },
    isSelected: false
};
const $29feb65a99c04950$export$76f9cf2ec852a055 = {
    ["spaces"]: [],
    ["contributors"]: [],
    ["type"]: [],
    ["date"]: {
        ["lastModified"]: [
            ...$29feb65a99c04950$export$e7960fb7f4252d8
        ],
        ["to"]: $29feb65a99c04950$export$9d468108add3ddca,
        ["from"]: $29feb65a99c04950$export$8fcd57e0ace11aa0
    },
    ["labels"]: [],
    ["verified"]: [
        $29feb65a99c04950$export$3c7203d4013c68b9
    ],
    ["ancestor"]: [],
    ["moreFilters"]: [
        $29feb65a99c04950$export$dbdd99aa72455639,
        $29feb65a99c04950$export$2f0eb3386fd9fe47
    ]
};
module.exports["defaultOptionValue"] = $29feb65a99c04950$export$aad07b8ec9031cb6;
module.exports["CROSSPRODUCT_SEARCH_API"] = $29feb65a99c04950$export$a4c5cde0daa9b961;
module.exports["CONFLUENCE_SEARCH_API"] = $29feb65a99c04950$export$5e8718d49d6c8c22;
module.exports["FilterIds"] = $29feb65a99c04950$export$67bed5d1bc1f6c29;
module.exports["OptionIds"] = $29feb65a99c04950$export$1118b8908e5d0501;
module.exports["PAGE_SIZE"] = $29feb65a99c04950$export$8ec3d08588d2eeda;
module.exports["QUERY_PARAM_ARRAY_SEPARATOR"] = $29feb65a99c04950$export$b014b1b85cc3561;
module.exports["DEFAULT_ENTITIES"] = $29feb65a99c04950$export$c94fdbf59dff15c8;
module.exports["CONFLUENCE_AS_EXPERIENCE"] = $29feb65a99c04950$export$529483abfcf12013;
module.exports["CONFLUENCE_ARI"] = $29feb65a99c04950$export$1f960e9ecae3cb06;
module.exports["CONTEXT_PATH"] = $29feb65a99c04950$export$8c6bf2df244e6a99;
module.exports["CURRENT"] = $29feb65a99c04950$export$eed19b551669af14;
module.exports["ARCHIVED"] = $29feb65a99c04950$export$c936349447a77fe0;
module.exports["INCLUDEARCHIVEDSTATUS"] = $29feb65a99c04950$export$60114111d5b5f818;
module.exports["LastModifiedValues"] = $29feb65a99c04950$export$2a1fb5b806348bf0;
module.exports["ConfluenceATIs"] = $29feb65a99c04950$export$9da7f865fb841394;
module.exports["lastModifiedFilterOptions"] = $29feb65a99c04950$export$e7960fb7f4252d8;
module.exports["titleFilterOption"] = $29feb65a99c04950$export$dbdd99aa72455639;
module.exports["archivedFilterOption"] = $29feb65a99c04950$export$2f0eb3386fd9fe47;
module.exports["toFilterOption"] = $29feb65a99c04950$export$9d468108add3ddca;
module.exports["fromFilterOption"] = $29feb65a99c04950$export$8fcd57e0ace11aa0;
module.exports["verifiedOption"] = $29feb65a99c04950$export$3c7203d4013c68b9;
module.exports["defaultFilterState"] = $29feb65a99c04950$export$76f9cf2ec852a055;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_baseNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac59572d5177720dc1f7db0f6832687d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_baseNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("gElAV")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_baseNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_baseNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("gElAV")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_baseNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("ghRmG"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("ghRmG", function(module, exports) {

let $bdb7a10228ebb3d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bdb7a10228ebb3d5$var$load("ddvkk"),
    $bdb7a10228ebb3d5$var$load("3upHR"),
    $bdb7a10228ebb3d5$var$load("3Pqne"),
    $bdb7a10228ebb3d5$var$load("biEu6"),
    $bdb7a10228ebb3d5$var$load("fiqxC"),
    $bdb7a10228ebb3d5$var$load("6xfz8"),
    $bdb7a10228ebb3d5$var$load("hZ2FX"),
    $bdb7a10228ebb3d5$var$load("6wr18"),
    $bdb7a10228ebb3d5$var$load("ffEVr"),
    $bdb7a10228ebb3d5$var$load("4Ldt2"),
    $bdb7a10228ebb3d5$var$load("kFiBp"),
    $bdb7a10228ebb3d5$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $fqVYq = parcelRequire("fqVYq");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("fGkN6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $zzZbq = parcelRequire("zzZbq");


var $hMFmW = parcelRequire("hMFmW");


var $7zgzO = parcelRequire("7zgzO");


var $bQm3c = parcelRequire("bQm3c");


var $1mK5P = parcelRequire("1mK5P");





var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<f02e27ae015f5657b8ba41dbe57ff82a>>
 * @relayHash bd8827c7edc6a48b50d686c3dd8a397e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c375228181f1918e3f386753a2d419e70cd34e5b5203e19f4299029adf5e488
const $5705848849826294$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ancestorId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventTypes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasAncestor"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSpaces"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasUsers"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnon"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKeys"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "alias": "contentTypes",
        "concreteType": "Confluence_cqlMetaData",
        "kind": "LinkedField",
        "name": "cqlMetaData",
        "plural": false,
        "selections": [
            {
                "concreteType": "CQLDisplayableType",
                "kind": "LinkedField",
                "name": "cqlContentTypes",
                "plural": true,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "label"
                    }
                ]
            }
        ]
    }, v14 = [
        {
            "items": [
                {
                    "fields": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "entityIds.0",
                                    "variableName": "userId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "entityIds"
                        },
                        {
                            "kind": "Literal",
                            "name": "entityType",
                            "value": "user"
                        },
                        {
                            "kind": "Literal",
                            "name": "features",
                            "value": [
                                "recommendedSpaces",
                                "recommendedPeople"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input.0"
                }
            ],
            "kind": "ListValue",
            "name": "input"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "entityType"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "kind": "ScalarField",
        "name": "score"
    }, v18 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v20 = {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = [
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "ABSOLUTE"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "path",
                    "storageKey": "path(type:\"ABSOLUTE\")"
                }
            ]
        }
    ], v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "SmartFeaturesUserResult",
                "kind": "LinkedField",
                "name": "result",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    {
                        "concreteType": "SmartUserFeatures",
                        "kind": "LinkedField",
                        "name": "features",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "RecommendedPeopleItem",
                                "kind": "LinkedField",
                                "name": "recommendedPeople",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "concreteType": "AtlassianUser",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v16 /*: any*/ ,
                                            v18 /*: any*/ ,
                                            v20 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUserPhoto",
                                                "kind": "LinkedField",
                                                "name": "photos",
                                                "plural": true,
                                                "selections": [
                                                    v21 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "RecommendedSpaceItem",
                                "kind": "LinkedField",
                                "name": "recommendedSpaces",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "concreteType": "Space",
                                        "kind": "LinkedField",
                                        "name": "space",
                                        "plural": false,
                                        "selections": v22 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SmartFeaturesUserResultResponse"
    }, v24 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "eventTypes",
                            "variableName": "eventTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = [
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "title"
        },
        v12 /*: any*/ 
    ], v27 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluencePage"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceBlogPost"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceWhiteboard"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceDatabase"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v26 /*: any*/ ,
        "type": "ConfluenceEmbed"
    }, v32 = {
        "concreteType": "ActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v33 = {
        "alias": "currentUser",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v18 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v21 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            },
            v20 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v34 = {
        "condition": "hasSpaces",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "spaceKeys",
                        "variableName": "spaceKeys"
                    }
                ],
                "concreteType": "PaginatedSpaceList",
                "kind": "LinkedField",
                "name": "spaces",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": v22 /*: any*/ 
                    }
                ]
            }
        ]
    }, v35 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v36 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v37 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "KnownUser"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "UnknownUser"
    }, v39 = {
        "condition": "hasAncestor",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "ancestorData",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "ancestorId"
                    }
                ],
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "singleContent",
                "plural": false,
                "selections": v26 /*: any*/ 
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v41 = [
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFilterSupplierAdvancedSearchFilterQuery",
            "selections": [
                v13 /*: any*/ ,
                {
                    "condition": "isAnon",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "SmartFeaturesResponse",
                            "kind": "LinkedField",
                            "name": "getSmartFeatures",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Activity",
                            "kind": "LinkedField",
                            "name": "activity",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MyActivity",
                                    "kind": "LinkedField",
                                    "name": "myActivity",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "ActivityConnection",
                                            "kind": "LinkedField",
                                            "name": "all",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityNode",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ActivityObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "object",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                v34 /*: any*/ ,
                {
                    "condition": "hasUsers",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "concreteType": "PaginatedPersonList",
                            "kind": "LinkedField",
                            "name": "confluenceUsers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        v38 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFilterSupplierAdvancedSearchFilterQuery",
            "selections": [
                v13 /*: any*/ ,
                {
                    "condition": "isAnon",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "SmartFeaturesResponse",
                            "kind": "LinkedField",
                            "name": "getSmartFeatures",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v40 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Activity",
                            "kind": "LinkedField",
                            "name": "activity",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MyActivity",
                                    "kind": "LinkedField",
                                    "name": "myActivity",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "ActivityConnection",
                                            "kind": "LinkedField",
                                            "name": "all",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityNode",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ActivityObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "object",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v41 /*: any*/ ,
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v41 /*: any*/ ,
                                                                                    "type": "DevOpsPullRequestDetails"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v41 /*: any*/ ,
                                                                                    "type": "MercuryPortfolio"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                },
                v34 /*: any*/ ,
                {
                    "condition": "hasUsers",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "concreteType": "PaginatedPersonList",
                            "kind": "LinkedField",
                            "name": "confluenceUsers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v40 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        v38 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "bd8827c7edc6a48b50d686c3dd8a397e",
            "id": "2c375228181f1918e3f386753a2d419e70cd34e5b5203e19f4299029adf5e488",
            "metadata": {},
            "name": "useFilterSupplierAdvancedSearchFilterQuery",
            "operationKind": "query",
            "text": "query useFilterSupplierAdvancedSearchFilterQuery($userId:String!,$isAnon:Boolean!,$accountIds:[String],$spaceKeys:[String],$ancestorId:ID,$hasUsers:Boolean!,$hasSpaces:Boolean!,$hasAncestor:Boolean!,$cloudId:ID!,$objectTypes:[String!],$eventTypes:[String!],$first:Int){getSmartFeatures(input:[{entityType:\"user\",entityIds:[$userId],features:[\"recommendedSpaces\",\"recommendedPeople\"]}])@skip(if:$isAnon){results{__typename,entityType,...on SmartFeaturesUserResultResponse{entityType,result{id,features{recommendedPeople{score,user{id,displayName,confluence{accountId},photos{value}}},recommendedSpaces{score,space{id,key,name,icon{path(type:ABSOLUTE)}}}}}}}}\n  activity@skip(if:$isAnon){myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type},...on ConfluenceBlogPost{id,title,type},...on ConfluenceWhiteboard{id,title,type},...on ConfluenceDatabase{id,title,type},...on ConfluenceEmbed{id,title,type},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}}}},pageInfo{hasNextPage}}}}\n  currentUser:confluence_atlassianUser(current:true)@skip(if:$isAnon){id,displayName,photos{value,isPrimary},confluence{accountId}},spaces(spaceKeys:$spaceKeys)@include(if:$hasSpaces){nodes{id,key,name,icon{path(type:ABSOLUTE)}}},confluenceUsers(accountIds:$accountIds)@include(if:$hasUsers){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},contentTypes:cqlMetaData{cqlContentTypes{type,label}},ancestorData:singleContent(id:$ancestorId)@include(if:$hasAncestor){id,title,type}}"
        }
    };
}();
$5705848849826294$var$node.hash = "b20dff9e6f16edd6fd21318454adcbc1";
var $5705848849826294$export$2e2bcd8739ae039 = $5705848849826294$var$node;






var $kSwu1 = parcelRequire("kSwu1");


var $kTGj5 = parcelRequire("kTGj5");





var $95rLf = parcelRequire("95rLf");


var $kDja4 = parcelRequire("kDja4");


var $yuLaV = parcelRequire("yuLaV");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $jMyy4 = parcelRequire("jMyy4");


var $jghB4 = parcelRequire("jghB4");


var $iD4ky = parcelRequire("iD4ky");

/**
 * @generated SignedSource<<20024b220b8a541a9be780307ef83ee2>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $5ed490bb402384d5$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    return ActivitiesObjectType;
}({});
var $5ed490bb402384d5$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["VIEWED"] = "VIEWED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["EDITED"] = "EDITED";
    return ActivityEventType;
}({});
var $5ed490bb402384d5$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["JIRA"] = "JIRA";
    ActivityProduct["JIRA_BUSINESS"] = "JIRA_BUSINESS";
    ActivityProduct["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    ActivityProduct["JIRA_OPS"] = "JIRA_OPS";
    ActivityProduct["JIRA_SERVICE_DESK"] = "JIRA_SERVICE_DESK";
    ActivityProduct["CONFLUENCE"] = "CONFLUENCE";
    return ActivityProduct;
}({});



var $dIdGO = parcelRequire("dIdGO");

const $a104828753d942eb$export$3aa26ca92eac8d26 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useFilterSupplier(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { filters: filters, queryParams: queryParams, setFilters: setFilters, setUpdatedQueryParams: setUpdatedQueryParams } = t0;
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled("whiteboardsEnabled");
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database");
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("slide");
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { contributorsToHydrate: contributorsToHydrate, spacesToHydrate: spacesToHydrate, contributors: contributors, spaces: spaces, lastModified: lastModified, ancestorId: ancestorId, selectedType: selectedType } = (0, $iD4ky.getOptionsToHydrate)(queryParams, filters);
    const filtersAreInParity = (0, $iD4ky.areFiltersConsistent)(filters, [
        ...contributors,
        ...spaces,
        ...lastModified ? [
            lastModified
        ] : []
    ]);
    const typesRequireHydration = filters[(0, $jghB4.FilterIds).TYPE].length <= 1;
    const ancestorRequiresHydration = ancestorId !== "" && filters[(0, $jghB4.FilterIds).ANCESTOR].some((ancestorOption)=>Boolean(ancestorOption.isSelected && ancestorOption.value !== ancestorId));
    const shouldSkipHydration = Boolean(contributorsToHydrate.length + spacesToHydrate.length === 0 && !typesRequireHydration && !ancestorRequiresHydration);
    const objectTypes = [
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).PAGE,
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).EMBED
    ];
    if (isWhiteboardsEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).WHITEBOARD);
    if (isDatabasesEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).DATABASE);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $5705848849826294$export$2e2bcd8739ae039), {
        variables: {
            userId: userId || "",
            isAnon: !userId,
            accountIds: contributorsToHydrate,
            spaceKeys: spacesToHydrate,
            ancestorId: ancestorId,
            hasUsers: userId ? contributorsToHydrate.length > 0 : false,
            hasSpaces: spacesToHydrate.length > 0,
            hasAncestor: ancestorId !== "",
            cloudId: (0, $kTGj5.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            objectTypes: objectTypes.map(String),
            eventTypes: [
                "VIEWED"
            ],
            first: 10
        },
        skip: shouldSkipHydration,
        errorPolicy: "all",
        interopApolloAggClient: true,
        onCompleted: ()=>{
            if (!shouldSkipHydration) {
                const updatedFilters = {
                    ...filters
                };
                updatedFilters[(0, $jghB4.FilterIds).SPACES] = [
                    ...spaceOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...contributorOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).TYPE] = [
                    ...typeOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).ANCESTOR] = [
                    ...ancestorOptions
                ];
                setFilters(updatedFilters);
                if (!filtersAreInParity) setUpdatedQueryParams(updatedFilters);
            }
            if (shouldSkipHydration && !filtersAreInParity) {
                const updatedFilters_0 = {
                    ...(0, $jghB4.defaultFilterState)
                };
                updatedFilters_0[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = [
                    ...filters[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option)=>({
                            ...option,
                            isSelected: lastModified === option.value
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).SPACES] = [
                    ...filters[(0, $jghB4.FilterIds).SPACES].map((option_0)=>({
                            ...option_0,
                            isSelected: !!spaces.includes(option_0.value)
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...filters[(0, $jghB4.FilterIds).CONTRIBUTORS].map((option_1)=>({
                            ...option_1,
                            isSelected: !!contributors.includes(option_1.value)
                        }))
                ];
                setFilters(updatedFilters_0);
            }
        },
        __callerPackage__: "advanced-search"
    });
    if (error) {
        if ((0, $95rLf.isExpectedApolloError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: "Expected GQL error"
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: error
        });
    }
    const defaultTypesFilterOptions = [
        {
            value: "page",
            label: formatMessage((0, $dIdGO.i18n).typePage),
            isSelected: "page" === selectedType
        },
        {
            value: "blogpost",
            label: formatMessage((0, $dIdGO.i18n).typeBlogpost),
            isSelected: "blogpost" === selectedType
        },
        {
            value: "attachment",
            label: formatMessage((0, $dIdGO.i18n).typeAttachment),
            isSelected: "attachment" === selectedType
        },
        {
            value: "space",
            label: formatMessage((0, $dIdGO.i18n).typeSpace),
            isSelected: "space" === selectedType
        },
        {
            value: "comment",
            label: formatMessage((0, $dIdGO.i18n).typeComments),
            isSelected: "comment" === selectedType
        },
        {
            value: "embed",
            label: formatMessage((0, $dIdGO.i18n).typeEmbed),
            isSelected: "embed" === selectedType
        }
    ].concat(isWhiteboardsEnabledAS ? [
        {
            value: "whiteboard",
            label: formatMessage((0, $dIdGO.i18n).typeWhiteboard),
            isSelected: "whiteboard" === selectedType
        }
    ] : []).concat(isDatabasesEnabledAS ? [
        {
            value: "database",
            label: formatMessage((0, $dIdGO.i18n).typeDatabase),
            isSelected: "database" === selectedType
        }
    ] : []).concat(isSlidesEnabledAS ? [
        {
            value: "slide",
            label: formatMessage((0, $dIdGO.i18n).typeSlide),
            isSelected: "slide" === selectedType
        }
    ] : []).concat([
        {
            value: "folder",
            label: formatMessage((0, $dIdGO.i18n).typeFolder),
            isSelected: "folder" === selectedType
        }
    ]);
    const { ancestorOptions: t1, hydratedTypes: hydratedTypes, spaceOptions: t2, contributorOptions: t3 } = (0, $iD4ky.mapDataToOptions)({
        data: data,
        spaces: spaces,
        contributors: contributors,
        contributorsToHydrate: contributorsToHydrate,
        spacesToHydrate: spacesToHydrate,
        selectedType: selectedType,
        defaultTypesFilterOptions: defaultTypesFilterOptions,
        isWhiteboardsEnabledAS: isWhiteboardsEnabledAS,
        isDatabasesEnabledAS: isDatabasesEnabledAS,
        isSlidesEnabledAS: isSlidesEnabledAS,
        userId: userId
    });
    const ancestorOptions = t1;
    const spaceOptions = t2;
    const contributorOptions = t3;
    const typeOptions = [
        ...defaultTypesFilterOptions,
        ...hydratedTypes
    ];
    let t4;
    if ($[0] !== ancestorOptions || $[1] !== contributorOptions || $[2] !== loading || $[3] !== spaceOptions || $[4] !== typeOptions) {
        t4 = {
            loading: loading,
            spaceOptions: spaceOptions,
            contributorOptions: contributorOptions,
            typeOptions: typeOptions,
            ancestorOptions: ancestorOptions
        };
        $[0] = ancestorOptions;
        $[1] = contributorOptions;
        $[2] = loading;
        $[3] = spaceOptions;
        $[4] = typeOptions;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function useFilterSupplier({ filters: filters, queryParams: queryParams, setFilters: setFilters, setUpdatedQueryParams: setUpdatedQueryParams }) {
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabledAS = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isDatabasesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabledAS = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { contributorsToHydrate: contributorsToHydrate, spacesToHydrate: spacesToHydrate, contributors: contributors, spaces: spaces, lastModified: lastModified, ancestorId: ancestorId, selectedType: selectedType } = (0, $iD4ky.getOptionsToHydrate)(queryParams, filters);
    const filtersAreInParity = (0, $iD4ky.areFiltersConsistent)(filters, [
        ...contributors,
        ...spaces,
        ...lastModified ? [
            lastModified
        ] : []
    ]);
    const typesRequireHydration = filters[(0, $jghB4.FilterIds).TYPE].length <= 1;
    const ancestorRequiresHydration = ancestorId !== '' && filters[(0, $jghB4.FilterIds).ANCESTOR].some((ancestorOption)=>Boolean(ancestorOption.isSelected && ancestorOption.value !== ancestorId));
    const shouldSkipHydration = Boolean(contributorsToHydrate.length + spacesToHydrate.length === 0 && !typesRequireHydration && !ancestorRequiresHydration);
    const objectTypes = [
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).PAGE,
        (0, $5ed490bb402384d5$export$4edf00fad4b97379).EMBED
    ];
    if (isWhiteboardsEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).WHITEBOARD);
    if (isDatabasesEnabledAS) objectTypes.push((0, $5ed490bb402384d5$export$4edf00fad4b97379).DATABASE);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $5705848849826294$export$2e2bcd8739ae039), {
        variables: {
            userId: userId || '',
            isAnon: !userId,
            accountIds: contributorsToHydrate,
            spaceKeys: spacesToHydrate,
            ancestorId: ancestorId,
            hasUsers: userId ? contributorsToHydrate.length > 0 : false,
            hasSpaces: spacesToHydrate.length > 0,
            hasAncestor: ancestorId !== '',
            cloudId: (0, $kTGj5.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            objectTypes: objectTypes.map(String),
            eventTypes: [
                'VIEWED'
            ],
            first: 10
        },
        skip: shouldSkipHydration,
        errorPolicy: 'all',
        interopApolloAggClient: true,
        onCompleted: ()=>{
            if (!shouldSkipHydration) {
                const updatedFilters = {
                    ...filters
                };
                updatedFilters[(0, $jghB4.FilterIds).SPACES] = [
                    ...spaceOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...contributorOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).TYPE] = [
                    ...typeOptions
                ];
                updatedFilters[(0, $jghB4.FilterIds).ANCESTOR] = [
                    ...ancestorOptions
                ];
                setFilters(updatedFilters);
                if (!filtersAreInParity) setUpdatedQueryParams(updatedFilters);
            }
            if (shouldSkipHydration && !filtersAreInParity) {
                const updatedFilters_0 = {
                    ...(0, $jghB4.defaultFilterState)
                };
                updatedFilters_0[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = [
                    ...filters[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option)=>({
                            ...option,
                            isSelected: lastModified === option.value
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).SPACES] = [
                    ...filters[(0, $jghB4.FilterIds).SPACES].map((option_0)=>({
                            ...option_0,
                            isSelected: !!spaces.includes(option_0.value)
                        }))
                ];
                updatedFilters_0[(0, $jghB4.FilterIds).CONTRIBUTORS] = [
                    ...filters[(0, $jghB4.FilterIds).CONTRIBUTORS].map((option_1)=>({
                            ...option_1,
                            isSelected: !!contributors.includes(option_1.value)
                        }))
                ];
                setFilters(updatedFilters_0);
            }
        },
        __callerPackage__: "advanced-search"
    });
    if (error) {
        if ((0, $95rLf.isExpectedApolloError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
                reason: 'Expected GQL error'
            });
        } else experienceTracker.stopOnError({
            name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
            error: error
        });
    }
    const defaultTypesFilterOptions = [
        {
            value: 'page',
            label: formatMessage((0, $dIdGO.i18n).typePage),
            isSelected: 'page' === selectedType
        },
        {
            value: 'blogpost',
            label: formatMessage((0, $dIdGO.i18n).typeBlogpost),
            isSelected: 'blogpost' === selectedType
        },
        {
            value: 'attachment',
            label: formatMessage((0, $dIdGO.i18n).typeAttachment),
            isSelected: 'attachment' === selectedType
        },
        {
            value: 'space',
            label: formatMessage((0, $dIdGO.i18n).typeSpace),
            isSelected: 'space' === selectedType
        },
        {
            value: 'comment',
            label: formatMessage((0, $dIdGO.i18n).typeComments),
            isSelected: 'comment' === selectedType
        },
        {
            value: 'embed',
            label: formatMessage((0, $dIdGO.i18n).typeEmbed),
            isSelected: 'embed' === selectedType
        }
    ].concat(isWhiteboardsEnabledAS ? [
        {
            value: 'whiteboard',
            label: formatMessage((0, $dIdGO.i18n).typeWhiteboard),
            isSelected: 'whiteboard' === selectedType
        }
    ] : []).concat(isDatabasesEnabledAS ? [
        {
            value: 'database',
            label: formatMessage((0, $dIdGO.i18n).typeDatabase),
            isSelected: 'database' === selectedType
        }
    ] : []).concat(isSlidesEnabledAS ? [
        {
            value: 'slide',
            label: formatMessage((0, $dIdGO.i18n).typeSlide),
            isSelected: 'slide' === selectedType
        }
    ] : []).concat([
        {
            value: 'folder',
            label: formatMessage((0, $dIdGO.i18n).typeFolder),
            isSelected: 'folder' === selectedType
        }
    ]);
    const { ancestorOptions: ancestorOptions, hydratedTypes: hydratedTypes, spaceOptions: spaceOptions, contributorOptions: contributorOptions } = (0, $iD4ky.mapDataToOptions)({
        data: data,
        spaces: spaces,
        contributors: contributors,
        contributorsToHydrate: contributorsToHydrate,
        spacesToHydrate: spacesToHydrate,
        selectedType: selectedType,
        defaultTypesFilterOptions: defaultTypesFilterOptions,
        isWhiteboardsEnabledAS: isWhiteboardsEnabledAS,
        isDatabasesEnabledAS: isDatabasesEnabledAS,
        isSlidesEnabledAS: isSlidesEnabledAS,
        userId: userId
    });
    const typeOptions = [
        ...defaultTypesFilterOptions,
        ...hydratedTypes
    ];
    return {
        loading: loading,
        spaceOptions: spaceOptions,
        contributorOptions: contributorOptions,
        typeOptions: typeOptions,
        ancestorOptions: ancestorOptions
    };
};
























var $8uBwM = parcelRequire("8uBwM");


var $9wGTI = parcelRequire("9wGTI");




const $8d942dc771991e4d$export$bd1c6954a81c5a8a = (0, $3u0dr.isReactCompilerActiveV2)() ? (searchQuery)=>{
    const $ = (0, $bDgLe.c)(13);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { activationId: activationId, cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [queryIntent, setQueryIntent] = (0, $cozmU.useState)((0, $zzZbq.QueryIntent).DEFAULT);
    const [transformedQuery, setTransformedQuery] = (0, $cozmU.useState)("");
    const siteARI = `ari:cloud:confluence::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:confluence:${cloudId}:workspace/${activationId}` : "";
    let t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== isAdminHubAIEnabled || $[2] !== locale || $[3] !== orgId || $[4] !== searchQuery || $[5] !== siteARI || $[6] !== workspaceId) {
        t0 = ()=>{
            if (!searchQuery || !isAdminHubAIEnabled || !(0, $9wGTI.fg)("confluence_advanced_search_query_intent")) return;
            const callGetSmartAnswerRoute = async ()=>{
                setLoading(true);
                await (0, $8uBwM.getSmartAnswerRoute)({
                    query: searchQuery,
                    locale: locale,
                    siteId: siteARI,
                    cloudId: cloudId,
                    orgId: orgId ?? "",
                    workspaceId: workspaceId,
                    product: "confluence",
                    setQueryIntent: setQueryIntent,
                    setTransformedQuery: setTransformedQuery
                });
                setLoading(false);
            };
            callGetSmartAnswerRoute();
        };
        t1 = [
            locale,
            siteARI,
            searchQuery,
            isAdminHubAIEnabled,
            cloudId,
            workspaceId,
            orgId
        ];
        $[0] = cloudId;
        $[1] = isAdminHubAIEnabled;
        $[2] = locale;
        $[3] = orgId;
        $[4] = searchQuery;
        $[5] = siteARI;
        $[6] = workspaceId;
        $[7] = t0;
        $[8] = t1;
    } else {
        t0 = $[7];
        t1 = $[8];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[9] !== loading || $[10] !== queryIntent || $[11] !== transformedQuery) {
        t2 = {
            loading: loading,
            transformedQuery: transformedQuery,
            queryIntent: queryIntent
        };
        $[9] = loading;
        $[10] = queryIntent;
        $[11] = transformedQuery;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : (searchQuery)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { activationId: activationId, cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [queryIntent, setQueryIntent] = (0, $cozmU.useState)((0, $zzZbq.QueryIntent).DEFAULT);
    const [transformedQuery, setTransformedQuery] = (0, $cozmU.useState)('');
    const siteARI = `ari:cloud:confluence::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:confluence:${cloudId}:workspace/${activationId}` : '';
    (0, $cozmU.useEffect)(()=>{
        if (!searchQuery || !isAdminHubAIEnabled || !(0, $9wGTI.fg)('confluence_advanced_search_query_intent')) return;
        const callGetSmartAnswerRoute = async ()=>{
            setLoading(true);
            await (0, $8uBwM.getSmartAnswerRoute)({
                query: searchQuery,
                locale: locale,
                siteId: siteARI,
                cloudId: cloudId,
                orgId: orgId ?? '',
                workspaceId: workspaceId,
                product: 'confluence',
                setQueryIntent: setQueryIntent,
                setTransformedQuery: setTransformedQuery
            });
            setLoading(false);
        };
        callGetSmartAnswerRoute();
    }, [
        locale,
        siteARI,
        searchQuery,
        isAdminHubAIEnabled,
        cloudId,
        workspaceId,
        orgId
    ]);
    return {
        loading: loading,
        transformedQuery: transformedQuery,
        queryIntent: queryIntent
    };
};


const $88423f473bb19836$export$e92004becf463495 = /*#__PURE__*/ (0, $cozmU.createContext)({
    searchQuery: '',
    filters: (0, $jghB4.defaultFilterState),
    cql: undefined,
    queryType: 'AGGQuery',
    isHydrated: false,
    toggleOption: ()=>{},
    updateCustomDateRange: ()=>{},
    resetOptions: ()=>{},
    toggleDateOption: ()=>{},
    resetDateOptions: ()=>{},
    onSearchQueryChange: ()=>{},
    clearFilters: ()=>{},
    sessionHasAppliedFilters: false,
    sessionHasUserInput: false,
    onClickAskAI: ()=>{},
    showSearchAI: false,
    aiTriggeredByAskAI: false,
    aiSearchConfig: undefined
});
const $88423f473bb19836$export$cb42e09961db7f36 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($88423f473bb19836$export$e92004becf463495);
} : ()=>(0, $cozmU.useContext)($88423f473bb19836$export$e92004becf463495);
const $88423f473bb19836$export$720fa7c1ee69c9fc = ({ children: children })=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const [filters, setFilters] = (0, $cozmU.useState)((0, $iD4ky.initializeFilters)(queryParams));
    const setUpdatedQueryParams = (0, $cozmU.useCallback)((updatedFilters)=>{
        const updatedQueryParams = (0, $iD4ky.generateUpdatedQueryParams)(updatedFilters);
        setQueryParams({
            ...updatedQueryParams
        });
    }, [
        setQueryParams
    ]);
    const { loading: loading } = (0, $a104828753d942eb$export$3aa26ca92eac8d26)({
        queryParams: queryParams,
        filters: filters,
        setFilters: setFilters,
        setUpdatedQueryParams: setUpdatedQueryParams
    });
    const cqlQuery = queryParams?.cql;
    const searchQuery = queryParams?.text?.toString() || '';
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const { loading: queryIntentLoading, queryIntent: queryIntent } = (0, $8d942dc771991e4d$export$bd1c6954a81c5a8a)(searchQuery);
    const shouldShowAIAnswer = (0, $cozmU.useCallback)(()=>{
        const isAiAnswerEnabled = queryParams?.aiAnswer === 'true' && searchQuery.length > 0;
        const queryIsQuestion = (0, $hMFmW.isQuestion)({
            locale: locale,
            query: searchQuery
        });
        const isPersonIntent = !queryIntentLoading && queryIntent === (0, $zzZbq.QueryIntent).PERSON && queryParams?.aiAnswer !== 'false';
        return isAiAnswerEnabled || queryIsQuestion || isPersonIntent;
    }, [
        locale,
        queryParams?.aiAnswer,
        searchQuery,
        queryIntentLoading,
        queryIntent
    ]);
    const [showSearchAI, setShowSearchAI] = (0, $cozmU.useState)(shouldShowAIAnswer);
    const [aiTriggeredByAskAI, setAITriggeredByAskAI] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const aiAnswerEnabled = shouldShowAIAnswer();
        setShowSearchAI(aiAnswerEnabled);
    }, [
        shouldShowAIAnswer
    ]);
    const { aiSearchConfig: aiSearchConfig } = (0, $1mK5P.useAISearchSupplier)({});
    const toggleOption = (0, $cozmU.useCallback)(({ filterId: filterId, toggledOption: toggledOption, isMulti: isMulti })=>{
        const updatedFilters_0 = {
            ...filters
        };
        const existingOption = filters[filterId].find((filterOption)=>filterOption?.value === toggledOption?.value);
        if (existingOption) updatedFilters_0[filterId] = updatedFilters_0[filterId].map((option)=>{
            if (option.value === toggledOption.value) return {
                ...option,
                isSelected: !option.isSelected
            };
            return isMulti ? option : {
                ...option,
                isSelected: false
            };
        });
        else {
            const newSelectedOption = {
                ...toggledOption,
                isSelected: true
            };
            updatedFilters_0[filterId] = updatedFilters_0[filterId].map((option_0)=>{
                return isMulti ? option_0 : {
                    ...option_0,
                    isSelected: false
                };
            });
            updatedFilters_0[filterId] = [
                ...updatedFilters_0[filterId],
                newSelectedOption
            ];
        }
        setFilters(updatedFilters_0);
        setUpdatedQueryParams(updatedFilters_0);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const resetDateOptions = (0, $cozmU.useCallback)(()=>{
        const updatedFilters_1 = {
            ...filters
        };
        updatedFilters_1[(0, $jghB4.FilterIds).DATE] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE];
        updatedFilters_1[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option_1)=>({
                ...option_1,
                isSelected: false
            }));
        updatedFilters_1[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM];
        updatedFilters_1[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO];
        setFilters(updatedFilters_1);
        setUpdatedQueryParams(updatedFilters_1);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const toggleDateOption = (0, $cozmU.useCallback)((filterId_0, option_2)=>{
        const { optionId: optionId, value: value } = option_2;
        const updatedFilters_2 = {
            ...filters
        };
        if (optionId === (0, $jghB4.OptionIds).LAST_MODIFIED) updatedFilters_2[filterId_0] = {
            ...updatedFilters_2[filterId_0],
            [(0, $jghB4.OptionIds).LAST_MODIFIED]: updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).LAST_MODIFIED].map((dateOption)=>dateOption.value === value && dateOption.value !== (0, $jghB4.defaultOptionValue) ? {
                    ...dateOption,
                    isSelected: !option_2.isSelected
                } : {
                    ...dateOption,
                    isSelected: false
                }),
            [(0, $jghB4.OptionIds).TO]: {
                ...updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).TO],
                isSelected: value === (0, $jghB4.LastModifiedValues).CUSTOM ? updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).TO].isSelected : false
            },
            [(0, $jghB4.OptionIds).FROM]: {
                ...updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).FROM],
                isSelected: value === (0, $jghB4.LastModifiedValues).CUSTOM ? updatedFilters_2[filterId_0][(0, $jghB4.OptionIds).FROM].isSelected : false
            }
        };
        else updatedFilters_2[filterId_0] = {
            ...updatedFilters_2[filterId_0],
            [`${optionId}`]: {
                ...option_2,
                isSelected: !option_2.isSelected
            }
        };
        setFilters(updatedFilters_2);
        setUpdatedQueryParams(updatedFilters_2);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const updateCustomDateRange = (0, $cozmU.useCallback)((selectedFromOption, selectedToOption)=>{
        const updatedFilters_3 = {
            ...filters
        };
        updatedFilters_3[(0, $jghB4.FilterIds).DATE] = {
            ...updatedFilters_3[(0, $jghB4.FilterIds).DATE],
            [(0, $jghB4.OptionIds).FROM]: {
                ...selectedFromOption,
                isSelected: selectedFromOption.isSelected
            },
            [(0, $jghB4.OptionIds).TO]: {
                ...selectedToOption,
                isSelected: selectedToOption.isSelected
            }
        };
        setFilters(updatedFilters_3);
        setUpdatedQueryParams(updatedFilters_3);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const resetOptions = (0, $cozmU.useCallback)((filterId_1)=>{
        const updatedFilters_4 = {
            ...filters
        };
        updatedFilters_4[filterId_1] = updatedFilters_4[filterId_1].map((option_3)=>{
            return {
                ...option_3,
                isSelected: false
            };
        });
        setFilters(updatedFilters_4);
        setUpdatedQueryParams(updatedFilters_4);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const onSearchQueryChange = (0, $cozmU.useCallback)((newQuery)=>{
        const queryIsQuestion_0 = (0, $hMFmW.isQuestion)({
            locale: locale,
            query: newQuery
        });
        if (queryIsQuestion_0) {
            setShowSearchAI(true);
            setAITriggeredByAskAI(false);
        } else setShowSearchAI(false);
        setQueryParams({
            text: newQuery || undefined
        });
    }, [
        setQueryParams,
        locale
    ]);
    const onClickAskAI = (0, $cozmU.useCallback)((newQuery_0)=>{
        setShowSearchAI(true);
        setAITriggeredByAskAI(true);
        setQueryParams({
            text: newQuery_0
        });
    }, [
        setQueryParams
    ]);
    const clearFilters = (0, $cozmU.useCallback)(()=>{
        const updatedFilters_5 = {
            ...filters
        };
        Object.keys((0, $jghB4.defaultFilterState)).forEach((filterId_2)=>{
            if (filterId_2 === (0, $jghB4.FilterIds).DATE) {
                updatedFilters_5[(0, $jghB4.FilterIds).DATE] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE];
                updatedFilters_5[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].map((option_4)=>({
                        ...option_4,
                        isSelected: false
                    }));
                updatedFilters_5[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).FROM];
                updatedFilters_5[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO] = (0, $jghB4.defaultFilterState)[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).TO];
            } else updatedFilters_5[filterId_2] = filters[filterId_2].map((option_5)=>({
                    ...option_5,
                    isSelected: false
                }));
        });
        setFilters(updatedFilters_5);
        setUpdatedQueryParams(updatedFilters_5);
    }, [
        filters,
        setUpdatedQueryParams
    ]);
    const hasAppliedFilters = (0, $iD4ky.areFiltersSelected)(filters, false);
    const queryType = cqlQuery && !hasAppliedFilters && !searchQuery ? 'CQLQuery' : 'AGGQuery';
    const contextValue = (0, $cozmU.useMemo)(()=>({
            searchQuery: searchQuery,
            filters: filters,
            cql: cqlQuery,
            queryType: queryType,
            isHydrated: !loading,
            onSearchQueryChange: onSearchQueryChange,
            toggleOption: toggleOption,
            resetOptions: resetOptions,
            toggleDateOption: toggleDateOption,
            updateCustomDateRange: updateCustomDateRange,
            resetDateOptions: resetDateOptions,
            clearFilters: clearFilters,
            sessionHasAppliedFilters: hasAppliedFilters,
            sessionHasUserInput: !!searchQuery || (0, $iD4ky.areFiltersSelected)(filters, true),
            onClickAskAI: onClickAskAI,
            showSearchAI: showSearchAI,
            aiTriggeredByAskAI: aiTriggeredByAskAI,
            aiSearchConfig: aiSearchConfig
        }), [
        clearFilters,
        cqlQuery,
        filters,
        loading,
        onSearchQueryChange,
        resetOptions,
        searchQuery,
        toggleDateOption,
        updateCustomDateRange,
        resetDateOptions,
        toggleOption,
        onClickAskAI,
        showSearchAI,
        aiTriggeredByAskAI,
        aiSearchConfig,
        hasAppliedFilters,
        queryType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($88423f473bb19836$export$e92004becf463495.Provider, {
        value: contextValue
    }, children);
};
module.exports["useSearchInputContext"] = $88423f473bb19836$export$cb42e09961db7f36;
module.exports["SearchInputProvider"] = $88423f473bb19836$export$720fa7c1ee69c9fc;

});

parcelRegister("hMFmW", function(module, exports) {
//refer to
//https://hello.atlassian.net/wiki/spaces/CASRAQ/pages/2821410030/Spike+Spec+Basic+Question+Detection+Integration+in+the+FE

var $4yVit = parcelRequire("4yVit");


var $d3Hhb = parcelRequire("d3Hhb");


var $c6z0X = parcelRequire("c6z0X");

const $e85a2d04cee4dc80$export$f72a6b3071a7b2a5 = ({ query: query, locale: locale })=>{
    const language = locale.split('-')[0].toLowerCase();
    const queryWords = query.split(' ');
    const endsWithAQuestionMark = query.endsWith('?');
    const isLanguageWithSpaces = (0, $4yVit.languagesWithSpaces).includes(language);
    const isLanguageWithoutSpaces = (0, $d3Hhb.languagesWithoutSpaces).includes(language);
    const isLanguageSupported = isLanguageWithSpaces || isLanguageWithoutSpaces;
    if (isLanguageSupported && endsWithAQuestionMark && queryWords.length > 1) return true;
    if (isLanguageWithSpaces) {
        const languageQuestionWords = (0, $c6z0X.questionWords)[language];
        return queryWords.some((queryWord)=>languageQuestionWords.includes(queryWord.toLocaleLowerCase(locale))) && queryWords.length > 1;
    }
    if (isLanguageWithoutSpaces) {
        const languageQuestionWords = language === 'zh' ? (0, $c6z0X.questionWords)[locale.toLowerCase()] : (0, $c6z0X.questionWords)[language];
        return languageQuestionWords.some((questionWord)=>query.includes(questionWord)) && query.length > 1;
    }
    return false;
};
module.exports["isQuestion"] = $e85a2d04cee4dc80$export$f72a6b3071a7b2a5;

});

parcelRegister("4yVit", function(module, exports) {
// combined lists below make the complete list of languages we currently support for detection
const $15ccc1249579e754$export$bd2c824c45156b2b = [
    'en',
    'de',
    'ru',
    'fr',
    'pt',
    'cs',
    'el'
];
module.exports["languagesWithSpaces"] = $15ccc1249579e754$export$bd2c824c45156b2b;

});

parcelRegister("d3Hhb", function(module, exports) {
const $b5404fc60f32220e$export$175fffd27b9ba43e = [
    'zh',
    'ja',
    'ko'
];
module.exports["languagesWithoutSpaces"] = $b5404fc60f32220e$export$175fffd27b9ba43e;

});

parcelRegister("c6z0X", function(module, exports) {
const $787bd19dc3188be0$export$6f8f84a4a12a6044 = {
    en: [
        'who',
        'what',
        'when',
        'where',
        'why',
        'is',
        'how',
        'which',
        'do',
        'does',
        'are',
        'can',
        'does',
        'would',
        'will',
        'could',
        'should',
        'did',
        'has',
        'have',
        'was'
    ],
    de: [
        'wer',
        'was',
        'wann',
        'wo',
        'warum',
        'wie',
        'welcher',
        'wieviel'
    ],
    ru: [
        "\u0447\u0442\u043E",
        "\u043A\u043E\u0433\u0434\u0430",
        "\u0433\u0434\u0435",
        "\u043F\u043E\u0447\u0435\u043C\u0443",
        "\u043A\u0430\u043A",
        "\u043A\u0430\u043A\u043E\u0432\u0430",
        "\u043A\u0442\u043E",
        "\u043A\u0430\u043A\u043E\u0439",
        "\u0441\u043A\u043E\u043B\u044C\u043A\u043E",
        "\u0437\u0430\u0447\u0435\u043C",
        "\u043E\u0442\u043A\u0443\u0434\u0430",
        "\u043A\u0443\u0434\u0430"
    ],
    fr: [
        'qui',
        'quoi',
        "o\xf9",
        'quand',
        'pourquoi',
        'comment',
        'combien',
        'lequel',
        'quel',
        'quelle',
        'quels',
        'quelles'
    ],
    pt: [
        'que',
        'quem',
        'onde',
        'quando',
        'como',
        'quanto',
        'qual'
    ],
    cs: [
        'kdo',
        'co',
        'kdy',
        'kde',
        "pro\u010D",
        'jak',
        'kolik',
        "kter\xfd"
    ],
    el: [
        "\u03C4\u03B9",
        "\u03C0\u03BF\u03B9\u03BF\u03C2",
        "\u03C0\u03BF\u03B9\u03B1",
        "\u03C0\u03BF\u03B9\u03BF",
        "\u03C0\u03CC\u03C4\u03B5",
        "\u03C0\u03BF\u03CD",
        "\u03C0\u03CE\u03C2",
        "\u03B3\u03B9\u03B1\u03C4\u03AF",
        "\u03C0\u03CC\u03C3\u03BF"
    ],
    'zh-cn': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-sg': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-hk': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-mo': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-tw': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    ja: [
        "\u4F55",
        "\u306A\u306B",
        "\u8AB0",
        "\u3060\u308C",
        "\u3069\u3053",
        "\u3069\u3046\u3057\u3066",
        "\u3044\u3064",
        "\u3069\u306E",
        "\u3044\u304F\u3064",
        "\u3069\u308C"
    ],
    ko: [
        "\uBB34\uC5C7",
        "\uBB50",
        "\uC5B4\uB514",
        "\uC5B8\uC81C",
        "\uC65C",
        "\uB204\uAD6C",
        "\uC5B4\uB5BB\uAC8C",
        "\uBA87",
        "\uC5B4\uB290"
    ]
};
module.exports["questionWords"] = $787bd19dc3188be0$export$6f8f84a4a12a6044;

});

parcelRegister("1mK5P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aBKty = parcelRequire("aBKty");


var $7XBGk = parcelRequire("7XBGk");


var $hcBeC = parcelRequire("hcBeC");


var $bQm3c = parcelRequire("bQm3c");

const $db4dd28f79880540$export$39f60520d0d25b0e = ({ prequeryBannerEnabled: prequeryBannerEnabled, dismissPrequeryBanner: dismissPrequeryBanner })=>{
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const cloudIdARI = (0, $aBKty.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
    const aiSearchStreamingFunction = (0, $cozmU.useCallback)(({ variables: variables })=>({
            type: (0, $7XBGk.AIAnswerAPIType).STREAM,
            stream: (0, $hcBeC.sainStreamFetchConvoAIService)({
                variables: {
                    ...variables,
                    cloudIdARI: cloudIdARI
                },
                isReadingAids: false
            })
        }), [
        cloudIdARI
    ]);
    return {
        aiSearchConfig: isAdminHubAIEnabled ? {
            aiSearchQueryFunction: aiSearchStreamingFunction,
            prequeryBannerEnabled: prequeryBannerEnabled,
            dismissPrequeryBanner: dismissPrequeryBanner,
            followUpsEnabled: true
        } : undefined
    };
};
module.exports["useAISearchSupplier"] = $db4dd28f79880540$export$39f60520d0d25b0e;

});

parcelRegister("aBKty", function(module, exports) {

var $6EphZ = parcelRequire("6EphZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/site/manifest.ts
var $7b91693551a8064f$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $6EphZ.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $6EphZ.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $7b91693551a8064f$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $7b91693551a8064f$export$82e6693d75ffdd8;

});

parcelRegister("6EphZ", function(module, exports) {
// src/confluence/site/types.ts
var $4d7a18635b736c71$export$9e07499cd8b0bde5 = "confluence", $4d7a18635b736c71$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $4d7a18635b736c71$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $4d7a18635b736c71$export$57b7cabbf31f1f68;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("8uBwM", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $zzZbq = parcelRequire("zzZbq");


var $3fxJ4 = parcelRequire("3fxJ4");

// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $9f6e3ef40e15ea84$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
// temporaray solution for detecting query intent for new smart answers
// TODO: remove this once BE/ML solution is ready for use
function $9f6e3ef40e15ea84$var$detectQueryIntent(query, _cloudId) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $iDrrr.fg)('kd_restrict_jira_issue_query_intent')) return (0, $zzZbq.QueryIntent).JIRA_ISSUE;
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $iDrrr.fg)('kd_restrict_jira_issue_query_intent')) return (0, $zzZbq.QueryIntent).JIRA_ISSUE;
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return (0, $zzZbq.QueryIntent).AGENT;
    return null;
}
const $9f6e3ef40e15ea84$export$af8ff827a7d12c1e = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $zzZbq.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
    };
    try {
        let queryIntent = $9f6e3ef40e15ea84$var$detectQueryIntent(query, cloudId);
        if (queryIntent) setQueryIntent(queryIntent);
        const aggResponse = await (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $3fxJ4.KnowledgeDiscoveryAnswerRouteQuery),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $3fxJ4.ANSWER_ROUTE_OPERATION_NAME),
            cache: {
                ttl: 300000,
                key: query
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        const response = aggResponse?.data?.knowledgeDiscovery.smartAnswersRoute;
        if (!response || response?.__typename === 'QueryError' || Boolean(response?.message)) {
            // If we have a query intent, we can use the original query
            if (queryIntent) {
                if (queryIntent === (0, $zzZbq.QueryIntent).AGENT) {
                    setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
                    return;
                }
                setTransformedQuery(query);
                return;
            }
            const error = new Error(response?.message || 'getSmartAnswerRoute error');
            handleError(error);
            return;
        }
        if (!queryIntent) {
            let beQueryIntent = response.route;
            if (beQueryIntent === (0, $zzZbq.QueryIntent).VISUAL && !(0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search')) beQueryIntent = (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
            if ((beQueryIntent === (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY || beQueryIntent === (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD) && selectedProduct && !$9f6e3ef40e15ea84$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $iDrrr.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) beQueryIntent = (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
            setQueryIntent(beQueryIntent);
        }
        if (queryIntent === (0, $zzZbq.QueryIntent).AGENT) {
            setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
            return;
        }
        setTransformedQuery(response.transformedQuery);
    } catch (error) {
        handleError(error);
    }
};
module.exports["getSmartAnswerRoute"] = $9f6e3ef40e15ea84$export$af8ff827a7d12c1e;

});

parcelRegister("3fxJ4", function(module, exports) {
const $18ca693a3690e788$export$9b6dcba7f888840b = 'KnowledgeDiscoveryAnswerRoute';
const $18ca693a3690e788$export$87415d93715f6028 = `
  query ${$18ca693a3690e788$export$9b6dcba7f888840b}(
    $siteId: String!
    $query: String!
    $locale: String!
    $metadata: KnowledgeDiscoveryMetadata
    $orgId: String
  ) {
    knowledgeDiscovery {
      smartAnswersRoute(
        siteId: $siteId
        query: $query
        locale: $locale
				metadata: $metadata
				orgId: $orgId
      ) {
        __typename
        ... on KnowledgeDiscoverySmartAnswersRoute {
          route
          transformedQuery
        }
        ... on QueryError {
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
module.exports["ANSWER_ROUTE_OPERATION_NAME"] = $18ca693a3690e788$export$9b6dcba7f888840b;
module.exports["KnowledgeDiscoveryAnswerRouteQuery"] = $18ca693a3690e788$export$87415d93715f6028;

});

parcelRegister("dmHCt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");

const $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.ADVANCED_SEARCH_LOAD_KEY)
});
const $39eddf90ec2ee1a9$export$8c056601d31b4cd5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$db955b49fff67969 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$c9bd41426c856cf1 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$b390264dd924c8b1 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.UNIFIED_SEARCH_LOAD_KEY)
});
module.exports["ADVANCED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac;
module.exports["ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$8c056601d31b4cd5;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$db955b49fff67969;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$c9bd41426c856cf1;
module.exports["UNIFIED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$b390264dd924c8b1;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b94r6 = parcelRequire("b94r6");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $b94r6.pageLoad,
    pageSegmentLoad: $b94r6.pageSegmentLoad,
    interaction: $b94r6.interaction,
    custom: $b94r6.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b94r6 = parcelRequire("b94r6");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b94r6.interaction) : (0, $b94r6.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b94r6", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $3L5Pu = parcelRequire("3L5Pu");


var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $01df368966019ba1$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
const $01df368966019ba1$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $01df368966019ba1$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
const $01df368966019ba1$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $01df368966019ba1$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $01df368966019ba1$export$94114666844d5f66;
module.exports["interaction"] = $01df368966019ba1$export$92473e6020ad89b4;
module.exports["custom"] = $01df368966019ba1$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $3PNw6.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("1HFOS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i9pyX = parcelRequire("i9pyX");


var $cc6x1 = parcelRequire("cc6x1");


var $hUO8p = parcelRequire("hUO8p");


var $59jY5 = parcelRequire("59jY5");


var $1xpoY = parcelRequire("1xpoY");

const $35ce488ded4e8412$var$HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $35ce488ded4e8412$var$EXPIRATION_TIME = 86400000;
const $35ce488ded4e8412$export$796c8e9967745d9a = ({ cloudId: cloudId, entities: entities, userId: userId, experience: experience })=>{
    const [searchConfig, setSearchConfig] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!cloudId) return;
        (0, $i9pyX.getSearchConfigV2)({
            cloudId: cloudId,
            userId: userId,
            onlyRefreshIfExpired: true,
            expiration: $35ce488ded4e8412$var$EXPIRATION_TIME
        }).then((result)=>{
            setSearchConfig(result);
        }).catch(()=>{
            // TODO: Error handling with Confluence's sentry client
            setSearchConfig({
                siteMetadata: [],
                resources: [],
                intercomHmac: ''
            });
        });
    }, [
        cloudId,
        userId
    ]);
    return (0, $cozmU.useMemo)(()=>{
        // Do not return dynamic experiments if search config is not loaded
        if (!searchConfig) return {
            backendExperiment: undefined,
            loading: true
        };
        const dynamicExperiments = (0, $cc6x1.dynamicExperimentsSchema).safeParse((0, $1xpoY.default).getStringList('search_platform_layer_functions', [])).data;
        if (!dynamicExperiments) return {
            backendExperiment: undefined,
            loading: false
        };
        const siteMetadata = searchConfig?.siteMetadata.find((metadata)=>metadata.siteId === cloudId);
        const isHello = siteMetadata?.siteId === $35ce488ded4e8412$var$HELLO_CLOUD_ID;
        const productEdition = siteMetadata?.productEdition;
        const productDataRegions = siteMetadata?.productDataRegions;
        const isJiraIssueIndexed = siteMetadata?.isJiraIssueIndexed;
        const requestedEntities = entities.flatMap((entity)=>{
            try {
                const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $59jY5.Ati).parse(entity);
                return [
                    {
                        entity: resourceOwner,
                        subEntity: resourceType.toUpperCase()
                    }
                ];
            } catch  {
                // TODO: Error handling with Confluence's sentry client
                return [];
            }
        });
        const backendExperiment = (0, $hUO8p.mapDynamicExperiments)({
            dynamicExperiments: dynamicExperiments,
            requestedEntities: requestedEntities,
            productEdition: productEdition,
            isHello: isHello,
            productDataRegions: productDataRegions,
            experience: experience,
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed
        });
        return {
            backendExperiment: backendExperiment,
            productEdition: productEdition,
            loading: false
        };
    }, [
        cloudId,
        entities,
        experience,
        searchConfig
    ]);
};
module.exports["useDynamicBackendExperiment"] = $35ce488ded4e8412$export$796c8e9967745d9a;

});

parcelRegister("i9pyX", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $bfpjP = parcelRequire("bfpjP");


var $d9nAp = parcelRequire("d9nAp");

const $c1ab7bf16286d454$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ab7bf16286d454$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ab7bf16286d454$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ab7bf16286d454$export$19524a749d98a458 = 'search-config';
const $c1ab7bf16286d454$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ab7bf16286d454$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch, update: $c1ab7bf16286d454$var$update3pCache } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$44d1e7c4ef26c467
});
const $c1ab7bf16286d454$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ab7bf16286d454$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ab7bf16286d454$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ab7bf16286d454$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ab7bf16286d454$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageFirstPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ab7bf16286d454$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageThirdPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $d9nAp.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $d9nAp.generate3pHash)(userId, cloudId);
    return $c1ab7bf16286d454$var$update3pCache(key.toString(), updater);
};
const $c1ab7bf16286d454$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bfpjP.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ab7bf16286d454$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ab7bf16286d454$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ab7bf16286d454$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ab7bf16286d454$export$46e3d34ee7b8c58a;

});

parcelRegister("bfpjP", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $413fa6e1c2c21add$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $bZF61.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $413fa6e1c2c21add$export$42b67d93e908c9dc;

});

parcelRegister("d9nAp", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $de62146c16c69af1$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $bZF61.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $de62146c16c69af1$export$f80795c7fd0ce9fc;

});

parcelRegister("cacu1", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lLRfG = parcelRequire("lLRfG");


var $dmHCt = parcelRequire("dmHCt");

const $94cd8136f02eb351$export$7999a9defd2c3cf4 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
    }));
const $94cd8136f02eb351$export$f397be5efb2fdcd6 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
            metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
    }));
module.exports["PageLoadEndEvent"] = $94cd8136f02eb351$export$7999a9defd2c3cf4;
module.exports["PageLoadEndEventUnifiedSearch"] = $94cd8136f02eb351$export$f397be5efb2fdcd6;

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $3PNw6 = parcelRequire("3PNw6");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $3PNw6.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("6Igo2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

var $8750f1d1f42354de$exports = {};
$8750f1d1f42354de$exports = new URL("GenericError.ea0db8e6.svg", import.meta.url).toString();


const $455c34b0e24b3e5a$export$815a543a64d7dd5e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_ca0q1b66 _1ekaidpf _1shmidpf",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.loading ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_ca0q1b66 _1ekaidpf _1shmidpf",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.loading ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$91cab4befa1216ba = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkxncg _1e0c1txw _2lx21bp4 _4cvr1h6o _1z97kbql _1qon1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkxncg _1e0c1txw _2lx21bp4 _4cvr1h6o _1z97kbql _1qon1h6o",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$33462456345ed820 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $9aYkv.default)((0, (/*@__PURE__*/$parcel$interopDefault($8750f1d1f42354de$exports))), ")", "url(");
            $[3] = t3;
        } else t3 = $[3];
        let t4;
        if ($[4] !== __cmpls) {
            t4 = {
                ...__cmpls,
                "--_6u6us4": t3
            };
            $[4] = __cmpls;
            $[5] = t4;
        } else t4 = $[5];
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmplp,
            style: t4,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_11q71o12 _1lrw1f51 _1bsb68cl _4t3iplmo",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6u6us4": (0, $9aYkv.default)((0, (/*@__PURE__*/$parcel$interopDefault($8750f1d1f42354de$exports))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q71o12 _1lrw1f51 _1bsb68cl _4t3iplmo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $455c34b0e24b3e5a$export$1c93378887204d45 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $455c34b0e24b3e5a$export$8c06dfd742f74a6f = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_ca0qpxbi",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$ed4dedd23dd2ba7d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.loading ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $455c34b0e24b3e5a$export$3bab0e8c0fc477a3 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3iyly2 _18m915vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4t3iyly2 _18m915vq",
            __cmplp.className
        ])
    });
});
module.exports["SearchResultListContainer"] = $455c34b0e24b3e5a$export$815a543a64d7dd5e;
module.exports["SearchMessagesContainer"] = $455c34b0e24b3e5a$export$91cab4befa1216ba;
module.exports["GenericErrorImage"] = $455c34b0e24b3e5a$export$33462456345ed820;
module.exports["ErrorSuggestionLink"] = $455c34b0e24b3e5a$export$1c93378887204d45;
module.exports["ClearFiltersButtonWrapper"] = $455c34b0e24b3e5a$export$8c06dfd742f74a6f;
module.exports["SearchPaginationContainer"] = $455c34b0e24b3e5a$export$ed4dedd23dd2ba7d;
module.exports["SearchResultListLoadingContainer"] = $455c34b0e24b3e5a$export$3bab0e8c0fc477a3;

});

parcelRegister("8Vm5v", function(module, exports) {
const $332d9bbfd770378f$export$a707596ddc3340c = '---';
const $332d9bbfd770378f$export$5204c4564f8b6d00 = '___';
const $332d9bbfd770378f$export$6e18f540c8c76192 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split('____');
    events.forEach((event)=>{
        const formattedEvent = event?.split('---');
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
module.exports["valueSeparator"] = $332d9bbfd770378f$export$a707596ddc3340c;
module.exports["attributeSeparator"] = $332d9bbfd770378f$export$5204c4564f8b6d00;

});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const localeLanguage = new Intl.Locale(locale).language;
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("6p02T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?/[\]_\-+=`~|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("bmowW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $kSwu1.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("3DisR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $320o0 = parcelRequire("320o0");

const $2785e5028b3f2b25$export$81e857055d3e1f66 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
        color: "var(--ds-icon, #292A2E)",
        ...props
    });
module.exports["QuickSummaryIcon"] = $2785e5028b3f2b25$export$81e857055d3e1f66;

});

parcelRegister("dqROc", function(module, exports) {

let $9c777158ac98bacc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9c777158ac98bacc$var$load("fiqxC"),
    $9c777158ac98bacc$var$load("6xfz8"),
    $9c777158ac98bacc$var$load("ac6oS")
]).then(()=>parcelRequire('bA62P'));

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $krxYo = parcelRequire("krxYo");


var $iITVA = parcelRequire("iITVA");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($iITVA)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $hekY6.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    const setLoaded = (0, $cozmU.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("8WOej", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqehY = parcelRequire("iqehY");


var $9TA3F = parcelRequire("9TA3F");


var $9Jnyo = parcelRequire("9Jnyo");


var $gCdaE = parcelRequire("gCdaE");


var $1kVaD = parcelRequire("1kVaD");


var $67SYT = parcelRequire("67SYT");


var $5t27u = parcelRequire("5t27u");


var $cAa12 = parcelRequire("cAa12");


var $EhIdb = parcelRequire("EhIdb");


var $gCL8n = parcelRequire("gCL8n");


var $1rDre = parcelRequire("1rDre");


var $4C7IM = parcelRequire("4C7IM");


var $8B1YK = parcelRequire("8B1YK");


var $90EXt = parcelRequire("90EXt");


var $aeJll = parcelRequire("aeJll");


var $6lknI = parcelRequire("6lknI");


var $fxeqy = parcelRequire("fxeqy");


var $42Fpa = parcelRequire("42Fpa");


var $eziPO = parcelRequire("eziPO");


var $5Dz6O = parcelRequire("5Dz6O");


var $8If3N = parcelRequire("8If3N");


var $fGSwx = parcelRequire("fGSwx");

const $403c9cfb5b020557$export$c647cb0ee6e282fe = [
    'small',
    'medium'
];
const $403c9cfb5b020557$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($8B1YK))),
            (0, (/*@__PURE__*/$parcel$interopDefault($90EXt)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($EhIdb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gCL8n)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
            (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
            (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
            (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
            (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
        ]
    }
];
const $403c9cfb5b020557$export$724dbd38c6f8ef0 = {
    'application/pdf': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8B1YK))),
        (0, (/*@__PURE__*/$parcel$interopDefault($90EXt)))
    ],
    'image/gif': [
        (0, (/*@__PURE__*/$parcel$interopDefault($EhIdb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCL8n)))
    ],
    'image/jpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
    ],
    'image/png': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
    ],
    'text/xml': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/html': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/css': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/javascript': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/plain': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON,
    'application/zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/x-zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/x-zip-compressed': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/java-archive': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/vnd.ms-excel': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.ms-powerpoint': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/msword': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/x-shockwave-flash': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON
    'video/quicktime': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/x-ms-wma': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'audio/x-ms-wmv': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'video/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/x-pn-realaudio': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'application/vnd.rn-realmedia': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON
    'audio/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'video/x-msvideo': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'video/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'audio/mp3': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    default: [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ]
};
const $403c9cfb5b020557$export$2063a590c0694ba8 = (extensions)=>{
    if (!extensions || !Array.isArray(extensions)) return null;
    const mediaType = extensions.find(({ key: key })=>key === 'mediaType');
    return mediaType ? mediaType.value : null;
};
class $403c9cfb5b020557$export$edc04f92718bbea4 extends (0, $cozmU.PureComponent) {
    render() {
        const { mediaType: mediaType, label: label, size: size } = this.props;
        const iconArray = this.getIconArray();
        const sizeIndex = $403c9cfb5b020557$export$c647cb0ee6e282fe.indexOf(size ?? 'medium') || 0;
        const icon = iconArray[sizeIndex];
        const testId = `attachment-icon-${mediaType?.replace('/', '-') ?? 'unknown'}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(icon, {
            size: // @ts-expect-error FIXME: `size` is not an acceptable prop here
            size,
            label: label,
            testId: testId
        });
    }
    constructor(...args){
        super(...args);
        this.getIconArray = ()=>{
            const { mediaType: mediaType, title: title } = this.props;
            if (mediaType && $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType]) return $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType];
            if (title) {
                const extension = $403c9cfb5b020557$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
                    const matches = extensionMatcher.regexp.exec(title);
                    return !!matches && matches.length > 0;
                });
                if (extension) return extension.icon;
            }
            return $403c9cfb5b020557$export$724dbd38c6f8ef0['default'];
        };
    }
}
module.exports["AttachmentIcon"] = $403c9cfb5b020557$export$edc04f92718bbea4;

});

parcelRegister("iqehY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d695bd348a8c5b11$var$_react = $d695bd348a8c5b11$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $d695bd348a8c5b11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d695bd348a8c5b11$var$Archive16Icon = (props)=>/*#__PURE__*/ $d695bd348a8c5b11$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d695bd348a8c5b11$var$Archive16Icon.displayName = 'Archive16Icon';
var $d695bd348a8c5b11$var$_default = module.exports.default = $d695bd348a8c5b11$var$Archive16Icon;

});

parcelRegister("adk2f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $3cb2d8c9faefdb0f$var$iconStyles = null;
const $3cb2d8c9faefdb0f$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $3cb2d8c9faefdb0f$var$baseHcmStyles = null;
const $3cb2d8c9faefdb0f$var$primaryEqualsSecondaryHcmStyles = null;
const $3cb2d8c9faefdb0f$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $3cb2d8c9faefdb0f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Icon(props) {
    const $ = (0, $bDgLe.c)(24);
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: t0, secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const primaryColor = t0 === undefined ? "currentColor" : t0;
    let t1;
    if ($[0] !== Glyph || $[1] !== dangerouslySetGlyph) {
        t1 = dangerouslySetGlyph ? {
            dangerouslySetInnerHTML: {
                __html: dangerouslySetGlyph
            }
        } : {
            children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
                role: "presentation"
            }) : null
        };
        $[0] = Glyph;
        $[1] = dangerouslySetGlyph;
        $[2] = t1;
    } else t1 = $[2];
    const glyphProps = t1;
    let t2;
    if ($[3] !== height || $[4] !== width) {
        t2 = width && height ? {
            width: width + "px",
            height: height + "px"
        } : null;
        $[3] = height;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    const customDimensions = t2;
    const t3 = `icon-${testId}`;
    const t4 = label ? "img" : undefined;
    const t5 = label ? label : undefined;
    const t6 = label ? undefined : true;
    let t7;
    if ($[6] !== UNSAFE_margin || $[7] !== customDimensions || $[8] !== primaryColor || $[9] !== secondaryColor) {
        t7 = {
            ...customDimensions,
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor,
            margin: UNSAFE_margin
        };
        $[6] = UNSAFE_margin;
        $[7] = customDimensions;
        $[8] = primaryColor;
        $[9] = secondaryColor;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    const t9 = primaryColor === secondaryColor && "_18hbwc43";
    const t10 = secondaryColor === "transparent" && "_4fyi1j28";
    const t11 = size && $3cb2d8c9faefdb0f$var$sizeStyles[size];
    let t12;
    if ($[11] !== t10 || $[12] !== t11 || $[13] !== t9) {
        t12 = (0, $hekY6.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            t9,
            t10,
            t11
        ]);
        $[11] = t10;
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== glyphProps || $[16] !== t12 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t8 || $[22] !== testId) {
        t13 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            "data-vc": t3,
            role: t4,
            "aria-label": t5,
            "aria-hidden": t6,
            style: t8,
            ...glyphProps,
            className: t12
        });
        $[15] = glyphProps;
        $[16] = t12;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = testId;
        $[23] = t13;
    } else t13 = $[23];
    return t13;
} : function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $hekY6.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $3cb2d8c9faefdb0f$var$sizeStyles[size]
        ])
    });
});
var $3cb2d8c9faefdb0f$export$2e2bcd8739ae039 = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;
module.exports["Icon"] = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;

});

parcelRegister("9TA3F", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73453881445d309b$var$_react = $73453881445d309b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $73453881445d309b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73453881445d309b$var$Archive24Icon = (props)=>/*#__PURE__*/ $73453881445d309b$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$73453881445d309b$var$Archive24Icon.displayName = 'Archive24Icon';
var $73453881445d309b$var$_default = module.exports.default = $73453881445d309b$var$Archive24Icon;

});

parcelRegister("9Jnyo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $715a9653e306c98f$var$_react = $715a9653e306c98f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $715a9653e306c98f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $715a9653e306c98f$var$Audio16Icon = (props)=>/*#__PURE__*/ $715a9653e306c98f$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$715a9653e306c98f$var$Audio16Icon.displayName = 'Audio16Icon';
var $715a9653e306c98f$var$_default = module.exports.default = $715a9653e306c98f$var$Audio16Icon;

});

parcelRegister("gCdaE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c18a696825273ec6$var$_react = $c18a696825273ec6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $c18a696825273ec6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c18a696825273ec6$var$Audio24Icon = (props)=>/*#__PURE__*/ $c18a696825273ec6$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c18a696825273ec6$var$Audio24Icon.displayName = 'Audio24Icon';
var $c18a696825273ec6$var$_default = module.exports.default = $c18a696825273ec6$var$Audio24Icon;

});

parcelRegister("1kVaD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0f9401986b2d6c49$var$_react = $0f9401986b2d6c49$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $0f9401986b2d6c49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $0f9401986b2d6c49$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$0f9401986b2d6c49$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $0f9401986b2d6c49$var$_default = module.exports.default = $0f9401986b2d6c49$var$ExcelSpreadsheet16Icon;

});

parcelRegister("67SYT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $475e0ba3e7829a3a$var$_react = $475e0ba3e7829a3a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $475e0ba3e7829a3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $475e0ba3e7829a3a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $475e0ba3e7829a3a$var$_default = module.exports.default = $475e0ba3e7829a3a$var$ExcelSpreadsheet24Icon;

});

parcelRegister("5t27u", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3fb14e1bddde3789$var$_react = $3fb14e1bddde3789$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $3fb14e1bddde3789$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3fb14e1bddde3789$var$Generic16Icon = (props)=>/*#__PURE__*/ $3fb14e1bddde3789$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3fb14e1bddde3789$var$Generic16Icon.displayName = 'Generic16Icon';
var $3fb14e1bddde3789$var$_default = module.exports.default = $3fb14e1bddde3789$var$Generic16Icon;

});

parcelRegister("cAa12", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $92909dc17280e83d$var$_react = $92909dc17280e83d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $92909dc17280e83d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $92909dc17280e83d$var$Generic24Icon = (props)=>/*#__PURE__*/ $92909dc17280e83d$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$92909dc17280e83d$var$Generic24Icon.displayName = 'Generic24Icon';
var $92909dc17280e83d$var$_default = module.exports.default = $92909dc17280e83d$var$Generic24Icon;

});

parcelRegister("EhIdb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $079179cb50a24843$var$_react = $079179cb50a24843$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $079179cb50a24843$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $079179cb50a24843$var$Gif16Icon = (props)=>/*#__PURE__*/ $079179cb50a24843$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m7.042 11.09H7.755a.16.16 0 0 1-.162-.161v-5.34c0-.09.072-.162.162-.162h1.287c.09 0 .163.072.163.163v5.339c0 .09-.073.162-.163.162m2.528 0h-1.288a.16.16 0 0 1-.162-.162v-5.34c0-.09.072-.162.162-.162h3.556c.089 0 .162.072.162.163v1.048c0 .09-.073.162-.162.162h-2.106v.947h1.898c.09 0 .162.073.162.162v1.013c0 .09-.072.162-.162.162h-1.898v1.845c0 .09-.074.162-.162.162m-7.045.097C2.944 11.188 2 10.207 2 8.562v-.641c0-1.597.968-2.588 2.528-2.588 1.544 0 2.291.978 2.349 1.948a.16.16 0 0 1-.162.172H5.463a.16.16 0 0 1-.16-.133c-.066-.367-.368-.595-.786-.595-.74 0-.894.657-.894 1.207v.626c0 .822.312 1.238.929 1.238.59 0 .8-.359.8-.667v-.06h-.77a.16.16 0 0 1-.161-.163v-.915c0-.09.072-.162.162-.162h2.144c.09 0 .162.072.162.162v1.036c0 .997-.62 2.161-2.364 2.161"/></svg>`
    }, props, {
        size: 'small'
    }));
$079179cb50a24843$var$Gif16Icon.displayName = 'Gif16Icon';
var $079179cb50a24843$var$_default = module.exports.default = $079179cb50a24843$var$Gif16Icon;

});

parcelRegister("gCL8n", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1a4c1cb74e7fe66$var$_react = $c1a4c1cb74e7fe66$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $c1a4c1cb74e7fe66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1a4c1cb74e7fe66$var$Gif24Icon = (props)=>/*#__PURE__*/ $c1a4c1cb74e7fe66$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1a4c1cb74e7fe66$var$Gif24Icon.displayName = 'Gif24Icon';
var $c1a4c1cb74e7fe66$var$_default = module.exports.default = $c1a4c1cb74e7fe66$var$Gif24Icon;

});

parcelRegister("1rDre", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $10d6e7acdde4b7aa$var$_react = $10d6e7acdde4b7aa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $10d6e7acdde4b7aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $10d6e7acdde4b7aa$var$Image16Icon = (props)=>/*#__PURE__*/ $10d6e7acdde4b7aa$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$10d6e7acdde4b7aa$var$Image16Icon.displayName = 'Image16Icon';
var $10d6e7acdde4b7aa$var$_default = module.exports.default = $10d6e7acdde4b7aa$var$Image16Icon;

});

parcelRegister("4C7IM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $35c0b35464adb49e$var$_react = $35c0b35464adb49e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $35c0b35464adb49e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $35c0b35464adb49e$var$Image24Icon = (props)=>/*#__PURE__*/ $35c0b35464adb49e$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$35c0b35464adb49e$var$Image24Icon.displayName = 'Image24Icon';
var $35c0b35464adb49e$var$_default = module.exports.default = $35c0b35464adb49e$var$Image24Icon;

});

parcelRegister("8B1YK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6423506162d1ed28$var$_react = $6423506162d1ed28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $6423506162d1ed28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6423506162d1ed28$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $6423506162d1ed28$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$6423506162d1ed28$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $6423506162d1ed28$var$_default = module.exports.default = $6423506162d1ed28$var$PdfDocument16Icon;

});

parcelRegister("90EXt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $01b15a5d4b81fd5c$var$_react = $01b15a5d4b81fd5c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $01b15a5d4b81fd5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01b15a5d4b81fd5c$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $01b15a5d4b81fd5c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$01b15a5d4b81fd5c$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $01b15a5d4b81fd5c$var$_default = module.exports.default = $01b15a5d4b81fd5c$var$PdfDocument24Icon;

});

parcelRegister("aeJll", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $773e626dd1065814$var$_react = $773e626dd1065814$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $773e626dd1065814$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $773e626dd1065814$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $773e626dd1065814$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$773e626dd1065814$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $773e626dd1065814$var$_default = module.exports.default = $773e626dd1065814$var$PowerpointPresentation16Icon;

});

parcelRegister("6lknI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $49e483933a21e023$var$_react = $49e483933a21e023$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $49e483933a21e023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $49e483933a21e023$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $49e483933a21e023$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$49e483933a21e023$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $49e483933a21e023$var$_default = module.exports.default = $49e483933a21e023$var$PowerpointPresentation24Icon;

});

parcelRegister("fxeqy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b4f521093462ae6c$var$_react = $b4f521093462ae6c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $b4f521093462ae6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b4f521093462ae6c$var$SourceCode16Icon = (props)=>/*#__PURE__*/ $b4f521093462ae6c$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm6.639 8.417L4.253 8.1l2.589-2.51a.924.924 0 1 0-1.288-1.328L2.281 7.435a.925.925 0 0 0 0 1.328l3.07 2.976a.925.925 0 1 0 1.288-1.328m7.203-3.173L10.77 4.26a.924.924 0 1 0-1.286 1.33l2.385 2.313-2.588 2.51a.924.924 0 1 0 1.287 1.327l3.274-3.173a.925.925 0 0 0 0-1.328"/></svg>`
    }, props, {
        size: 'small'
    }));
$b4f521093462ae6c$var$SourceCode16Icon.displayName = 'SourceCode16Icon';
var $b4f521093462ae6c$var$_default = module.exports.default = $b4f521093462ae6c$var$SourceCode16Icon;

});

parcelRegister("42Fpa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2f17777bbdd9049a$var$_react = $2f17777bbdd9049a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $2f17777bbdd9049a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f17777bbdd9049a$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2f17777bbdd9049a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2f17777bbdd9049a$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2f17777bbdd9049a$var$_default = module.exports.default = $2f17777bbdd9049a$var$SourceCode24Icon;

});

parcelRegister("eziPO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a9b2f1c15109a71a$var$_react = $a9b2f1c15109a71a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $a9b2f1c15109a71a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9b2f1c15109a71a$var$Video16Icon = (props)=>/*#__PURE__*/ $a9b2f1c15109a71a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$a9b2f1c15109a71a$var$Video16Icon.displayName = 'Video16Icon';
var $a9b2f1c15109a71a$var$_default = module.exports.default = $a9b2f1c15109a71a$var$Video16Icon;

});

parcelRegister("5Dz6O", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $41abd4227f5a613a$var$_react = $41abd4227f5a613a$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $41abd4227f5a613a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $41abd4227f5a613a$var$Video24Icon = (props)=>/*#__PURE__*/ $41abd4227f5a613a$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$41abd4227f5a613a$var$Video24Icon.displayName = 'Video24Icon';
var $41abd4227f5a613a$var$_default = module.exports.default = $41abd4227f5a613a$var$Video24Icon;

});

parcelRegister("8If3N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $657e1d6efd6121d9$var$_react = $657e1d6efd6121d9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $657e1d6efd6121d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $657e1d6efd6121d9$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $657e1d6efd6121d9$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$657e1d6efd6121d9$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $657e1d6efd6121d9$var$_default = module.exports.default = $657e1d6efd6121d9$var$WordDocument16Icon;

});

parcelRegister("fGSwx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b6c5128728f95629$var$_react = $b6c5128728f95629$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $b6c5128728f95629$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b6c5128728f95629$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $b6c5128728f95629$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$b6c5128728f95629$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $b6c5128728f95629$var$_default = module.exports.default = $b6c5128728f95629$var$WordDocument24Icon;

});

parcelRegister("ckNg0", function(module, exports) {

let $8fad8fc1b2f6d092$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8fad8fc1b2f6d092$var$load("5Q3hn").then(()=>parcelRequire('79zMz'));

});

parcelRegister("kdE8o", function(module, exports) {

let $eb842765bea35808$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb842765bea35808$var$load("kaNx1").then(()=>parcelRequire('3pSQ0'));

});

parcelRegister("5wttV", function(module, exports) {
/* ai-topics-card-by-document.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $8tNXq = parcelRequire("8tNXq");


var $lPcf8 = parcelRequire("lPcf8");


var $hXc9i = parcelRequire("hXc9i");


var $fwt1L = parcelRequire("fwt1L");


var $2i5Nf = parcelRequire("2i5Nf");


var $b8eEv = parcelRequire("b8eEv");


var $fqeT5 = parcelRequire("fqeT5");


var $agblG = parcelRequire("agblG");


var $7EwcU = parcelRequire("7EwcU");

const $b889584c91432eb7$var$styles = {
    root: "_2rko12b0 _bfhkhp5a _16qst7xp _19pkpxbi"
};
const $b889584c91432eb7$var$TOPICS_CARD_FEEDBACK_CONTEXT = 'AI topics from topics card in advanced search';
const $b889584c91432eb7$var$documentMap = {
    page: (0, $fwt1L.RelatedEntityType).CONFLUENCE_PAGE,
    blogpost: (0, $fwt1L.RelatedEntityType).CONFLUENCE_BLOGPOST
};
const $b889584c91432eb7$var$AITopicsCardByDocumentComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ documentId: documentId, documentType: documentType, searchQuery: searchQuery, cloudId: cloudId, userId: userId, userName: userName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { aiRelatedTopics: aiRelatedTopics, fetchRelatedTopics: fetchRelatedTopics, showTopics: showTopics, resetTopics: resetTopics } = (0, $7EwcU.useRelatedTopics)();
    const principalEntityType = $b889584c91432eb7$var$documentMap[documentType ?? ''];
    const principalEntityId = documentId ?? '';
    const feedbackAttributes = {
        feedbackContext: $b889584c91432eb7$var$TOPICS_CARD_FEEDBACK_CONTEXT,
        principalEntityId: principalEntityId,
        principalEntityType: principalEntityType
    };
    const userInfo = {
        id: userId,
        name: userName
    };
    const onBadgeClickHandler = (topicId)=>{
        fireAnalyticsEvent((0, $2i5Nf.onRelatedEntityClick)({
            clickedEntityId: topicId,
            clickedEntityType: (0, $fwt1L.RelatedEntityType).TOPIC,
            principalEntityType: principalEntityType,
            principalEntityId: principalEntityId,
            location: 'topicCardAdvancedSearch'
        }));
    };
    (0, $cozmU.useEffect)(()=>{
        if (!principalEntityType || !searchQuery) resetTopics();
        else if (principalEntityType) fetchRelatedTopics({
            entityId: principalEntityId,
            principalEntityType: principalEntityType,
            cloudId: cloudId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        principalEntityType,
        searchQuery,
        resetTopics,
        principalEntityId,
        cloudId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (showTopics) fireAnalyticsEvent((0, $2i5Nf.onSurfaceShown)({
            principalEntityId: principalEntityId,
            principalEntityType: principalEntityType,
            relatedTopics: aiRelatedTopics.map((topic)=>topic.id),
            location: 'topicCardAdvancedSearch'
        }));
    }, [
        showTopics,
        fireAnalyticsEvent,
        principalEntityId,
        principalEntityType,
        aiRelatedTopics
    ]);
    if (!showTopics) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $b889584c91432eb7$var$styles.root,
        testId: "ai-topics-card-by-document"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        padding: "space.200",
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $agblG.messages).ai_topics_card_header_text,
        values: {
            searchQuery: /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
                weight: "bold"
            }, searchQuery)
        }
    }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.100",
        rowSpace: "space.100",
        shouldWrap: true
    }, aiRelatedTopics.map((topic)=>/*#__PURE__*/ $cozmU.createElement((0, $hXc9i.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: `/wiki/topics/${topic.id}`,
            onBadgeClick: ()=>onBadgeClickHandler(topic.id)
        }))), /*#__PURE__*/ $cozmU.createElement((0, $fqeT5.AITopicsSentimentFeedback), {
        attributes: feedbackAttributes,
        prompt: formatMessage((0, $agblG.messages).ai_topics_card_feedback_prompt),
        location: "aiTopicsCardAdvancedSearch",
        userDetails: userInfo
    }))), /*#__PURE__*/ $cozmU.createElement((0, $b8eEv.AITopicsFooter), null));
});
const $b889584c91432eb7$export$dc980e08cd0dec3e = (props)=>/*#__PURE__*/ $cozmU.createElement((0, $lPcf8.ErrorBoundary), null, /*#__PURE__*/ $cozmU.createElement($b889584c91432eb7$var$AITopicsCardByDocumentComponent, props));
module.exports["AITopicsCardByDocument"] = $b889584c91432eb7$export$dc980e08cd0dec3e;

});

parcelRegister("8tNXq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $zzZbq = parcelRequire("zzZbq");

const $a273dd7aa35752e1$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $a273dd7aa35752e1$export$e955abb82869dc84;

});

parcelRegister("b8eEv", function(module, exports) {
/* ai-topics-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $eJGpm = parcelRequire("eJGpm");


var $f9PMs = parcelRequire("f9PMs");


var $agblG = parcelRequire("agblG");

const $a36bc10d6708e026$var$styles = {
    root: "_1rjc1b66 _18zrpxbi _uwhke4h9 _15a5nqa1 _1i531l7x _1e0c1txw _1bah1yb4"
};
const $a36bc10d6708e026$export$5a4b3935f294490b = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $a36bc10d6708e026$var$styles.root,
        testId: "ai-topics-footer"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $eJGpm.default), {
        text: formatMessage((0, $agblG.messages).ai_topics_surface_footer_beta_lozenge),
        isRemovable: false,
        migration_fallback: "lozenge"
    }), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        color: "var(--ds-icon, #292A2E)",
        label: "",
        spacing: "compact",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $agblG.messages).ai_topics_surface_footer_content_may_vary))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $agblG.messages).ai_topics_surface_footer_powered_by_ai)), /*#__PURE__*/ $cozmU.createElement((0, $f9PMs.default), {
        greyed: true
    })));
};
module.exports["AITopicsFooter"] = $a36bc10d6708e026$export$5a4b3935f294490b;

});

parcelRegister("f9PMs", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes

var $cozmU = parcelRequire("cozmU");

const $caf4f92c4dcab1e2$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5 15.3L17.5 18.3",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.5 15.3L6.5 18.3",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.5 10.3L6.5 7.30002",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5 10.3L17.5 7.30002",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.0001 16.8V19.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.00012 12.8L5.00012 12.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.0001 8.80003L12.0001 5.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.0002 12.8L19.0002 12.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$caf4f92c4dcab1e2$export$2e2bcd8739ae039 = $caf4f92c4dcab1e2$export$eaf821108be3620b;
module.exports["default"] = $caf4f92c4dcab1e2$export$2e2bcd8739ae039;

});

parcelRegister("fqeT5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $3hVWe = parcelRequire("3hVWe");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $cTbgg = parcelRequire("cTbgg");


var $zzZbq = parcelRequire("zzZbq");


var $3NZYX = parcelRequire("3NZYX");

const $8b68625a5ff6aada$export$43a172640d082206 = ({ prompt: prompt, attributes: attributes, location: location, userDetails: userDetails })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const onLikeClick = ()=>{
        fireAnalyticsEvent((0, $3NZYX.onSentimentClick)({
            ...attributes,
            sentiment: 'positive',
            location: location
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDislikeClick = ()=>{
        fireAnalyticsEvent((0, $3NZYX.onSentimentClick)({
            ...attributes,
            sentiment: 'negative',
            location: location
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        space: "space.050",
        testId: "ai-topics-sentiment-feedback"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest"
    }, prompt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTbgg.AIFeedbackV2), {
        entrypointId: (0, $zzZbq.FEEDBACK_ENTRYPOINT_ID_TOPICS),
        userDetails: userDetails,
        attributes: attributes,
        attributesWithConsent: {},
        onLikeButtonClickHandler: onLikeClick,
        onDislikeButtonClickHandler: onDislikeClick
    }));
};
module.exports["AITopicsSentimentFeedback"] = $8b68625a5ff6aada$export$43a172640d082206;

});

parcelRegister("cTbgg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2uDbg = parcelRequire("2uDbg");


var $lqtHz = parcelRequire("lqtHz");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $zzZbq = parcelRequire("zzZbq");


var $7P4I0 = parcelRequire("7P4I0");


var $jCFxN = parcelRequire("jCFxN");


var $gZ0x5 = parcelRequire("gZ0x5");


const $36caf53ba4f49a31$var$AkFeedbackCollector = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $36caf53ba4f49a31$var$AkFeedbackFlag = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $36caf53ba4f49a31$export$204772be093f4012 = ({ entrypointId: entrypointId, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, userDetails: userDetails, attributes: attributes, attributesWithConsent: attributesWithConsent = {}, liked: externalLike, customContent: // set like state from the outside
customContent, featureTitle: featureTitle })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [showFeedbackModal, setFeedbackModal] = (0, $cozmU.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const [hasConsent, setConsent] = (0, $cozmU.useState)(false);
    const [liked, setLiked] = (0, $cozmU.useState)(externalLike);
    const feedbackObject = {
        ...attributes,
        ...hasConsent ? attributesWithConsent : {}
    };
    const feedbackContext = Object.entries(feedbackObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $cozmU.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7P4I0.FeedbackButtons), {
        setDisplayFlag: setDisplayFlag,
        setFeedbackModal: setFeedbackModal,
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        liked: liked,
        setLiked: setLiked
    })), showFeedbackModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36caf53ba4f49a31$var$AkFeedbackCollector, {
        locale: locale,
        onClose: ()=>{
            setFeedbackModal(false);
        },
        onSubmit: ()=>{
            setDisplayFlag(true);
        },
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.050"
        }, Object.keys(attributesWithConsent).length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
            label: formatMessage((0, $jCFxN.messages).ai_answer_component_report_consent_checkbox_label),
            onChange: toggleConsentCheckbox,
            isChecked: hasConsent
        }) : undefined, customContent),
        atlassianAccountId: userDetails.id,
        name: userDetails.name,
        entrypointId: entrypointId,
        additionalFields: [
            {
                id: (0, $zzZbq.FEEDBACK_CONTEXT_CF),
                value: feedbackContext
            }
        ],
        feedbackTitle: formatMessage((0, $jCFxN.messages).ai_answer_component_report_modal_title, {
            featureTitle: featureTitle ?? 'Atlassian Intelligence'
        }),
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gZ0x5.AIAnswerReportDescriptionWrapper), null, formatMessage((0, $jCFxN.messages).ai_answer_component_report_summary_label)),
        feedbackGroupLabels: {
            empty: {
                fieldLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_details_label),
                selectOptionLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_empty_option_share_label)
            },
            question: {
                fieldLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_details_label),
                selectOptionLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_relevance_option_label)
            },
            comment: {
                fieldLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_details_label),
                selectOptionLabel: ''
            },
            bug: {
                fieldLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_details_label),
                selectOptionLabel: ''
            },
            suggestion: {
                fieldLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_details_label),
                selectOptionLabel: formatMessage((0, $jCFxN.messages).ai_answer_component_report_other_option_label)
            }
        },
        summaryPlaceholder: formatMessage((0, $jCFxN.messages).ai_answer_component_summary_placeholder_label)
    })) : null, displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36caf53ba4f49a31$var$AkFeedbackFlag, {
        locale: locale,
        description: formatMessage((0, $jCFxN.messages).ai_answer_component_feedback_flag_description)
    }))));
};
module.exports["AIFeedbackV2"] = $36caf53ba4f49a31$export$204772be093f4012;

});

parcelRegister("2uDbg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$var$Checkbox = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ $cozmU.createElement("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ $cozmU.createElement((0, $cAK2R.default), null, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $kbRVk.default), null));
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss
        }, t16, t17, t18);
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $cozmU.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $cozmU.createElement((0, $8c6io.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $cozmU.createElement((0, $cAK2R.default), null, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $kbRVk.default), null)));
}));
$5e9458ef4430c05f$var$Checkbox.displayName = 'Checkbox';
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$var$Checkbox;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $hekY6.default)([
                $ef6550583d45a5c6$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement("g", {
            fillRule: "evenodd"
        }, t3, icon));
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $cozmU.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.rect
        ])
    }), icon));
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_zulp1nu5 _yv0ey09t";
    const t2 = (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz";
    const t3 = isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2";
    const t4 = isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ $cozmU.createElement("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id
        }, children);
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $cozmU.createElement("label", {
        className: (0, $hekY6.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_nd5l11ig _1wpz1h6o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_syaz1tmw _bozgv77o"
            ])
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("7P4I0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");


var $jCFxN = parcelRequire("jCFxN");

const $1246ee19cfc1bb52$var$LikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $1246ee19cfc1bb52$var$ActiveLikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
const $1246ee19cfc1bb52$var$DislikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $1246ee19cfc1bb52$var$ActiveDislikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
const $1246ee19cfc1bb52$export$c633fc044a8b8981 = ({ liked: liked, setLiked: setLiked, setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [likesDisabled, setLikesDisabled] = (0, $cozmU.useState)(false);
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        onLikeButtonClickHandler && onLikeButtonClickHandler(e);
    }, [
        setDisplayFlag,
        setLiked,
        onLikeButtonClickHandler
    ]);
    const dislikeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        onDislikeButtonClickHandler && onDislikeButtonClickHandler(e);
    }, [
        setFeedbackModal,
        setLiked,
        onDislikeButtonClickHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: liked === true ? $1246ee19cfc1bb52$var$ActiveLikeIcon : $1246ee19cfc1bb52$var$LikeIcon,
        onClick: likeButtonCallback,
        label: formatMessage((0, $jCFxN.messages).ai_answer_component_like_button_tooltip),
        appearance: "subtle",
        isTooltipDisabled: false,
        isDisabled: liked && likesDisabled,
        testId: "ai-answer-like-button",
        spacing: "compact"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: liked === false ? $1246ee19cfc1bb52$var$ActiveDislikeIcon : $1246ee19cfc1bb52$var$DislikeIcon,
        onClick: dislikeButtonCallback,
        label: formatMessage((0, $jCFxN.messages).ai_answer_component_dislike_button_tooltip),
        appearance: "subtle",
        isTooltipDisabled: false,
        isDisabled: !liked && likesDisabled,
        testId: "ai-answer-dislike-button",
        spacing: "compact"
    }));
};
module.exports["FeedbackButtons"] = $1246ee19cfc1bb52$export$c633fc044a8b8981;

});

parcelRegister("jCFxN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $37d5691a36575327$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {featureTitle}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the response? Let us know what happened."
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    }
});
module.exports["messages"] = $37d5691a36575327$export$defe85febe8b728c;

});

parcelRegister("gZ0x5", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5fcd6871051cc1f3$export$8b91051e793e6316 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_n3tdpxbi",
            __cmplp.className
        ])
    });
});
module.exports["AIAnswerReportDescriptionWrapper"] = $5fcd6871051cc1f3$export$8b91051e793e6316;

});

parcelRegister("hUVfy", function(module, exports) {

let $d0b41348fd61a524$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d0b41348fd61a524$var$load("hhss7"),
    $d0b41348fd61a524$var$load("7gL7H")
]).then(()=>parcelRequire('91uAX'));

});

parcelRegister("3NZYX", function(module, exports) {

var $cuvLu = parcelRequire("cuvLu");

const $d30b14d0df6a9eea$export$c5c4147343613b24 = (sentimentClickAttributes)=>{
    try {
        return {
            action: 'clicked',
            actionSubjectId: 'aiTopic',
            actionSubject: sentimentClickAttributes.sentiment === 'positive' ? 'likeButton' : 'dislikeButton',
            eventType: 'ui',
            attributes: {
                ...sentimentClickAttributes
            }
        };
    } catch (error) {
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'onSentimentClick'
        });
        return {};
    }
};
module.exports["onSentimentClick"] = $d30b14d0df6a9eea$export$c5c4147343613b24;

});

parcelRegister("8vZgd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eiLi2 = parcelRequire("eiLi2");


var $gABt9 = parcelRequire("gABt9");


var $fviYm = parcelRequire("fviYm");


var $7IVDd = parcelRequire("7IVDd");


var $13XKD = parcelRequire("13XKD");


var $7M6bX = parcelRequire("7M6bX");


var $eWfIw = parcelRequire("eWfIw");


var $lEmcH = parcelRequire("lEmcH");


var $dIM8m = parcelRequire("dIM8m");


var $e5W8z = parcelRequire("e5W8z");


var $2jVpk = parcelRequire("2jVpk");


var $ckHIF = parcelRequire("ckHIF");

const $fa8da1c80064cad5$export$67c8b43f41ede17a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { label: label, onClick: onClick, corrections: corrections } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fviYm.TextLabelWrapper), null, label, ": ");
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== corrections) {
        let t3;
        if ($[4] !== corrections.length) {
            t3 = (t4, index)=>{
                const { distance: distance, term: term } = t4;
                const space = index === corrections.length - 1 ? "" : " ";
                if (distance === 0) return term.concat(space);
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, term), space);
            };
            $[4] = corrections.length;
            $[5] = t3;
        } else t3 = $[5];
        t2 = corrections.map(t3);
        $[2] = corrections;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[6] !== onClick || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7IVDd.TextCorrectionWrapper), {
            onClick: onClick
        }, t2);
        $[6] = onClick;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t1, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ label: label, onClick: onClick, corrections: corrections })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fviYm.TextLabelWrapper), null, label, ": "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7IVDd.TextCorrectionWrapper), {
        onClick: onClick
    }, corrections.map(({ distance: distance, term: term }, index)=>{
        const space = index === corrections.length - 1 ? '' : ' ';
        if (distance === 0) return term.concat(space);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, term), space);
    })));
};
const $fa8da1c80064cad5$var$AutocorrectionComponent = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, query: query, label: label, lang: lang, onCorrectionSelect: onCorrectionSelect, source: source = '', searchSessionId: searchSessionId = '', productId: productId = '', debounce: debounce = (0, $ckHIF.DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS), noCorrectionPlaceholder: noCorrectionPlaceholder })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7M6bX.useAnalytics)();
    const [corrections, setCorrections] = (0, $cozmU.useState)([]);
    const correction = corrections.map((word)=>word.term).join(' ');
    const shouldFetchCorrections = (0, $2jVpk.shouldFetchAutocorrection)(query);
    const getCorrection = (0, $cozmU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($eiLi2)))((query_0)=>{
        return (0, $gABt9.utils).requestService({
            url: aggregatorUrl
        }, {
            path: `${(0, $ckHIF.AUTOCORRECT_API_PATH)}`,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query: query_0,
                    language: lang,
                    cloudId: cloudId
                })
            }
        });
    }, debounce)).current;
    const onClick = (0, $cozmU.useCallback)(()=>{
        setCorrections([]);
        onCorrectionSelect(correction);
        fireAnalyticsEvent((0, $lEmcH.onAutocorrectClicked)({
            source: source,
            attributes: {
                searchSessionId: searchSessionId,
                correctionHash: (0, $eWfIw.sha256Hash)(correction),
                language: lang,
                productId: productId
            }
        }));
    }, [
        onCorrectionSelect,
        correction,
        fireAnalyticsEvent,
        lang,
        productId,
        searchSessionId,
        source
    ]);
    (0, $cozmU.useEffect)(()=>{
        setCorrections([]);
        if (shouldFetchCorrections) getCorrection(query).then((result)=>{
            if (!!result.termCorrections) setCorrections(result.termCorrections);
        });
    }, [
        shouldFetchCorrections,
        query,
        getCorrection
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (corrections.length > 0 && shouldFetchCorrections) fireAnalyticsEvent((0, $lEmcH.onAutocorrectShown)({
            source: source,
            attributes: {
                searchSessionId: searchSessionId,
                correction: (0, $eWfIw.sha256Hash)(correction),
                language: lang,
                productId: productId
            }
        }));
    }, [
        shouldFetchCorrections,
        corrections,
        correction,
        fireAnalyticsEvent,
        lang,
        productId,
        query,
        searchSessionId,
        source
    ]);
    if (corrections.length === 0 || !query) return !!noCorrectionPlaceholder ? noCorrectionPlaceholder : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa8da1c80064cad5$export$67c8b43f41ede17a, {
        label: label,
        onClick: onClick,
        corrections: corrections
    });
};
const $fa8da1c80064cad5$export$20554bfec541828d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    let container;
    let propsLang;
    let rest;
    let t1;
    if ($[0] !== t0) {
        ({ lang: propsLang, aggregatorUrl: t1, container: container, ...rest } = t0);
        $[0] = t0;
        $[1] = container;
        $[2] = propsLang;
        $[3] = rest;
        $[4] = t1;
    } else {
        container = $[1];
        propsLang = $[2];
        rest = $[3];
        t1 = $[4];
    }
    const aggregatorUrl = t1 === undefined ? (0, $dIM8m.AGGREGATOR_URL) : t1;
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[5] !== locale) {
        t2 = (0, $e5W8z.sanitizeLanguage)(locale);
        $[5] = locale;
        $[6] = t2;
    } else t2 = $[6];
    const intlLang = t2;
    const lang = propsLang || intlLang;
    if (!(0, $ckHIF.isSupportedLanguage)(lang)) return null;
    const Wrapper = !!container ? container : $fa8da1c80064cad5$var$_temp;
    let t3;
    if ($[7] !== formatMessage) {
        t3 = formatMessage((0, $13XKD.messages).common_autocorrection_label);
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== aggregatorUrl || $[10] !== lang || $[11] !== rest || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa8da1c80064cad5$var$AutocorrectionComponent, {
            label: t3,
            lang: lang,
            aggregatorUrl: aggregatorUrl,
            ...rest
        });
        $[9] = aggregatorUrl;
        $[10] = lang;
        $[11] = rest;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== Wrapper || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
            "data-testid": "autocorrect-wrapper"
        }, t4);
        $[14] = Wrapper;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ lang: propsLang, aggregatorUrl: aggregatorUrl = (0, $dIM8m.AGGREGATOR_URL), container: container, ...rest })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const intlLang = (0, $e5W8z.sanitizeLanguage)(locale);
    const lang = propsLang || intlLang;
    if (!(0, $ckHIF.isSupportedLanguage)(lang)) return null;
    const Wrapper = !!container ? container : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        "data-testid": "autocorrect-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fa8da1c80064cad5$var$AutocorrectionComponent, {
        label: formatMessage((0, $13XKD.messages).common_autocorrection_label),
        lang: lang,
        aggregatorUrl: aggregatorUrl,
        ...rest
    }));
};
function $fa8da1c80064cad5$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props);
}
module.exports["AutocorrectionText"] = $fa8da1c80064cad5$export$67c8b43f41ede17a;
module.exports["Autocorrection"] = $fa8da1c80064cad5$export$20554bfec541828d;

});

parcelRegister("eiLi2", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $a6976de9968040b3$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $a6976de9968040b3$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $a6976de9968040b3$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $a6976de9968040b3$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("fviYm", function(module, exports) {
// eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $c8XQL = parcelRequire("c8XQL");

function $8d17b52051058b8b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d17b52051058b8b$export$379a552b6c4d77e1 = /*#__PURE__*/ (0, $c8XQL.default)("span", {
    target: "e2gsb010"
})({
    name: "9gup9y",
    styles: "color:var(--ds-text-accent-red, #AE2E24);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
module.exports["TextLabelWrapper"] = $8d17b52051058b8b$export$379a552b6c4d77e1;

});

parcelRegister("c8XQL", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lOiVq = parcelRequire("lOiVq");


var $fp2Bc = parcelRequire("fp2Bc");


var $gE1ec = parcelRequire("gE1ec");


var $lxV8r = parcelRequire("lxV8r");


var $cozmU = parcelRequire("cozmU");


var $ifF9E = parcelRequire("ifF9E");

var $8d74a858e0464007$var$isDevelopment = false;
var $8d74a858e0464007$var$testOmitPropsOnStringTag = (0, $ifF9E.default);
var $8d74a858e0464007$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8d74a858e0464007$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8d74a858e0464007$var$testOmitPropsOnStringTag : $8d74a858e0464007$var$testOmitPropsOnComponent;
};
var $8d74a858e0464007$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8d74a858e0464007$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lxV8r.registerStyles)(cache, serialized, isStringTag);
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lxV8r.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8d74a858e0464007$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8d74a858e0464007$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8d74a858e0464007$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $lOiVq.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $cozmU.useContext((0, $lOiVq.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fp2Bc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8d74a858e0464007$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($8d74a858e0464007$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $cozmU.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $8d74a858e0464007$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eb3ax.default)({}, options, nextOptions, {
                shouldForwardProp: $8d74a858e0464007$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $8d74a858e0464007$export$2e2bcd8739ae039;

});

parcelRegister("gE1ec", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c1e155a1b94f67fa$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c1e155a1b94f67fa$var$useInsertionEffect = $cozmU.useInsertionEffect ? $cozmU.useInsertionEffect : false;
var $c1e155a1b94f67fa$export$db21c7ffa21794e7 = $c1e155a1b94f67fa$var$useInsertionEffect || $c1e155a1b94f67fa$var$syncFallback;
var $c1e155a1b94f67fa$export$811a713a7276cb9d = $c1e155a1b94f67fa$var$useInsertionEffect || $cozmU.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $c1e155a1b94f67fa$export$db21c7ffa21794e7;
module.exports["useInsertionEffectWithLayoutFallback"] = $c1e155a1b94f67fa$export$811a713a7276cb9d;

});

parcelRegister("ifF9E", function(module, exports) {

var $e8eWN = parcelRequire("e8eWN");

// eslint-disable-next-line no-undef
var $d4998d3150d9a680$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d4998d3150d9a680$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $e8eWN.default)(function(prop) {
    return $d4998d3150d9a680$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $d4998d3150d9a680$export$2e2bcd8739ae039;

});

parcelRegister("7IVDd", function(module, exports) {
// eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $c8XQL = parcelRequire("c8XQL");

function $e828f48df03f1e85$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e828f48df03f1e85$export$98340ed1d0e44a86 = /*#__PURE__*/ (0, $c8XQL.default)("a", {
    target: "e1wannzz0"
})({
    name: "10s0jjn",
    styles: "cursor:pointer;color:var(--ds-text-accent-blue, #1558BC);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
module.exports["TextCorrectionWrapper"] = $e828f48df03f1e85$export$98340ed1d0e44a86;

});

parcelRegister("13XKD", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $kSwu1 = parcelRequire("kSwu1");

const $998ad8a31a9bf936$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    /**
   * Product-agnostic messages
   */ common_updated_date_formatter: {
        id: "product_search_dialog.updated_date_formatter",
        defaultMessage: "Updated {date}"
    },
    common_recently_viewed_section_heading: {
        id: "product_search_dialog.recently_viewed_section_heading",
        defaultMessage: "Recently viewed"
    },
    common_recently_spaces_section_heading: {
        id: "product_search_dialog.recent_spaces_section_heading",
        defaultMessage: "Recent spaces"
    },
    common_recently_worked_with_section_heading: {
        id: "product_search_dialog.recently_worked_with_section_heading",
        defaultMessage: "Recently worked with"
    },
    common_error_state_failed_search_heading: {
        id: "product_search_dialog.error.failed_loading_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    common_error_state_failed_search_body: {
        id: "product_search_dialog.error.failed_loading_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>"
    },
    common_empty_state_heading: {
        id: "product_search_dialog.empty.no_results_heading",
        defaultMessage: "We couldn't find anything matching your search."
    },
    common_empty_state_prequery_heading: {
        id: "product_search_dialog.empty_prequery.no_results_heading",
        defaultMessage: "Search for what you need"
    },
    common_error_state_prequery_heading: {
        id: "product_search_dialog.empty_prequery.error_heading",
        defaultMessage: "Something went wrong with showing initial results"
    },
    common_show_more_results_link: {
        id: "product_search_dialog.show_more_results_link",
        defaultMessage: "Show more"
    },
    common_show_all_results_link: {
        id: "product_search_dialog.show_all_results_link",
        defaultMessage: "View all results"
    },
    common_search_people_link: {
        id: "product_search_dialog.search_people_link",
        defaultMessage: "Search people"
    },
    common_search_input_collapsed_placeholder: {
        id: "product_search_dialog.search_input_collapsed_placeholder",
        defaultMessage: "Search"
    },
    common_search_input_aria_label: {
        id: "product_search_dialog.search_input_aria_label",
        defaultMessage: "Search, press enter to navigate to advanced search with your text query"
    },
    common_search_input_enlarged_aria_label: {
        id: "product_search_dialog.search_input_enlarged_aria_label",
        defaultMessage: "Press enter to navigate to advanced search"
    },
    common_empty_state_body: {
        id: "product_search_dialog.empty.no_results_body",
        defaultMessage: "Try again with a different term, or refine your results with <a>Advanced Search</a>"
    },
    common_empty_state_body_no_advanced_search: {
        id: "product_search_dialog.empty.no_results_body_with_no_advanced_search",
        defaultMessage: "Try again with a different term."
    },
    common_give_feedback: {
        id: "product_search_dialog.give_feedback",
        defaultMessage: "Give feedback"
    },
    common_inline_onboarding_title: {
        id: "product_search_dialog.inline_onboarding_title",
        defaultMessage: "Search across Jira and Confluence"
    },
    common_inline_onboarding_body: {
        id: "product_search_dialog.inline_onboarding_body",
        defaultMessage: "Use the Jira and Confluence tabs to search and see recent items in either location."
    },
    common_inline_onboarding_action: {
        id: "product_search_dialog.inline_onboarding_action",
        defaultMessage: "Ok"
    },
    common_search_input_exit_button_label: {
        id: "search_dialog.search_input_exit_label",
        defaultMessage: "Exit Search"
    },
    common_search_input_clear_button_label: {
        id: "search_dialog.search_input_clear_label",
        defaultMessage: "Clear search session"
    },
    multi_site_advanced_search_label: {
        id: "product_search_dialog.multi_site_advanced_search_label",
        defaultMessage: "Search on:"
    },
    multi_site_advanced_search_more_dropdown: {
        id: "product_search_dialog.multi_site_advanced_search_more_dropdown",
        defaultMessage: "{count} more"
    },
    common_autocorrection_label: {
        id: "product_search_dialog.autocorrection.label",
        defaultMessage: "Did you mean"
    },
    /**
   * Cross product
   */ jira_tab_label: {
        id: "cross_product_search_dialog.jira.tab_label",
        defaultMessage: "Jira"
    },
    confluence_tab_label: {
        id: "cross_product_search_dialog.confluence.tab_label",
        defaultMessage: "Confluence"
    },
    atlas_tab_label: {
        id: "cross_product_search_dialog.atlas.tab_label",
        defaultMessage: "Atlas"
    },
    bitbucket_tab_label: {
        id: "cross_product_search_dialog.bitbucket.tab_label",
        defaultMessage: "Bitbucket"
    },
    opsgenie_tab_label: {
        id: "cross_product_search_dialog.opsgenie.tab_label",
        defaultMessage: "Opsgenie"
    },
    trello_tab_label: {
        id: "cross_product_search_dialog.trello.tab_label",
        defaultMessage: "Trello"
    },
    view_all_results_link: {
        id: "cross_product_search_dialog.view_all_results_link",
        defaultMessage: "View all {sectionTitle}"
    },
    recently_viewed_title: {
        id: "cross_product_search_dialog.recently_viewed_title",
        defaultMessage: "Recently Viewed {sectionTitle}"
    },
    /**
   * Common Confluence Messages
   */ confluence_people_section_heading: {
        id: "product_search_dialog.confluence.people_section_heading",
        defaultMessage: "People"
    },
    confluence_content_section_heading: {
        id: "product_search_dialog.confluence.content_section_heading",
        defaultMessage: "Content"
    },
    confluence_spaces_section_heading: {
        id: "product_search_dialog.confluence.spaces_section_heading",
        defaultMessage: "Spaces"
    },
    confluence_search_input_expanded_placeholder: {
        id: "product_search_dialog.confluence.search_input_expanded_placeholder",
        defaultMessage: "Search Confluence"
    },
    confluence_search_input_expanded_placeholder_ai: {
        id: "product_search_dialog.confluence.search_input_expanded_placeholder_ai",
        defaultMessage: "Search or ask questions within your Confluence"
    },
    confluence_pages_blogs_attachments_section_heading: {
        id: "product_search_dialog.confluence.pages_blogs_attachments_section_heading",
        defaultMessage: "Pages, blogs and attachments"
    },
    /**
   * Common Filtering Messages
   */ filters_applied: {
        id: "product_search_dialog.confluence.filters_applied",
        defaultMessage: "Looks like you have some filters applied"
    },
    clear_filters: {
        id: "product_search_dialog.confluence.clear_filters",
        defaultMessage: "Clear filters"
    },
    show_more_filters: {
        id: "search_dialog.filters.group.show-more",
        defaultMessage: "Show more"
    },
    more_filters: {
        id: "product_search_dialog.more_filters",
        defaultMessage: "View all filters"
    },
    no_options_filters: {
        id: "product_search_dialog.no_options_filters",
        defaultMessage: "No options"
    },
    loading_filters: {
        id: "product_search_dialog.loading_filters",
        defaultMessage: "Loading"
    },
    site_filters_title: {
        id: "product_search_dialog.common.site_filters",
        defaultMessage: "Filter by site"
    },
    space_filters_title: {
        id: "product_search_dialog.confluence.space_filters",
        defaultMessage: "Filter by space"
    },
    contributor_filters_title: {
        id: "product_search_dialog.confluence.contributor_filters",
        defaultMessage: "Filter by contributor"
    },
    contributor_filters_find_more: {
        id: "product_search_dialog.confluence.contributor_filters_find_more",
        defaultMessage: "Find a contributor"
    },
    space_filters_find_more: {
        id: "product_search_dialog.confluence.space_filters_find_more",
        defaultMessage: "Find a space"
    },
    site_filters_find_more: {
        id: "product_search_dialog.jira.site_filters_find_more",
        defaultMessage: "Find a site"
    },
    project_filters_find_more: {
        id: "product_search_dialog.jira.project_filters_find_more",
        defaultMessage: "Find a project"
    },
    project_filters_title: {
        id: "product_search_dialog.jira.project_filters",
        defaultMessage: "Filter by project"
    },
    assignee_filters_find_more: {
        id: "product_s earch_dialog.confluence.assignee_filters_find_more",
        defaultMessage: "Find an assignee"
    },
    assignee_filters_title: {
        id: "product_search_dialog.jira.assignee_filters",
        defaultMessage: "Filter by assignee"
    },
    binary_status_category_filters_title: {
        id: "product_search_dialog.jira.issue_filters",
        defaultMessage: "Filter by status"
    },
    binary_status_category_filter_option_done: {
        id: "product_search_dialog.jira.issue_filter_done",
        defaultMessage: "Done"
    },
    binary_status_category_filter_option_open: {
        id: "product_search_dialog.jira.issue_filter_open",
        defaultMessage: "Open"
    },
    date_filter_any_time_label: {
        id: "product_search_dialog.jira.date_filter_any",
        defaultMessage: "Any time"
    },
    date_filter_filters_title: {
        id: "product_search_dialog.jira.date_filters",
        defaultMessage: "Last updated"
    },
    /**
   * Common Jira Messages
   */ jira_advanced_search_label: {
        id: "global_search.jira.advanced_search_label",
        defaultMessage: "Go to all:"
    },
    jira_advanced_search_projects: {
        id: "global_search.jira.advanced_search_projects",
        defaultMessage: "Projects"
    },
    jira_advanced_search_boards: {
        id: "global_search.jira.advanced_search_boards",
        defaultMessage: "Boards"
    },
    jira_advanced_search_filters: {
        id: "global_search.jira.advanced_search_filters",
        defaultMessage: "Filters"
    },
    jira_advanced_search_plans: {
        id: "global_search.jira.advanced_search_plans",
        defaultMessage: "Plans"
    },
    jira_advanced_search_people: {
        id: "global_search.jira.advanced_search_people",
        defaultMessage: "People"
    },
    jira_empty_state_prequery_heading: {
        id: "product_search_dialog.jira.empty_prequery.no_results_heading",
        defaultMessage: "Start searching to find your work"
    },
    jira_boards_projects_filters_section_heading: {
        id: "product_search_dialog.jira.boards_projects_filters_section_heading",
        defaultMessage: "Boards, Projects and Filters"
    },
    jira_projects_filters_section_heading: {
        id: "product_search_dialog.jira.projects_filters_section_heading",
        defaultMessage: "Projects and Filters"
    },
    jira_boards_projects_filters_plans_section_heading: {
        id: "product_search_dialog.jira.boards_projects_filters_plans_section_heading",
        defaultMessage: "Boards, Projects, Filters and Plans"
    },
    jira_recent_boards_projects_filters_section_heading: {
        id: "product_search_dialog.jira.recent_boards_projects_filters_section_heading",
        defaultMessage: "Recent Boards, Projects and Filters"
    },
    jira_recent_projects_filters_section_heading: {
        id: "product_search_dialog.jira.recent_projects_filters_section_heading",
        defaultMessage: "Recent Projects and Filters"
    },
    jira_recent_boards_projects_filters_plans_section_heading: {
        id: "product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading",
        defaultMessage: "Recent Boards, Projects, Filters and Plans"
    },
    jira_search_placeholder: {
        id: "global_search.jira.search_placeholder",
        defaultMessage: "Search Jira"
    },
    jira_search_placeholder_experiment_jsw_enabled: {
        id: "global_search.jira.search_placeholder_experiment_jsw_enabled",
        defaultMessage: "Search for issues, boards, projects, and filters"
    },
    jira_advanced_search_issuesIssueTermRefresh: {
        id: "global_search.jira.advanced_search_issues-issue-term-refresh",
        defaultMessage: "Work items"
    },
    jira_issues_section_headingIssueTermRefresh: {
        id: "product_search_dialog.jira.issues_section_heading-issue-term-refresh",
        defaultMessage: "Work items"
    },
    jira_view_all_issues_newIssueTermRefresh: {
        id: "product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh",
        defaultMessage: "View all work items"
    },
    jira_recently_viewed_issues_section_headingIssueTermRefresh: {
        id: "product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh",
        defaultMessage: "Recently viewed work items"
    },
    jira_search_placeholder_experiment_jsw_enabledIssueTermRefresh: {
        id: "global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh",
        defaultMessage: "Search for work items, boards, projects, and filters"
    }
});
module.exports["messages"] = $998ad8a31a9bf936$export$defe85febe8b728c;

});

parcelRegister("7M6bX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $lEmcH = parcelRequire("lEmcH");

const $9e97719c9c5a0bc1$export$e955abb82869dc84 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload).fire((0, $lEmcH.DEFAULT_GAS_CHANNEL));
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = t0;
    let t2;
    if ($[2] !== t1) {
        t2 = {
            fireAnalyticsEvent: t1
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return {
        fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((payload)=>createAnalyticsEvent(payload).fire((0, $lEmcH.DEFAULT_GAS_CHANNEL)), [
            createAnalyticsEvent
        ])
    };
};
module.exports["useAnalytics"] = $9e97719c9c5a0bc1$export$e955abb82869dc84;

});

parcelRegister("lEmcH", function(module, exports) {
/**
 * Note all events fired include the searchSessionId, experiment-id, queryHash, queryVersion, wordCount, resultCount where applicable
 */ const $29d9b68adf75f21c$export$ed78826c06dd24e3 = 'fabric-elements';
const $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE = 'searchDialog';
const $29d9b68adf75f21c$export$b544183e0becb531 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, isRovoCrossProductSearchLink: isRovoCrossProductSearchLink = false })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLink
        }
    };
};
const $29d9b68adf75f21c$export$7d52695c66ad1422 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab })=>{
    return {
        action: 'selected',
        actionSubject: 'askAtlassianIntelligenceLink',
        actionSubjectId: actionSubjectId,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab
        }
    };
};
const $29d9b68adf75f21c$export$19360e9b825e4dfb = ({ actionSubjectId: actionSubjectId, searchSessionId: searchSessionId })=>{
    return {
        action: 'dismissed',
        actionSubject: 'stickySearch',
        actionSubjectId: actionSubjectId,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId
        }
    };
};
const $29d9b68adf75f21c$export$72e9f7dfc882e584 = ()=>{
    return {
        action: 'triggered',
        actionSubject: 'nonDebouncedSearch',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui'
    };
};
const $29d9b68adf75f21c$export$9cb41cdfd7c5452f = ({ timeout: timeout })=>{
    return {
        eventType: 'track',
        action: 'cleared',
        actionSubject: 'stickySearch',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        attributes: {
            timeout: timeout
        }
    };
};
const $29d9b68adf75f21c$export$b4f9d93cc4bd7b82 = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $29d9b68adf75f21c$export$33cdbdfa7f154d6c = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $29d9b68adf75f21c$export$82cfcc46988a9165 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        action: 'show',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $29d9b68adf75f21c$export$c666b7de327a3cc2 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        action: 'shown',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $29d9b68adf75f21c$export$dfba1b0d5d9e4887 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        action: 'clicked',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $29d9b68adf75f21c$export$4b429c3d1a2c2d67 = ({ attributes: attributes })=>({
        eventType: 'operational',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        action: 'failed',
        actionSubject: 'trelloCardRequest',
        attributes: {
            ...attributes
        }
    });
const $29d9b68adf75f21c$export$b87f0592bfac0edc = (sectionId)=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'searchResultViewAllLink',
        attributes: {
            sectionId: sectionId
        }
    });
const $29d9b68adf75f21c$export$62946e9fdc11ae8d = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, destinationId: destinationId, index: index })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            destinationId: destinationId,
            index: index
        }
    };
};
const $29d9b68adf75f21c$export$6c5bd82ba411ffb0 = ({ trigger: trigger, selectedFiltersCount: selectedFiltersCount })=>{
    return {
        action: 'selected',
        actionSubject: 'moreFilterLink',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            selectedFiltersCount: selectedFiltersCount
        }
    };
};
const $29d9b68adf75f21c$export$7816fccc5a0a2fed = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'selected',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$95ef6569b5b2de4a = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'highlighted',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$656ab76fbb25e04 = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'contextMenu opened',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$2d1da932f40a427e = ({ actionSubjectId: actionSubjectId, resultCount: resultCount, sectionCount: sectionCount, results: results, timeToQueryMs: timeToQueryMs, activeProduct: activeProduct, isMultiProduct: isMultiProduct, filters: filters, experimentLayers: experimentLayers })=>{
    return {
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: actionSubjectId,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            resultCount: resultCount,
            sectionCount: sectionCount,
            timeToQueryMs: timeToQueryMs,
            results: results,
            noResultsFetched: !resultCount,
            activeProduct: activeProduct,
            isMultiProduct: isMultiProduct,
            filters: filters,
            backendExperiments: {
                experimentLayers: experimentLayers
            }
        }
    };
};
const $29d9b68adf75f21c$export$db28d8e16fb16e80 = (activeProduct)=>{
    return {
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            activeProduct: activeProduct
        }
    };
};
const $29d9b68adf75f21c$export$3484ea513055aa12 = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showMoreButton',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $29d9b68adf75f21c$export$3fb15ebf22b4884e = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showAllLink',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $29d9b68adf75f21c$export$145f05df248491e5 = ({ searchSessionId: searchSessionId, trigger: trigger })=>{
    return {
        name: 'searchDialogPreQueryScreen',
        eventType: 'screen',
        attributes: {
            searchSessionId: searchSessionId,
            trigger: trigger
        }
    };
};
const $29d9b68adf75f21c$export$93a340bed59d6525 = ({ actionSubjectId: actionSubjectId, timings: timings, activeProduct: activeProduct, isExpanded: isExpanded, isMultiProduct: isMultiProduct, filters: filters, experimentLayers: experimentLayers }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    return {
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: actionSubjectId,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            activeProduct: activeProduct,
            isExpanded: isExpanded,
            isMultiProduct: isMultiProduct,
            filters: filters,
            experimentLayers: experimentLayers,
            ...timings,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $29d9b68adf75f21c$export$a8d299e4bdceb0be = ()=>({
        action: 'shown',
        eventType: 'ui',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: {
            resultCount: 0,
            results: []
        },
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE
    });
const $29d9b68adf75f21c$export$97e12e4b0f216b1d = (activeProduct)=>{
    return {
        action: 'dismissed',
        actionSubject: 'searchDialog',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            activeProduct: activeProduct
        }
    };
};
const $29d9b68adf75f21c$export$e79368bde551c62e = ({ visibleProducts: visibleProducts, visibleTabsCount: visibleTabsCount, isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown, activeProduct: activeProduct })=>{
    return {
        action: 'shown',
        actionSubject: 'searchDialog',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            visibleProducts: visibleProducts,
            visibleTabsCount: visibleTabsCount,
            isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown,
            activeProduct: activeProduct
        }
    };
};
const $29d9b68adf75f21c$export$9e2ba0ae72f48da8 = ({ filterType: filterType })=>{
    return {
        action: 'viewed',
        actionSubject: 'filterField',
        actionSubjectId: 'dropdownMenuFilterField',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $29d9b68adf75f21c$export$151951fdc112763c = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'selected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $29d9b68adf75f21c$export$f448c439d93613dd = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'unselected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $29d9b68adf75f21c$export$2e387d28788cf23b = ({ filterType: filterType })=>{
    return {
        action: 'cleared',
        actionSubject: 'filterField',
        actionSubjectId: 'searchDialogFilterField',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $29d9b68adf75f21c$export$e785b4d14ffa4348 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'searchDialogClearFilters',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$8ba00734f8071933 = (product, duration)=>{
    return {
        action: 'loadComplete',
        actionSubject: 'searchDialogPane',
        actionSubjectId: product,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            durationMs: duration
        }
    };
};
const $29d9b68adf75f21c$export$d9576525adc921c1 = (abTest, experimentRequestDuration, isMultiProduct)=>{
    return {
        action: 'loaded',
        actionSubject: 'experiment',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'operational',
        attributes: {
            abTest: abTest,
            experimentRequestDuration: experimentRequestDuration,
            isMultiProduct: isMultiProduct
        }
    };
};
const $29d9b68adf75f21c$export$1c45c07dd15a8ffa = ()=>{
    return {
        action: 'failed',
        actionSubject: 'experiment',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'operational',
        attributes: {
            error: 'GetBackendExperimentFailed'
        }
    };
};
const $29d9b68adf75f21c$export$cb0c8d6d4bf862f8 = ({ tabName: tabName }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    // this event is fired at the same level as the anlytics context hence it needs mandatory additional objects.
    return {
        action: 'clicked',
        actionSubject: 'tab',
        actionSubjectId: 'crossProductSearchTab',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            tabName: tabName,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $29d9b68adf75f21c$export$e89c96d52a36944 = (authorised, product)=>{
    return {
        action: 'checked',
        actionSubject: 'thirdPartyAuth',
        actionSubjectId: product,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            authorised: authorised
        }
    };
};
const $29d9b68adf75f21c$export$a93c057f87e755b3 = (product)=>{
    return {
        action: 'authorised',
        actionSubject: 'thirdPartyProduct',
        actionSubjectId: product,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $29d9b68adf75f21c$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            ...attributes
        }
    });
const $29d9b68adf75f21c$var$position = (options, value)=>{
    return value ? options.findIndex((option)=>option.id === value.data.id) : -1;
};
const $29d9b68adf75f21c$var$result = (option)=>{
    return option ? $29d9b68adf75f21c$var$optionData2Analytics(option.data) : null;
};
const $29d9b68adf75f21c$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    return {
        id: id ? id : null,
        type: type || null
    };
};
const $29d9b68adf75f21c$var$createDefaultPickerAttributes = (fieldId, collabGraphSessionId)=>({
        context: fieldId,
        isCheckbox: true,
        queryLength: 0,
        collabGraphSessionId: collabGraphSessionId
    });
const $29d9b68adf75f21c$export$48143d759475d90f = (value, options, fieldId, collabGraphSessionId)=>{
    return $29d9b68adf75f21c$var$createEvent('ui', 'clicked', 'userPicker', {
        ...$29d9b68adf75f21c$var$createDefaultPickerAttributes(fieldId, collabGraphSessionId),
        position: $29d9b68adf75f21c$var$position(options, value),
        result: $29d9b68adf75f21c$var$result(value)
    });
};
const $29d9b68adf75f21c$export$73da5bde227e14d8 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'recentSearch',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$1338fc4f37de8396 = ()=>{
    return {
        action: 'shown',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'prequeryBanner',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$e7721900a147b5b2 = (promptId)=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: promptId,
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$889f319cb696bfae = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'dismissButton',
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $29d9b68adf75f21c$export$e98932ab9e22c265 = ({ reason: reason })=>{
    return {
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        action: 'degradedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: 'search-config',
                reason: reason
            }
        }
    };
};
const $29d9b68adf75f21c$export$7199f2d13e6ae9f7 = ()=>{
    return {
        source: $29d9b68adf75f21c$var$BASE_ANALYTICS_SOURCE,
        action: 'failedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: 'search-config'
            }
        }
    };
};
module.exports["DEFAULT_GAS_CHANNEL"] = $29d9b68adf75f21c$export$ed78826c06dd24e3;
module.exports["onAdvancedSearchSelected"] = $29d9b68adf75f21c$export$b544183e0becb531;
module.exports["onXButtonClicked"] = $29d9b68adf75f21c$export$19360e9b825e4dfb;
module.exports["onNonDebouncedSearchTriggered"] = $29d9b68adf75f21c$export$72e9f7dfc882e584;
module.exports["onStickySearchCleared"] = $29d9b68adf75f21c$export$9cb41cdfd7c5452f;
module.exports["onAutocorrectShown"] = $29d9b68adf75f21c$export$b4f9d93cc4bd7b82;
module.exports["onAutocorrectClicked"] = $29d9b68adf75f21c$export$33cdbdfa7f154d6c;
module.exports["onHoverPreviewShow"] = $29d9b68adf75f21c$export$82cfcc46988a9165;
module.exports["onHoverPreviewShown"] = $29d9b68adf75f21c$export$c666b7de327a3cc2;
module.exports["onHoverPreviewClicked"] = $29d9b68adf75f21c$export$dfba1b0d5d9e4887;
module.exports["onCardRequestFailed"] = $29d9b68adf75f21c$export$4b429c3d1a2c2d67;
module.exports["onSearchResultViewAllLinkClicked"] = $29d9b68adf75f21c$export$b87f0592bfac0edc;
module.exports["onMultiSiteAdvancedSearchSelected"] = $29d9b68adf75f21c$export$62946e9fdc11ae8d;
module.exports["onMoreFiltersSelected"] = $29d9b68adf75f21c$export$6c5bd82ba411ffb0;
module.exports["onSearchResultSelected"] = $29d9b68adf75f21c$export$7816fccc5a0a2fed;
module.exports["onSearchResultHighlighted"] = $29d9b68adf75f21c$export$95ef6569b5b2de4a;
module.exports["onSearchResultContext"] = $29d9b68adf75f21c$export$656ab76fbb25e04;
module.exports["onSearchResultsShown"] = $29d9b68adf75f21c$export$2d1da932f40a427e;
module.exports["onTextEntered"] = $29d9b68adf75f21c$export$db28d8e16fb16e80;
module.exports["onPreQueryScreenViewed"] = $29d9b68adf75f21c$export$145f05df248491e5;
module.exports["onRequestMade"] = $29d9b68adf75f21c$export$93a340bed59d6525;
module.exports["onDismissed"] = $29d9b68adf75f21c$export$97e12e4b0f216b1d;
module.exports["onShown"] = $29d9b68adf75f21c$export$e79368bde551c62e;
module.exports["onDropdownMenuFilterView"] = $29d9b68adf75f21c$export$9e2ba0ae72f48da8;
module.exports["onFilterSelect"] = $29d9b68adf75f21c$export$151951fdc112763c;
module.exports["onFilterUnselect"] = $29d9b68adf75f21c$export$f448c439d93613dd;
module.exports["onFilterFieldCleared"] = $29d9b68adf75f21c$export$2e387d28788cf23b;
module.exports["onPaneLoadComplete"] = $29d9b68adf75f21c$export$8ba00734f8071933;
module.exports["onGetBackendExperimentFailed"] = $29d9b68adf75f21c$export$1c45c07dd15a8ffa;
module.exports["onTabSelected"] = $29d9b68adf75f21c$export$cb0c8d6d4bf862f8;
module.exports["selectEvent"] = $29d9b68adf75f21c$export$48143d759475d90f;
module.exports["onPrequeryBannerShown"] = $29d9b68adf75f21c$export$1338fc4f37de8396;
module.exports["onSuggestedPromptClick"] = $29d9b68adf75f21c$export$e7721900a147b5b2;
module.exports["onPrequeryBannerDismiss"] = $29d9b68adf75f21c$export$889f319cb696bfae;

});

parcelRegister("eWfIw", function(module, exports) {

var $eVK28 = parcelRequire("eVK28");

const $4c8146bb3ecdbfc1$export$e9131c78c1110376 = (str)=>(0, $eVK28.sha256)(str);
module.exports["sha256Hash"] = $4c8146bb3ecdbfc1$export$e9131c78c1110376;

});

parcelRegister("dIM8m", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gABt9 = parcelRequire("gABt9");


var $hTYPZ = parcelRequire("hTYPZ");


var $31wMq = parcelRequire("31wMq");

var $92f5d59a1af2d766$var$ProductsFromARI = /*#__PURE__*/ function(ProductsFromARI) {
    ProductsFromARI["JIRA"] = "jira";
    ProductsFromARI["CONFLUENCE"] = "confluence";
    ProductsFromARI["TOWNSQUARE"] = "townsquare";
    return ProductsFromARI;
}($92f5d59a1af2d766$var$ProductsFromARI || {});
const $92f5d59a1af2d766$var$CONFIG_API_URL = '/configuration/v1';
const $92f5d59a1af2d766$export$55ad0abefe643b5f = '/gateway/api/xpsearch-aggregator';
const $92f5d59a1af2d766$var$options = {
    path: $92f5d59a1af2d766$var$CONFIG_API_URL,
    requestInit: {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }
};
const $92f5d59a1af2d766$var$noAccessState = {
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
};
const $92f5d59a1af2d766$var$dedupeEntriesById = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.id === initial.id) === index);
};
const $92f5d59a1af2d766$var$dedupeEntriesByCloudId = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.cloudId === initial.cloudId) === index);
};
const $92f5d59a1af2d766$export$ba14d9a5a581e827 = (response)=>{
    const groupedProducts = response.resources.reduce((acc, resource)=>{
        const { baseUrl: baseUrl, id: ari, siteName: siteName } = resource;
        const { id: id, product: product } = (0, $hTYPZ.parseSiteARI)(ari);
        if (product.includes("jira")) acc.jiraSites && acc.jiraSites.push({
            product: (0, $31wMq.Products).jira,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "confluence") acc.confluenceSites && acc.confluenceSites.push({
            product: (0, $31wMq.Products).confluence,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "townsquare") acc.atlasWorkspaces && acc.atlasWorkspaces.push({
            name: siteName,
            id: id,
            baseUrl: baseUrl
        });
        return acc;
    }, $92f5d59a1af2d766$var$noAccessState);
    return {
        jiraSites: $92f5d59a1af2d766$var$dedupeEntriesByCloudId(groupedProducts.jiraSites),
        confluenceSites: $92f5d59a1af2d766$var$dedupeEntriesByCloudId(groupedProducts.confluenceSites),
        atlasWorkspaces: $92f5d59a1af2d766$var$dedupeEntriesById(groupedProducts.atlasWorkspaces)
    };
};
const $92f5d59a1af2d766$export$16414e90b8f90666 = (props)=>{
    const { aggregatorUrl: aggregatorUrl = `${$92f5d59a1af2d766$export$55ad0abefe643b5f}`, skip: skip = false } = props;
    const [accessibleProducts, setAccessibleProducts] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!skip && accessibleProducts === null) (0, $gABt9.utils).requestService({
            url: aggregatorUrl
        }, $92f5d59a1af2d766$var$options).then((resp)=>{
            setAccessibleProducts($92f5d59a1af2d766$export$ba14d9a5a581e827(resp));
        }).catch((_e)=>{
            setAccessibleProducts($92f5d59a1af2d766$var$noAccessState);
        });
    }, [
        accessibleProducts,
        setAccessibleProducts,
        aggregatorUrl,
        skip
    ]);
    return accessibleProducts;
};
module.exports["AGGREGATOR_URL"] = $92f5d59a1af2d766$export$55ad0abefe643b5f;
module.exports["useSearchConfigClient"] = $92f5d59a1af2d766$export$16414e90b8f90666;

});

parcelRegister("hTYPZ", function(module, exports) {
const $448329d9ca0db71a$var$SITE_ARI_REGEX = new RegExp('ari:cloud:(.+)::site/(.+)');
const $448329d9ca0db71a$export$8837a793ca98a5b5 = (ari)=>{
    if (!ari) return {
        product: '',
        id: ''
    };
    const [_original, product, id] = Array.from(ari.match($448329d9ca0db71a$var$SITE_ARI_REGEX) || [
        '',
        '',
        ''
    ]);
    return {
        product: product,
        id: id
    };
};
module.exports["parseSiteARI"] = $448329d9ca0db71a$export$8837a793ca98a5b5;

});

parcelRegister("31wMq", function(module, exports) {
var $9c30df8503e8e28c$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["other"] = "OTHER";
    return Products;
}({});
module.exports["Products"] = $9c30df8503e8e28c$export$92e44ea1079b9ec6;

});

parcelRegister("e5W8z", function(module, exports) {
const $4d0d2ae629a29b8a$export$2c7172743adddb3f = (locale)=>{
    if (locale.includes('-')) return locale.split('-')[0];
    return locale;
};
module.exports["sanitizeLanguage"] = $4d0d2ae629a29b8a$export$2c7172743adddb3f;

});

parcelRegister("2jVpk", function(module, exports) {
const $3812a454181a616c$export$68b44e0f3b4076e = (query)=>{
    return query.length >= 4;
};
module.exports["shouldFetchAutocorrection"] = $3812a454181a616c$export$68b44e0f3b4076e;

});

parcelRegister("ckHIF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $eiLi2 = parcelRequire("eiLi2");


var $gABt9 = parcelRequire("gABt9");


var $hCs5h = parcelRequire("hCs5h");


var $e5W8z = parcelRequire("e5W8z");

var $eb748d2e55de9d8b$var$SUPPORTED_LANGUAGES = /*#__PURE__*/ function(SUPPORTED_LANGUAGES) {
    SUPPORTED_LANGUAGES["English"] = "en";
    return SUPPORTED_LANGUAGES;
}($eb748d2e55de9d8b$var$SUPPORTED_LANGUAGES || {});
const $eb748d2e55de9d8b$export$9e194549e403d7c0 = 'autocorrect';
const $eb748d2e55de9d8b$export$8cc0d0855105f007 = 250;
const $eb748d2e55de9d8b$export$47c66070d6d6cd6d = (language)=>{
    return Object.values($eb748d2e55de9d8b$var$SUPPORTED_LANGUAGES).includes(language);
};
const $eb748d2e55de9d8b$export$bf742519320d45e9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const lang = (0, $e5W8z.sanitizeLanguage)(locale);
    const { getActiveProduct: getActiveProduct } = (0, $hCs5h.useProductContext)();
    let t0;
    if ($[0] !== getActiveProduct) {
        t0 = getActiveProduct();
        $[0] = getActiveProduct;
        $[1] = t0;
    } else t0 = $[1];
    const product = t0;
    const t1 = !!product?.autocorrectEnabled && $eb748d2e55de9d8b$export$47c66070d6d6cd6d(lang);
    const t2 = product?.id || "";
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            autocorrectionEnabled: t1,
            productId: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const lang = (0, $e5W8z.sanitizeLanguage)(locale);
    const { getActiveProduct: getActiveProduct } = (0, $hCs5h.useProductContext)();
    const product = getActiveProduct();
    return {
        autocorrectionEnabled: !!product?.autocorrectEnabled && $eb748d2e55de9d8b$export$47c66070d6d6cd6d(lang),
        productId: product?.id || ''
    };
};
const $eb748d2e55de9d8b$export$ac1bfa03f151bc79 = (0, (/*@__PURE__*/$parcel$interopDefault($eiLi2)))(({ query: query, aggregatorUrl: aggregatorUrl, lang: lang, cloudId: cloudId })=>{
    return (0, $gABt9.utils).requestService({
        url: aggregatorUrl
    }, {
        path: `${$eb748d2e55de9d8b$export$9e194549e403d7c0}`,
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                language: lang,
                cloudId: cloudId
            })
        }
    });
}, $eb748d2e55de9d8b$export$8cc0d0855105f007);
module.exports["AUTOCORRECT_API_PATH"] = $eb748d2e55de9d8b$export$9e194549e403d7c0;
module.exports["DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS"] = $eb748d2e55de9d8b$export$8cc0d0855105f007;
module.exports["isSupportedLanguage"] = $eb748d2e55de9d8b$export$47c66070d6d6cd6d;
module.exports["useAutocorrectionEnabled"] = $eb748d2e55de9d8b$export$bf742519320d45e9;
module.exports["fetchAutocorrection"] = $eb748d2e55de9d8b$export$ac1bfa03f151bc79;

});

parcelRegister("hCs5h", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jg98Q = parcelRequire("jg98Q");


var $2yIui = parcelRequire("2yIui");


var $aasNp = parcelRequire("aasNp");

const $49bbf4bcb301db1a$var$ProductContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    getProduct: (id)=>undefined,
    getActiveProduct: ()=>undefined,
    getPrimaryProduct: ()=>undefined,
    getPrimaryProductId: ()=>undefined,
    getPrimarySubProduct: ()=>undefined,
    addProduct: ()=>undefined,
    updateProduct: ()=>undefined,
    removeProduct: ()=>undefined,
    showProduct: ()=>undefined,
    getDefaultAIConfig: ()=>undefined,
    products: []
});
const $49bbf4bcb301db1a$export$36d5c2ec3fe68eef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, __initialProducts: t1, children: children } = t0;
    const __initialProducts = t1 === undefined ? (0, $aasNp.INITIAL_STATE) : t1;
    const [products, dispatch] = (0, $cozmU.useReducer)((0, $aasNp.reducer), __initialProducts);
    const { isExpanded: isExpanded } = (0, $2yIui.useDialogExpansionContext)();
    let t2;
    let t3;
    if ($[0] !== isExpanded) {
        t2 = ()=>{
            if (!isExpanded) dispatch({
                type: "HIDE_ALL"
            });
        };
        t3 = [
            isExpanded
        ];
        $[0] = isExpanded;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (payload)=>dispatch({
                type: "ADD",
                payload: payload
            });
        $[3] = t4;
    } else t4 = $[3];
    const addProduct = t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (payload_0)=>dispatch({
                type: "UPDATE",
                payload: payload_0
            });
        $[4] = t5;
    } else t5 = $[4];
    const updateProduct = t5;
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (id)=>dispatch({
                type: "REMOVE",
                payload: {
                    id: id
                }
            });
        $[5] = t6;
    } else t6 = $[5];
    const removeProduct = t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (id_0)=>dispatch({
                type: "SHOW",
                payload: {
                    id: id_0
                }
            });
        $[6] = t7;
    } else t7 = $[6];
    const showProduct = t7;
    let t8;
    if ($[7] !== products) {
        t8 = ()=>products.find($49bbf4bcb301db1a$var$_temp);
        $[7] = products;
        $[8] = t8;
    } else t8 = $[8];
    const getActiveProduct = t8;
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {};
        $[9] = t9;
    } else t9 = $[9];
    const productsRef = (0, $cozmU.useRef)(t9);
    let t10;
    if ($[10] !== products) {
        t10 = (id_1)=>{
            const product_1 = products.find((product_0)=>product_0.id === id_1);
            const productRef = productsRef.current[id_1];
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))(product_1, productRef)) productsRef.current[id_1] = product_1;
            return productsRef.current[id_1];
        };
        $[10] = products;
        $[11] = t10;
    } else t10 = $[11];
    const getProduct = t10;
    let t11;
    if ($[12] !== getProduct || $[13] !== primaryProduct || $[14] !== products) {
        t11 = ()=>{
            const nominatedPrimaryProduct = primaryProduct && getProduct(primaryProduct);
            const firstRegisteredProduct = products.length > 0 && products[0];
            return nominatedPrimaryProduct || firstRegisteredProduct || undefined;
        };
        $[12] = getProduct;
        $[13] = primaryProduct;
        $[14] = products;
        $[15] = t11;
    } else t11 = $[15];
    const getPrimaryProduct = t11;
    let t12;
    if ($[16] !== primaryProduct) {
        t12 = ()=>primaryProduct;
        $[16] = primaryProduct;
        $[17] = t12;
    } else t12 = $[17];
    const getPrimaryProductId = t12;
    let t13;
    if ($[18] !== primarySubProduct) {
        t13 = ()=>primarySubProduct;
        $[18] = primarySubProduct;
        $[19] = t13;
    } else t13 = $[19];
    const getPrimarySubProduct = t13;
    let t14;
    if ($[20] !== getPrimaryProduct || $[21] !== products) {
        t14 = ()=>{
            const primaryProduct_0 = getPrimaryProduct();
            if (primaryProduct_0?.aiSearchConfig) return primaryProduct_0.aiSearchConfig;
            else return products.filter($49bbf4bcb301db1a$var$_temp2)[0]?.aiSearchConfig;
        };
        $[20] = getPrimaryProduct;
        $[21] = products;
        $[22] = t14;
    } else t14 = $[22];
    const getDefaultAIConfig = t14;
    let t15;
    if ($[23] !== getActiveProduct || $[24] !== getDefaultAIConfig || $[25] !== getPrimaryProduct || $[26] !== getPrimaryProductId || $[27] !== getPrimarySubProduct || $[28] !== getProduct || $[29] !== products) {
        t15 = {
            getProduct: getProduct,
            getActiveProduct: getActiveProduct,
            getPrimaryProduct: getPrimaryProduct,
            getPrimaryProductId: getPrimaryProductId,
            getPrimarySubProduct: getPrimarySubProduct,
            addProduct: addProduct,
            updateProduct: updateProduct,
            removeProduct: removeProduct,
            showProduct: showProduct,
            products: products,
            getDefaultAIConfig: getDefaultAIConfig
        };
        $[23] = getActiveProduct;
        $[24] = getDefaultAIConfig;
        $[25] = getPrimaryProduct;
        $[26] = getPrimaryProductId;
        $[27] = getPrimarySubProduct;
        $[28] = getProduct;
        $[29] = products;
        $[30] = t15;
    } else t15 = $[30];
    let t16;
    if ($[31] !== children || $[32] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($49bbf4bcb301db1a$var$ProductContext.Provider, {
            value: t15
        }, children);
        $[31] = children;
        $[32] = t15;
        $[33] = t16;
    } else t16 = $[33];
    return t16;
} : ({ primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, __initialProducts: __initialProducts = (0, $aasNp.INITIAL_STATE), children: children })=>{
    const [products, dispatch] = (0, $cozmU.useReducer)((0, $aasNp.reducer), __initialProducts);
    const { isExpanded: isExpanded } = (0, $2yIui.useDialogExpansionContext)();
    (0, $cozmU.useEffect)(()=>{
        if (!isExpanded) dispatch({
            type: 'HIDE_ALL'
        });
    }, [
        isExpanded
    ]);
    const addProduct = (0, $cozmU.useCallback)((payload)=>{
        return dispatch({
            type: 'ADD',
            payload: payload
        });
    }, [
        dispatch
    ]);
    const updateProduct = (0, $cozmU.useCallback)((payload_0)=>{
        return dispatch({
            type: 'UPDATE',
            payload: payload_0
        });
    }, [
        dispatch
    ]);
    const removeProduct = (0, $cozmU.useCallback)((id)=>{
        return dispatch({
            type: 'REMOVE',
            payload: {
                id: id
            }
        });
    }, [
        dispatch
    ]);
    /**
   * @function showProduct will ensure that only one product is displayed at a time
   * @param {string} id - The product id which has to be made visible.
   */ const showProduct = (0, $cozmU.useCallback)((id_0)=>dispatch({
            type: 'SHOW',
            payload: {
                id: id_0
            }
        }), [
        dispatch
    ]);
    const getActiveProduct = (0, $cozmU.useCallback)(()=>{
        return products.find((product)=>product.isDisplayed);
    }, [
        products
    ]);
    const productsRef = (0, $cozmU.useRef)({});
    const getProduct = (0, $cozmU.useCallback)((id_1)=>{
        const product_1 = products.find((product_0)=>product_0.id === id_1);
        const productRef = productsRef.current[id_1];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))(product_1, productRef)) productsRef.current[id_1] = product_1;
        return productsRef.current[id_1];
    }, [
        products
    ]);
    const getPrimaryProduct = (0, $cozmU.useCallback)(()=>{
        const nominatedPrimaryProduct = primaryProduct && getProduct(primaryProduct);
        const firstRegisteredProduct = products.length > 0 && products[0];
        return nominatedPrimaryProduct || firstRegisteredProduct || undefined;
    }, [
        getProduct,
        primaryProduct,
        products
    ]);
    const getPrimaryProductId = (0, $cozmU.useCallback)(()=>primaryProduct, [
        primaryProduct
    ]);
    const getPrimarySubProduct = (0, $cozmU.useCallback)(()=>primarySubProduct, [
        primarySubProduct
    ]);
    const getDefaultAIConfig = (0, $cozmU.useCallback)(()=>{
        const primaryProduct_0 = getPrimaryProduct();
        if (primaryProduct_0?.aiSearchConfig) return primaryProduct_0.aiSearchConfig;
        else return products.filter((product_2)=>product_2.aiSearchConfig)[0]?.aiSearchConfig;
    }, [
        products,
        getPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($49bbf4bcb301db1a$var$ProductContext.Provider, {
        value: {
            getProduct: getProduct,
            getActiveProduct: getActiveProduct,
            getPrimaryProduct: getPrimaryProduct,
            getPrimaryProductId: getPrimaryProductId,
            getPrimarySubProduct: getPrimarySubProduct,
            addProduct: addProduct,
            updateProduct: updateProduct,
            removeProduct: removeProduct,
            showProduct: showProduct,
            products: products,
            getDefaultAIConfig: getDefaultAIConfig
        }
    }, children);
};
const $49bbf4bcb301db1a$export$b5aab9e12d92574f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($49bbf4bcb301db1a$var$ProductContext);
} : ()=>(0, $cozmU.useContext)($49bbf4bcb301db1a$var$ProductContext);
const $49bbf4bcb301db1a$export$a1f708a69696ca95 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            ...$49bbf4bcb301db1a$export$b5aab9e12d92574f()
        });
};
function $49bbf4bcb301db1a$var$_temp(product) {
    return product.isDisplayed;
}
function $49bbf4bcb301db1a$var$_temp2(product_2) {
    return product_2.aiSearchConfig;
}
module.exports["ProductRouter"] = $49bbf4bcb301db1a$export$36d5c2ec3fe68eef;
module.exports["useProductContext"] = $49bbf4bcb301db1a$export$b5aab9e12d92574f;
module.exports["withProductContext"] = $49bbf4bcb301db1a$export$a1f708a69696ca95;

});

parcelRegister("2yIui", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d2135dd564b15dd3$export$5d07de159ce5026c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    isExpanded: false,
    setIsExpanded: (isExpanded)=>{},
    allowChangeExpand: (expand)=>{}
});
const $d2135dd564b15dd3$export$4a9c91610a2bc03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, isExpanded: isExpanded, setIsExpanded: setIsExpanded } = t0;
    const [changeExpand, setChangeExpand] = (0, $cozmU.useState)(true);
    const t1 = changeExpand ? setIsExpanded : $d2135dd564b15dd3$var$_temp;
    let t2;
    if ($[0] !== isExpanded || $[1] !== t1) {
        t2 = {
            isExpanded: isExpanded,
            setIsExpanded: t1,
            allowChangeExpand: setChangeExpand
        };
        $[0] = isExpanded;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2135dd564b15dd3$export$5d07de159ce5026c.Provider, {
            value: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, isExpanded: isExpanded, setIsExpanded: setIsExpanded })=>{
    const [changeExpand, setChangeExpand] = (0, $cozmU.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2135dd564b15dd3$export$5d07de159ce5026c.Provider, {
        value: {
            isExpanded: isExpanded,
            setIsExpanded: changeExpand ? setIsExpanded : ()=>{},
            allowChangeExpand: setChangeExpand
        }
    }, children);
};
const $d2135dd564b15dd3$export$124a7aa8f9a7a608 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($d2135dd564b15dd3$export$5d07de159ce5026c);
} : ()=>{
    return (0, $cozmU.useContext)($d2135dd564b15dd3$export$5d07de159ce5026c);
};
const $d2135dd564b15dd3$export$be366799d3426bb9 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            ...$d2135dd564b15dd3$export$124a7aa8f9a7a608()
        });
};
function $d2135dd564b15dd3$var$_temp() {}
module.exports["DialogExpansionContextProvider"] = $d2135dd564b15dd3$export$4a9c91610a2bc03;
module.exports["useDialogExpansionContext"] = $d2135dd564b15dd3$export$124a7aa8f9a7a608;
module.exports["withDialogExpansionContext"] = $d2135dd564b15dd3$export$be366799d3426bb9;

});

parcelRegister("aasNp", function(module, exports) {
const $00e26d1b44e665ee$export$36d128238e6b60f5 = [];
const $00e26d1b44e665ee$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case 'ADD':
            {
                const { payload: newProduct } = action;
                return $00e26d1b44e665ee$export$7caf006d7b64ee15(state, newProduct);
            }
        case 'UPDATE':
            {
                const { payload: updatePayload } = action;
                return $00e26d1b44e665ee$export$8d590d0c8872145e(state, updatePayload);
            }
        case 'SHOW':
            {
                const productIdToShow = action.payload.id;
                return $00e26d1b44e665ee$export$821c121fea76e4f5(state, productIdToShow);
            }
        case 'REMOVE':
            {
                const productIdToRemove = action.payload.id;
                return $00e26d1b44e665ee$export$86a330d9a979afdd(state, productIdToRemove);
            }
        case 'HIDE_ALL':
            return $00e26d1b44e665ee$export$b6d3947c481ec009(state);
        default:
            return state;
    }
};
function $00e26d1b44e665ee$export$7caf006d7b64ee15(products, addPayload) {
    // Check that new product id does not exist already
    if (products.filter((product)=>product.id === addPayload.id).length) return products;
    // Show error in console when duplicate order is added
    const duplicateOrder = products.find(({ order: order })=>order === addPayload.order);
    if (duplicateOrder) // eslint-disable-next-line no-console
    console.error(`product-search-dialog: Duplicate order of ${addPayload.order} has been set for the products of ${duplicateOrder.id} and ${addPayload.id}`);
    // Add product to state and maintain sorted array using order
    const newProduct = {
        ...addPayload,
        isDisplayed: false
    };
    const unsorted = [
        ...products,
        newProduct
    ];
    const sorted = unsorted.sort((a, b)=>a.order - b.order);
    return sorted;
}
function $00e26d1b44e665ee$export$8d590d0c8872145e(products, updatePayload) {
    const productToUpdate = products.find((p)=>p.id === updatePayload.id);
    if (!productToUpdate) throw new Error(`Cannot update ${updatePayload.id} before being added`);
    const validUpdateKeys = [
        'generateAdvancedSearchUrl',
        'tabRenderer'
    ];
    const validUpdatePayload = Object.fromEntries(Object.entries(updatePayload).filter(([key])=>validUpdateKeys.includes(key)));
    Object.assign(productToUpdate, validUpdatePayload);
    return products;
}
function $00e26d1b44e665ee$export$821c121fea76e4f5(products, productIdToShow) {
    return products.map((product)=>({
            ...product,
            isDisplayed: product.id === productIdToShow
        }));
}
function $00e26d1b44e665ee$export$86a330d9a979afdd(products, productIdToRemove) {
    return products.filter((product)=>product.id !== productIdToRemove);
}
function $00e26d1b44e665ee$export$b6d3947c481ec009(products) {
    return products.map((product)=>({
            ...product,
            isDisplayed: false
        }));
}
module.exports["INITIAL_STATE"] = $00e26d1b44e665ee$export$36d128238e6b60f5;
module.exports["reducer"] = $00e26d1b44e665ee$export$1650419e431d3ba3;

});

parcelRegister("2Ta1U", function(module, exports) {

let $21a87f8ce899b441$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $21a87f8ce899b441$var$load("gbejv"),
    $21a87f8ce899b441$var$load("GD9EA"),
    $21a87f8ce899b441$var$load("6wr18"),
    $21a87f8ce899b441$var$load("aJLFD"),
    $21a87f8ce899b441$var$load("ffEVr"),
    $21a87f8ce899b441$var$load("7gL7H"),
    $21a87f8ce899b441$var$load("hhss7"),
    $21a87f8ce899b441$var$load("2nwxY")
]).then(()=>parcelRequire('bonfL'));

});

parcelRegister("1oLkX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e5cea1fed6b35db0$export$a4874344a0a08e9e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_p12f1fra _1e0c116y _1n261g80 _1p57u2gc _gy1pu2gc _19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_p12f1fra _1e0c116y _1n261g80 _1p57u2gc _gy1pu2gc _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$668eb470a70772b7 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _11q71j9a _vchhusvi _1e0c1ule _16qs130s _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _11q71j9a _vchhusvi _1e0c1ule _16qs130s _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$d586e0ae81c7b89b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsb1gwv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1gwv",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$c0e1e4e72a41cc80 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { context: context, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _102efhey _1t4pi7uo",
            __cmplp.context === "menu" ? "_18u01y44" : "_18u0idpf",
            __cmplp.context === "menu" ? "_24rcftgi" : "_24rc1y44",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { context: context, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _102efhey _1t4pi7uo",
            __cmplp.context === 'menu' ? "_18u01y44" : "_18u0idpf",
            __cmplp.context === 'menu' ? "_24rcftgi" : "_24rc1y44",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$e58ef81ce68260bb = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11q71j9a _2rkofajl _1bsb1gwv _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q71j9a _2rkofajl _1bsb1gwv _16qs130s",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$389e8eff9d059b16 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isSelected: isSelected, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3i14no _1bsb1osq _1e0c1txw _1bah1y6m _4cvr1h6o _vchhusvi _d0al73ad",
            __cmplp.isSelected ? "_19bvo7ao" : "_19bv7vkz",
            __cmplp.isSelected ? "_syaz6x5g" : "_syaz1kw7",
            __cmplp.isSelected ? "_11q71s93" : "_bfhk1j28",
            __cmplp.isSelected ? "_1kl71rih" : "_1kl7glyw",
            __cmplp.isSelected ? "_19lc1s93" : "_19lcl4ek",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4t3i14no _1bsb1osq _1e0c1txw _1bah1y6m _4cvr1h6o _vchhusvi _d0al73ad",
            __cmplp.isSelected ? "_19bvo7ao" : "_19bv7vkz",
            __cmplp.isSelected ? "_syaz6x5g" : "_syaz1kw7",
            __cmplp.isSelected ? "_11q71s93" : "_bfhk1j28",
            __cmplp.isSelected ? "_1kl71rih" : "_1kl7glyw",
            __cmplp.isSelected ? "_19lc1s93" : "_19lcl4ek",
            __cmplp.className
        ])
    });
});
const $e5cea1fed6b35db0$export$1e83d727324d4b8e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4utpp _vchhusvi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4utpp _vchhusvi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e5cea1fed6b35db0$export$bf0bb6fde72bdac0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e5cea1fed6b35db0$export$64dbc8be437eccf5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11q77qp0 _19itglyw _11c81kw7 _2rkofajl _1bsbymf6 _4t3i1ylp _19pkutpp _19lc7qp0 _d0altlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q77qp0 _19itglyw _11c81kw7 _2rkofajl _1bsbymf6 _4t3i1ylp _19pkutpp _19lc7qp0 _d0altlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e5cea1fed6b35db0$export$9ee345695ec4f581 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8wadc _1e0c1txw _19pk1b66 _syaz1tmw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _1e0c1txw _19pk1b66 _syaz1tmw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e5cea1fed6b35db0$export$ae3a7dd4d8a05cb1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _n7zlia51 _1e0c1txw _kqsw1if8 _154iidpf _bfhkvuon _1pbyegat",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _n7zlia51 _1e0c1txw _kqsw1if8 _154iidpf _bfhkvuon _1pbyegat",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e5cea1fed6b35db0$export$464eacbfb9fbeb3e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18u01wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});
module.exports["HorizontalFilterPane"] = $e5cea1fed6b35db0$export$a4874344a0a08e9e;
module.exports["PopupComponentContainer"] = $e5cea1fed6b35db0$export$668eb470a70772b7;
module.exports["SelectWrapper"] = $e5cea1fed6b35db0$export$d586e0ae81c7b89b;
module.exports["OptionInMenu"] = $e5cea1fed6b35db0$export$c0e1e4e72a41cc80;
module.exports["CustomDropdown"] = $e5cea1fed6b35db0$export$e58ef81ce68260bb;
module.exports["CustomDropdownItem"] = $e5cea1fed6b35db0$export$389e8eff9d059b16;
module.exports["CustomDateWrapper"] = $e5cea1fed6b35db0$export$1e83d727324d4b8e;
module.exports["DatePickersWrapper"] = $e5cea1fed6b35db0$export$bf0bb6fde72bdac0;
module.exports["SelectDateRangeButton"] = $e5cea1fed6b35db0$export$64dbc8be437eccf5;
module.exports["DateRangeErrorMessage"] = $e5cea1fed6b35db0$export$9ee345695ec4f581;
module.exports["HorizontalFilterWrapper"] = $e5cea1fed6b35db0$export$ae3a7dd4d8a05cb1;
module.exports["FeedbackButtonWrapper"] = $e5cea1fed6b35db0$export$464eacbfb9fbeb3e;

});

parcelRegister("hY8sQ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $eb19ddf4aa386faf$export$a54ec244c8863715 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Li_FD",
    name: "SearchPage",
    loader: async ()=>(await (parcelRequire("339Kh"))).ConfluenceSearchPage
});
module.exports["SearchPage"] = $eb19ddf4aa386faf$export$a54ec244c8863715;

});

parcelRegister("339Kh", function(module, exports) {

let $2389362bb1208974$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2389362bb1208974$var$load("jZMUd"),
    $2389362bb1208974$var$load("kT6dz"),
    $2389362bb1208974$var$load("hDJ0x"),
    $2389362bb1208974$var$load("e7Dyr"),
    $2389362bb1208974$var$load("diUSq"),
    $2389362bb1208974$var$load("hZVEi"),
    $2389362bb1208974$var$load("icfaw"),
    $2389362bb1208974$var$load("1GGfq"),
    $2389362bb1208974$var$load("XbUoB"),
    $2389362bb1208974$var$load("iUz8S"),
    $2389362bb1208974$var$load("ftDGD"),
    $2389362bb1208974$var$load("gbejv"),
    $2389362bb1208974$var$load("GD9EA"),
    $2389362bb1208974$var$load("7TnhR"),
    $2389362bb1208974$var$load("houtd"),
    $2389362bb1208974$var$load("hUbK8"),
    $2389362bb1208974$var$load("6wr18"),
    $2389362bb1208974$var$load("lJX1r"),
    $2389362bb1208974$var$load("7Vdd5"),
    $2389362bb1208974$var$load("1xRFJ"),
    $2389362bb1208974$var$load("8nUmp"),
    $2389362bb1208974$var$load("5AKrm"),
    $2389362bb1208974$var$load("6GBKZ"),
    $2389362bb1208974$var$load("28xpM"),
    $2389362bb1208974$var$load("3cN9G"),
    $2389362bb1208974$var$load("j3345"),
    $2389362bb1208974$var$load("2J2X1"),
    $2389362bb1208974$var$load("do0Fh"),
    $2389362bb1208974$var$load("fGNCf"),
    $2389362bb1208974$var$load("4RsKm"),
    $2389362bb1208974$var$load("aJLFD"),
    $2389362bb1208974$var$load("dZYhM"),
    $2389362bb1208974$var$load("3RQq6"),
    $2389362bb1208974$var$load("fi4h0"),
    $2389362bb1208974$var$load("dxcsb"),
    $2389362bb1208974$var$load("2hLAI"),
    $2389362bb1208974$var$load("dCilB"),
    $2389362bb1208974$var$load("1T8H1"),
    $2389362bb1208974$var$load("fyKFO"),
    $2389362bb1208974$var$load("d9sg7"),
    $2389362bb1208974$var$load("l0N35"),
    $2389362bb1208974$var$load("ekVH8"),
    $2389362bb1208974$var$load("5lBmr"),
    $2389362bb1208974$var$load("j6n20"),
    $2389362bb1208974$var$load("gpnR1"),
    $2389362bb1208974$var$load("8zMmc"),
    $2389362bb1208974$var$load("dGhn8"),
    $2389362bb1208974$var$load("5omeF"),
    $2389362bb1208974$var$load("ffEVr"),
    $2389362bb1208974$var$load("gzrfp"),
    $2389362bb1208974$var$load("ddvkk"),
    $2389362bb1208974$var$load("3upHR"),
    $2389362bb1208974$var$load("3Pqne"),
    $2389362bb1208974$var$load("biEu6"),
    $2389362bb1208974$var$load("Wowvf"),
    $2389362bb1208974$var$load("eRhBr"),
    $2389362bb1208974$var$load("fiqxC"),
    $2389362bb1208974$var$load("6xfz8"),
    $2389362bb1208974$var$load("hZ2FX"),
    $2389362bb1208974$var$load("hhss7"),
    $2389362bb1208974$var$load("7EorR"),
    $2389362bb1208974$var$load("7pIPL")
]).then(()=>parcelRequire('kku53'));

});

parcelRegister("3YLTK", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $838d3f0e1bef3f68$var$COMPONENT = 'search-page';
const $838d3f0e1bef3f68$export$a98443e214d7b1fd = new (0, $34VCg.UFOExperience)('load', {
    type: (0, $gZFfs.ExperienceTypes).Load,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $838d3f0e1bef3f68$var$COMPONENT
    }
});
const $838d3f0e1bef3f68$export$e882a2ec68d19be8 = new (0, $34VCg.UFOExperience)('search-results-load', {
    type: (0, $gZFfs.ExperienceTypes).Experience,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $838d3f0e1bef3f68$var$COMPONENT
    },
    timings: [
        {
            key: 'request',
            startMark: 'request_start',
            endMark: 'request_end'
        },
        {
            key: 'render',
            startMark: 'render_start',
            endMark: 'render_end'
        }
    ]
});
const $838d3f0e1bef3f68$export$eda1f56a83aaec73 = async ()=>{
    if (!$838d3f0e1bef3f68$export$e882a2ec68d19be8.state.final) await $838d3f0e1bef3f68$export$e882a2ec68d19be8.abort({
        metadata: {
            reason: 'restarted'
        }
    });
    $838d3f0e1bef3f68$export$e882a2ec68d19be8.start();
};
const $838d3f0e1bef3f68$export$b066085d86746240 = ({ queryLength: queryLength, wordCount: wordCount })=>{
    $838d3f0e1bef3f68$export$e882a2ec68d19be8.success({
        metadata: {
            queryLength: queryLength,
            wordCount: wordCount
        }
    });
};
const $838d3f0e1bef3f68$export$7cc1b457adcf3334 = ()=>{
    $838d3f0e1bef3f68$export$e882a2ec68d19be8.failure();
};
module.exports["searchPageLoadUFOExperience"] = $838d3f0e1bef3f68$export$a98443e214d7b1fd;
module.exports["searchResultsLoadUFOExperienceStart"] = $838d3f0e1bef3f68$export$eda1f56a83aaec73;
module.exports["searchResultsLoadUFOExperienceSuccess"] = $838d3f0e1bef3f68$export$b066085d86746240;
module.exports["searchResultsLoadUFOExperienceError"] = $838d3f0e1bef3f68$export$7cc1b457adcf3334;

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");


});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");


});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");


});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_1bsbgm0b _4t3igm0b _ahbqzjw7"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $abc73c6f5c74c436$var$useRouterLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $abc73c6f5c74c436$export$2e2bcd8739ae039 = $abc73c6f5c74c436$var$useRouterLink;
module.exports["default"] = $abc73c6f5c74c436$export$2e2bcd8739ae039;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("jawC3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1XrQ3 = parcelRequire("1XrQ3");


var $9Q3yl = parcelRequire("9Q3yl");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $2B4lz = parcelRequire("2B4lz");


var $hhrxw = parcelRequire("hhrxw");

function $6adaebd1c889f1f2$export$ab527c45f467d3f7(options) {
    const { defaultExtractorFunction: defaultExtractorFunction, extractorPrioritiesByType: extractorPrioritiesByType, extractorFunctionsByType: extractorFunctionsByType, json: json } = options;
    if (json) {
        const type = json['@type'];
        if (type && Array.isArray(type)) {
            let highestPriority = 0;
            let highestPriorityExtractorFunction = defaultExtractorFunction;
            for (let t of type)if (extractorPrioritiesByType[t] > highestPriority) {
                highestPriority = extractorPrioritiesByType[t];
                highestPriorityExtractorFunction = extractorFunctionsByType[t];
            }
            return highestPriorityExtractorFunction(json);
        }
        if (type && extractorFunctionsByType[type]) return extractorFunctionsByType[type](json);
    }
    return defaultExtractorFunction(json);
}
const $6adaebd1c889f1f2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
const $6adaebd1c889f1f2$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(icon);
    else {
        if (icon.url) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(icon.url);
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
const $6adaebd1c889f1f2$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(url);
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = $6adaebd1c889f1f2$export$efdbd45f3e77a161(jsonLd);
    const type = $6adaebd1c889f1f2$export$2e9ae379995d99e3(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
const $6adaebd1c889f1f2$export$3185b99040f72cfd = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $6adaebd1c889f1f2$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && $6adaebd1c889f1f2$export$67f3d92c824fd850(context.icon),
                type: $6adaebd1c889f1f2$export$2e9ae379995d99e3(context)
            };
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return (0, $iDrrr.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
                text: generator.name
            }) : {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return (0, $iDrrr.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
                text: generator.name,
                icon: $6adaebd1c889f1f2$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $6adaebd1c889f1f2$var$extractProviderImage(generator.image)
            }) : {
                text: generator.name,
                icon: $6adaebd1c889f1f2$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $6adaebd1c889f1f2$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3yl.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $iDrrr.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $hhrxw.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $iDrrr.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return $6adaebd1c889f1f2$export$67f3d92c824fd850(icon);
    return undefined;
};
const $6adaebd1c889f1f2$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
const $6adaebd1c889f1f2$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
const $6adaebd1c889f1f2$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
const $6adaebd1c889f1f2$export$601b23e9cf369aed = (jsonLd)=>{
    if (jsonLd['atlassian:dateViewed']) return jsonLd['atlassian:dateViewed'];
    return undefined;
};
const $6adaebd1c889f1f2$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && $6adaebd1c889f1f2$export$67f3d92c824fd850(person.icon)
        };
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>$6adaebd1c889f1f2$export$c471ae5fddcf1392(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = $6adaebd1c889f1f2$export$c471ae5fddcf1392(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return $6adaebd1c889f1f2$export$c471ae5fddcf1392(assignedTo);
    return undefined;
};
const $6adaebd1c889f1f2$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map($6adaebd1c889f1f2$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $6adaebd1c889f1f2$export$c471ae5fddcf1392(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map($6adaebd1c889f1f2$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $6adaebd1c889f1f2$export$c471ae5fddcf1392(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return $6adaebd1c889f1f2$export$c471ae5fddcf1392(updatedBy);
    return undefined;
};
const $6adaebd1c889f1f2$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
const $6adaebd1c889f1f2$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = $6adaebd1c889f1f2$export$3e8ad908070b68b2(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: $6adaebd1c889f1f2$export$396ba4ef2e37dc65(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: $6adaebd1c889f1f2$export$396ba4ef2e37dc65(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$8beff7405d020ddf = (response)=>response?.entityData;
const $6adaebd1c889f1f2$export$c7168210b81d9383 = (response)=>Boolean($6adaebd1c889f1f2$export$8beff7405d020ddf(response));
const $6adaebd1c889f1f2$var$extractEntityEmbedUrl = (response)=>{
    const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $6adaebd1c889f1f2$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entityIcon = $6adaebd1c889f1f2$export$19346520e937a99f(response);
        if (entityIcon) return (0, $iDrrr.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        }) : {
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        };
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $hhrxw.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3yl.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $iDrrr.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $hhrxw.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                appearance: "brand",
                ...(0, $iDrrr.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return (0, $iDrrr.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    }) : {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    };
};
const $6adaebd1c889f1f2$export$19346520e937a99f = (response)=>{
    if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        if (!entity) return undefined;
        if (!(0, $1XrQ3.isBaseEntity)(entity)) return undefined;
        if ((0, $1XrQ3.isDesignEntity)(entity) && entity.iconUrl) return {
            url: entity.iconUrl,
            label: entity.type
        };
        if ((0, $1XrQ3.isDocumentEntity)(entity) && entity.type.iconUrl) return {
            url: entity.type.iconUrl,
            label: entity.type.category
        };
        // When JSON-LD is deprecated, we can change this to returning entity provider icon.
        // For now code upstream will return better result when this method returns undefined.
        return undefined;
    } else {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        let url;
        if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
        return {
            url: url,
            label: entity?.displayName
        };
    }
};
const $6adaebd1c889f1f2$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.displayName;
    return $6adaebd1c889f1f2$export$b05803156e5015b6(response?.data, removeTextHighlightingFromTitle);
};
const $6adaebd1c889f1f2$export$7ba9b12c6a1b73de = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.url;
    return $6adaebd1c889f1f2$export$63f54cf4c5883620(response?.data);
};
const $6adaebd1c889f1f2$export$16b02be3e2bb31ad = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.ari || $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.thirdPartyAri;
    const data = response?.data;
    return $6adaebd1c889f1f2$export$be18a6294fd426ec(data);
};
const $6adaebd1c889f1f2$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $6adaebd1c889f1f2$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return $6adaebd1c889f1f2$export$4b0d98b1b7f6d115(response?.data, 'web', iframeUrlType);
};
const $6adaebd1c889f1f2$export$ff753ed519e96e9e = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$ad879f2c9d5100a0(response);
    return response?.data && $6adaebd1c889f1f2$export$a832871718466647(response?.data);
};
const $6adaebd1c889f1f2$export$7a685df468cbf38f = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.createdAt;
    return response?.data && $6adaebd1c889f1f2$export$e1226a5e0bbbf862(response.data);
};
const $6adaebd1c889f1f2$export$75047940e157fd1f = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.lastUpdatedAt;
    return response?.data && $6adaebd1c889f1f2$export$7fc2f5e6f9d22ae7(response.data);
};
const $6adaebd1c889f1f2$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.createdBy?.displayName;
    const persons = $6adaebd1c889f1f2$export$a66235cba0c9d11a(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $6adaebd1c889f1f2$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return $6adaebd1c889f1f2$export$a66235cba0c9d11a(response.data);
};
const $6adaebd1c889f1f2$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.lastUpdatedBy?.displayName;
    const person = $6adaebd1c889f1f2$export$8a2d1ed7e6f336f0(response.data);
    return person ? person.name : undefined;
};
const $6adaebd1c889f1f2$export$96ed4c1b14ac210a = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["genericExtractPropsFromJSONLD"] = $6adaebd1c889f1f2$export$ab527c45f467d3f7;
module.exports["extractUrlFromLinkJsonLd"] = $6adaebd1c889f1f2$export$396ba4ef2e37dc65;
module.exports["extractUrlFromIconJsonLd"] = $6adaebd1c889f1f2$export$67f3d92c824fd850;
module.exports["extractType"] = $6adaebd1c889f1f2$export$2e9ae379995d99e3;
module.exports["extractAri"] = $6adaebd1c889f1f2$export$be18a6294fd426ec;
module.exports["extractLink"] = $6adaebd1c889f1f2$export$63f54cf4c5883620;
module.exports["extractSummary"] = $6adaebd1c889f1f2$export$db5a8500f6b6286e;
module.exports["extractTitle"] = $6adaebd1c889f1f2$export$b05803156e5015b6;
module.exports["extractContext"] = $6adaebd1c889f1f2$export$efdbd45f3e77a161;
module.exports["extractNameFromJsonLd"] = $6adaebd1c889f1f2$export$3185b99040f72cfd;
module.exports["extractProvider"] = $6adaebd1c889f1f2$export$a832871718466647;
module.exports["extractProviderIcon"] = $6adaebd1c889f1f2$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $6adaebd1c889f1f2$export$38df542ff03a4183;
module.exports["extractDateCreated"] = $6adaebd1c889f1f2$export$e1226a5e0bbbf862;
module.exports["extractDateUpdated"] = $6adaebd1c889f1f2$export$7fc2f5e6f9d22ae7;
module.exports["extractDateViewed"] = $6adaebd1c889f1f2$export$601b23e9cf369aed;
module.exports["extractPersonFromJsonLd"] = $6adaebd1c889f1f2$export$c471ae5fddcf1392;
module.exports["extractMembers"] = $6adaebd1c889f1f2$export$6281d080d62a0719;
module.exports["extractPersonAssignedTo"] = $6adaebd1c889f1f2$export$38a0979ebf273662;
module.exports["extractPersonCreatedBy"] = $6adaebd1c889f1f2$export$a66235cba0c9d11a;
module.exports["extractPersonOwnedBy"] = $6adaebd1c889f1f2$export$19ee667f3f7a6ec3;
module.exports["extractPersonUpdatedBy"] = $6adaebd1c889f1f2$export$8a2d1ed7e6f336f0;
module.exports["extractImage"] = $6adaebd1c889f1f2$export$4c753a1297cb9805;
module.exports["extractPlatformIsSupported"] = $6adaebd1c889f1f2$export$3e8ad908070b68b2;
module.exports["extractPreview"] = $6adaebd1c889f1f2$export$4b0d98b1b7f6d115;
module.exports["extractEntity"] = $6adaebd1c889f1f2$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $6adaebd1c889f1f2$export$c7168210b81d9383;
module.exports["extractEntityProvider"] = $6adaebd1c889f1f2$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $6adaebd1c889f1f2$export$19346520e937a99f;
module.exports["extractSmartLinkTitle"] = $6adaebd1c889f1f2$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $6adaebd1c889f1f2$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $6adaebd1c889f1f2$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $6adaebd1c889f1f2$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $6adaebd1c889f1f2$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $6adaebd1c889f1f2$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $6adaebd1c889f1f2$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $6adaebd1c889f1f2$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $6adaebd1c889f1f2$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $6adaebd1c889f1f2$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $6adaebd1c889f1f2$export$96ed4c1b14ac210a;

});

parcelRegister("1XrQ3", function(module, exports) {
const $54e326c4fdcf6d71$var$DESIGN_TYPES = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $54e326c4fdcf6d71$var$DESIGN_STATUSES = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $54e326c4fdcf6d71$var$REMOTE_LINK_TYPES = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $54e326c4fdcf6d71$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $54e326c4fdcf6d71$var$WORK_ITEM_SUB_TYPES = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $54e326c4fdcf6d71$var$DOCUMENT_CATEGORIES = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $54e326c4fdcf6d71$var$isOneOf = (values, value)=>typeof value === 'string' && values.includes(value);
const $54e326c4fdcf6d71$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $54e326c4fdcf6d71$var$asRecord = (value)=>value;
const $54e326c4fdcf6d71$export$12af7c5462954d1e = (value)=>$54e326c4fdcf6d71$var$isObject(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
const $54e326c4fdcf6d71$export$8dc9be81b5b6266b = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DESIGN_STATUSES, $54e326c4fdcf6d71$var$asRecord(value).status) && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DESIGN_TYPES, $54e326c4fdcf6d71$var$asRecord(value).type);
const $54e326c4fdcf6d71$export$f16c4076686c1f5b = (value)=>{
    if (!$54e326c4fdcf6d71$export$12af7c5462954d1e(value)) return false;
    const entity = $54e326c4fdcf6d71$var$asRecord(value);
    const remoteLink = entity['atlassian:remote-link'];
    return $54e326c4fdcf6d71$var$isObject(remoteLink) && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$REMOTE_LINK_TYPES, remoteLink.type);
};
const $54e326c4fdcf6d71$export$791f1b4852e2a184 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && $54e326c4fdcf6d71$var$isObject($54e326c4fdcf6d71$var$asRecord(value)['atlassian:project']);
const $54e326c4fdcf6d71$export$162dad7a1238d377 = (value)=>{
    if (!$54e326c4fdcf6d71$export$12af7c5462954d1e(value)) return false;
    const entity = $54e326c4fdcf6d71$var$asRecord(value);
    const workItem = entity['atlassian:work-item'];
    return $54e326c4fdcf6d71$var$isObject(workItem) && typeof workItem.status === 'string' && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$WORK_ITEM_SUB_TYPES, workItem.subtype) && typeof workItem.team === 'string';
};
const $54e326c4fdcf6d71$export$32c06ee7e0e9b79e = (value)=>{
    if (!$54e326c4fdcf6d71$export$12af7c5462954d1e(value)) return false;
    const entityType = $54e326c4fdcf6d71$var$asRecord(value).type;
    return $54e326c4fdcf6d71$var$isObject(entityType) && (entityType.category === undefined || $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DOCUMENT_CATEGORIES, entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ($54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DOCUMENT_CATEGORIES, entityType.category) || typeof entityType.iconUrl === 'string');
};
const $54e326c4fdcf6d71$export$33e8c1bbf9148b0e = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && ('attachments' in value || 'commentCount' in value || 'hidden' in value || 'isPinned' in value || 'lastActive' in value || 'reactions' in value);
const $54e326c4fdcf6d71$export$6c20afe8743cb761 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && ('isArchived' in value || 'lastActive' in value || 'memberCount' in value || 'members' in value || 'membershipType' in value || 'topic' in value || 'workspace' in value);
const $54e326c4fdcf6d71$export$fe785532d894f833 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && !$54e326c4fdcf6d71$export$8dc9be81b5b6266b(value) && !$54e326c4fdcf6d71$export$f16c4076686c1f5b(value) && !$54e326c4fdcf6d71$export$791f1b4852e2a184(value) && !$54e326c4fdcf6d71$export$162dad7a1238d377(value) && !$54e326c4fdcf6d71$export$32c06ee7e0e9b79e(value) && !$54e326c4fdcf6d71$export$33e8c1bbf9148b0e(value) && !$54e326c4fdcf6d71$export$6c20afe8743cb761(value);
const $54e326c4fdcf6d71$export$47565ffe58e56845 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && ($54e326c4fdcf6d71$export$8dc9be81b5b6266b(value) || $54e326c4fdcf6d71$export$f16c4076686c1f5b(value) || $54e326c4fdcf6d71$export$791f1b4852e2a184(value) || $54e326c4fdcf6d71$export$162dad7a1238d377(value) || $54e326c4fdcf6d71$export$32c06ee7e0e9b79e(value) || $54e326c4fdcf6d71$export$33e8c1bbf9148b0e(value) || $54e326c4fdcf6d71$export$6c20afe8743cb761(value) || $54e326c4fdcf6d71$export$fe785532d894f833(value));
module.exports["isBaseEntity"] = $54e326c4fdcf6d71$export$12af7c5462954d1e;
module.exports["isDesignEntity"] = $54e326c4fdcf6d71$export$8dc9be81b5b6266b;
module.exports["isDocumentEntity"] = $54e326c4fdcf6d71$export$32c06ee7e0e9b79e;

});

parcelRegister("9Q3yl", function(module, exports) {

var $5lkNm = parcelRequire("5lkNm");


var $6YXrY = parcelRequire("6YXrY");


var $8UJqr = parcelRequire("8UJqr");

const $c22c9af788df97f8$export$68f3db7f6af48bcb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $8UJqr.ConfluenceIcon), (0, $5lkNm.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $c22c9af788df97f8$export$68f3db7f6af48bcb;

});

parcelRegister("2B4lz", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $602fe273a6b2bdab$var$GOOGLE_DRIVE = 'Google Drive';
const $602fe273a6b2bdab$export$df1b15aebbcf717e = (provider)=>{
    switch(provider?.text){
        case 'Google':
            return {
                ...provider,
                ...(0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: $602fe273a6b2bdab$var$GOOGLE_DRIVE
                } : undefined,
                text: $602fe273a6b2bdab$var$GOOGLE_DRIVE
            };
        default:
            return provider;
    }
};
module.exports["rebrandProvider"] = $602fe273a6b2bdab$export$df1b15aebbcf717e;

});

parcelRegister("hhrxw", function(module, exports) {
const $e03d26a78ec0b544$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $e03d26a78ec0b544$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $e03d26a78ec0b544$export$84a73a0383f58180 = 'JiraTask';
const $e03d26a78ec0b544$export$c6c83963a9378a67 = 'JiraSubTask';
const $e03d26a78ec0b544$export$58af3c426c111a6d = 'JiraStory';
const $e03d26a78ec0b544$export$ac9898a63417219e = 'JiraBug';
const $e03d26a78ec0b544$export$54db5e3fb12e39cd = 'JiraEpic';
const $e03d26a78ec0b544$export$2f54a5a217202c85 = 'JiraIncident';
const $e03d26a78ec0b544$export$d097371052bfc411 = 'JiraServiceRequest';
const $e03d26a78ec0b544$export$efd9452ad16c6676 = 'JiraChange';
const $e03d26a78ec0b544$export$2e7e70abb5d81f67 = 'JiraProblem';
const $e03d26a78ec0b544$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $e03d26a78ec0b544$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $e03d26a78ec0b544$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});
module.exports["CONFLUENCE_GENERATOR_ID"] = $e03d26a78ec0b544$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $e03d26a78ec0b544$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $e03d26a78ec0b544$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $e03d26a78ec0b544$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $e03d26a78ec0b544$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $e03d26a78ec0b544$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $e03d26a78ec0b544$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $e03d26a78ec0b544$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $e03d26a78ec0b544$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $e03d26a78ec0b544$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $e03d26a78ec0b544$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $e03d26a78ec0b544$export$ce25cfc40b280dbc;
module.exports["SmartLinkSize"] = $e03d26a78ec0b544$export$51f13ced115cbdae;
module.exports["IconType"] = $e03d26a78ec0b544$export$13ff1290a9e22e77;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("6YrB3", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");

const $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $293056f9068f55f6$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $293056f9068f55f6$export$2e2bcd8739ae039;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("6dPGs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    if (!(0, $iDrrr.fg)('fix_ssr_browser_storage_undefined')) return true;
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("1LXnB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $12a75cc47e499450$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $12a75cc47e499450$export$2e2bcd8739ae039 = $12a75cc47e499450$var$WidthObserver;
module.exports["default"] = $12a75cc47e499450$export$2e2bcd8739ae039;

});

parcelRegister("69NJe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("8Xus6", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $cfd109792a890cba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $cfd109792a890cba$export$7c77c3a9bb93870d;

});

parcelRegister("itJFr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eKMV3 = parcelRequire("eKMV3");


var $6V5rQ = parcelRequire("6V5rQ");


var $gPPT7 = parcelRequire("gPPT7");


var $hojDG = parcelRequire("hojDG");

const $63a844e0a99b99ab$export$1d9b6b20d392c702 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    let href;
    let onClick;
    let rest;
    if ($[0] !== props) {
        ({ href: href, onClick: onClick, ...rest } = props);
        $[0] = props;
        $[1] = href;
        $[2] = onClick;
        $[3] = rest;
    } else {
        href = $[1];
        onClick = $[2];
        rest = $[3];
    }
    const context = (0, $hojDG.useTeamsNavigationContext)();
    let t0;
    if ($[4] !== context || $[5] !== href || $[6] !== onClick || $[7] !== props) {
        const input = (0, $gPPT7.buildNavigationInput)({
            ...props,
            href: href ?? "",
            context: context,
            onBeforeNavigate: onClick
        });
        t0 = (0, $6V5rQ.getNavigationProps)(input);
        $[4] = context;
        $[5] = href;
        $[6] = onClick;
        $[7] = props;
        $[8] = t0;
    } else t0 = $[8];
    const navigationProps = t0;
    let t1;
    if ($[9] !== navigationProps || $[10] !== rest) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            ...rest,
            ...navigationProps
        });
        $[9] = navigationProps;
        $[10] = rest;
        $[11] = t1;
    } else t1 = $[11];
    return t1;
} : (props)=>{
    const { href: href, onClick: onClick, ...rest } = props;
    const context = (0, $hojDG.useTeamsNavigationContext)();
    const input = (0, $gPPT7.buildNavigationInput)({
        ...props,
        href: href ?? '',
        context: context,
        onBeforeNavigate: onClick
    });
    const navigationProps = (0, $6V5rQ.getNavigationProps)(input);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        ...rest,
        ...navigationProps
    });
};
module.exports["TeamsLinkButton"] = $63a844e0a99b99ab$export$1d9b6b20d392c702;

});

parcelRegister("6V5rQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $gPPT7 = parcelRequire("gPPT7");


var $c6FmK = parcelRequire("c6FmK");

function $e9288cd702ed0dd6$export$9f4607ca273c83d(input) {
    const { href: rawHref, intent: intent, context: context, onClick: rawOnClick } = input;
    const previewPanelProps = 'previewPanelProps' in input ? input.previewPanelProps : undefined;
    const resolvedIntent = intent !== 'unknown' ? intent : (0, $c6FmK.classifyNavigationIntent)(rawHref);
    const openLinkInNewTab = resolvedIntent === 'external' || context.forceExternalIntent;
    // Prefix relative hrefs with the context entry point for the current product
    const href = (0, $iDrrr.fg)('ptc-fix-teams-isolated-links') ? (0, $gPPT7.prefixWithContextEntryPoint)(rawHref, context.contextEntryPoint) : openLinkInNewTab ? rawHref : (0, $gPPT7.prefixWithContextEntryPoint)(rawHref, context.contextEntryPoint ?? '');
    if (openLinkInNewTab) return {
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        onClick: (...args)=>{
            const e = args[0];
            rawOnClick?.(...args);
            if (e.defaultPrevented) return;
            e.preventDefault();
            window.open(href, '_blank', 'noopener noreferrer');
        }
    };
    return {
        href: href,
        target: '_self',
        onClick: (...args)=>{
            const e = args[0];
            rawOnClick?.(...args);
            if (e.defaultPrevented) return;
            // Handle left-click with modifier keys (let browser handle it)
            if (e.button === 0 && (0, $gPPT7.isModified)(e)) return;
            if (previewPanelProps && context.openPreviewPanel) try {
                context.openPreviewPanel({
                    ari: previewPanelProps.ari,
                    name: previewPanelProps.name,
                    url: href
                });
                e.preventDefault();
                return;
            } catch  {
            // Fall through to navigation below if opening the preview panel fails
            }
            // Handle left-clicks without modifier keys
            if (context.navigate && // only use navigate when a handler is provided
            (0, $gPPT7.isTeamsAppRoute)(href) && // only SPA navigate for townsquare routes
            e.button === 0 && // only use navigate for left mouse button clicks
            !(0, $gPPT7.isModified)(e) // let browser handle clicks with modifier
            ) {
                e.preventDefault();
                const routePath = (0, $gPPT7.getRoutePathFromUrl)(href);
                context.navigate(routePath);
                return;
            }
        }
    };
}
module.exports["getNavigationProps"] = $e9288cd702ed0dd6$export$9f4607ca273c83d;

});

parcelRegister("gPPT7", function(module, exports) {
// A collection of utility functions for the teams-app-internal-navigation package.

var $iDrrr = parcelRequire("iDrrr");

const $ef3c42dd8f7eebcd$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $ef3c42dd8f7eebcd$export$f9ded33a1a6c97c7 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $ef3c42dd8f7eebcd$export$ced0c1c5c19926df = (url)=>{
    try {
        const path = $ef3c42dd8f7eebcd$export$78cf1468c39d05b1(url);
        const hostname = new URL(url).hostname;
        return (hostname.includes('home.atlassian') || $ef3c42dd8f7eebcd$export$634ecc602a6871aa(hostname) || $ef3c42dd8f7eebcd$export$9186ccba8effc5de(hostname)) && path.includes('/people');
    } catch  {
        return false;
    }
};
const $ef3c42dd8f7eebcd$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ((0, $iDrrr.fg)('ptc-fix-teams-isolated-links')) {
        if ($ef3c42dd8f7eebcd$export$895d6838d29edd02(path) || // do not prefix for absolute URL
        contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
        path.startsWith('/')) return path;
        return `${contextEntryPoint}/${path}`;
    }
    if ($ef3c42dd8f7eebcd$export$895d6838d29edd02(path) || !contextEntryPoint || path.startsWith('/') || path.startsWith(contextEntryPoint)) return path;
    return `${contextEntryPoint}/${path}`;
};
const $ef3c42dd8f7eebcd$export$78cf1468c39d05b1 = (url)=>{
    try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.pathname;
    } catch  {
        // fallback for malformed URLs
        return url;
    }
};
function $ef3c42dd8f7eebcd$export$e0ed33167fbba483({ href: href, context: context, onBeforeNavigate: onBeforeNavigate, ...intentProps }) {
    return intentProps.intent === 'action' ? {
        href: href,
        intent: intentProps.intent,
        previewPanelProps: intentProps.previewPanelProps,
        context: context,
        onClick: onBeforeNavigate
    } : {
        href: href,
        intent: intentProps.intent,
        context: context,
        onClick: onBeforeNavigate
    };
}
// FedRAMP domain patterns used by Atlassian products
const $ef3c42dd8f7eebcd$var$FEDRAMP_DOMAIN_PATTERNS = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
// Isolated Cloud domain pattern
const $ef3c42dd8f7eebcd$var$ISOLATED_CLOUD_DOMAIN_PATTERN = /atlassian-isolated\.net/;
const $ef3c42dd8f7eebcd$export$634ecc602a6871aa = (hostname)=>{
    return $ef3c42dd8f7eebcd$var$FEDRAMP_DOMAIN_PATTERNS.test(hostname.toLowerCase());
};
const $ef3c42dd8f7eebcd$export$9186ccba8effc5de = (hostname)=>{
    return $ef3c42dd8f7eebcd$var$ISOLATED_CLOUD_DOMAIN_PATTERN.test(hostname.toLowerCase());
};
module.exports["isModified"] = $ef3c42dd8f7eebcd$export$f9ded33a1a6c97c7;
module.exports["isTeamsAppRoute"] = $ef3c42dd8f7eebcd$export$ced0c1c5c19926df;
module.exports["getRoutePathFromUrl"] = $ef3c42dd8f7eebcd$export$78cf1468c39d05b1;
module.exports["isFedramp"] = $ef3c42dd8f7eebcd$export$634ecc602a6871aa;
module.exports["isIsolatedCloud"] = $ef3c42dd8f7eebcd$export$9186ccba8effc5de;
module.exports["prefixWithContextEntryPoint"] = $ef3c42dd8f7eebcd$export$715c8f9057ac0c01;
module.exports["buildNavigationInput"] = $ef3c42dd8f7eebcd$export$e0ed33167fbba483;

});

parcelRegister("c6FmK", function(module, exports) {

var $gPPT7 = parcelRequire("gPPT7");

// List of domains that are considered Atlassian domains - taken from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $3f3af0f39adcc7f4$var$ATLASSIAN_DOMAINS = [
    'localhost',
    '127.0.0.1',
    'atlassian.com',
    'atlassian.net',
    'atl-paas.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'trello.com',
    'loom.com',
    'atlassian-dev.net',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net',
    'atlassian-us-gov.com',
    'atlassian-us-gov.net',
    'atlassian-fex.com',
    'atlassian-fex.net',
    'atlassian-stg-fedm.com',
    'atlassian-stg-fedm.net',
    'atlassian-isolated.net'
];
/** Extra roots for staging links */ const $3f3af0f39adcc7f4$var$STAGING_SUFFIXES = [
    'staging.atlassian.io',
    'atl-test.space',
    'jira-dev.com',
    'stg-jira.com',
    'staging.paas-inf.net'
];
function $3f3af0f39adcc7f4$var$matchesDomainList(hostname, domains) {
    const lower = hostname.toLowerCase();
    return domains.some((domain)=>lower === domain || lower.endsWith('.' + domain));
}
function $3f3af0f39adcc7f4$var$isAtlassianDomain(hostname) {
    const lower = hostname.toLowerCase();
    return $3f3af0f39adcc7f4$var$matchesDomainList(hostname, $3f3af0f39adcc7f4$var$ATLASSIAN_DOMAINS) || $3f3af0f39adcc7f4$var$matchesDomainList(hostname, $3f3af0f39adcc7f4$var$STAGING_SUFFIXES) || (0, $gPPT7.isFedramp)(lower) || (0, $gPPT7.isIsolatedCloud)(lower);
}
const $3f3af0f39adcc7f4$var$REFERENCE_DOMAINS = [
    'support.atlassian.com',
    'developer.atlassian.com',
    'community.atlassian.com'
];
function $3f3af0f39adcc7f4$var$isReferenceDomain(hostname) {
    return $3f3af0f39adcc7f4$var$matchesDomainList(hostname, $3f3af0f39adcc7f4$var$REFERENCE_DOMAINS);
}
function $3f3af0f39adcc7f4$export$f293869d7b7da38b(href) {
    const IS_ABSOLUTE_LINK_REGEX = /^(?:(http|https):\/\/)/;
    const IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
    const isAbsolute = IS_ABSOLUTE_LINK_REGEX.test(href);
    const isNonHttpBased = IS_NON_HTTP_BASED.test(href);
    const isRelative = !isAbsolute && !isNonHttpBased;
    if (isRelative) return 'navigation';
    let parsedUrl;
    try {
        parsedUrl = new URL(href);
    } catch  {
        return 'unknown';
    }
    if (!$3f3af0f39adcc7f4$var$isAtlassianDomain(parsedUrl.hostname)) return 'external';
    if ($3f3af0f39adcc7f4$var$isReferenceDomain(parsedUrl.hostname)) return 'reference';
    if ($3f3af0f39adcc7f4$var$isAtlassianDomain(parsedUrl.hostname)) return 'navigation';
    return 'unknown';
}
module.exports["classifyNavigationIntent"] = $3f3af0f39adcc7f4$export$f293869d7b7da38b;

});

parcelRegister("hojDG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $27be7c542cd53f0f$var$NavigationContextReact = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $27be7c542cd53f0f$export$e41452ac1c641b11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamsNavigationProvider(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { value: value, children: children } = t0;
    const ancestorEntryPoint = (0, $cozmU.useContext)($27be7c542cd53f0f$var$NavigationContextReact)?.contextEntryPoint;
    let t1;
    if ($[0] !== ancestorEntryPoint || $[1] !== value) {
        t1 = !value.contextEntryPoint && ancestorEntryPoint ? {
            ...value,
            contextEntryPoint: ancestorEntryPoint
        } : value;
        $[0] = ancestorEntryPoint;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    const contextValue = t1;
    let t2;
    if ($[3] !== children || $[4] !== contextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($27be7c542cd53f0f$var$NavigationContextReact.Provider, {
            value: contextValue
        }, children);
        $[3] = children;
        $[4] = contextValue;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function TeamsNavigationProvider({ value: value, children: children }) {
    const ancestorEntryPoint = (0, $cozmU.useContext)($27be7c542cd53f0f$var$NavigationContextReact)?.contextEntryPoint;
    const contextValue = (0, $cozmU.useMemo)(()=>!value.contextEntryPoint && ancestorEntryPoint ? {
            ...value,
            contextEntryPoint: ancestorEntryPoint
        } : value, [
        ancestorEntryPoint,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($27be7c542cd53f0f$var$NavigationContextReact.Provider, {
        value: contextValue
    }, children);
};
const $27be7c542cd53f0f$export$f3c3decdfa7dda68 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useTeamsNavigationContext() {
    const $ = (0, $bDgLe.c)(2);
    const context = (0, $cozmU.useContext)($27be7c542cd53f0f$var$NavigationContextReact);
    let t0;
    if ($[0] !== context) {
        t0 = context ?? {};
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useTeamsNavigationContext() {
    const context = (0, $cozmU.useContext)($27be7c542cd53f0f$var$NavigationContextReact);
    return context ?? {};
};
module.exports["TeamsNavigationProvider"] = $27be7c542cd53f0f$export$e41452ac1c641b11;
module.exports["useTeamsNavigationContext"] = $27be7c542cd53f0f$export$f3c3decdfa7dda68;

});

parcelRegister("hS5Ee", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f767605c1291541e11ee398674a3c525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d02bdc63cc831cb8$var$_react = $d02bdc63cc831cb8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d02bdc63cc831cb8$var$_baseNew = $d02bdc63cc831cb8$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d02bdc63cc831cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d02bdc63cc831cb8$var$LocationIcon = (props)=>/*#__PURE__*/ $d02bdc63cc831cb8$var$_react.default.createElement($d02bdc63cc831cb8$var$_baseNew.default, Object.assign({
        name: "LocationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$d02bdc63cc831cb8$var$LocationIcon.displayName = 'LocationIcon';
var $d02bdc63cc831cb8$var$_default = module.exports.default = $d02bdc63cc831cb8$var$LocationIcon;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("iXXww", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $6V5rQ = parcelRequire("6V5rQ");


var $gPPT7 = parcelRequire("gPPT7");


var $hojDG = parcelRequire("hojDG");

const $7a71d4cc37b329c3$export$72d1cecfc3326890 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    let children;
    let href;
    let onClick;
    let rest;
    if ($[0] !== props) {
        ({ href: href, onClick: onClick, children: children, ...rest } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = onClick;
        $[4] = rest;
    } else {
        children = $[1];
        href = $[2];
        onClick = $[3];
        rest = $[4];
    }
    const context = (0, $hojDG.useTeamsNavigationContext)();
    let t0;
    if ($[5] !== context || $[6] !== href || $[7] !== onClick || $[8] !== props) {
        const input = (0, $gPPT7.buildNavigationInput)({
            ...props,
            href: href ?? "",
            context: context,
            onBeforeNavigate: onClick
        });
        t0 = (0, $6V5rQ.getNavigationProps)(input);
        $[5] = context;
        $[6] = href;
        $[7] = onClick;
        $[8] = props;
        $[9] = t0;
    } else t0 = $[9];
    const { onClick: composedOnClick, href: resolvedHref, target: target, rel: rel } = t0;
    let t1;
    if ($[10] !== children || $[11] !== composedOnClick || $[12] !== rel || $[13] !== resolvedHref || $[14] !== rest || $[15] !== target) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            ...rest,
            href: resolvedHref,
            target: target,
            rel: rel,
            onClick: composedOnClick
        }, children);
        $[10] = children;
        $[11] = composedOnClick;
        $[12] = rel;
        $[13] = resolvedHref;
        $[14] = rest;
        $[15] = target;
        $[16] = t1;
    } else t1 = $[16];
    return t1;
} : (props)=>{
    const { href: href, onClick: onClick, children: children, ...rest } = props;
    const context = (0, $hojDG.useTeamsNavigationContext)();
    const input = (0, $gPPT7.buildNavigationInput)({
        ...props,
        href: href ?? '',
        context: context,
        onBeforeNavigate: onClick
    });
    const { onClick: composedOnClick, href: resolvedHref, target: target, rel: rel } = (0, $6V5rQ.getNavigationProps)(input);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        ...rest,
        href: resolvedHref,
        target: target,
        rel: rel,
        onClick: composedOnClick
    }, children);
};
module.exports["TeamsLink"] = $7a71d4cc37b329c3$export$72d1cecfc3326890;

});

parcelRegister("buXlg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jyWTZ = parcelRequire("jyWTZ");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");

const $5fb324c8098a6165$export$62aa48085237e36f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fireAnalytics: fireAnalytics, profileType: profileType } = t0;
    let t1;
    let t2;
    if ($[0] !== fireAnalytics || $[1] !== profileType) {
        t1 = ()=>{
            if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileType)}.rendered.spinner`, {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            fireAnalytics,
            profileType
        ];
        $[0] = fireAnalytics;
        $[1] = profileType;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jyWTZ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null));
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $cozmU.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileType)}.rendered.spinner`, {
            firedAt: Math.round((0, $1GhPJ.getPageTime)()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jyWTZ.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null));
};
module.exports["LoadingState"] = $5fb324c8098a6165$export$62aa48085237e36f;

});

parcelRegister("l0Ey3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $mfdwv = parcelRequire("mfdwv");

const $65ffbdb08fd6ebe6$export$38f9b635c1c454e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
            ...props,
            label: ""
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $65ffbdb08fd6ebe6$export$38f9b635c1c454e7;

});

parcelRegister("fmu9K", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("iTJtk")).FabricChannel);

var $hpWmZ = parcelRequire("hpWmZ");


var $lMjmr = parcelRequire("lMjmr");


var $iTJtk = parcelRequire("iTJtk");


});

parcelRegister("jPaq9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $jC4nA = parcelRequire("jC4nA");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $l0Ey3 = parcelRequire("l0Ey3");


var $hNTpD = parcelRequire("hNTpD");

const $ac4acb6d8564709e$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $ac4acb6d8564709e$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $ac4acb6d8564709e$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let children;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ children: children, whiteSpacePreWrap: t1, renderIcon: t2, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
    } else {
        children = $[1];
        props = $[2];
        t1 = $[3];
        t2 = $[4];
    }
    const whiteSpacePreWrap = t1 === undefined ? true : t1;
    const renderIcon = t2 === undefined ? true : t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== renderIcon) {
        t4 = renderIcon ? /*#__PURE__*/ $cozmU.createElement((0, $l0Ey3.ChatPillIcon), null) : null;
        $[6] = renderIcon;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = whiteSpacePreWrap && $ac4acb6d8564709e$var$styles.whiteSpacePreWrap;
    let t6;
    if ($[8] !== t5) {
        t6 = (0, $w6R6I.cx)($ac4acb6d8564709e$var$styles.queryText, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== children || $[11] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: t6
        }, children);
        $[10] = children;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t4 || $[14] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.075",
            alignBlock: "baseline"
        }, t4, t7));
        $[13] = t4;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== props || $[17] !== ref || $[18] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            ref: ref,
            ...props,
            xcss: $ac4acb6d8564709e$var$styles.button
        }, t8);
        $[16] = props;
        $[17] = ref;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        ref: ref,
        ...props,
        xcss: $ac4acb6d8564709e$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.075",
        alignBlock: "baseline"
    }, renderIcon ? /*#__PURE__*/ $cozmU.createElement((0, $l0Ey3.ChatPillIcon), null) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ac4acb6d8564709e$var$styles.queryText, whiteSpacePreWrap && $ac4acb6d8564709e$var$styles.whiteSpacePreWrap)
    }, children)))));
const $ac4acb6d8564709e$export$76b47032dcd9063b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(10);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
            color: "currentColor",
            label: ""
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $hNTpD.default).browseAgentsPillLabel);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t0
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.050",
            xcss: $ac4acb6d8564709e$var$styles.buttonInline
        }, t1, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $ac4acb6d8564709e$var$styles.queryText
        }, t2)));
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== props || $[7] !== ref || $[8] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            ref: ref,
            ...props,
            xcss: $ac4acb6d8564709e$var$styles.button
        }, t3);
        $[6] = props;
        $[7] = ref;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props, ref)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        ref: ref,
        ...props,
        xcss: $ac4acb6d8564709e$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.050",
        xcss: $ac4acb6d8564709e$var$styles.buttonInline
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        color: "currentColor",
        label: ""
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $ac4acb6d8564709e$var$styles.queryText
    }, formatMessage((0, $hNTpD.default).browseAgentsPillLabel)))));
});
module.exports["ChatPill"] = $ac4acb6d8564709e$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $ac4acb6d8564709e$export$76b47032dcd9063b;

});

parcelRegister("hNTpD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d5949bd621a1b2eb$var$message = (0, $kSwu1.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse agents"
    }
});
var $d5949bd621a1b2eb$export$2e2bcd8739ae039 = $d5949bd621a1b2eb$var$message;
module.exports["default"] = $d5949bd621a1b2eb$export$2e2bcd8739ae039;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("kmvdJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5ae331244e5ce5f0d911605ea315070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed2e1473028ddf28$var$_react = $ed2e1473028ddf28$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ed2e1473028ddf28$var$_baseNew = $ed2e1473028ddf28$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ed2e1473028ddf28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed2e1473028ddf28$var$AudioIcon = (props)=>/*#__PURE__*/ $ed2e1473028ddf28$var$_react.default.createElement($ed2e1473028ddf28$var$_baseNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$ed2e1473028ddf28$var$AudioIcon.displayName = 'AudioIcon';
var $ed2e1473028ddf28$var$_default = module.exports.default = $ed2e1473028ddf28$var$AudioIcon;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $88149 = parcelRequire("88149");

const $c358709489b4576e$var$FileIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $88149 = parcelRequire("88149");

const $3736b97729106be6$var$ChartBarIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $88149 = parcelRequire("88149");

const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("rECdA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("8m50u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $fb7caad66dba5065$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $fb7caad66dba5065$export$6e8ea24b15199873;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("8Xvwd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dUI0h = parcelRequire("dUI0h");

/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $17a57d278defc8d4$var$CheckboxField = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, defaultIsChecked: t1, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value } = t0;
    const defaultIsChecked = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== defaultIsChecked || $[1] !== value) {
        t2 = (t3)=>{
            const currentValue = t3 === undefined ? [] : t3;
            return defaultIsChecked && value !== undefined ? [
                ...currentValue,
                value
            ] : currentValue;
        };
        $[0] = defaultIsChecked;
        $[1] = value;
        $[2] = t2;
    } else t2 = $[2];
    const defaultValue = t2;
    let t3;
    if ($[3] !== children || $[4] !== defaultIsChecked || $[5] !== defaultValue || $[6] !== isDisabled || $[7] !== isRequired || $[8] !== label || $[9] !== name || $[10] !== value) {
        t3 = value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            defaultValue: defaultValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            label: label,
            name: name,
            transform: (event, currentValue_0)=>!Array.isArray(event) && event.currentTarget.checked && currentValue_0 ? [
                    ...currentValue_0,
                    value
                ] : currentValue_0.filter((v)=>v !== value)
        }, (t4)=>{
            const { fieldProps: t5, ...others } = t4;
            const { value: fieldValue, onChange: onChange, ...otherFieldProps } = t5;
            return children({
                fieldProps: {
                    ...otherFieldProps,
                    onChange: (v_0)=>onChange(v_0),
                    isChecked: !!fieldValue.find((v_1)=>v_1 === value),
                    value: value
                },
                ...others
            });
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            defaultValue: defaultIsChecked,
            isDisabled: isDisabled,
            isRequired: isRequired,
            label: label,
            name: name,
            transform: $17a57d278defc8d4$var$_temp
        }, (t6)=>{
            const { fieldProps: t7, ...others_0 } = t6;
            const { value: fieldValue_0, onChange: onChange_0, ...otherFieldProps_0 } = t7;
            return children({
                fieldProps: {
                    ...otherFieldProps_0,
                    onChange: (v_2)=>onChange_0(v_2),
                    isChecked: fieldValue_0,
                    value: value
                },
                ...others_0
            });
        });
        $[3] = children;
        $[4] = defaultIsChecked;
        $[5] = defaultValue;
        $[6] = isDisabled;
        $[7] = isRequired;
        $[8] = label;
        $[9] = name;
        $[10] = value;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $cozmU.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue_0)=>!Array.isArray(event) && event.currentTarget.checked && currentValue_0 ? [
                ...currentValue_0,
                value
            ] : currentValue_0.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                // Setting to any because it's typed weirdly at the field level
                onChange: (v_0)=>onChange(v_0),
                isChecked: !!fieldValue.find((v_1)=>v_1 === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event_0)=>typeof event_0 === 'boolean' ? event_0 : event_0.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue_0, onChange: onChange_0, ...otherFieldProps_0 }, ...others_0 })=>children({
            fieldProps: {
                ...otherFieldProps_0,
                // Setting to any because it's typed weirdly at the field level
                onChange: (v_2)=>onChange_0(v_2),
                isChecked: fieldValue_0,
                value: value
            },
            ...others_0
        }));
};
var $17a57d278defc8d4$export$2e2bcd8739ae039 = $17a57d278defc8d4$var$CheckboxField;
function $17a57d278defc8d4$var$_temp(event_0) {
    return typeof event_0 === "boolean" ? event_0 : event_0.currentTarget.checked;
}
module.exports["default"] = $17a57d278defc8d4$export$2e2bcd8739ae039;

});

parcelRegister("e3Wrf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$transitionDuration = '0.2s';
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$baseStylesT26Shape = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(63);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] !== appearance || $[37] !== isMonospaced || $[38] !== resize) {
        t20 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $iDrrr.fg)("platform-dst-shape-theme-default") && "_2rko1qi0",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]);
        $[36] = appearance;
        $[37] = isMonospaced;
        $[38] = resize;
        $[39] = t20;
    } else t20 = $[39];
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[40] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[42] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== maxHeight || $[45] !== style || $[46] !== t22 || $[47] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[44] = maxHeight;
        $[45] = style;
        $[46] = t22;
        $[47] = t24;
        $[48] = t25;
    } else t25 = $[48];
    let t26;
    if ($[49] !== controlProps || $[50] !== getTextAreaRef || $[51] !== handleOnChange || $[52] !== isDisabled || $[53] !== isReadOnly || $[54] !== isRequired || $[55] !== minimumRows || $[56] !== onBlurWithAnalytics || $[57] !== onFocusWithAnalytics || $[58] !== rest || $[59] !== t20 || $[60] !== t25 || $[61] !== value) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[49] = controlProps;
        $[50] = getTextAreaRef;
        $[51] = handleOnChange;
        $[52] = isDisabled;
        $[53] = isReadOnly;
        $[54] = isRequired;
        $[55] = minimumRows;
        $[56] = onBlurWithAnalytics;
        $[57] = onFocusWithAnalytics;
        $[58] = rest;
        $[59] = t20;
        $[60] = t25;
        $[61] = value;
        $[62] = t26;
    } else t26 = $[62];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TextArea(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("fLtAn", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");


var $j39Hd = parcelRequire("j39Hd");

const $aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE = 'smart-card-social-proof';
const $aff19b92c38e9221$export$f44b87513fae83d9 = 'site-cloud-id:v1:';
const $aff19b92c38e9221$export$a99d139543208cca = 86400000;
const $aff19b92c38e9221$var$smartCardStorage = new (0, $6YrB3.default)($aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE);
function $aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
function $aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash = '') {
    return `${$aff19b92c38e9221$export$f44b87513fae83d9}${encodeURIComponent($aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash))}`;
}
const $aff19b92c38e9221$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${$aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE}_${$aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash)}`;
const $aff19b92c38e9221$export$b4b75b5ce5d33ae5 = $aff19b92c38e9221$export$dea1a8bc5840f118();
class $aff19b92c38e9221$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $aff19b92c38e9221$var$smartCardStorage.getItem($aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $aff19b92c38e9221$var$smartCardStorage.setItemWithExpiry($aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash), cloudId, $aff19b92c38e9221$export$a99d139543208cca);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = $aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $j39Hd.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
const $aff19b92c38e9221$export$1956112846aa829e = new $aff19b92c38e9221$export$a15da722a3b05509();
function $aff19b92c38e9221$export$763646cf0dfa675c(baseUriWithNoTrailingSlash = '') {
    return $aff19b92c38e9221$export$1956112846aa829e.getStoredCloudId(baseUriWithNoTrailingSlash);
}
const $aff19b92c38e9221$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>$aff19b92c38e9221$export$1956112846aa829e.get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudIdSync"] = $aff19b92c38e9221$export$763646cf0dfa675c;
module.exports["getCurrentSiteCloudId"] = $aff19b92c38e9221$export$143af22820ae9de;

});

parcelRegister("kMzDv", function(module, exports) {
$parcel$export(module.exports, "auth", () => (parcelRequire("eEPSE")).auth);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("7zxJs")).AuthError);

var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");


});

parcelRegister("eEPSE", function(module, exports) {

var $7zxJs = parcelRequire("7zxJs");


var $75u2V = parcelRequire("75u2V");

function $4e31e5414e67a93e$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $75u2V.isOfTypeAuthError)(errorType)) reject(new (0, $7zxJs.AuthError)(data.message, errorType));
                    else reject(new (0, $7zxJs.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $7zxJs.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $4e31e5414e67a93e$export$73693bad9f5880b0;

});

parcelRegister("7zxJs", function(module, exports) {
class $dd3fe40c981b3bd9$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $dd3fe40c981b3bd9$export$145273558d58e0ac;

});

parcelRegister("75u2V", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $6f56de9d96dc4f7f$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $6f56de9d96dc4f7f$export$400e64c8451aa84f;

});

parcelRegister("1G3WB", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");

const $dc93231c4629fa01$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $2zVsi.functionWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), functionTrue, functionFalse);
module.exports["functionWithFG"] = $dc93231c4629fa01$export$53903226fff06fbb;

});

parcelRegister("c3xon", function(module, exports) {

var $2zVsi = parcelRequire("2zVsi");

function $98c7b2cae218afe1$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return (0, $2zVsi.functionWithCondition)(condition, functionTrue, functionFalse);
}
module.exports["functionUnionWithCondition"] = $98c7b2cae218afe1$export$c41c28c1d883fcd5;

});

parcelRegister("gJj3k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jpl1A = parcelRequire("jpl1A");


var $19zon = parcelRequire("19zon");

const $5b6c9e2393a4e885$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $19zon.useConfluencePageData)(props.src || '', extensionKey || '');
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jpl1A.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};
module.exports["IFrame"] = $5b6c9e2393a4e885$export$b32b5f1ee4493319;

});

parcelRegister("jpl1A", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $huDU4 = parcelRequire("huDU4");

const $4e16066777de6fa0$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huDU4.Page), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huDU4.Page), props));
module.exports["Page"] = $4e16066777de6fa0$export$6955bcca4cd3539f;

});

parcelRegister("cuq2s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $q9Cpn = parcelRequire("q9Cpn");

const $cc5224b9f28cd9ed$export$a54013f0d02a8f82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $q9Cpn.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $cozmU.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $q9Cpn.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $q9Cpn.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    const locale = (0, $cozmU.useMemo)(()=>(0, $q9Cpn.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $cozmU.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $cc5224b9f28cd9ed$export$a54013f0d02a8f82;

});

parcelRegister("q9Cpn", function(module, exports) {
const $bacd93d5d71e2df6$var$DEFAULT_LANGUAGE = 'en';
const $bacd93d5d71e2df6$var$DEFAULT_REGION = 'US';
const $bacd93d5d71e2df6$export$1af4c7e47ad72f44 = `${$bacd93d5d71e2df6$var$DEFAULT_LANGUAGE}-${$bacd93d5d71e2df6$var$DEFAULT_REGION}`;
const $bacd93d5d71e2df6$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $bacd93d5d71e2df6$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $bacd93d5d71e2df6$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $bacd93d5d71e2df6$export$dca0327c9b9c6498;

});

parcelRegister("ZTkH5", function(module, exports) {

var $bhgzl = parcelRequire("bhgzl");


var $kN2Vj = parcelRequire("kN2Vj");

const $7689e3ff3e3f1e38$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $bhgzl.default;
        case 'en-US':
        default:
            return 0, $kN2Vj.default;
    }
};
var $7689e3ff3e3f1e38$export$2e2bcd8739ae039 = $7689e3ff3e3f1e38$var$fetchTranslations;
module.exports["default"] = $7689e3ff3e3f1e38$export$2e2bcd8739ae039;

});

parcelRegister("bhgzl", function(module, exports) {
$parcel$export(module.exports, "default", () => $934ba482728c60bf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $934ba482728c60bf$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("kN2Vj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ff8966a59ac9886$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2ff8966a59ac9886$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("huDU4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bneqI = parcelRequire("bneqI");


var $kSwu1 = parcelRequire("kSwu1");


var $lNV6K = parcelRequire("lNV6K");


var $eqf9i = parcelRequire("eqf9i");

const $2a2f2045c781985c$var$ViewComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNV6K.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNV6K.ViewPage), {
        locale: locale,
        ...props
    });
};
const $2a2f2045c781985c$var$EditComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqf9i.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqf9i.EditPage), {
        locale: locale,
        ...props
    });
};
const $2a2f2045c781985c$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bneqI.Page), {
            locale: locale,
            ...props,
            viewComponent: $2a2f2045c781985c$var$ViewComponent,
            editComponent: $2a2f2045c781985c$var$EditComponent
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bneqI.Page), {
        locale: locale,
        ...props,
        viewComponent: $2a2f2045c781985c$var$ViewComponent,
        editComponent: $2a2f2045c781985c$var$EditComponent
    });
};
module.exports["Page"] = $2a2f2045c781985c$export$6955bcca4cd3539f;

});

parcelRegister("lNV6K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $d6sBA = parcelRequire("d6sBA");

const $33123752fa9ae571$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6sBA.ViewPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6sBA.ViewPage), props));
module.exports["ViewPage"] = $33123752fa9ae571$export$767e3006bdbb424a;

});

parcelRegister("d6sBA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $50kEc = parcelRequire("50kEc");


var $kSwu1 = parcelRequire("kSwu1");

const $f2833a7709cd73fa$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50kEc.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50kEc.ViewPage), {
        locale: locale,
        ...props
    });
};
module.exports["ViewPage"] = $f2833a7709cd73fa$export$767e3006bdbb424a;

});

parcelRegister("eqf9i", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $b06A9 = parcelRequire("b06A9");

const $93cc002eb7ec4a9a$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b06A9.EditPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b06A9.EditPage), props));
module.exports["EditPage"] = $93cc002eb7ec4a9a$export$1fea75498367c4ac;

});

parcelRegister("b06A9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4nZvv = parcelRequire("4nZvv");


var $kSwu1 = parcelRequire("kSwu1");

const $3470eb5cef855d36$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4nZvv.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4nZvv.EditPage), {
        locale: locale,
        ...props
    });
};
module.exports["EditPage"] = $3470eb5cef855d36$export$1fea75498367c4ac;

});

parcelRegister("19zon", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k4lqb = parcelRequire("k4lqb");


var $jIrdU = parcelRequire("jIrdU");

var $0848f0766ba8a46c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $0848f0766ba8a46c$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $0848f0766ba8a46c$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $0848f0766ba8a46c$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $cozmU.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($0848f0766ba8a46c$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $jIrdU.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $cozmU.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $k4lqb.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $0848f0766ba8a46c$export$10fb2803bc7b79fc;

});

parcelRegister("36Uax", function(module, exports) {

var $bVevd = parcelRequire("bVevd");


var $kTPbu = parcelRequire("kTPbu");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("hMKdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ctzvi = parcelRequire("ctzvi");

const $e93c907c43f1ec9c$var$UniqueKeyContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    uniqueKey: undefined
});
const $e93c907c43f1ec9c$export$71829d27b87a2006 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ctzvi.createUniqueKey)();
        $[0] = t1;
    } else t1 = $[0];
    const uniqueKey = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            uniqueKey: uniqueKey
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children })=>{
    const uniqueKey = (0, $cozmU.useMemo)(()=>(0, $ctzvi.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        }
    }, children);
};
const $e93c907c43f1ec9c$export$cef64a0cfb90e369 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
} : ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $e93c907c43f1ec9c$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $e93c907c43f1ec9c$export$cef64a0cfb90e369;

});

parcelRegister("lWz4S", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRK7f = parcelRequire("iRK7f");


var $hDLmU = parcelRequire("hDLmU");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $495e0a92c5164d61$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $495e0a92c5164d61$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $495e0a92c5164d61$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $cozmU.useState)(contentType);
    const isInitialized = (0, $cozmU.useRef)(true);
    const iframeLoadMetrics = (0, $cozmU.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $iRK7f.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $cozmU.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $iRK7f.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $cozmU.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $cozmU.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};
const $495e0a92c5164d61$export$865423e6f8e2e839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
} : ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
};
const $495e0a92c5164d61$export$c6f19d9afc6c86c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentType: contentType, sourceComponent: sourceComponent } = t0;
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    let t1;
    let t2;
    if ($[0] !== contentType || $[1] !== isInitialized || $[2] !== setContentType) {
        t1 = ()=>{
            isInitialized && contentType && setContentType(contentType);
        };
        t2 = [
            isInitialized,
            contentType,
            setContentType
        ];
        $[0] = contentType;
        $[1] = isInitialized;
        $[2] = setContentType;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children || $[6] !== contentType || $[7] !== isInitialized || $[8] !== sourceComponent) {
        t3 = !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
            contentType: contentType,
            sourceComponent: sourceComponent
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[5] = children;
        $[6] = contentType;
        $[7] = isInitialized;
        $[8] = sourceComponent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    (0, $cozmU.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["usePerformanceMetrics"] = $495e0a92c5164d61$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $495e0a92c5164d61$export$c6f19d9afc6c86c8;

});

parcelRegister("iRK7f", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");


var $lCTbz = parcelRequire("lCTbz");

const $e6b49468896929e5$export$4de078c3b9971f9b = ()=>(0, $iDdTC.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $e6b49468896929e5$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $e6b49468896929e5$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    }
};
const $e6b49468896929e5$export$a23245993532c751 = (contentType)=>(0, $iDdTC.metrics).pageSegmentLoad($e6b49468896929e5$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $e6b49468896929e5$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $e6b49468896929e5$export$a23245993532c751;

});

parcelRegister("hDLmU", function(module, exports) {
const $b5c2a7dcc1a96b34$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $b5c2a7dcc1a96b34$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $b5c2a7dcc1a96b34$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $b5c2a7dcc1a96b34$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $b5c2a7dcc1a96b34$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $b5c2a7dcc1a96b34$export$73b982309451f084;

});

parcelRegister("ij75C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fcaWu = parcelRequire("fcaWu");


var $36Uax = parcelRequire("36Uax");


var $hMKdq = parcelRequire("hMKdq");


var $kTPbu = parcelRequire("kTPbu");

var $bVevd = parcelRequire("bVevd");


var $eAWIs = parcelRequire("eAWIs");

const $1ae0fabae864f28a$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $fcaWu.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $1ae0fabae864f28a$var$serializeQueryParams = (queryParams)=>queryParams ? new URLSearchParams(Object.entries(queryParams).sort(([paramA], [paramB])=>paramA.localeCompare(paramB))).toString() : '';
const $1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $1ae0fabae864f28a$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $1ae0fabae864f28a$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, queryParams: consumerQueryParams, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $cozmU.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $cozmU.useMemo)(()=>allowedFeatures === 'all' ? (0, $36Uax.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature_0)=>feature_0 !== 'edit' && feature_0 !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature_1)=>!$1ae0fabae864f28a$var$nonAllFeatures.includes(feature_1)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature_2)=>(0, $eAWIs.isRedirectionEnabled)(feature_2)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $eAWIs.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const consumerQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(consumerQueryParams);
    const contentConfigurationQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(contentConfiguration?.queryParams);
    const queryParams = (0, $cozmU.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $1ae0fabae864f28a$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        const searchParams = new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery
        });
        new URLSearchParams(consumerQueryParamsString).forEach((value, key)=>{
            if (!searchParams.has(key)) searchParams.set(key, value);
        });
        new URLSearchParams(contentConfigurationQueryParamsString).forEach((value_0, key_0)=>{
            searchParams.set(key_0, value_0);
        });
        return `?${searchParams.toString()}`;
    }, [
        consumerQueryParamsString,
        contentConfigurationQueryParamsString,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $cozmU.useMemo)(()=>({
            ...$1ae0fabae864f28a$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $1ae0fabae864f28a$var$CONTEXT_PATH = '/wiki/spaces';
const $1ae0fabae864f28a$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $1ae0fabae864f28a$var$constructUrl(mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$1ae0fabae864f28a$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$1ae0fabae864f28a$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $1ae0fabae864f28a$export$6e43e60d51b79331;
module.exports["useUrl"] = $1ae0fabae864f28a$export$305222dff575c4e3;

});

parcelRegister("eAWIs", function(module, exports) {
const $66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $66050da24b77bea6$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $66050da24b77bea6$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$66050da24b77bea6$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $66050da24b77bea6$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $66050da24b77bea6$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $66050da24b77bea6$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $66050da24b77bea6$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $66050da24b77bea6$export$243fbba563b8aa8e;

});

parcelRegister("3Xkfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $fBqzD = parcelRequire("fBqzD");


var $iMQz5 = parcelRequire("iMQz5");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $gITbz = parcelRequire("gITbz");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $jrSlu = parcelRequire("jrSlu");


var $jawC3 = parcelRequire("jawC3");

const $f1ce3764841d3d06$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $f1ce3764841d3d06$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $f1ce3764841d3d06$var$getEmptyJsonLd = ()=>$f1ce3764841d3d06$var$emptyData;
const $f1ce3764841d3d06$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $f1ce3764841d3d06$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $jawC3.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $f1ce3764841d3d06$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];
const $f1ce3764841d3d06$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};

const $f1ce3764841d3d06$var$getBlogIconWrapped = ()=>(parcelRequire("6kJW0")).default;

const $f1ce3764841d3d06$var$getDocumentIcon = ()=>(parcelRequire("9v3GN")).default;

const $f1ce3764841d3d06$var$getFileIcon = ()=>(parcelRequire("4Emmj")).default;

const $f1ce3764841d3d06$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dGdE6")).default;

const $f1ce3764841d3d06$var$getPresentationIcon = ()=>(parcelRequire("b5Dss")).default;

const $f1ce3764841d3d06$var$getSpreadsheetIcon = ()=>(parcelRequire("7vzLW")).default;
const $f1ce3764841d3d06$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $jawC3.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $f1ce3764841d3d06$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: $f1ce3764841d3d06$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $f1ce3764841d3d06$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
        label: $f1ce3764841d3d06$var$documentLabel(opts, 'file'),
        testId: "file-icon"
    });
};
const $f1ce3764841d3d06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $f1ce3764841d3d06$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $f1ce3764841d3d06$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $f1ce3764841d3d06$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $f1ce3764841d3d06$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: $f1ce3764841d3d06$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
const $f1ce3764841d3d06$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $hhrxw.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $hhrxw.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $hhrxw.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $hhrxw.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $hhrxw.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $hhrxw.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $hhrxw.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $hhrxw.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $hhrxw.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $hhrxw.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $hhrxw.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $f1ce3764841d3d06$var$typeToIcon = (type, opts)=>{
    const getLabel = (title)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $f1ce3764841d3d06$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $f1ce3764841d3d06$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $f1ce3764841d3d06$var$extractIconFromDocument(type, opts);
        default:
            return type ? $f1ce3764841d3d06$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $f1ce3764841d3d06$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $jawC3.extractTitle)(jsonLd)
        },
        provider: (0, $jawC3.extractProvider)(jsonLd),
        fileFormat: $f1ce3764841d3d06$var$extractFileFormat(jsonLd),
        taskType: $f1ce3764841d3d06$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $jawC3.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$f1ce3764841d3d06$var$extractorPriorityMap[b] - $f1ce3764841d3d06$var$extractorPriorityMap[a])[0];
        return $f1ce3764841d3d06$var$extractIconByType(highestPriorityType, opts);
    } else return $f1ce3764841d3d06$var$extractIconByType(type, opts);
};
const $f1ce3764841d3d06$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $jawC3.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $hhrxw.JIRA_GENERATOR_ID)) return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $f1ce3764841d3d06$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $jawC3.isEntityPresent)(response)) {
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            const entityIcon = (0, $jawC3.extractEntityIcon)(response);
            if (entityIcon) return [
                entityIcon.url,
                entityIcon.label
            ];
        }
        const provider = (0, $jawC3.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $f1ce3764841d3d06$var$extractInlineIcon(response?.data || $f1ce3764841d3d06$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $f1ce3764841d3d06$export$643db2ee2409e635;

});

parcelRegister("jrSlu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $l8WFq = parcelRequire("l8WFq");























const $73d439951cf388f8$var$getLazyIcons = ()=>({
        [(0, $hhrxw.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9v3GN")))
        },
        [(0, $hhrxw.IconType).Audio]: {
            default: ()=>(parcelRequire("kPWC0"))
        },
        [(0, $hhrxw.IconType).Code]: {
            default: ()=>(parcelRequire("7nVQ2"))
        },
        [(0, $hhrxw.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Folder]: {
            default: ()=>(parcelRequire("9VLzs"))
        },
        [(0, $hhrxw.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Image]: {
            default: ()=>(parcelRequire("j9LJx"))
        },
        [(0, $hhrxw.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("b5Dss")))
        },
        [(0, $hhrxw.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("7vzLW")))
        },
        [(0, $hhrxw.IconType).Video]: {
            default: ()=>(parcelRequire("96zb4"))
        },
        [(0, $hhrxw.IconType).Archive]: {
            default: ()=>Promise.resolve((parcelRequire("iqehY")))
        },
        [(0, $hhrxw.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89"))
        },
        [(0, $hhrxw.IconType).GIF]: {
            default: ()=>Promise.resolve((parcelRequire("EhIdb")))
        },
        [(0, $hhrxw.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2"))
        },
        [(0, $hhrxw.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ"))
        },
        [(0, $hhrxw.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN"))
        },
        [(0, $hhrxw.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly"))
        },
        [(0, $hhrxw.IconType).MSExcel]: {
            default: ()=>Promise.resolve((parcelRequire("1kVaD")))
        },
        [(0, $hhrxw.IconType).MSPowerpoint]: {
            default: ()=>Promise.resolve((parcelRequire("aeJll")))
        },
        [(0, $hhrxw.IconType).MSWord]: {
            default: ()=>Promise.resolve((parcelRequire("8If3N")))
        },
        [(0, $hhrxw.IconType).PDF]: {
            default: ()=>Promise.resolve((parcelRequire("8B1YK")))
        },
        [(0, $hhrxw.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm"))
        }
    });
const $73d439951cf388f8$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $l8WFq.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $73d439951cf388f8$var$getLazyIcons();
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
    return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $73d439951cf388f8$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $73d439951cf388f8$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || '';
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
module.exports["getIconForFileType"] = $73d439951cf388f8$export$4d685c85ebc7a1e3;

});

parcelRegister("l8WFq", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $eb169b73453c71b7$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $hhrxw.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $hhrxw.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $hhrxw.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $hhrxw.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $hhrxw.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $hhrxw.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $hhrxw.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $hhrxw.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $hhrxw.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $hhrxw.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $hhrxw.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $hhrxw.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $hhrxw.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $hhrxw.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $hhrxw.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $hhrxw.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $eb169b73453c71b7$export$2e2bcd8739ae039 = $eb169b73453c71b7$var$extractFileFormatIcon;
module.exports["default"] = $eb169b73453c71b7$export$2e2bcd8739ae039;

});

parcelRegister("kPWC0", function(module, exports) {

let $f2b60935c73a6c05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2b60935c73a6c05$var$load("gkVge"),
    $f2b60935c73a6c05$var$load("hLbGw")
]).then(()=>parcelRequire('hyaPI'));

});

parcelRegister("7nVQ2", function(module, exports) {

let $56078bdb4bba4b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56078bdb4bba4b6f$var$load("kDfOJ").then(()=>parcelRequire('gMML3'));

});

parcelRegister("9VLzs", function(module, exports) {

let $73ae5688c13ac7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73ae5688c13ac7f1$var$load("6wr18"),
    $73ae5688c13ac7f1$var$load("ffEVr"),
    $73ae5688c13ac7f1$var$load("iN2uJ")
]).then(()=>parcelRequire('giuMD'));

});

parcelRegister("j9LJx", function(module, exports) {

let $df23e277716dc04b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df23e277716dc04b$var$load("6wr18"),
    $df23e277716dc04b$var$load("ffEVr"),
    $df23e277716dc04b$var$load("6aZeI")
]).then(()=>parcelRequire('4b38C'));

});

parcelRegister("96zb4", function(module, exports) {

let $6a0ff61f5e39486f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a0ff61f5e39486f$var$load("6wr18"),
    $6a0ff61f5e39486f$var$load("ffEVr"),
    $6a0ff61f5e39486f$var$load("8TGE7")
]).then(()=>parcelRequire('8aT6O'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("6kJW0", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $h9stc = parcelRequire("h9stc");

const $616e4ede6f48d352$var$BlogIconWithColor = (0, $h9stc.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$616e4ede6f48d352$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $616e4ede6f48d352$export$2e2bcd8739ae039 = $616e4ede6f48d352$var$BlogIconWithColor;
module.exports["default"] = $616e4ede6f48d352$export$2e2bcd8739ae039;

});

parcelRegister("h9stc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2Fmt9 = parcelRequire("2Fmt9");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $886a479395619017$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $886a479395619017$var$isIconSizeLarge = (size)=>size && [
        (0, $hhrxw.SmartLinkSize).Large,
        (0, $hhrxw.SmartLinkSize).XLarge
    ].includes(size);
const $886a479395619017$export$3acc3fb10995f020 = (size)=>{
    if ((0, $iDrrr.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $hhrxw.SmartLinkSize).Small:
        case (0, $hhrxw.SmartLinkSize).Medium:
            return undefined;
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
const $886a479395619017$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($886a479395619017$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
const $886a479395619017$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $886a479395619017$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $886a479395619017$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconPerSize"] = $886a479395619017$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $886a479395619017$export$87c3646d0e299cfe;

});

parcelRegister("9v3GN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $h9stc = parcelRequire("h9stc");

const $fc0d527adbaaccfa$var$PageIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$fc0d527adbaaccfa$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $fc0d527adbaaccfa$export$2e2bcd8739ae039 = $fc0d527adbaaccfa$var$PageIconWithColor;
module.exports["default"] = $fc0d527adbaaccfa$export$2e2bcd8739ae039;

});

parcelRegister("4Emmj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $h9stc = parcelRequire("h9stc");

const $30795df12c6626e4$var$FileIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$30795df12c6626e4$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $30795df12c6626e4$export$2e2bcd8739ae039 = $30795df12c6626e4$var$FileIconWithColor;
module.exports["default"] = $30795df12c6626e4$export$2e2bcd8739ae039;

});

parcelRegister("dGdE6", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $h9stc = parcelRequire("h9stc");

const $c10f705a5270d647$var$LiveDocumentIconWithColor = (0, $h9stc.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$c10f705a5270d647$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $c10f705a5270d647$export$2e2bcd8739ae039 = $c10f705a5270d647$var$LiveDocumentIconWithColor;
module.exports["default"] = $c10f705a5270d647$export$2e2bcd8739ae039;

});

parcelRegister("b5Dss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $h9stc = parcelRequire("h9stc");

const $77093538826d7e25$var$ChartBarIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$77093538826d7e25$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $77093538826d7e25$export$2e2bcd8739ae039 = $77093538826d7e25$var$ChartBarIconWithColor;
module.exports["default"] = $77093538826d7e25$export$2e2bcd8739ae039;

});

parcelRegister("7vzLW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $h9stc = parcelRequire("h9stc");

const $7d25c80ed1a76c0d$var$ListBulletedIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$7d25c80ed1a76c0d$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $7d25c80ed1a76c0d$export$2e2bcd8739ae039 = $7d25c80ed1a76c0d$var$ListBulletedIconWithColor;
module.exports["default"] = $7d25c80ed1a76c0d$export$2e2bcd8739ae039;

});

parcelRegister("hyOTw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $52c0c0ab9e795973$var$placeholderShimmer = null;
const $52c0c0ab9e795973$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $52c0c0ab9e795973$var$spanSkeletonStyles = null;
const $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $52c0c0ab9e795973$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $52c0c0ab9e795973$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $52c0c0ab9e795973$export$2e2bcd8739ae039 = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $52c0c0ab9e795973$export$85d5658002cae6ce;
module.exports["Skeleton"] = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;

});

parcelRegister("cUcPn", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $cfc2cb470fbdc4fd$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $cfc2cb470fbdc4fd$export$2e2bcd8739ae039 = $cfc2cb470fbdc4fd$export$852ff24d0930c62f;
module.exports["default"] = $cfc2cb470fbdc4fd$export$2e2bcd8739ae039;

});

parcelRegister("iHsYL", function(module, exports) {


(function(global, factory) {
    factory(module.exports, (parcelRequire("lvJXz")), (parcelRequire("cozmU")));
})(module.exports, function(exports1, lottie, React) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var lottie__default = /*#__PURE__*/ _interopDefaultLegacy(lottie);
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[r] = t, e;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _objectWithoutProperties(e, t) {
        if (null == e) return {};
        var o, r, i = _objectWithoutPropertiesLoose(e, t);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
        }
        return i;
    }
    function _objectWithoutPropertiesLoose(r, e) {
        if (null == r) return {};
        var t = {};
        for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
            if (e.includes(n)) continue;
            t[n] = r[n];
        }
        return t;
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var _excluded$1 = [
        "animationData",
        "loop",
        "autoplay",
        "initialSegment",
        "onComplete",
        "onLoopComplete",
        "onEnterFrame",
        "onSegmentStart",
        "onConfigReady",
        "onDataReady",
        "onDataFailed",
        "onLoadedImages",
        "onDOMLoaded",
        "onDestroy",
        "lottieRef",
        "renderer",
        "name",
        "assetsPath",
        "rendererSettings"
    ];
    var useLottie = function useLottie(props, style) {
        var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
        props.lottieRef;
        props.renderer;
        props.name;
        props.assetsPath;
        props.rendererSettings;
        var rest = _objectWithoutProperties(props, _excluded$1);
        var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
        var animationInstanceRef = React.useRef();
        var animationContainer = React.useRef(null);
        /*
          ======================================
              INTERACTION METHODS
          ======================================
       */ /**
     * Play
     */ var play = function play() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.play();
        };
        /**
     * Stop
     */ var stop = function stop() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.stop();
        };
        /**
     * Pause
     */ var pause = function pause() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.pause();
        };
        /**
     * Set animation speed
     * @param speed
     */ var setSpeed = function setSpeed(speed) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSpeed(speed);
        };
        /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */ var goToAndPlay = function goToAndPlay(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndPlay(value, isFrame);
        };
        /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */ var goToAndStop = function goToAndStop(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndStop(value, isFrame);
        };
        /**
     * Set animation direction
     * @param direction
     */ var setDirection = function setDirection(direction) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setDirection(direction);
        };
        /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */ var playSegments = function playSegments(segments, forceFlag) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.playSegments(segments, forceFlag);
        };
        /**
     * Set sub frames
     * @param useSubFrames
     */ var setSubframe = function setSubframe(useSubFrames) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSubframe(useSubFrames);
        };
        /**
     * Get animation duration
     * @param inFrames
     */ var getDuration = function getDuration(inFrames) {
            var _a;
            return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
        };
        /**
     * Destroy animation
     */ var destroy = function destroy() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Removing the reference to the animation so separate cleanups are skipped.
            // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
            animationInstanceRef.current = undefined;
        };
        /*
          ======================================
              LOTTIE
          ======================================
       */ /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */ var loadAnimation = function loadAnimation() {
            var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _a;
            // Return if the container ref is null
            if (!animationContainer.current) return;
            // Destroy any previous instance
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Build the animation configuration
            var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
                container: animationContainer.current
            });
            // Save the animation instance
            animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
            setAnimationLoaded(!!animationInstanceRef.current);
            // Return a function that will clean up
            return function() {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
                animationInstanceRef.current = undefined;
            };
        };
        /**
     * (Re)Initialize when animation data changed
     */ React.useEffect(function() {
            var onUnmount = loadAnimation();
            // Clean up on unmount
            return function() {
                return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            animationData,
            loop
        ]);
        // Update the autoplay state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            animationInstanceRef.current.autoplay = !!autoplay;
        }, [
            autoplay
        ]);
        // Update the initial segment state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            // When null should reset to default animation length
            if (!initialSegment) {
                animationInstanceRef.current.resetSegments(true);
                return;
            }
            // If it's not a valid segment, do nothing
            if (!Array.isArray(initialSegment) || !initialSegment.length) return;
            // If the current position it's not in the new segment
            // set the current position to start
            if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) animationInstanceRef.current.currentRawFrame = initialSegment[0];
            // Update the segment
            animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
        }, [
            initialSegment
        ]);
        /*
          ======================================
              EVENTS
          ======================================
       */ /**
     * Reinitialize listener on change
     */ React.useEffect(function() {
            var partialListeners = [
                {
                    name: "complete",
                    handler: onComplete
                },
                {
                    name: "loopComplete",
                    handler: onLoopComplete
                },
                {
                    name: "enterFrame",
                    handler: onEnterFrame
                },
                {
                    name: "segmentStart",
                    handler: onSegmentStart
                },
                {
                    name: "config_ready",
                    handler: onConfigReady
                },
                {
                    name: "data_ready",
                    handler: onDataReady
                },
                {
                    name: "data_failed",
                    handler: onDataFailed
                },
                {
                    name: "loaded_images",
                    handler: onLoadedImages
                },
                {
                    name: "DOMLoaded",
                    handler: onDOMLoaded
                },
                {
                    name: "destroy",
                    handler: onDestroy
                }
            ];
            var listeners = partialListeners.filter(function(listener) {
                return listener.handler != null;
            });
            if (!listeners.length) return;
            var deregisterList = listeners.map(/**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */ function(listener) {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.addEventListener(listener.name, listener.handler);
                // Return a function to deregister this listener
                return function() {
                    var _a;
                    (_a = animationInstanceRef.current) === null || _a === void 0 || _a.removeEventListener(listener.name, listener.handler);
                };
            });
            // Deregister listeners on unmount
            return function() {
                deregisterList.forEach(function(deregister) {
                    return deregister();
                });
            };
        }, [
            onComplete,
            onLoopComplete,
            onEnterFrame,
            onSegmentStart,
            onConfigReady,
            onDataReady,
            onDataFailed,
            onLoadedImages,
            onDOMLoaded,
            onDestroy
        ]);
        /**
     * Build the animation view
     */ var View = /*#__PURE__*/ React__default["default"].createElement("div", _objectSpread2({
            style: style,
            ref: animationContainer
        }, rest));
        return {
            View: View,
            play: play,
            stop: stop,
            pause: pause,
            setSpeed: setSpeed,
            goToAndStop: goToAndStop,
            goToAndPlay: goToAndPlay,
            setDirection: setDirection,
            playSegments: playSegments,
            setSubframe: setSubframe,
            getDuration: getDuration,
            destroy: destroy,
            animationContainerRef: animationContainer,
            animationLoaded: animationLoaded,
            animationItem: animationInstanceRef.current
        };
    };
    // helpers
    function getContainerVisibility(container) {
        var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height = _container$getBoundin.height;
        var current = window.innerHeight - top;
        var max = window.innerHeight + height;
        return current / max;
    }
    function getContainerCursorPosition(container, cursorX, cursorY) {
        var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width = _container$getBoundin2.width, height = _container$getBoundin2.height;
        var x = (cursorX - left) / width;
        var y = (cursorY - top) / height;
        return {
            x: x,
            y: y
        };
    }
    var useInitInteractivity = function useInitInteractivity(_ref) {
        var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
        React.useEffect(function() {
            var wrapper = wrapperRef.current;
            if (!wrapper || !animationItem || !actions.length) return;
            animationItem.stop();
            var scrollModeHandler = function scrollModeHandler() {
                var assignedSegment = null;
                var scrollHandler = function scrollHandler() {
                    var currentPercent = getContainerVisibility(wrapper);
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref2) {
                        var visibility = _ref2.visibility;
                        return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    if (action.type === "seek" && action.visibility && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
                        //! goToAndStop must be relative to the start of the current segment
                        animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                    }
                    if (action.type === "loop") {
                        // Loop: Loop a given frames
                        if (assignedSegment === null) {
                            // if not playing any segments currently. play those segments and save to state
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        } else {
                            // if playing any segments currently.
                            //check if segments in state are equal to the frames selected by action
                            if (assignedSegment !== action.frames) {
                                // if they are not equal. new segments are to be loaded
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            } else if (animationItem.isPaused) {
                                // if they are equal the play method must be called only if lottie is paused
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            }
                        }
                    }
                    if (action.type === "play" && animationItem.isPaused) {
                        // Play: Reset segments and continue playing full animation from current position
                        animationItem.resetSegments(true);
                        animationItem.play();
                    }
                    if (action.type === "stop") // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                };
                document.addEventListener("scroll", scrollHandler);
                return function() {
                    document.removeEventListener("scroll", scrollHandler);
                };
            };
            var cursorModeHandler = function cursorModeHandler() {
                var handleCursor = function handleCursor(_x, _y) {
                    var x = _x;
                    var y = _y;
                    // Resolve cursor position if cursor is inside container
                    if (x !== -1 && y !== -1) {
                        // Get container cursor position
                        var pos = getContainerCursorPosition(wrapper, x, y);
                        // Use the resolved position
                        x = pos.x;
                        y = pos.y;
                    }
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref3) {
                        var position = _ref3.position;
                        if (position && Array.isArray(position.x) && Array.isArray(position.y)) return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
                        if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) return x === position.x && y === position.y;
                        return false;
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    // Process action types:
                    if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
                        var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
                        animationItem.playSegments(action.frames, true);
                        animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
                    }
                    if (action.type === "loop") animationItem.playSegments(action.frames, true);
                    if (action.type === "play") {
                        // Play: Reset segments and continue playing full animation from current position
                        if (animationItem.isPaused) animationItem.resetSegments(false);
                        animationItem.playSegments(action.frames);
                    }
                    if (action.type === "stop") animationItem.goToAndStop(action.frames[0], true);
                };
                var mouseMoveHandler = function mouseMoveHandler(ev) {
                    handleCursor(ev.clientX, ev.clientY);
                };
                var mouseOutHandler = function mouseOutHandler() {
                    handleCursor(-1, -1);
                };
                wrapper.addEventListener("mousemove", mouseMoveHandler);
                wrapper.addEventListener("mouseout", mouseOutHandler);
                return function() {
                    wrapper.removeEventListener("mousemove", mouseMoveHandler);
                    wrapper.removeEventListener("mouseout", mouseOutHandler);
                };
            };
            switch(mode){
                case "scroll":
                    return scrollModeHandler();
                case "cursor":
                    return cursorModeHandler();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            mode,
            animationItem
        ]);
    };
    var useLottieInteractivity = function useLottieInteractivity(_ref4) {
        var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
        var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
        useInitInteractivity({
            actions: actions,
            animationItem: animationItem,
            mode: mode,
            wrapperRef: animationContainerRef
        });
        return View;
    };
    var _excluded = [
        "style",
        "interactivity"
    ];
    var Lottie = function Lottie(props) {
        var _a, _b, _c;
        var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
        /**
     * Initialize the 'useLottie' hook
     */ var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
        /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */ React.useEffect(function() {
            if (props.lottieRef) props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            (_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current
        ]);
        return useLottieInteractivity({
            lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            },
            actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
            mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
        });
    };
    Object.defineProperty(exports1, 'LottiePlayer', {
        enumerable: true,
        get: function() {
            return lottie__default["default"];
        }
    });
    exports1["default"] = Lottie;
    exports1.useLottie = useLottie;
    exports1.useLottieInteractivity = useLottieInteractivity;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("eRn3r", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("9aUDG")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("9aUDG")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("9aUDG")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("8r5Wf")).useLazyPhase);
parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $5a3Es = parcelRequire("5a3Es");


var $9aUDG = parcelRequire("9aUDG");

parcelRequire("6VSrF");
var $86UVJ = parcelRequire("86UVJ");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("hZz7i");
var $3QYdZ = parcelRequire("3QYdZ");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");


var $bvYi1 = parcelRequire("bvYi1");


});

parcelRegister("jxKH9", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("3Pobi")).MODE);

var $3Pobi = parcelRequire("3Pobi");

const $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e3a55206c71bac9e$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e3a55206c71bac9e$var$DEFAULT_MODE = (0, $3Pobi.MODE).HYDRATE;
const $e3a55206c71bac9e$var$DEFAULT_RETRY = 2;
const $e3a55206c71bac9e$var$config = {
    crossOrigin: $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e3a55206c71bac9e$var$DEFAULT_MANIFEST,
    mode: $e3a55206c71bac9e$var$DEFAULT_MODE,
    retry: $e3a55206c71bac9e$var$DEFAULT_RETRY
};
const $e3a55206c71bac9e$export$44487a86467333c3 = ()=>$e3a55206c71bac9e$var$config;
const $e3a55206c71bac9e$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $e3a55206c71bac9e$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN;
    $e3a55206c71bac9e$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $e3a55206c71bac9e$var$DEFAULT_MANIFEST;
    $e3a55206c71bac9e$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $e3a55206c71bac9e$var$DEFAULT_MODE;
    $e3a55206c71bac9e$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $e3a55206c71bac9e$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $e3a55206c71bac9e$export$44487a86467333c3;
module.exports["setConfig"] = $e3a55206c71bac9e$export$940a7873bb071df8;

});

parcelRegister("3Pobi", function(module, exports) {
const $2c98e46ce94c4b5d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $2c98e46ce94c4b5d$export$e48589d9e4824227;

});

parcelRegister("5a3Es", function(module, exports) {

var $eegtN = parcelRequire("eegtN");


var $jxKH9 = parcelRequire("jxKH9");

parcelRequire("itHHy");
var $ehkpF = parcelRequire("ehkpF");
var $8r5Wf = parcelRequire("8r5Wf");


var $hBrZE = parcelRequire("hBrZE");

const $3c20b80e9e8d3df3$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $jxKH9.setConfig)(config);
        (0, $ehkpF.LISTENERS).length = 0;
        (0, $8r5Wf.setCurrent)(0);
        if (!(0, $hBrZE.isNodeEnvironment)()) (0, $eegtN.collect)();
    }
};

});

parcelRegister("eegtN", function(module, exports) {

var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");


var $4qzp5 = parcelRequire("4qzp5");


var $8WAU6 = parcelRequire("8WAU6");

const $a5bf27f95a5c4338$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $jxKH9.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $3Pobi.MODE).RENDER ? (0, $4qzp5.cloneElements)(markers[i], lazyBegin) : (0, $8WAU6.refElements)(markers[i], lazyBegin);
        if ((0, $gy5kI.COLLECTED).has(lazyBegin)) (0, $gy5kI.COLLECTED).get(lazyBegin).push(value);
        else (0, $gy5kI.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $a5bf27f95a5c4338$export$bb44f104e3c54dae;

});

parcelRegister("gy5kI", function(module, exports) {
const $c0c3f558a37c633a$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c0c3f558a37c633a$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $c0c3f558a37c633a$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $c0c3f558a37c633a$export$4831ef3968ea94ef;

});

parcelRegister("4qzp5", function(module, exports) {
const $33950d892bd67505$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $33950d892bd67505$export$c42217d53a7ebafb;

});

parcelRegister("8WAU6", function(module, exports) {
const $68305ddfb331b362$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $68305ddfb331b362$export$c69443129766a7fc;

});

parcelRegister("itHHy", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("8r5Wf")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("8r5Wf")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("8r5Wf")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("ehkpF")).LISTENERS);

var $8r5Wf = parcelRequire("8r5Wf");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");


});

parcelRegister("8r5Wf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gy5kI = parcelRequire("gy5kI");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");

let $6245739e6eaab8ef$var$CURRENT_PHASE = (0, $gy5kI.PHASE).PAINT;
const $6245739e6eaab8ef$export$5f80f094fd31fffd = (phase)=>{
    $6245739e6eaab8ef$var$CURRENT_PHASE = phase;
    (0, $ehkpF.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $6245739e6eaab8ef$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $6h5l4.createSubscribe)((0, $ehkpF.LISTENERS)),
    currentValue: ()=>$6245739e6eaab8ef$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).PAINT)
    }
});
const $6245739e6eaab8ef$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($6245739e6eaab8ef$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $6245739e6eaab8ef$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $6245739e6eaab8ef$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $6245739e6eaab8ef$export$1dc361b277327f88;

});

parcelRegister("ehkpF", function(module, exports) {
const $a6527ccf54714552$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $a6527ccf54714552$export$81b9c458a026d68f;

});

parcelRegister("6h5l4", function(module, exports) {
const $491878cc97587aa1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $491878cc97587aa1$export$364097d812234b3f;

});

parcelRegister("hBrZE", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("9fFjP")).default);

var $9fFjP = parcelRequire("9fFjP");

const $cd0b9b420a47cee1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $cd0b9b420a47cee1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $cd0b9b420a47cee1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $cd0b9b420a47cee1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $cd0b9b420a47cee1$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $cd0b9b420a47cee1$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $cd0b9b420a47cee1$export$283635c04a02cc36;
module.exports["attrToProp"] = $cd0b9b420a47cee1$export$62bf630d0de3d781;

});

parcelRegister("9fFjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc590d7746b5907$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6bc590d7746b5907$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9aUDG", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");


var $hBrZE = parcelRequire("hBrZE");
var $9fFjP = parcelRequire("9fFjP");


var $aH9lN = parcelRequire("aH9lN");


var $ilEj6 = parcelRequire("ilEj6");


var $lJ3sU = parcelRequire("lJ3sU");


var $ajpr4 = parcelRequire("ajpr4");


var $67Nku = parcelRequire("67Nku");


var $edTIv = parcelRequire("edTIv");


var $17PxK = parcelRequire("17PxK");

function $6ae0fb8adbd87448$var$_extends() {
    $6ae0fb8adbd87448$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae0fb8adbd87448$var$_extends.apply(this, arguments);
}
function $6ae0fb8adbd87448$var$lazyProxy(_loader, { defer: defer = (0, $gy5kI.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $hBrZE.isNodeEnvironment)();
    const dataLazyId = (0, $9fFjP.default)(moduleId);
    const LazyInternal = isServer ? (0, $lJ3sU.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ilEj6.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ajpr4.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $jxKH9.getConfig)();
                return (0, $edTIv.retry)(_loader, {
                    delay: (0, $aH9lN.RETRY_DELAY),
                    factor: (0, $aH9lN.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $hBrZE.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jxKH9.getConfig)();
        return (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gy5kI.PHASE).PAINT ? (0, $aH9lN.PRIORITY).HIGH : (0, $aH9lN.PRIORITY).LOW;
        return (0, $67Nku.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6ae0fb8adbd87448$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gy5kI.PHASE).LAZY
    }
};
function $6ae0fb8adbd87448$export$c952e5f94576010e(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$291dd592399bdafa(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$488013bae63b21da(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6ae0fb8adbd87448$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6ae0fb8adbd87448$export$291dd592399bdafa;
module.exports["lazy"] = $6ae0fb8adbd87448$export$488013bae63b21da;

});

parcelRegister("hXfAR", function(module, exports) {
const $d1240ae4295f4288$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $d1240ae4295f4288$export$303f43e55cf1ef2f;

});

parcelRegister("aH9lN", function(module, exports) {
const $7c952c608ad2380e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $7c952c608ad2380e$export$a339266ad71b2447 = 300;
const $7c952c608ad2380e$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $7c952c608ad2380e$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $7c952c608ad2380e$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $7c952c608ad2380e$export$ba64c908e55507fe;

});

parcelRegister("ilEj6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("6VSrF");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $aH9lN = parcelRequire("aH9lN");


var $17PxK = parcelRequire("17PxK");


var $6adGO = parcelRequire("6adGO");


var $jl5l1 = parcelRequire("jl5l1");


var $67Nku = parcelRequire("67Nku");


var $bvYi1 = parcelRequire("bvYi1");


var $aiyJe = parcelRequire("aiyJe");

function $d5b97455f4530d40$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $cozmU.useContext)((0, $bvYi1.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $17PxK.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $aiyJe.useSubscription)({
            context: (0, $dHqFW.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gy5kI.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $aiyJe.useSubscription)({
                context: (0, $8r5Wf.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $cozmU.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $67Nku.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $aH9lN.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        (0, $cozmU.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gy5kI.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jxKH9.getConfig)().mode === (0, $3Pobi.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6adGO.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jl5l1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $d5b97455f4530d40$export$6898b5504b58699a;

});

parcelRegister("6VSrF", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("dHqFW")).WaitContext);

var $dHqFW = parcelRequire("dHqFW");


var $86UVJ = parcelRequire("86UVJ");


});

parcelRegister("dHqFW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eYtLL = parcelRequire("eYtLL");

const $9f93fbb489094a52$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>(0, $eYtLL.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $9f93fbb489094a52$export$9ba3fe09d15de47b;

});

parcelRegister("eYtLL", function(module, exports) {
const $ae6dc2e0431b9395$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $ae6dc2e0431b9395$export$276c7dbda7675aec;

});

parcelRegister("86UVJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dHqFW = parcelRequire("dHqFW");

const $5e7b0b64cd38d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $cozmU.useContext)((0, $dHqFW.WaitContext));
    const value = (0, $cozmU.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $cozmU.useRef)(new Set());
    const api = (0, $cozmU.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $cozmU.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHqFW.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZz7i", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("aZNtm")).LazySuspenseContext);

var $3QYdZ = parcelRequire("3QYdZ");


var $aZNtm = parcelRequire("aZNtm");


});

parcelRegister("3QYdZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");


var $aZNtm = parcelRequire("aZNtm");

class $2ce4f1cfa8b44b57$export$256c542058532d6f extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $hBrZE.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $cozmU.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $2ce4f1cfa8b44b57$export$256c542058532d6f;

});

parcelRegister("aZNtm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8015fa1bd12f3c41$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $8015fa1bd12f3c41$export$c33990e84065970c;

});

parcelRegister("17PxK", function(module, exports) {
const $0d1e6d5848f254be$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $0d1e6d5848f254be$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$0d1e6d5848f254be$export$6aa69c1258005366]: true
    });
    return error;
};
const $0d1e6d5848f254be$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($0d1e6d5848f254be$export$6aa69c1258005366);
module.exports["createLoaderError"] = $0d1e6d5848f254be$export$c73a6a6f0bf7d425;

});

parcelRegister("6adGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $47ce4bb11269d032$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $47ce4bb11269d032$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($47ce4bb11269d032$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $47ce4bb11269d032$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $47ce4bb11269d032$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $47ce4bb11269d032$export$d55db778a3e1446b;

});

parcelRegister("jl5l1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");

function $e1441e868bb78192$var$_extends() {
    $e1441e868bb78192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1441e868bb78192$var$_extends.apply(this, arguments);
}
const $e1441e868bb78192$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $hBrZE.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), $e1441e868bb78192$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $e1441e868bb78192$export$ca5b8fbc835d95e4;

});

parcelRegister("67Nku", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");


var $hBrZE = parcelRequire("hBrZE");


var $aH9lN = parcelRequire("aH9lN");


var $2mjKV = parcelRequire("2mjKV");


var $bvYi1 = parcelRequire("bvYi1");

function $4759a958e17e309b$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jxKH9.getConfig)();
    const assets = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2mjKV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $4759a958e17e309b$var$fakePromise = {
    then: ()=>$4759a958e17e309b$var$fakePromise,
    catch: ()=>$4759a958e17e309b$var$fakePromise,
    finally: ()=>$4759a958e17e309b$var$fakePromise
};
function $4759a958e17e309b$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2mjKV.insertLinkTag)(href, rel));
        return $4759a958e17e309b$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $4759a958e17e309b$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $eYtLL.noopCleanup;
}
function $4759a958e17e309b$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $hBrZE.isNodeEnvironment)()) return 0, $eYtLL.noopCleanup;
    (_GlobalReactLooselyLa = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $aH9lN.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $4759a958e17e309b$export$3af04dbcb01bad4d,
        $4759a958e17e309b$export$1046fd6a49d5e7a,
        $4759a958e17e309b$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $eYtLL.noopCleanup;
}
module.exports["preloadAsset"] = $4759a958e17e309b$export$25bad4aa00c45355;

});

parcelRegister("2mjKV", function(module, exports) {

var $bvYi1 = parcelRequire("bvYi1");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");

function $1b7cf5f1f73f5f76$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $eYtLL.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jxKH9.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $1b7cf5f1f73f5f76$export$6610512821c8a4ce;

});

parcelRegister("bvYi1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $86215b3df1759e88$export$e2d53c0cbedd2710 = {
    current: null
};
const $86215b3df1759e88$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $cozmU.createContext)($86215b3df1759e88$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $86215b3df1759e88$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $86215b3df1759e88$export$8146ab57a3f7a7cb;

});

parcelRegister("aiyJe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $77f6862aa953f5ea$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $77f6862aa953f5ea$export$368b4214baeb914c;

});

parcelRegister("lJ3sU", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $hBrZE = parcelRequire("hBrZE");


var $17PxK = parcelRequire("17PxK");

function $fd107d191750b962$var$load(moduleId, loader) {
    try {
        return (0, $hBrZE.getExport)(loader());
    } catch (err) {
        throw (0, $17PxK.createLoaderError)(err);
    }
}
function $fd107d191750b962$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $fd107d191750b962$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $jxKH9.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gy5kI.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
                key: url,
                rel: defer === (0, $gy5kI.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $fd107d191750b962$export$eb2e4b04351cdd9e;

});

parcelRegister("ajpr4", function(module, exports) {
const $781f68b739b0ef47$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $781f68b739b0ef47$export$e673efccd97e4223;

});

parcelRegister("edTIv", function(module, exports) {
const $a5ad7fc44a458961$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $a5ad7fc44a458961$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $a5ad7fc44a458961$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $a5ad7fc44a458961$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $a5ad7fc44a458961$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $a5ad7fc44a458961$var$calculateDelay(context, policy);
        if (delay) await $a5ad7fc44a458961$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $a5ad7fc44a458961$export$9369b12211e1fce4;

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("gRGWz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8cnlb = parcelRequire("8cnlb");


var $22LbG = parcelRequire("22LbG");

// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $d5729dd6b31bdc01$var$TabPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, testId: testId } = t0;
    const { role: role, id: id, hidden: hidden, "aria-labelledby": ariaLabelledBy, tabIndex: tabIndex } = (0, $22LbG.default)();
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== ariaLabelledBy || $[3] !== hidden || $[4] !== id || $[5] !== role || $[6] !== t1 || $[7] !== tabIndex || $[8] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.default), {
            as: "div",
            isInset: true,
            testId: testId,
            role: role,
            id: id,
            hidden: hidden,
            "aria-labelledby": ariaLabelledBy,
            tabIndex: tabIndex
        }, t1);
        $[2] = ariaLabelledBy;
        $[3] = hidden;
        $[4] = id;
        $[5] = role;
        $[6] = t1;
        $[7] = tabIndex;
        $[8] = testId;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $22LbG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children));
};
var $d5729dd6b31bdc01$export$2e2bcd8739ae039 = $d5729dd6b31bdc01$var$TabPanel;
module.exports["default"] = $d5729dd6b31bdc01$export$2e2bcd8739ae039;

});

parcelRegister("47D8u", function(module, exports) {

var $lPUNq = parcelRequire("lPUNq");


var $6Zv1z = parcelRequire("6Zv1z");

const $0df718a42b56c80f$var$AsyncSelect = (0, $6Zv1z.default)((0, $lPUNq.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0df718a42b56c80f$export$2e2bcd8739ae039 = $0df718a42b56c80f$var$AsyncSelect;
module.exports["default"] = $0df718a42b56c80f$export$2e2bcd8739ae039;

});

parcelRegister("ds2zu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48827792ad56aec1327e3c5557d624a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cafe280d0f1b4b2$var$_react = $9cafe280d0f1b4b2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9cafe280d0f1b4b2$var$_baseNew = $9cafe280d0f1b4b2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9cafe280d0f1b4b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cafe280d0f1b4b2$var$PagesIcon = (props)=>/*#__PURE__*/ $9cafe280d0f1b4b2$var$_react.default.createElement($9cafe280d0f1b4b2$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$9cafe280d0f1b4b2$var$PagesIcon.displayName = 'PagesIcon';
var $9cafe280d0f1b4b2$var$_default = module.exports.default = $9cafe280d0f1b4b2$var$PagesIcon;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("5Sv3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $447a164f7d0faf6b$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $447a164f7d0faf6b$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $cozmU.useRef)(null);
    var maxWaitArgs = (0, $cozmU.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $cozmU.useRef)(false);
    var functionTimeoutHandler = (0, $cozmU.useRef)(null);
    var isComponentUnmounted = (0, $cozmU.useRef)(false);
    var debouncedFunction = (0, $cozmU.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $cozmU.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $cozmU.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $cozmU.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $cozmU.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("lmL4n", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $73286e13e84d8c04$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("8NxN0")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $73286e13e84d8c04$var$DatasourceTableViewWithWrappers = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($73286e13e84d8c04$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($73286e13e84d8c04$var$LazyDatasourceTableView, {
            ...props
        })
    });
};
var $73286e13e84d8c04$export$2e2bcd8739ae039 = $73286e13e84d8c04$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $73286e13e84d8c04$export$2e2bcd8739ae039;

});

parcelRegister("8NxN0", function(module, exports) {

let $667d1c32e686797d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $667d1c32e686797d$var$load("66GvX"),
    $667d1c32e686797d$var$load("hxVzR"),
    $667d1c32e686797d$var$load("gbejv"),
    $667d1c32e686797d$var$load("GD9EA"),
    $667d1c32e686797d$var$load("ddvkk"),
    $667d1c32e686797d$var$load("3upHR"),
    $667d1c32e686797d$var$load("eRhBr"),
    $667d1c32e686797d$var$load("hZ2FX"),
    $667d1c32e686797d$var$load("6wr18"),
    $667d1c32e686797d$var$load("6KvrM"),
    $667d1c32e686797d$var$load("151Um"),
    $667d1c32e686797d$var$load("ffEVr"),
    $667d1c32e686797d$var$load("iWnyc"),
    $667d1c32e686797d$var$load("hhss7"),
    $667d1c32e686797d$var$load("Wowvf"),
    $667d1c32e686797d$var$load("7EorR"),
    $667d1c32e686797d$var$load("3WGfe")
]).then(()=>parcelRequire('khl4A'));

});

parcelRegister("nsx26", function(module, exports) {
$parcel$export(module.exports, "default", () => $046847ea799ac561$export$2e2bcd8739ae039);

var $zxlpF = parcelRequire("zxlpF");


var $3yGK6 = parcelRequire("3yGK6");

function $046847ea799ac561$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeftStartOfDay = (0, $zxlpF.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $zxlpF.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("1tBud", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2mOOd = parcelRequire("2mOOd");


var $717N0 = parcelRequire("717N0");


const $4cc16dba49469f3f$var$MediaViewer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("bnYCj")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
const $4cc16dba49469f3f$var$AsyncMediaViewer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncMediaViewer(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function AsyncMediaViewer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
};
var $4cc16dba49469f3f$export$2e2bcd8739ae039 = $4cc16dba49469f3f$var$AsyncMediaViewer;
module.exports["default"] = $4cc16dba49469f3f$export$2e2bcd8739ae039;

});

parcelRegister("2mOOd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $imqjG = parcelRequire("imqjG");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6ffa2f80eb372db6$export$442b7be89436c101 = '#101214';
const $6ffa2f80eb372db6$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const t0 = colorMode !== "dark";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
            blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
            invertSpinnerColor: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
        blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $6ffa2f80eb372db6$export$2e2bcd8739ae039 = $6ffa2f80eb372db6$var$ModalSpinner;
module.exports["default"] = $6ffa2f80eb372db6$export$2e2bcd8739ae039;

});

parcelRegister("imqjG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $knkYU = parcelRequire("knkYU");

const $75f640d6e866ba35$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
var $75f640d6e866ba35$export$2e2bcd8739ae039 = $75f640d6e866ba35$var$ModalSpinner;
module.exports["default"] = $75f640d6e866ba35$export$2e2bcd8739ae039;

});

parcelRegister("knkYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea0f137a8e557bc$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $1ea0f137a8e557bc$var$blanketStyles = null;
const $1ea0f137a8e557bc$var$spinnerStyles = null;
const $1ea0f137a8e557bc$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1ea0f137a8e557bc$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: blankedColor || $1ea0f137a8e557bc$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hekY6.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        appearance: invertSpinnerColor || $1ea0f137a8e557bc$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("717N0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cK21K = parcelRequire("cK21K");

const $60b53ae22e9372b5$export$51aee4c01b17acde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: 510
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 510
    }, children);
module.exports["MediaViewerPortal"] = $60b53ae22e9372b5$export$51aee4c01b17acde;

});

parcelRegister("bnYCj", function(module, exports) {

let $84a0dcf10c928f7c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $84a0dcf10c928f7c$var$load("ftDGD"),
    $84a0dcf10c928f7c$var$load("hZ2FX"),
    $84a0dcf10c928f7c$var$load("6OMo6"),
    $84a0dcf10c928f7c$var$load("aaRXj"),
    $84a0dcf10c928f7c$var$load("fHlIz"),
    $84a0dcf10c928f7c$var$load("4QwAJ"),
    $84a0dcf10c928f7c$var$load("3i44s"),
    $84a0dcf10c928f7c$var$load("5kI0b"),
    $84a0dcf10c928f7c$var$load("kYkz1"),
    $84a0dcf10c928f7c$var$load("jfYeU"),
    $84a0dcf10c928f7c$var$load("b4nm1"),
    $84a0dcf10c928f7c$var$load("geXPZ"),
    $84a0dcf10c928f7c$var$load("aQ5uu"),
    $84a0dcf10c928f7c$var$load("6wr18"),
    $84a0dcf10c928f7c$var$load("1xeJ3"),
    $84a0dcf10c928f7c$var$load("60PUI"),
    $84a0dcf10c928f7c$var$load("flY2n"),
    $84a0dcf10c928f7c$var$load("fV46K"),
    $84a0dcf10c928f7c$var$load("ffEVr"),
    $84a0dcf10c928f7c$var$load("jOE2W"),
    $84a0dcf10c928f7c$var$load("jTOhL"),
    $84a0dcf10c928f7c$var$load("cuNBo"),
    $84a0dcf10c928f7c$var$load("2XRLb"),
    $84a0dcf10c928f7c$var$load("gkVge"),
    $84a0dcf10c928f7c$var$load("io0qR"),
    $84a0dcf10c928f7c$var$load("3MJxZ"),
    $84a0dcf10c928f7c$var$load("kHMR7"),
    $84a0dcf10c928f7c$var$load("e3OZZ"),
    $84a0dcf10c928f7c$var$load("cL682"),
    $84a0dcf10c928f7c$var$load("4MePG"),
    $84a0dcf10c928f7c$var$load("4Ldt2"),
    $84a0dcf10c928f7c$var$load("5JWJI"),
    $84a0dcf10c928f7c$var$load("hhss7"),
    $84a0dcf10c928f7c$var$load("4jXCC")
]).then(()=>parcelRequire('9vMzD'));

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $j1Rvl = parcelRequire("j1Rvl");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("j1Rvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $92AHJ = parcelRequire("92AHJ");

const $878ccfcc8552aaa6$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $878ccfcc8552aaa6$export$98e06fe7a6174253 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).differentText);































const $878ccfcc8552aaa6$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("d4YSb")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2cdNr")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("7l9dA")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("bjfkf")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("kLZmK")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("5a0Qd")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("1KQVk")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("bqpxF")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("l7Ke1")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("dGQYY")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("freW0")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("3OPCa")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("bwEbt")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5at1X")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("eWJ7x")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("2FTTE")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("bq5Mn")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("I5fxG")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1FesQ")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("jK1Cf")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("fIOvF")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("8jfJ9")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("isVNG")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $878ccfcc8552aaa6$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $878ccfcc8552aaa6$export$d0a3169680473b6c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("d4YSb", function(module, exports) {

let $985ade335fa31a0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $985ade335fa31a0e$var$load("1JYrd"),
    $985ade335fa31a0e$var$load("cip6w"),
    $985ade335fa31a0e$var$load("3feYV"),
    $985ade335fa31a0e$var$load("gAG2n"),
    $985ade335fa31a0e$var$load("hFpP9"),
    $985ade335fa31a0e$var$load("cwjU2"),
    $985ade335fa31a0e$var$load("3Ff1R"),
    $985ade335fa31a0e$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("2cdNr", function(module, exports) {

let $19976772e476e5d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $19976772e476e5d9$var$load("30242"),
    $19976772e476e5d9$var$load("3qBwQ"),
    $19976772e476e5d9$var$load("7Q1SM"),
    $19976772e476e5d9$var$load("cYGDU"),
    $19976772e476e5d9$var$load("ddSTH"),
    $19976772e476e5d9$var$load("33Iaa"),
    $19976772e476e5d9$var$load("blA7x"),
    $19976772e476e5d9$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("7l9dA", function(module, exports) {

let $5581a51deee4024c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5581a51deee4024c$var$load("15aAJ"),
    $5581a51deee4024c$var$load("8rREG"),
    $5581a51deee4024c$var$load("7JdzX"),
    $5581a51deee4024c$var$load("dgXJL"),
    $5581a51deee4024c$var$load("9d8JZ"),
    $5581a51deee4024c$var$load("6681T"),
    $5581a51deee4024c$var$load("3dn3H"),
    $5581a51deee4024c$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("bjfkf", function(module, exports) {

let $83bd5b66aa53de45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $83bd5b66aa53de45$var$load("l5BBd"),
    $83bd5b66aa53de45$var$load("93ASN"),
    $83bd5b66aa53de45$var$load("24LNf"),
    $83bd5b66aa53de45$var$load("htu5t"),
    $83bd5b66aa53de45$var$load("1A450"),
    $83bd5b66aa53de45$var$load("iYQCc"),
    $83bd5b66aa53de45$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("kLZmK", function(module, exports) {

let $f1f7cc6d5a6f7a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f1f7cc6d5a6f7a03$var$load("bbv9t"),
    $f1f7cc6d5a6f7a03$var$load("9fQoJ"),
    $f1f7cc6d5a6f7a03$var$load("cnlNg"),
    $f1f7cc6d5a6f7a03$var$load("lTboH"),
    $f1f7cc6d5a6f7a03$var$load("gBDXQ"),
    $f1f7cc6d5a6f7a03$var$load("d3Phe"),
    $f1f7cc6d5a6f7a03$var$load("lASLx"),
    $f1f7cc6d5a6f7a03$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("5a0Qd", function(module, exports) {

let $3c1e89fd267619bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c1e89fd267619bd$var$load("7p4je"),
    $3c1e89fd267619bd$var$load("8SZbD"),
    $3c1e89fd267619bd$var$load("9Uf61"),
    $3c1e89fd267619bd$var$load("iE05k"),
    $3c1e89fd267619bd$var$load("lv5aU"),
    $3c1e89fd267619bd$var$load("3Yk1e"),
    $3c1e89fd267619bd$var$load("5lJyy"),
    $3c1e89fd267619bd$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("1KQVk", function(module, exports) {

let $147323d6e8bf4a31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $147323d6e8bf4a31$var$load("5ZQnr"),
    $147323d6e8bf4a31$var$load("2hqQb"),
    $147323d6e8bf4a31$var$load("lJyww"),
    $147323d6e8bf4a31$var$load("gVfjY"),
    $147323d6e8bf4a31$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("bqpxF", function(module, exports) {

let $8515ef876a31f490$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8515ef876a31f490$var$load("1jQRQ"),
    $8515ef876a31f490$var$load("5pOQA"),
    $8515ef876a31f490$var$load("fJSEb"),
    $8515ef876a31f490$var$load("5GSny"),
    $8515ef876a31f490$var$load("cQump"),
    $8515ef876a31f490$var$load("ajzkj"),
    $8515ef876a31f490$var$load("eyysG"),
    $8515ef876a31f490$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("l7Ke1", function(module, exports) {

let $f60e1bc71727e466$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f60e1bc71727e466$var$load("km37l"),
    $f60e1bc71727e466$var$load("gbksI"),
    $f60e1bc71727e466$var$load("9TeWr"),
    $f60e1bc71727e466$var$load("j2X7f"),
    $f60e1bc71727e466$var$load("fE8pi"),
    $f60e1bc71727e466$var$load("kUZ7k"),
    $f60e1bc71727e466$var$load("dJQL7"),
    $f60e1bc71727e466$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("dGQYY", function(module, exports) {

let $9f784bcef31f77a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9f784bcef31f77a7$var$load("lTbXI"),
    $9f784bcef31f77a7$var$load("a98cw"),
    $9f784bcef31f77a7$var$load("fOGnR"),
    $9f784bcef31f77a7$var$load("e40mE"),
    $9f784bcef31f77a7$var$load("btBGI"),
    $9f784bcef31f77a7$var$load("cDQOq"),
    $9f784bcef31f77a7$var$load("8upye"),
    $9f784bcef31f77a7$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("freW0", function(module, exports) {

let $b3d4f6565dde8137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b3d4f6565dde8137$var$load("iUyZj"),
    $b3d4f6565dde8137$var$load("4PDaO"),
    $b3d4f6565dde8137$var$load("8nEeY"),
    $b3d4f6565dde8137$var$load("lMhbw"),
    $b3d4f6565dde8137$var$load("amTTV"),
    $b3d4f6565dde8137$var$load("kLZKK"),
    $b3d4f6565dde8137$var$load("c7GMc"),
    $b3d4f6565dde8137$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("3OPCa", function(module, exports) {

let $2c7e1436d04eac89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c7e1436d04eac89$var$load("kPlMQ"),
    $2c7e1436d04eac89$var$load("ervs7"),
    $2c7e1436d04eac89$var$load("fzzMQ"),
    $2c7e1436d04eac89$var$load("8CX31"),
    $2c7e1436d04eac89$var$load("kYd4i"),
    $2c7e1436d04eac89$var$load("33S6H"),
    $2c7e1436d04eac89$var$load("kFae4"),
    $2c7e1436d04eac89$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("bwEbt", function(module, exports) {

let $8641da90021f141d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8641da90021f141d$var$load("iT2sv"),
    $8641da90021f141d$var$load("iMMtn"),
    $8641da90021f141d$var$load("3gNEO"),
    $8641da90021f141d$var$load("23VWs"),
    $8641da90021f141d$var$load("e1KaU"),
    $8641da90021f141d$var$load("93obY"),
    $8641da90021f141d$var$load("6Y9jE"),
    $8641da90021f141d$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("5at1X", function(module, exports) {

let $3c3467c741031007$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c3467c741031007$var$load("lyPpF"),
    $3c3467c741031007$var$load("eX5n7"),
    $3c3467c741031007$var$load("gvylW"),
    $3c3467c741031007$var$load("aiYuN"),
    $3c3467c741031007$var$load("gqMCT"),
    $3c3467c741031007$var$load("bxfRe"),
    $3c3467c741031007$var$load("ed6s8"),
    $3c3467c741031007$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("eWJ7x", function(module, exports) {

let $ae197b7e6281f8e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae197b7e6281f8e9$var$load("iN3cj"),
    $ae197b7e6281f8e9$var$load("3nHdy"),
    $ae197b7e6281f8e9$var$load("80OLx"),
    $ae197b7e6281f8e9$var$load("gDEvm"),
    $ae197b7e6281f8e9$var$load("5MwHB"),
    $ae197b7e6281f8e9$var$load("1EVcg"),
    $ae197b7e6281f8e9$var$load("96q1k"),
    $ae197b7e6281f8e9$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("2FTTE", function(module, exports) {

let $1f2ac4fcd19f7080$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f2ac4fcd19f7080$var$load("eC1OL"),
    $1f2ac4fcd19f7080$var$load("ilL9c"),
    $1f2ac4fcd19f7080$var$load("e4s0V"),
    $1f2ac4fcd19f7080$var$load("64nco"),
    $1f2ac4fcd19f7080$var$load("9cx6P"),
    $1f2ac4fcd19f7080$var$load("28EXy"),
    $1f2ac4fcd19f7080$var$load("7RZp5"),
    $1f2ac4fcd19f7080$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("bq5Mn", function(module, exports) {

let $85069b121ab4bc4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $85069b121ab4bc4a$var$load("4NJ49"),
    $85069b121ab4bc4a$var$load("bfOZL"),
    $85069b121ab4bc4a$var$load("4dPO1"),
    $85069b121ab4bc4a$var$load("jLbRX"),
    $85069b121ab4bc4a$var$load("5g0HW"),
    $85069b121ab4bc4a$var$load("gg8tK"),
    $85069b121ab4bc4a$var$load("eF54W"),
    $85069b121ab4bc4a$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("I5fxG", function(module, exports) {

let $08482ea73d01879b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $08482ea73d01879b$var$load("fsCDU"),
    $08482ea73d01879b$var$load("apVmx"),
    $08482ea73d01879b$var$load("kuolm"),
    $08482ea73d01879b$var$load("fvE7S"),
    $08482ea73d01879b$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("1FesQ", function(module, exports) {

let $1364d713114d6fc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1364d713114d6fc2$var$load("g9gkE"),
    $1364d713114d6fc2$var$load("jYdbS"),
    $1364d713114d6fc2$var$load("ltrgi"),
    $1364d713114d6fc2$var$load("6ncWv"),
    $1364d713114d6fc2$var$load("gFneG"),
    $1364d713114d6fc2$var$load("fu25G"),
    $1364d713114d6fc2$var$load("iQGcz"),
    $1364d713114d6fc2$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("jK1Cf", function(module, exports) {

let $e5f391125e366c30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f391125e366c30$var$load("jhikU"),
    $e5f391125e366c30$var$load("f0i3H"),
    $e5f391125e366c30$var$load("69YlM"),
    $e5f391125e366c30$var$load("bvBAp"),
    $e5f391125e366c30$var$load("9kqmW"),
    $e5f391125e366c30$var$load("cyTsc"),
    $e5f391125e366c30$var$load("kXCsp"),
    $e5f391125e366c30$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("fIOvF", function(module, exports) {

let $b72225467f057513$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b72225467f057513$var$load("fSsz4"),
    $b72225467f057513$var$load("kWOpS"),
    $b72225467f057513$var$load("kgHzZ"),
    $b72225467f057513$var$load("9tUAi"),
    $b72225467f057513$var$load("bS9pO"),
    $b72225467f057513$var$load("j4ur8"),
    $b72225467f057513$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("8jfJ9", function(module, exports) {

let $60cc4c332ad17f63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $60cc4c332ad17f63$var$load("d91RK"),
    $60cc4c332ad17f63$var$load("f7hfJ"),
    $60cc4c332ad17f63$var$load("brdRT"),
    $60cc4c332ad17f63$var$load("QI1kr"),
    $60cc4c332ad17f63$var$load("5LvhC"),
    $60cc4c332ad17f63$var$load("lWBlc"),
    $60cc4c332ad17f63$var$load("s2EmI"),
    $60cc4c332ad17f63$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("isVNG", function(module, exports) {

let $d717ad7a14072abe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d717ad7a14072abe$var$load("708J7"),
    $d717ad7a14072abe$var$load("kVqUf"),
    $d717ad7a14072abe$var$load("j03Pa"),
    $d717ad7a14072abe$var$load("2IMxh"),
    $d717ad7a14072abe$var$load("98tcg"),
    $d717ad7a14072abe$var$load("kke1I"),
    $d717ad7a14072abe$var$load("gOwMq"),
    $d717ad7a14072abe$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("eKpjD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hq9Cp = parcelRequire("hq9Cp");


var $eW61a = parcelRequire("eW61a");


var $lUcpS = parcelRequire("lUcpS");


var $dRAjC = parcelRequire("dRAjC");


var $7mRGw = parcelRequire("7mRGw");


var $hIwXM = parcelRequire("hIwXM");

const $02fe2f9f47117f75$export$64983741fea6a45d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ ...props }, ref)=>{
    const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId, agentIdType: agentIdType = 'agent' } = props;
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    /**
   * @TODO replace with `getAgentCreator` from `@atlassian/rovo-agent-components`
   * @deprecated use `getAgentCreator` from `@atlassian/rovo-agent-components`
   */ const getCreator = async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        if (!creator) return undefined;
        if ((0, $hq9Cp.isForgeAgentByCreatorType)(creator_type) && (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar')) return {
            type: 'THIRD_PARTY',
            name: creator ?? ''
        };
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'FORGE':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                const userId_0 = (0, $dRAjC.getAAIDFromARI)(creator) || '';
                try {
                    if (!userId_0 || !cloudId) return undefined;
                    if (authoringTeam) return {
                        type: 'CUSTOMER',
                        name: authoringTeam.displayName ?? '',
                        profileLink: authoringTeam.profileUrl ?? ''
                    };
                    const { href: profileHref } = (0, $eW61a.navigateToTeamsApp)({
                        type: 'USER',
                        payload: {
                            userId: userId_0
                        },
                        cloudId: cloudId
                    });
                    const creatorInfo = await props.resourceClient.getProfile(cloudId, userId_0, fireEvent);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${userId_0}`,
                        id: userId_0
                    };
                } catch  {
                    return undefined;
                }
            default:
                return undefined;
        }
    };
    const fetchAgentProfile = async ()=>{
        const agentProfileResult = await resourceClient.getRovoAgentProfile({
            type: agentIdType,
            value: userId
        }, fireEvent);
        const agentInfo = agentProfileResult.restData;
        const agentCreatorInfo = await getCreator({
            creator_type: agentInfo.creator_type,
            creator: agentInfo.creator || undefined,
            authoringTeam: agentProfileResult.aggData?.authoringTeam ?? undefined
        });
        return {
            ...agentInfo,
            creatorInfo: agentCreatorInfo
        };
    };
    const renderProfileCard = ({ profileData: profileData, error: error })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hIwXM.AgentProfileCardLazy), {
            agent: profileData,
            hasError: !!error,
            cloudId: props.cloudId,
            email: props.email,
            errorType: error,
            onChatClick: props.onChatClick,
            onConversationStartersClick: props.onConversationStartersClick,
            resourceClient: props.resourceClient,
            onDeleteAgent: props.onDeleteAgent,
            addFlag: props.addFlag,
            hideStarButton: props.hideStarButton
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7mRGw.default), {
        ...props,
        ref: ref,
        trigger: props.trigger ?? 'hover',
        renderProfileCard: renderProfileCard,
        fetchProfile: fetchAgentProfile,
        fireAnalytics: fireEvent,
        profileCardType: "agent"
    });
});
module.exports["AgentProfileCardTrigger"] = $02fe2f9f47117f75$export$64983741fea6a45d;

});

parcelRegister("7mRGw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $jp2Q3 = parcelRequire("jp2Q3");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");


var $6HFjc = parcelRequire("6HFjc");


var $buXlg = parcelRequire("buXlg");


var $8bTIj = parcelRequire("8bTIj");


var $2Vosv = parcelRequire("2Vosv");

const $e32bd4aabd53e95e$var$DELAY_MS_SHOW = 800;
const $e32bd4aabd53e95e$var$DELAY_MS_HIDE = 200;
const $e32bd4aabd53e95e$var$ProfileCardTriggerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProfileCardTriggerInner(t0, ref) {
    const $ = (0, $bDgLe.c)(55);
    let ariaLabelledBy;
    let children;
    let disabledAriaAttributes;
    let fetchProfile;
    let fireAnalytics;
    let popupProps;
    let profileCardType;
    let renderProfileCard;
    let testId;
    let trigger;
    if ($[0] !== t0) {
        ({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, testId: testId, fireAnalytics: fireAnalytics, ...popupProps } = t0);
        $[0] = t0;
        $[1] = ariaLabelledBy;
        $[2] = children;
        $[3] = disabledAriaAttributes;
        $[4] = fetchProfile;
        $[5] = fireAnalytics;
        $[6] = popupProps;
        $[7] = profileCardType;
        $[8] = renderProfileCard;
        $[9] = testId;
        $[10] = trigger;
    } else {
        ariaLabelledBy = $[1];
        children = $[2];
        disabledAriaAttributes = $[3];
        fetchProfile = $[4];
        fireAnalytics = $[5];
        popupProps = $[6];
        profileCardType = $[7];
        renderProfileCard = $[8];
        testId = $[9];
        trigger = $[10];
    }
    const showDelay = trigger === "click" ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_SHOW;
    const hideDelay = trigger === "click" ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_HIDE;
    const showTimer = (0, $cozmU.useRef)(0);
    const hideTimer = (0, $cozmU.useRef)(0);
    const [visible, setVisible] = (0, $cozmU.useState)(false);
    let t1;
    if ($[11] !== fetchProfile) {
        t1 = {
            fetchUserProfile: fetchProfile
        };
        $[11] = fetchProfile;
        $[12] = t1;
    } else t1 = $[12];
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $6HFjc.useProfileInfo)(t1);
    let t2;
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>()=>{
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        t3 = [];
        $[13] = t2;
        $[14] = t3;
    } else {
        t2 = $[13];
        t3 = $[14];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[15] !== hideDelay) {
        t4 = ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
            }, hideDelay);
        };
        $[15] = hideDelay;
        $[16] = t4;
    } else t4 = $[16];
    const hideProfilecard = t4;
    let t5;
    let t6;
    if ($[17] !== hideProfilecard) {
        t5 = ()=>({
                hideProfilecard: hideProfilecard
            });
        t6 = [
            hideProfilecard
        ];
        $[17] = hideProfilecard;
        $[18] = t5;
        $[19] = t6;
    } else {
        t5 = $[18];
        t6 = $[19];
    }
    (0, $cozmU.useImperativeHandle)(ref, t5, t6);
    let t7;
    if ($[20] !== fireAnalytics || $[21] !== getProfileData || $[22] !== profileCardType || $[23] !== showDelay || $[24] !== trigger || $[25] !== visible) {
        t7 = async ()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    getProfileData?.();
                    setVisible(true);
                    if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileCardType)}.triggered`, {
                        method: trigger,
                        ...(0, $cSSWJ.PACKAGE_META_DATA),
                        firedAt: Math.round((0, $1GhPJ.getPageTime)())
                    });
                }
            }, showDelay);
        };
        $[20] = fireAnalytics;
        $[21] = getProfileData;
        $[22] = profileCardType;
        $[23] = showDelay;
        $[24] = trigger;
        $[25] = visible;
        $[26] = t7;
    } else t7 = $[26];
    const showProfilecard = t7;
    let t8;
    if ($[27] !== showProfilecard) {
        t8 = ()=>{
            showProfilecard();
        };
        $[27] = showProfilecard;
        $[28] = t8;
    } else t8 = $[28];
    const onMouseEnter = t8;
    const t9 = !!visible;
    const t10 = popupProps.autoFocus ?? trigger === "click";
    let t11;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $jp2Q3.layers).modal();
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== ariaLabelledBy || $[31] !== children || $[32] !== disabledAriaAttributes || $[33] !== hideProfilecard || $[34] !== showProfilecard || $[35] !== testId || $[36] !== trigger) {
        t12 = (triggerProps)=>{
            if ((0, $iDrrr.fg)("fix_aria_attribute_violation_on_agent_card_trigger")) {
                const { "aria-expanded": _, "aria-haspopup": __, "aria-controls": ___, ...restInnerProps } = triggerProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bTIj.PopupTrigger), {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ref: triggerProps.ref,
                    hideProfilecard: hideProfilecard,
                    showProfilecard: showProfilecard,
                    children: children,
                    ariaLabelledBy: ariaLabelledBy,
                    trigger: trigger,
                    "data-testid": testId
                });
            } else {
                const { "aria-expanded": __0, "aria-haspopup": ___0, ...restInnerProps_0 } = triggerProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bTIj.PopupTrigger), {
                    ...disabledAriaAttributes ? restInnerProps_0 : triggerProps,
                    ref: triggerProps.ref,
                    hideProfilecard: hideProfilecard,
                    showProfilecard: showProfilecard,
                    children: children,
                    ariaLabelledBy: ariaLabelledBy,
                    trigger: trigger,
                    "data-testid": testId
                });
            }
        };
        $[30] = ariaLabelledBy;
        $[31] = children;
        $[32] = disabledAriaAttributes;
        $[33] = hideProfilecard;
        $[34] = showProfilecard;
        $[35] = testId;
        $[36] = trigger;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== error || $[39] !== fireAnalytics || $[40] !== hideProfilecard || $[41] !== isLoading || $[42] !== onMouseEnter || $[43] !== profileCardType || $[44] !== profileData || $[45] !== renderProfileCard || $[46] !== showProfilecard) {
        t13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard,
                onBlur: hideProfilecard,
                "data-testid": "profile-card--trigger-content"
            }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vosv.ProfileCardWrapper), {
                testId: "profilecard.profilecardtrigger.loading"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $buXlg.LoadingState), {
                fireAnalytics: fireAnalytics,
                profileType: profileCardType
            })) : renderProfileCard({
                profileData: profileData,
                error: error
            }));
        $[38] = error;
        $[39] = fireAnalytics;
        $[40] = hideProfilecard;
        $[41] = isLoading;
        $[42] = onMouseEnter;
        $[43] = profileCardType;
        $[44] = profileData;
        $[45] = renderProfileCard;
        $[46] = showProfilecard;
        $[47] = t13;
    } else t13 = $[47];
    let t14;
    if ($[48] !== hideProfilecard || $[49] !== popupProps || $[50] !== t10 || $[51] !== t12 || $[52] !== t13 || $[53] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            ...popupProps,
            isOpen: t9,
            onClose: hideProfilecard,
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: t10,
            zIndex: t11,
            shouldFitContainer: false,
            trigger: t12,
            content: t13
        });
        $[48] = hideProfilecard;
        $[49] = popupProps;
        $[50] = t10;
        $[51] = t12;
        $[52] = t13;
        $[53] = t9;
        $[54] = t14;
    } else t14 = $[54];
    return t14;
} : function ProfileCardTriggerInner({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, testId: testId, fireAnalytics: fireAnalytics, ...popupProps }, ref) {
    const showDelay = trigger === 'click' ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_SHOW;
    const hideDelay = trigger === 'click' ? 0 : $e32bd4aabd53e95e$var$DELAY_MS_HIDE;
    const showTimer = (0, $cozmU.useRef)(0);
    const hideTimer = (0, $cozmU.useRef)(0);
    const [visible, setVisible] = (0, $cozmU.useState)(false);
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $6HFjc.useProfileInfo)({
        fetchUserProfile: fetchProfile
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    const hideProfilecard = (0, $cozmU.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
        }, hideDelay);
    }, [
        hideDelay
    ]);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            hideProfilecard: hideProfilecard
        }), [
        hideProfilecard
    ]);
    const showProfilecard = (0, $cozmU.useCallback)(async ()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                getProfileData?.();
                setVisible(true);
                if (fireAnalytics) fireAnalytics(`ui.${(0, $cSSWJ.getActionSubject)(profileCardType)}.triggered`, {
                    method: trigger,
                    ...(0, $cSSWJ.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $1GhPJ.getPageTime)())
                });
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        getProfileData,
        fireAnalytics,
        profileCardType,
        trigger
    ]);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        ...popupProps,
        isOpen: !!visible,
        onClose: hideProfilecard,
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: popupProps.autoFocus ?? trigger === 'click',
        zIndex: (0, $jp2Q3.layers).modal(),
        shouldFitContainer: false,
        trigger: (triggerProps)=>{
            if ((0, $iDrrr.fg)('fix_aria_attribute_violation_on_agent_card_trigger')) {
                const { 'aria-expanded': _, 'aria-haspopup': __, 'aria-controls': ___, ...restInnerProps } = triggerProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bTIj.PopupTrigger), {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ref: triggerProps.ref,
                    hideProfilecard: hideProfilecard,
                    showProfilecard: showProfilecard,
                    children: children,
                    ariaLabelledBy: ariaLabelledBy,
                    trigger: trigger,
                    "data-testid": testId
                });
            } else {
                const { 'aria-expanded': __0, 'aria-haspopup': ___0, ...restInnerProps_0 } = triggerProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bTIj.PopupTrigger), {
                    ...disabledAriaAttributes ? restInnerProps_0 : triggerProps,
                    ref: triggerProps.ref,
                    hideProfilecard: hideProfilecard,
                    showProfilecard: showProfilecard,
                    children: children,
                    ariaLabelledBy: ariaLabelledBy,
                    trigger: trigger,
                    "data-testid": testId
                });
            }
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard,
                onBlur: hideProfilecard,
                "data-testid": "profile-card--trigger-content"
            }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vosv.ProfileCardWrapper), {
                testId: "profilecard.profilecardtrigger.loading"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $buXlg.LoadingState), {
                fireAnalytics: fireAnalytics,
                profileType: profileCardType
            })) : renderProfileCard({
                profileData: profileData,
                error: error
            }))
    });
};
const $e32bd4aabd53e95e$var$ProfileCardTrigger = /*#__PURE__*/ (0, $cozmU.forwardRef)($e32bd4aabd53e95e$var$ProfileCardTriggerInner);
var $e32bd4aabd53e95e$export$2e2bcd8739ae039 = $e32bd4aabd53e95e$var$ProfileCardTrigger;
module.exports["default"] = $e32bd4aabd53e95e$export$2e2bcd8739ae039;

});

parcelRegister("6HFjc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2c5cb016ddbec74b$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [profileData, setProfileData] = (0, $cozmU.useState)();
    const getProfileData = async ()=>{
        setIsLoading(true);
        try {
            const profileData_0 = await fetchUserProfile?.();
            setProfileData(profileData_0);
            setIsLoading(false);
        } catch (error_0) {
            setError(error_0);
            setIsLoading(false);
        }
    };
    return {
        profileData: profileData,
        isLoading: isLoading,
        error: error,
        getProfileData: getProfileData
    };
};
module.exports["useProfileInfo"] = $2c5cb016ddbec74b$export$6cace87f7d7a9738;

});

parcelRegister("8bTIj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

const $d9459e83ce60344e$var$PopupTriggerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(25);
    let ariaLabelledBy;
    let children;
    let hideProfilecard;
    let props;
    let showProfilecard;
    let trigger;
    if ($[0] !== t0) {
        ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props } = t0);
        $[0] = t0;
        $[1] = ariaLabelledBy;
        $[2] = children;
        $[3] = hideProfilecard;
        $[4] = props;
        $[5] = showProfilecard;
        $[6] = trigger;
    } else {
        ariaLabelledBy = $[1];
        children = $[2];
        hideProfilecard = $[3];
        props = $[4];
        showProfilecard = $[5];
        trigger = $[6];
    }
    let t1;
    if ($[7] !== showProfilecard) {
        t1 = ()=>{
            showProfilecard();
        };
        $[7] = showProfilecard;
        $[8] = t1;
    } else t1 = $[8];
    const onMouseEnter = t1;
    let t2;
    if ($[9] !== showProfilecard) {
        t2 = (event)=>{
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                showProfilecard();
            }
        };
        $[9] = showProfilecard;
        $[10] = t2;
    } else t2 = $[10];
    const onKeyPress = t2;
    let t3;
    if ($[11] !== showProfilecard) {
        t3 = (event_0)=>{
            event_0.stopPropagation();
            showProfilecard();
        };
        $[11] = showProfilecard;
        $[12] = t3;
    } else t3 = $[12];
    const onClick = t3;
    let t4;
    if ($[13] !== hideProfilecard || $[14] !== onClick || $[15] !== onKeyPress || $[16] !== onMouseEnter || $[17] !== trigger) {
        t4 = trigger === "hover" ? {
            ...(0, $iDrrr.fg)("update_profile_card_to_open_on_mouse_over") ? {
                onMouseOver: onMouseEnter,
                onMouseOut: hideProfilecard
            } : {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard
            },
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        };
        $[13] = hideProfilecard;
        $[14] = onClick;
        $[15] = onKeyPress;
        $[16] = onMouseEnter;
        $[17] = trigger;
        $[18] = t4;
    } else t4 = $[18];
    const containerListeners = t4;
    let t5;
    if ($[19] !== ariaLabelledBy || $[20] !== children || $[21] !== containerListeners || $[22] !== props || $[23] !== ref) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...props,
            ...containerListeners,
            ref: ref,
            "aria-labelledby": ariaLabelledBy
        }, children);
        $[19] = ariaLabelledBy;
        $[20] = children;
        $[21] = containerListeners;
        $[22] = props;
        $[23] = ref;
        $[24] = t5;
    } else t5 = $[24];
    return t5;
} : ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
    // rename to onMouseOver when cleaning up update_profile_card_to_open_on_mouse_over
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const onKeyPress = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showProfilecard();
        }
    }, [
        showProfilecard
    ]);
    const onClick = (0, $cozmU.useCallback)((event_0)=>{
        // Prevent the click event from propagating to parent containers.
        event_0.stopPropagation();
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $cozmU.useMemo)(()=>trigger === 'hover' ? {
            ...(0, $iDrrr.fg)('update_profile_card_to_open_on_mouse_over') ? {
                onMouseOver: onMouseEnter,
                onMouseOut: hideProfilecard
            } : {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard
            },
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...props,
        ...containerListeners,
        ref: ref,
        "aria-labelledby": ariaLabelledBy
    }, children);
};
const $d9459e83ce60344e$export$95d4acdbab2fc6ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef($d9459e83ce60344e$var$PopupTriggerInner);
module.exports["PopupTrigger"] = $d9459e83ce60344e$export$95d4acdbab2fc6ef;

});

parcelRegister("2Vosv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $ddd10e9f18035e94$var$styles = {
    wrapper: "_1bsb1gwv"
};
const $ddd10e9f18035e94$export$59abd6feb7dc8540 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $ddd10e9f18035e94$var$styles.wrapper,
            testId: testId
        }, children);
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $ddd10e9f18035e94$var$styles.wrapper,
        testId: testId
    }, children);
};
module.exports["ProfileCardWrapper"] = $ddd10e9f18035e94$export$59abd6feb7dc8540;

});

parcelRegister("k8VpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2UMCh = parcelRequire("2UMCh");


var $2YNjC = parcelRequire("2YNjC");


var $DdJXy = parcelRequire("DdJXy");

const $27783bb9fe854b58$export$6620595b7f837f8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (version, product, logger, baseUrl, configFetch, collabContextId)=>{
    const $ = (0, $bDgLe.c)(10);
    const { getArtifact: getArtifact } = (0, $2UMCh.useFlightDeckContext)();
    let t0;
    if ($[0] !== configFetch || $[1] !== getArtifact) {
        t0 = configFetch ?? (getArtifact ? ()=>getArtifact((0, $2YNjC.FD_CLIENT_FETCH_PROPS).name, (0, $2YNjC.FD_CLIENT_FETCH_PROPS).dimensions) : undefined);
        $[0] = configFetch;
        $[1] = getArtifact;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== baseUrl || $[4] !== collabContextId || $[5] !== logger || $[6] !== product || $[7] !== t0 || $[8] !== version) {
        t1 = (0, $DdJXy.createActivityClient)(version, product, logger, baseUrl, t0, collabContextId);
        $[3] = baseUrl;
        $[4] = collabContextId;
        $[5] = logger;
        $[6] = product;
        $[7] = t0;
        $[8] = version;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (version, product, logger, baseUrl, configFetch, collabContextId)=>{
    const { getArtifact: getArtifact } = (0, $2UMCh.useFlightDeckContext)();
    // `collabContextId` is included in the deps so the client is recreated if
    // it ever changes. In practice it is set once per page load and does not
    // change during a session, so the client is created once and reused for
    // the lifetime of the consumer.
    return (0, $cozmU.useMemo)(()=>(0, $DdJXy.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        configFetch ?? (getArtifact ? ()=>getArtifact((0, $2YNjC.FD_CLIENT_FETCH_PROPS).name, (0, $2YNjC.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), collabContextId), [
        version,
        product,
        logger,
        baseUrl,
        configFetch,
        getArtifact,
        collabContextId
    ]);
};
module.exports["useActivityClient"] = $27783bb9fe854b58$export$6620595b7f837f8f;

});

parcelRegister("2UMCh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hp074 = parcelRequire("hp074");

const $21f685ebe54e3804$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    getArtifact: null
});
function $21f685ebe54e3804$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return new (0, $hp074.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21f685ebe54e3804$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $21f685ebe54e3804$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($21f685ebe54e3804$export$ca1b33377afa620);
function $21f685ebe54e3804$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const { getArtifact: getArtifact } = $21f685ebe54e3804$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $21f685ebe54e3804$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $21f685ebe54e3804$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $21f685ebe54e3804$export$3b241cde208d2c5e;

});

parcelRegister("eFbDl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $bb0d05c0553a2342$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $bb0d05c0553a2342$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d1j28 _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $bb0d05c0553a2342$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Skeleton__
    *
    * A skeleton is the loading state for the avatar component.
    *
    * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
    * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
    */ 
const $bb0d05c0553a2342$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { size: size, appearance: t1, color: color, weight: weight } = t0;
    const appearance = t1 === undefined ? "circle" : t1;
    const avatarSize = size ?? "medium";
    const t2 = color ?? "currentColor";
    let t3;
    if ($[0] !== t2) {
        t3 = {
            [$bb0d05c0553a2342$var$bgColorCssVar]: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const t4 = t3;
    const t5 = $bb0d05c0553a2342$var$sizeStyles[avatarSize];
    const t6 = appearance === "square" && $bb0d05c0553a2342$var$styles.square;
    const t7 = appearance === "hexagon" && $bb0d05c0553a2342$var$styles.hexagon;
    const t8 = weight === "strong" && $bb0d05c0553a2342$var$styles.strongOpacity;
    let t9;
    if ($[2] !== t5 || $[3] !== t6 || $[4] !== t7 || $[5] !== t8) {
        t9 = (0, $hekY6.default)([
            $bb0d05c0553a2342$var$styles.root,
            t5,
            t6,
            t7,
            t8
        ]);
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] !== t4 || $[8] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t4,
            className: t9
        });
        $[7] = t4;
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    return t10;
} : ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            [$bb0d05c0553a2342$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $hekY6.default)([
            $bb0d05c0553a2342$var$styles.root,
            $bb0d05c0553a2342$var$sizeStyles[avatarSize],
            appearance === 'square' && $bb0d05c0553a2342$var$styles.square,
            appearance === 'hexagon' && $bb0d05c0553a2342$var$styles.hexagon,
            weight === 'strong' && $bb0d05c0553a2342$var$styles.strongOpacity
        ])
    });
};
var $bb0d05c0553a2342$export$2e2bcd8739ae039 = $bb0d05c0553a2342$var$Skeleton;
module.exports["default"] = $bb0d05c0553a2342$export$2e2bcd8739ae039;

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("bGNkz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $4m5jb = parcelRequire("4m5jb");

const $af081181a641afaf$export$6fdb848aa0eff3d1 = {
    isActive: false
};
const $af081181a641afaf$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    // If productionized will look to move this logic into conversation-assistant-onboarding
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchInteractionSource: undefined,
    emptyChatLaunchInvokedFrom: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    selectedSpace: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined,
    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1
};
const $af081181a641afaf$var$store = (0, $8s9DV.createStore)({
    name: 'uiStore',
    initialState: $af081181a641afaf$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$af081181a641afaf$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setSmartLink3PPostAuth: (payload)=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: payload
                });
            },
        clearSmartLink3PPostAuth: ()=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchInteractionSource: payload.interactionSource,
                    emptyChatLaunchInvokedFrom: payload.invokedFrom,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $af081181a641afaf$var$useStore = (0, $kBr4q.createHook)($af081181a641afaf$var$store);
const $af081181a641afaf$export$13a6c73a57f1d6a6 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            interactionSource: state.emptyChatLaunchInteractionSource,
            invokedFrom: state.emptyChatLaunchInvokedFrom,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId
        })
});
const $af081181a641afaf$export$81a40d215ef1c1de = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $af081181a641afaf$export$5f449dc44751be0a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$78ce19c6cc1eeb16 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            isAgentSelectorMenuOpen: state.isAgentSelectorMenuOpen,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$1bd034c20714e002 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu
        })
});
const $af081181a641afaf$export$762e860bb8461339 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            mounted: state.mounted
        })
});
const $af081181a641afaf$export$d3b1853c9cb98102 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen
        })
});
const $af081181a641afaf$export$f4c4584d8302c703 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            conversationHeader: state.conversationHeader
        })
});
const $af081181a641afaf$export$1e3791eaae70097a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$357ffd05205e0c5d = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$9e369d8095358b77 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$8f5523dfac6ff4fa = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$5b2ba9b8ea3b0771 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(26);
    const [t0, t1] = $af081181a641afaf$var$useStore();
    const { activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth } = t0;
    const { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth } = t1;
    const t2 = conversationHeader ?? null;
    let t3;
    if ($[0] !== activeMenu || $[1] !== activeTabId || $[2] !== clearSelectedSpace || $[3] !== clearSmartLink3PPostAuth || $[4] !== isAgentSelectorMenuOpen || $[5] !== isChatOnboardingMiniModalOpen || $[6] !== lastTabConversationId || $[7] !== mounted || $[8] !== previousTabId || $[9] !== reset || $[10] !== selectedSpace || $[11] !== setActiveMenu || $[12] !== setActiveTabId || $[13] !== setConversationHeader || $[14] !== setIsAgentSelectorMenuOpen || $[15] !== setIsChatOnboardingMiniModalOpen || $[16] !== setLastTabConversationId || $[17] !== setMounted || $[18] !== setPreviousTabId || $[19] !== setSelectedSpace || $[20] !== setSmartLink3PPostAuth || $[21] !== setStreamingStatus || $[22] !== smartLink3PPostAuth || $[23] !== streaming || $[24] !== t2) {
        t3 = {
            activeMenu: activeMenu,
            mounted: mounted,
            streaming: streaming,
            isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
            conversationHeader: t2,
            selectedSpace: selectedSpace,
            reset: reset,
            setActiveMenu: setActiveMenu,
            setMounted: setMounted,
            setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
            setStreamingStatus: setStreamingStatus,
            isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
            setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
            setConversationHeader: setConversationHeader,
            setSelectedSpace: setSelectedSpace,
            clearSelectedSpace: clearSelectedSpace,
            activeTabId: activeTabId,
            previousTabId: previousTabId,
            lastTabConversationId: lastTabConversationId,
            smartLink3PPostAuth: smartLink3PPostAuth,
            setSmartLink3PPostAuth: setSmartLink3PPostAuth,
            clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
            setActiveTabId: setActiveTabId,
            setPreviousTabId: setPreviousTabId,
            setLastTabConversationId: setLastTabConversationId
        };
        $[0] = activeMenu;
        $[1] = activeTabId;
        $[2] = clearSelectedSpace;
        $[3] = clearSmartLink3PPostAuth;
        $[4] = isAgentSelectorMenuOpen;
        $[5] = isChatOnboardingMiniModalOpen;
        $[6] = lastTabConversationId;
        $[7] = mounted;
        $[8] = previousTabId;
        $[9] = reset;
        $[10] = selectedSpace;
        $[11] = setActiveMenu;
        $[12] = setActiveTabId;
        $[13] = setConversationHeader;
        $[14] = setIsAgentSelectorMenuOpen;
        $[15] = setIsChatOnboardingMiniModalOpen;
        $[16] = setLastTabConversationId;
        $[17] = setMounted;
        $[18] = setPreviousTabId;
        $[19] = setSelectedSpace;
        $[20] = setSmartLink3PPostAuth;
        $[21] = setStreamingStatus;
        $[22] = smartLink3PPostAuth;
        $[23] = streaming;
        $[24] = t2;
        $[25] = t3;
    } else t3 = $[25];
    return t3;
} : ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth }] = $af081181a641afaf$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        smartLink3PPostAuth: smartLink3PPostAuth,
        setSmartLink3PPostAuth: setSmartLink3PPostAuth,
        clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $af081181a641afaf$export$cd2fc25ddd3752d4 = (0, $kBr4q.createActionsHook)($af081181a641afaf$var$store);
const $af081181a641afaf$var$isRenderStabilizationEnabled = ()=>(0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false);
const $af081181a641afaf$export$f0adc1af32e51b = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>$af081181a641afaf$var$isRenderStabilizationEnabled() ? null : state
});
module.exports["useEmptyChatLaunchSelector"] = $af081181a641afaf$export$13a6c73a57f1d6a6;
module.exports["useActiveTabSelector"] = $af081181a641afaf$export$81a40d215ef1c1de;
module.exports["useSelectedSpaceSelector"] = $af081181a641afaf$export$5f449dc44751be0a;
module.exports["useChatHeaderUISelector"] = $af081181a641afaf$export$78ce19c6cc1eeb16;
module.exports["useConversationHeaderSelector"] = $af081181a641afaf$export$f4c4584d8302c703;
module.exports["useChatInputUISelector"] = $af081181a641afaf$export$357ffd05205e0c5d;
module.exports["useSideNavUISelector"] = $af081181a641afaf$export$9e369d8095358b77;
module.exports["useRootUISelector"] = $af081181a641afaf$export$8f5523dfac6ff4fa;
module.exports["useUIStore"] = $af081181a641afaf$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $af081181a641afaf$export$cd2fc25ddd3752d4;
module.exports["useUIStoreSubscription"] = $af081181a641afaf$export$f0adc1af32e51b;

});

parcelRegister("aihbI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $12QCz = parcelRequire("12QCz");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $hSs5g = parcelRequire("hSs5g");


var $hq9Cp = parcelRequire("hq9Cp");


var $a9aSv = parcelRequire("a9aSv");


var $hlvTd = parcelRequire("hlvTd");


var $5SS4O = parcelRequire("5SS4O");


var $ji12t = parcelRequire("ji12t");


var $8reXX = parcelRequire("8reXX");


var $aaPn1 = parcelRequire("aaPn1");


var $fjlCA = parcelRequire("fjlCA");


var $cKhij = parcelRequire("cKhij");

const $117d671412ecf119$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $117d671412ecf119$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $117d671412ecf119$export$1565ea9a9fb7ad67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agent: agent, siteId: siteId, simplified: simplified, onClick: onClick } = t0;
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, "Atlassian"));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) {
            let t1;
            if ($[1] !== authoringTeam.display_name || $[2] !== authoringTeam.profile_url || $[3] !== onClick) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: authoringTeam.profile_url,
                    target: "_blank",
                    onClick: onClick
                }, authoringTeam.display_name));
                $[1] = authoringTeam.display_name;
                $[2] = authoringTeam.profile_url;
                $[3] = onClick;
                $[4] = t1;
            } else t1 = $[4];
            return t1;
        }
        let t1;
        if ($[5] !== agent.creator) {
            t1 = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
            $[5] = agent.creator;
            $[6] = t1;
        } else t1 = $[6];
        const aaid = t1;
        if (!aaid) return null;
        let t2;
        if ($[7] !== aaid || $[8] !== onClick || $[9] !== simplified || $[10] !== siteId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
                userId: aaid,
                siteId: siteId,
                profileCard: true,
                simplified: simplified,
                onClick: onClick
            });
            $[7] = aaid;
            $[8] = onClick;
            $[9] = simplified;
            $[10] = siteId;
            $[11] = t2;
        } else t2 = $[11];
        return t2;
    }
    if ((0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === "REMOTE_A2A" && (0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
        let t1;
        if ($[12] !== agent.creator) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, agent.creator);
            $[12] = agent.creator;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    return null;
} : ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        testId: "atlassian-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        label: "",
        appearance: "brand",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, "Atlassian"));
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            testId: "atlassian-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: authoringTeam.profile_url,
            target: "_blank",
            onClick: onClick
        }, authoringTeam.display_name));
        const aaid = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === 'REMOTE_A2A' && (0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, agent.creator);
    }
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $117d671412ecf119$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $6cFsl.di)($117d671412ecf119$export$5d980898591175e);
    const { profile: profile, client: client } = $117d671412ecf119$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { atlasURL: atlasURL } = (0, $aaPn1.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $cKhij.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick
        }, fullName);
    }
    return profileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
const $117d671412ecf119$export$5d980898591175e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProfileResolution(userId, siteId, t0) {
    const $ = (0, $bDgLe.c)(14);
    const shouldFetch = t0 === undefined ? true : t0;
    const profileClient = (0, $fjlCA.useProfileClient)();
    let t1;
    if ($[0] !== siteId || $[1] !== userId) {
        t1 = [
            "fetchProfile",
            siteId,
            userId
        ];
        $[0] = siteId;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== profileClient || $[4] !== siteId || $[5] !== userId) {
        t2 = async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (t3) {
                const error = t3;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "ConversationAssistantAgentUseProfileResolutionError"
                });
                return {};
            }
        };
        $[3] = profileClient;
        $[4] = siteId;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== shouldFetch || $[8] !== t1 || $[9] !== t2) {
        t3 = {
            queryKey: t1,
            queryFn: t2,
            enabled: shouldFetch
        };
        $[7] = shouldFetch;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const profile = (0, $5SS4O.useQuery)(t3);
    let t4;
    if ($[11] !== profile || $[12] !== profileClient) {
        t4 = {
            profile: profile,
            client: profileClient
        };
        $[11] = profile;
        $[12] = profileClient;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function useProfileResolution(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $fjlCA.useProfileClient)();
    const profile = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
};
const $117d671412ecf119$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $117d671412ecf119$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $117d671412ecf119$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $8reXX.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $117d671412ecf119$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $117d671412ecf119$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $117d671412ecf119$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $117d671412ecf119$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $117d671412ecf119$export$6d876204c5d593ac;

});

parcelRegister("8reXX", function(module, exports) {
const $631eae7ab6cb77ba$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $631eae7ab6cb77ba$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $631eae7ab6cb77ba$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $631eae7ab6cb77ba$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE;
const $631eae7ab6cb77ba$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE;
const $631eae7ab6cb77ba$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $631eae7ab6cb77ba$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $631eae7ab6cb77ba$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $631eae7ab6cb77ba$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $631eae7ab6cb77ba$export$429080cfef3412f2;

});

parcelRegister("fjlCA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5hJlu = parcelRequire("5hJlu");

const $b39593d68f627ba8$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $b39593d68f627ba8$var$client;
const $b39593d68f627ba8$export$d43dc22a8337ee9f = ()=>{
    (0, $6cFsl.di)((0, $5hJlu.default));
    const profileClient = (0, $cozmU.useMemo)(()=>{
        if (!$b39593d68f627ba8$var$client) // To support di
        $b39593d68f627ba8$var$client = new (0, $5hJlu.default)({
            url: $b39593d68f627ba8$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $b39593d68f627ba8$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $b39593d68f627ba8$export$d43dc22a8337ee9f;

});

parcelRegister("cKhij", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f61c2cb3f029b6ef$var$message = (0, $kSwu1.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $f61c2cb3f029b6ef$export$2e2bcd8739ae039 = $f61c2cb3f029b6ef$var$message;
module.exports["default"] = $f61c2cb3f029b6ef$export$2e2bcd8739ae039;

});

parcelRegister("gznGh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::240d2a2d2ecd17e4d685f807cd1b54f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10248beccb6a135$var$_react = $c10248beccb6a135$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c10248beccb6a135$var$_baseNew = $c10248beccb6a135$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c10248beccb6a135$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c10248beccb6a135$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $c10248beccb6a135$var$_react.default.createElement($c10248beccb6a135$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$c10248beccb6a135$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $c10248beccb6a135$var$_default = module.exports.default = $c10248beccb6a135$var$BookWithBookmarkIcon;

});

parcelRegister("fuSOM", function(module, exports) {
parcelRequire("eRn3r");
var $9aUDG = parcelRequire("9aUDG");


var $lA6N5 = parcelRequire("lA6N5");


const $cb5189150b488f78$var$LazyLinkPickerComponent = (0, $9aUDG.lazyForPaint)(()=>(parcelRequire("2mM0Z")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $cb5189150b488f78$var$_default_1 = (0, $lA6N5.composeLinkPicker)($cb5189150b488f78$var$LazyLinkPickerComponent);
var $cb5189150b488f78$export$2e2bcd8739ae039 = $cb5189150b488f78$var$_default_1;
module.exports["default"] = $cb5189150b488f78$export$2e2bcd8739ae039;

});

parcelRegister("lA6N5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

parcelRequire("eRn3r");
var $3QYdZ = parcelRequire("3QYdZ");


var $gBjHb = parcelRequire("gBjHb");


var $kJo8F = parcelRequire("kJo8F");


var $eg7eG = parcelRequire("eg7eG");


var $fCO8c = parcelRequire("fCO8c");


var $k5YvC = parcelRequire("k5YvC");


var $lg1Gp = parcelRequire("lg1Gp");

const $12f35d08bde2472f$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $12f35d08bde2472f$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $kJo8F.COMPONENT_NAME),
    source: (0, $kJo8F.COMPONENT_NAME)
};
const $12f35d08bde2472f$var$DefaultRootComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $12f35d08bde2472f$var$fixedWidthContainerStyles = null;
const $12f35d08bde2472f$var$FixedWidthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1bsb1ubl"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hekY6.default)([
            "_1bsb1ubl"
        ])
    });
};
const $12f35d08bde2472f$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $12f35d08bde2472f$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: $12f35d08bde2472f$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg7eG.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lg1Gp.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $kJo8F.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12f35d08bde2472f$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCO8c.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3QYdZ.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5YvC.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, {
            ...props,
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $12f35d08bde2472f$export$922eb685ceb4a294;

});

parcelRegister("kJo8F", function(module, exports) {
const $001c95c8c9eb30f1$export$85183a312807388d = 'media';
const $001c95c8c9eb30f1$export$fc44104665f4d1e5 = 'linkPicker';
const $001c95c8c9eb30f1$export$452f1062ecf44be7 = 5;
const $001c95c8c9eb30f1$export$bf31a09f182d5584 = 342;
const $001c95c8c9eb30f1$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $001c95c8c9eb30f1$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $001c95c8c9eb30f1$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $001c95c8c9eb30f1$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $001c95c8c9eb30f1$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $001c95c8c9eb30f1$export$542fb16962bf430c;

});

parcelRegister("eg7eG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $gt5Em = parcelRequire("gt5Em");

const $c7635a085ba363f5$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $c7635a085ba363f5$export$3285420c698bc605 = /*#__PURE__*/ (0, $cozmU.createContext)($c7635a085ba363f5$export$c07727f5eddb98f);
const $c7635a085ba363f5$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $cozmU.useRef)((0, $kHija.v4)());
    (0, $cozmU.useEffect)(()=>{
        (0, $gt5Em.startUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
        return ()=>(0, $gt5Em.abortUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7635a085ba363f5$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $c7635a085ba363f5$export$36ecc935abdc3636 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
} : ()=>(0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $c7635a085ba363f5$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $c7635a085ba363f5$export$36ecc935abdc3636;

});

parcelRegister("gt5Em", function(module, exports) {

var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

const $64cb77453c568c86$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $64cb77453c568c86$var$ufoExperiences = {
    [$64cb77453c568c86$export$f9c7780c574346a2.mounted]: new (0, $fh15z.ConcurrentExperience)($64cb77453c568c86$export$f9c7780c574346a2.mounted, {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $64cb77453c568c86$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $64cb77453c568c86$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $64cb77453c568c86$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $64cb77453c568c86$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $64cb77453c568c86$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $64cb77453c568c86$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $64cb77453c568c86$export$b1021040eb94cdca;

});

parcelRegister("fCO8c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");


var $aRBFH = parcelRequire("aRBFH");


var $f3GZb = parcelRequire("f3GZb");

const $96adf85769963d68$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $779pE.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    const handleError = (0, $cozmU.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $779pE.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $96adf85769963d68$export$e926676385687eaf;

});

parcelRegister("779pE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $eafc2c5357085519$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $eafc2c5357085519$export$2e2bcd8739ae039 = $eafc2c5357085519$var$createEventPayload;
module.exports["default"] = $eafc2c5357085519$export$2e2bcd8739ae039;

});

parcelRegister("aRBFH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $baa71a56a1d588bd$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $baa71a56a1d588bd$export$688779ac61ee945f;

});

parcelRegister("f3GZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kJo8F = parcelRequire("kJo8F");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");


var $dOXsL = parcelRequire("dOXsL");

const $66e5302c045c6e9e$var$errorBoundaryFallbackStyles = null;
const $66e5302c045c6e9e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $66e5302c045c6e9e$export$8a28b7e38e4685dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_11c8i4vh"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
            header: header,
            renderImage: $66e5302c045c6e9e$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
    const description = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hekY6.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null),
        description: description
    }));
};
function $66e5302c045c6e9e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $66e5302c045c6e9e$export$8a28b7e38e4685dd;

});

parcelRegister("bXDzR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $efcb4a3aca6e9417$var$SIZE = 96;
const $efcb4a3aca6e9417$var$genericErrorStyles = null;
const $efcb4a3aca6e9417$export$e54420a1a27457a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]);
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hekY6.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $efcb4a3aca6e9417$export$e54420a1a27457a4;

});

parcelRegister("k3ncb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $abc7c062eda24665$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $abc7c062eda24665$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] !== renderImage) {
        t1 = renderImage?.();
        $[0] = renderImage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== header) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, header);
        $[2] = header;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== description) {
        t3 = description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            as: "p",
            color: "color.text"
        }, description);
        $[4] = description;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = action && action;
    let t5;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
            xcss: $abc7c062eda24665$var$styles.containerV2,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t1, t2, t3, t4);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = testId;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        xcss: $abc7c062eda24665$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $abc7c062eda24665$export$fddf379e22a74b00;

});

parcelRegister("dOXsL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $1bc658963d2888d5$var$minHeightComponentStyles = null;
const $1bc658963d2888d5$export$42134e2a251518b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $1bc658963d2888d5$export$42134e2a251518b3;

});

parcelRegister("k5YvC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $dOXsL = parcelRequire("dOXsL");

const $9e6da8c9bb613998$var$styles = null;
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $9e6da8c9bb613998$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $9e6da8c9bb613998$export$d96e921133238c41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4cvr1h6o"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hekY6.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $9e6da8c9bb613998$export$d96e921133238c41;

});

parcelRegister("lg1Gp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Vh5j9 = parcelRequire("Vh5j9");

const $f169ae6f19f5b49d$export$54320b51a950d54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $f169ae6f19f5b49d$export$54320b51a950d54a;

});

parcelRegister("Vh5j9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $935R1 = parcelRequire("935R1");


var $2H5my = parcelRequire("2H5my");

const $550b5e1058020e28$export$d013d33430f9fb4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: (0, $935R1.default),
            loaderFn: (0, $2H5my.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $935R1.default),
        loaderFn: (0, $2H5my.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $550b5e1058020e28$export$d013d33430f9fb4b;

});

parcelRegister("2H5my", function(module, exports) {

var $b3upr = parcelRequire("b3upr");

const $d0c1d8c70ea117ba$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $d0c1d8c70ea117ba$export$2b153a2030b0feb2;

});

parcelRegister("b3upr", function(module, exports) {

























const $f5a6a4ca12953b28$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("dT096")),
    da: ()=>(parcelRequire("2P2sJ")),
    de: ()=>(parcelRequire("glb5m")),
    en_GB: ()=>(parcelRequire("1owFt")),
    en_ZZ: ()=>(parcelRequire("43PMH")),
    en: ()=>Promise.resolve((parcelRequire("935R1"))),
    es: ()=>(parcelRequire("hGEXH")),
    fi: ()=>(parcelRequire("3GUzN")),
    fr: ()=>(parcelRequire("2GqjB")),
    hu: ()=>(parcelRequire("nq1eZ")),
    it: ()=>(parcelRequire("i2ycc")),
    ja: ()=>(parcelRequire("5fClp")),
    ko: ()=>(parcelRequire("cb3oT")),
    nb: ()=>(parcelRequire("VbcI7")),
    nl: ()=>(parcelRequire("3PMwD")),
    pl: ()=>(parcelRequire("5jUF7")),
    pt_BR: ()=>(parcelRequire("4v22g")),
    ru: ()=>(parcelRequire("adodp")),
    sv: ()=>(parcelRequire("7wcjs")),
    th: ()=>(parcelRequire("5e2PY")),
    tr: ()=>(parcelRequire("11CPA")),
    uk: ()=>(parcelRequire("hRtvo")),
    vi: ()=>(parcelRequire("9PM3y")),
    zh_TW: ()=>(parcelRequire("29Ztf")),
    zh: ()=>(parcelRequire("dAeOf"))
};
module.exports["locales"] = $f5a6a4ca12953b28$export$df1c34db1371eeed;

});

parcelRegister("dT096", function(module, exports) {

let $029be122a3b04e2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $029be122a3b04e2f$var$load("1JYrd"),
    $029be122a3b04e2f$var$load("cip6w"),
    $029be122a3b04e2f$var$load("3feYV"),
    $029be122a3b04e2f$var$load("gAG2n"),
    $029be122a3b04e2f$var$load("hFpP9"),
    $029be122a3b04e2f$var$load("cwjU2"),
    $029be122a3b04e2f$var$load("3Ff1R"),
    $029be122a3b04e2f$var$load("423Ga")
]).then(()=>parcelRequire('ksVtB'));

});

parcelRegister("2P2sJ", function(module, exports) {

let $20e24127880f8644$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $20e24127880f8644$var$load("30242"),
    $20e24127880f8644$var$load("3qBwQ"),
    $20e24127880f8644$var$load("7Q1SM"),
    $20e24127880f8644$var$load("cYGDU"),
    $20e24127880f8644$var$load("ddSTH"),
    $20e24127880f8644$var$load("33Iaa"),
    $20e24127880f8644$var$load("blA7x"),
    $20e24127880f8644$var$load("gJroP")
]).then(()=>parcelRequire('1VdaT'));

});

parcelRegister("glb5m", function(module, exports) {

let $be5734d35c09852c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $be5734d35c09852c$var$load("15aAJ"),
    $be5734d35c09852c$var$load("8rREG"),
    $be5734d35c09852c$var$load("7JdzX"),
    $be5734d35c09852c$var$load("dgXJL"),
    $be5734d35c09852c$var$load("9d8JZ"),
    $be5734d35c09852c$var$load("6681T"),
    $be5734d35c09852c$var$load("3dn3H"),
    $be5734d35c09852c$var$load("cYXvt")
]).then(()=>parcelRequire('h2ceo'));

});

parcelRegister("1owFt", function(module, exports) {

let $10415f84a3555b14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $10415f84a3555b14$var$load("l5BBd"),
    $10415f84a3555b14$var$load("93ASN"),
    $10415f84a3555b14$var$load("24LNf"),
    $10415f84a3555b14$var$load("htu5t"),
    $10415f84a3555b14$var$load("1A450"),
    $10415f84a3555b14$var$load("iYQCc"),
    $10415f84a3555b14$var$load("nBJth")
]).then(()=>parcelRequire('6VGGT'));

});

parcelRegister("43PMH", function(module, exports) {

let $2f4f9c87cb3564a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2f4f9c87cb3564a3$var$load("bbv9t"),
    $2f4f9c87cb3564a3$var$load("9fQoJ"),
    $2f4f9c87cb3564a3$var$load("cnlNg"),
    $2f4f9c87cb3564a3$var$load("lTboH"),
    $2f4f9c87cb3564a3$var$load("gBDXQ"),
    $2f4f9c87cb3564a3$var$load("d3Phe"),
    $2f4f9c87cb3564a3$var$load("lASLx"),
    $2f4f9c87cb3564a3$var$load("bIXgz")
]).then(()=>parcelRequire('glan9'));

});

parcelRegister("hGEXH", function(module, exports) {

let $ce062218aa215854$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ce062218aa215854$var$load("7p4je"),
    $ce062218aa215854$var$load("8SZbD"),
    $ce062218aa215854$var$load("9Uf61"),
    $ce062218aa215854$var$load("iE05k"),
    $ce062218aa215854$var$load("lv5aU"),
    $ce062218aa215854$var$load("3Yk1e"),
    $ce062218aa215854$var$load("5lJyy"),
    $ce062218aa215854$var$load("9w9df")
]).then(()=>parcelRequire('jIUdy'));

});

parcelRegister("3GUzN", function(module, exports) {

let $2b012e3f25fe3861$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b012e3f25fe3861$var$load("1jQRQ"),
    $2b012e3f25fe3861$var$load("5pOQA"),
    $2b012e3f25fe3861$var$load("fJSEb"),
    $2b012e3f25fe3861$var$load("5GSny"),
    $2b012e3f25fe3861$var$load("cQump"),
    $2b012e3f25fe3861$var$load("ajzkj"),
    $2b012e3f25fe3861$var$load("eyysG"),
    $2b012e3f25fe3861$var$load("27gvR")
]).then(()=>parcelRequire('j6sWj'));

});

parcelRegister("2GqjB", function(module, exports) {

let $1f43eaae3d3fb0b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f43eaae3d3fb0b0$var$load("km37l"),
    $1f43eaae3d3fb0b0$var$load("gbksI"),
    $1f43eaae3d3fb0b0$var$load("9TeWr"),
    $1f43eaae3d3fb0b0$var$load("j2X7f"),
    $1f43eaae3d3fb0b0$var$load("fE8pi"),
    $1f43eaae3d3fb0b0$var$load("kUZ7k"),
    $1f43eaae3d3fb0b0$var$load("dJQL7"),
    $1f43eaae3d3fb0b0$var$load("czj6d")
]).then(()=>parcelRequire('6POS4'));

});

parcelRegister("nq1eZ", function(module, exports) {

let $046654ee53250fe6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $046654ee53250fe6$var$load("lTbXI"),
    $046654ee53250fe6$var$load("a98cw"),
    $046654ee53250fe6$var$load("fOGnR"),
    $046654ee53250fe6$var$load("e40mE"),
    $046654ee53250fe6$var$load("btBGI"),
    $046654ee53250fe6$var$load("cDQOq"),
    $046654ee53250fe6$var$load("8upye"),
    $046654ee53250fe6$var$load("GlmUM")
]).then(()=>parcelRequire('5BZIn'));

});

parcelRegister("i2ycc", function(module, exports) {

let $d222f07772d48585$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d222f07772d48585$var$load("iUyZj"),
    $d222f07772d48585$var$load("4PDaO"),
    $d222f07772d48585$var$load("8nEeY"),
    $d222f07772d48585$var$load("lMhbw"),
    $d222f07772d48585$var$load("amTTV"),
    $d222f07772d48585$var$load("kLZKK"),
    $d222f07772d48585$var$load("c7GMc"),
    $d222f07772d48585$var$load("bnhJ1")
]).then(()=>parcelRequire('dkwKE'));

});

parcelRegister("5fClp", function(module, exports) {

let $3d2c18d70682bf56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3d2c18d70682bf56$var$load("kPlMQ"),
    $3d2c18d70682bf56$var$load("ervs7"),
    $3d2c18d70682bf56$var$load("fzzMQ"),
    $3d2c18d70682bf56$var$load("8CX31"),
    $3d2c18d70682bf56$var$load("kYd4i"),
    $3d2c18d70682bf56$var$load("33S6H"),
    $3d2c18d70682bf56$var$load("kFae4"),
    $3d2c18d70682bf56$var$load("iZWpE")
]).then(()=>parcelRequire('4VLhA'));

});

parcelRegister("cb3oT", function(module, exports) {

let $8dd9266225896019$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8dd9266225896019$var$load("iT2sv"),
    $8dd9266225896019$var$load("iMMtn"),
    $8dd9266225896019$var$load("3gNEO"),
    $8dd9266225896019$var$load("23VWs"),
    $8dd9266225896019$var$load("e1KaU"),
    $8dd9266225896019$var$load("93obY"),
    $8dd9266225896019$var$load("6Y9jE"),
    $8dd9266225896019$var$load("cUTaY")
]).then(()=>parcelRequire('gVcgA'));

});

parcelRegister("VbcI7", function(module, exports) {

let $0abe03de5f1993f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0abe03de5f1993f1$var$load("lyPpF"),
    $0abe03de5f1993f1$var$load("eX5n7"),
    $0abe03de5f1993f1$var$load("gvylW"),
    $0abe03de5f1993f1$var$load("aiYuN"),
    $0abe03de5f1993f1$var$load("gqMCT"),
    $0abe03de5f1993f1$var$load("bxfRe"),
    $0abe03de5f1993f1$var$load("ed6s8"),
    $0abe03de5f1993f1$var$load("lAuJd")
]).then(()=>parcelRequire('6B7wN'));

});

parcelRegister("3PMwD", function(module, exports) {

let $2cabc6a47d3e23a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2cabc6a47d3e23a3$var$load("iN3cj"),
    $2cabc6a47d3e23a3$var$load("3nHdy"),
    $2cabc6a47d3e23a3$var$load("80OLx"),
    $2cabc6a47d3e23a3$var$load("gDEvm"),
    $2cabc6a47d3e23a3$var$load("5MwHB"),
    $2cabc6a47d3e23a3$var$load("1EVcg"),
    $2cabc6a47d3e23a3$var$load("96q1k"),
    $2cabc6a47d3e23a3$var$load("XQtfV")
]).then(()=>parcelRequire('6e51k'));

});

parcelRegister("5jUF7", function(module, exports) {

let $3dfaae0b91366a24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3dfaae0b91366a24$var$load("eC1OL"),
    $3dfaae0b91366a24$var$load("ilL9c"),
    $3dfaae0b91366a24$var$load("e4s0V"),
    $3dfaae0b91366a24$var$load("64nco"),
    $3dfaae0b91366a24$var$load("9cx6P"),
    $3dfaae0b91366a24$var$load("28EXy"),
    $3dfaae0b91366a24$var$load("7RZp5"),
    $3dfaae0b91366a24$var$load("leyTH")
]).then(()=>parcelRequire('guLr4'));

});

parcelRegister("4v22g", function(module, exports) {

let $346ba2deeef24df4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $346ba2deeef24df4$var$load("4NJ49"),
    $346ba2deeef24df4$var$load("bfOZL"),
    $346ba2deeef24df4$var$load("4dPO1"),
    $346ba2deeef24df4$var$load("jLbRX"),
    $346ba2deeef24df4$var$load("5g0HW"),
    $346ba2deeef24df4$var$load("gg8tK"),
    $346ba2deeef24df4$var$load("eF54W"),
    $346ba2deeef24df4$var$load("3hnPt")
]).then(()=>parcelRequire('9NY5A'));

});

parcelRegister("adodp", function(module, exports) {

let $76fde6e7dab93238$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $76fde6e7dab93238$var$load("g9gkE"),
    $76fde6e7dab93238$var$load("jYdbS"),
    $76fde6e7dab93238$var$load("ltrgi"),
    $76fde6e7dab93238$var$load("6ncWv"),
    $76fde6e7dab93238$var$load("gFneG"),
    $76fde6e7dab93238$var$load("fu25G"),
    $76fde6e7dab93238$var$load("iQGcz"),
    $76fde6e7dab93238$var$load("ar4uw")
]).then(()=>parcelRequire('l7nLc'));

});

parcelRegister("7wcjs", function(module, exports) {

let $5795129f16bebda4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5795129f16bebda4$var$load("jhikU"),
    $5795129f16bebda4$var$load("f0i3H"),
    $5795129f16bebda4$var$load("69YlM"),
    $5795129f16bebda4$var$load("bvBAp"),
    $5795129f16bebda4$var$load("9kqmW"),
    $5795129f16bebda4$var$load("cyTsc"),
    $5795129f16bebda4$var$load("kXCsp"),
    $5795129f16bebda4$var$load("disCG")
]).then(()=>parcelRequire('ijDRq'));

});

parcelRegister("5e2PY", function(module, exports) {

let $3ce075fd9818b53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ce075fd9818b53d$var$load("e2Idi").then(()=>parcelRequire('fC7VU'));

});

parcelRegister("11CPA", function(module, exports) {

let $0bf4017cfd787023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf4017cfd787023$var$load("3gdIo").then(()=>parcelRequire('4USSX'));

});

parcelRegister("hRtvo", function(module, exports) {

let $d00e46120947d0cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00e46120947d0cd$var$load("1uCJj").then(()=>parcelRequire('dWB8a'));

});

parcelRegister("9PM3y", function(module, exports) {

let $728e27781bf035cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728e27781bf035cb$var$load("crqMH").then(()=>parcelRequire('qL2MH'));

});

parcelRegister("29Ztf", function(module, exports) {

let $192c1ad55746f7d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $192c1ad55746f7d1$var$load("d91RK"),
    $192c1ad55746f7d1$var$load("f7hfJ"),
    $192c1ad55746f7d1$var$load("brdRT"),
    $192c1ad55746f7d1$var$load("QI1kr"),
    $192c1ad55746f7d1$var$load("5LvhC"),
    $192c1ad55746f7d1$var$load("lWBlc"),
    $192c1ad55746f7d1$var$load("s2EmI"),
    $192c1ad55746f7d1$var$load("jc0YL")
]).then(()=>parcelRequire('ayAwo'));

});

parcelRegister("dAeOf", function(module, exports) {

let $9e3a1fff2510c3a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9e3a1fff2510c3a2$var$load("708J7"),
    $9e3a1fff2510c3a2$var$load("kVqUf"),
    $9e3a1fff2510c3a2$var$load("j03Pa"),
    $9e3a1fff2510c3a2$var$load("2IMxh"),
    $9e3a1fff2510c3a2$var$load("98tcg"),
    $9e3a1fff2510c3a2$var$load("kke1I"),
    $9e3a1fff2510c3a2$var$load("gOwMq"),
    $9e3a1fff2510c3a2$var$load("6GfaN")
]).then(()=>parcelRequire('3x4gn'));

});

parcelRegister("2mM0Z", function(module, exports) {

let $1b92e19a0590b807$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1b92e19a0590b807$var$load("4RsKm"),
    $1b92e19a0590b807$var$load("3Pqne"),
    $1b92e19a0590b807$var$load("biEu6"),
    $1b92e19a0590b807$var$load("hZ2FX"),
    $1b92e19a0590b807$var$load("6wr18"),
    $1b92e19a0590b807$var$load("7EorR"),
    $1b92e19a0590b807$var$load("ffEVr"),
    $1b92e19a0590b807$var$load("Wowvf"),
    $1b92e19a0590b807$var$load("hhss7"),
    $1b92e19a0590b807$var$load("gnocL")
]).then(()=>parcelRequire('8mHp9'));

});

parcelRegister("15IyG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cb8d26c32694895$export$2e2bcd8739ae039);

var $nsx26 = parcelRequire("nsx26");


var $1xxT0 = parcelRequire("1xxT0");


var $3yGK6 = parcelRequire("3yGK6");

function $0cb8d26c32694895$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $nsx26.default)(dirtyDate, (0, $1xxT0.default)(Date.now(), 1));
}

});

parcelRegister("1xxT0", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f3289e9f8e4176$export$2e2bcd8739ae039);

var $gkHoc = parcelRequire("gkHoc");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $11f3289e9f8e4176$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $gkHoc.default)(dirtyDate, -amount);
}

});

parcelRegister("gMmzr", function(module, exports) {
const $cc0245eb84decfef$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $cc0245eb84decfef$export$d4fff2dfff3e2bc1;

});

parcelRegister("b6fxF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxdou.CardLoading), null),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }
    });
}
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, props));
}
/** Inner implementation of {@link UserProfileCardForMention}. */ function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        environmentProvider
    ]);
    // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    if (!referenceElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        shouldRenderToParent: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: onErrorBoundary,
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).modal()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
        referenceElement: referenceElement,
        placement: placement
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- positioning controlled by popper
            style: style,
            testId: testId ? `${testId}--mention-popup` : undefined
        }, entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0b67b0fc1e6d3033$var$PopperContent, {
            entryPointReference: entryPointReference,
            entryPointErrorFallback: entryPointErrorFallback,
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxdou.CardLoading), null))))));
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("HGu9Y", function(module, exports) {

var $7toP7 = parcelRequire("7toP7");


var $fClPf = parcelRequire("fClPf");


var $aOTwp = parcelRequire("aOTwp");


var $gYiLB = parcelRequire("gYiLB");

const $7545ccce0e49e308$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $7toP7.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $aOTwp.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $aOTwp.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $aOTwp.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $gYiLB.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $7545ccce0e49e308$export$171e576bb7c729fa;

});

parcelRegister("aOTwp", function(module, exports) {

var $iX5Ka = parcelRequire("iX5Ka");

var $krYZG = parcelRequire("krYZG");


var $9WBFV = parcelRequire("9WBFV");


var $fClPf = parcelRequire("fClPf");


var $fanJz = parcelRequire("fanJz");


var $eFZrs = parcelRequire("eFZrs");

const $8ccb9806c3a6424a$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $8ccb9806c3a6424a$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $9WBFV.toggleBlockMark)(indentation, getNewIndentationAttrs, $8ccb9806c3a6424a$export$54db194d337db321)(state, dispatch);
    };
}
function $8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $fanJz.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $8ccb9806c3a6424a$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $eFZrs.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $8ccb9806c3a6424a$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getIndentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $8ccb9806c3a6424a$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getOutdentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $8ccb9806c3a6424a$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $9WBFV.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $8ccb9806c3a6424a$export$54db194d337db321;
module.exports["getIndentCommand"] = $8ccb9806c3a6424a$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $8ccb9806c3a6424a$export$620b2a1f10eb3a5f;

});

parcelRegister("fanJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd1315d32deb815$export$2e2bcd8739ae039);
function $7dd1315d32deb815$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("eFZrs", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

var $iX5Ka = parcelRequire("iX5Ka");

const $1736d54b67a5c25e$var$indentTypes = {
    paragraph: (0, $iX5Ka.INDENT_TYPE).PARAGRAPH,
    heading: (0, $iX5Ka.INDENT_TYPE).HEADING
};
function $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $1736d54b67a5c25e$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $1736d54b67a5c25e$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $1736d54b67a5c25e$export$4f15b45384b61427;

});

parcelRegister("gYiLB", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $b9BvQ = parcelRequire("b9BvQ");


var $44cyU = parcelRequire("44cyU");


var $bjg0G = parcelRequire("bjg0G");


var $aOTwp = parcelRequire("aOTwp");

function $1df8e650ca8df6e6$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $aOTwp.getIndentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.outdent)), (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $b9BvQ.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $bjg0G.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
var $1df8e650ca8df6e6$export$2e2bcd8739ae039 = $1df8e650ca8df6e6$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $1df8e650ca8df6e6$export$e832373cff8dec22;

});

parcelRegister("jEaFE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");

const $3dd4b47fb9e5cae4$export$881345eb2554ea9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== childComponentSelector || $[1] !== dom || $[2] !== handleEscape || $[3] !== handleFocus || $[4] !== isShortcutToFocusToolbar) {
        t1 = ()=>{
            if (!wrapperRef.current) return;
            const { current: element } = wrapperRef;
            const getFocusableElements = ()=>{
                if (!element) return [];
                const focusableSelectors = [
                    "button:not([disabled])",
                    "[role=\"button\"]:not([disabled])",
                    "[tabindex]:not([tabindex=\"-1\"])"
                ].join(",");
                const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
                return allFocusable.filter((el)=>{
                    if (!el.closest(`${childComponentSelector}`)) return false;
                    let currentEl = el;
                    while(currentEl && currentEl !== element){
                        const computedStyle = window.getComputedStyle(currentEl);
                        if (computedStyle.display === "none" || computedStyle.visibility === "hidden") return false;
                        currentEl = currentEl.parentElement;
                    }
                    return true;
                });
            };
            const moveFocus = (direction)=>{
                const focusableElements = getFocusableElements();
                if (focusableElements.length === 0) return;
                const doc = (0, $1hQ0e.getDocument)();
                const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
                let nextIndex;
                if (currentIndex === -1) nextIndex = 0;
                else if (direction === "right") nextIndex = (currentIndex + 1) % focusableElements.length;
                else nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
                focusableElements[nextIndex]?.focus();
            };
            const handleTab = ()=>{
                const focusableElements_0 = getFocusableElements();
                if (focusableElements_0.length === 0) return;
                const doc_0 = (0, $1hQ0e.getDocument)();
                let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
                if (index < 0) index = 0;
                focusableElements_0.forEach($3dd4b47fb9e5cae4$var$_temp);
                focusableElements_0[index].setAttribute("tabindex", "0");
            };
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                bb86: switch(event.key){
                    case "Escape":
                        handleEscape(event);
                        break bb86;
                    case "ArrowLeft":
                        event.preventDefault();
                        moveFocus("left");
                        break bb86;
                    case "ArrowRight":
                        event.preventDefault();
                        moveFocus("right");
                        break bb86;
                    case "Tab":
                        handleTab();
                        break bb86;
                    default:
                }
            };
            const globalKeyDownHandler = (event_0)=>{
                if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
            };
            element?.addEventListener("keydown", handleKeyDown);
            dom?.addEventListener("keydown", globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener("keydown", handleKeyDown);
                dom?.removeEventListener("keydown", globalKeyDownHandler);
            };
        };
        t2 = [
            wrapperRef,
            childComponentSelector,
            dom,
            isShortcutToFocusToolbar,
            handleFocus,
            handleEscape
        ];
        $[0] = childComponentSelector;
        $[1] = dom;
        $[2] = handleEscape;
        $[3] = handleFocus;
        $[4] = isShortcutToFocusToolbar;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[7] !== ariaControls || $[8] !== ariaLabel || $[9] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": ariaLabel,
            "aria-controls": ariaControls
        }, children);
        $[7] = ariaControls;
        $[8] = ariaLabel;
        $[9] = children;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $1hQ0e.getDocument)();
            const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements_0 = getFocusableElements();
            if (focusableElements_0.length === 0) return;
            const doc_0 = (0, $1hQ0e.getDocument)();
            let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements_0.forEach((el_2)=>el_2.setAttribute('tabindex', '-1'));
            focusableElements_0[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event_0)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls
    }, children);
};
function $3dd4b47fb9e5cae4$var$_temp(el_2) {
    return el_2.setAttribute("tabindex", "-1");
}
module.exports["ToolbarKeyboardNavigationProvider"] = $3dd4b47fb9e5cae4$export$881345eb2554ea9e;

});

parcelRegister("erHVE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $786700e92aa2b215$export$31b2b7ff910ba1f3 = new (0, $kCECX.PluginKey)('editorToolbarPluginKey');
module.exports["editorToolbarPluginKey"] = $786700e92aa2b215$export$31b2b7ff910ba1f3;

});

parcelRegister("bR6es", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $b2jdX = parcelRequire("b2jdX");


var $gMrzi = parcelRequire("gMrzi");


var $jEaFE = parcelRequire("jEaFE");


var $2Wuyj = parcelRequire("2Wuyj");

const $726c97f63f4e2017$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $726c97f63f4e2017$export$4c260019440d418f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, label: label, actionSubjectId: actionSubjectId, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionSubjectId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Wuyj.ViewEventEmitter), {
            actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: actionSubjectId
        });
        $[1] = actionSubjectId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t1,
            "aria-label": label,
            testId: testId,
            "data-toolbar-type": "inline"
        }, t2, children);
        $[3] = children;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    const toolbar = t3;
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        let t4;
        if ($[8] !== ariaControls || $[9] !== ariaLabel || $[10] !== childComponentSelector || $[11] !== dom || $[12] !== handleEscape || $[13] !== handleFocus || $[14] !== isShortcutToFocusToolbar || $[15] !== toolbar) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: childComponentSelector,
                dom: dom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                handleFocus: handleFocus,
                ariaControls: ariaControls,
                ariaLabel: ariaLabel
            }, toolbar);
            $[8] = ariaControls;
            $[9] = ariaLabel;
            $[10] = childComponentSelector;
            $[11] = dom;
            $[12] = handleEscape;
            $[13] = handleFocus;
            $[14] = isShortcutToFocusToolbar;
            $[15] = toolbar;
            $[16] = t4;
        } else t4 = $[16];
        wrappedToolbar = t4;
    }
    let t4;
    if ($[17] !== wrappedToolbar) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveWrapper), null, wrappedToolbar);
        $[17] = wrappedToolbar;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Wuyj.ViewEventEmitter), {
        actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: actionSubjectId
    }), children);
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel
        }, toolbar);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveWrapper), null, wrappedToolbar);
};
const $726c97f63f4e2017$export$7469f9986edfc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, label: label, breakpointPreset: breakpointPreset } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== label) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t1,
            "aria-label": label,
            "data-toolbar-type": "primary"
        }, children);
        $[1] = children;
        $[2] = label;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== breakpointPreset || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveContainer), {
            breakpointPreset: breakpointPreset
        }, t2);
        $[4] = breakpointPreset;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, label: label, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveContainer), {
        breakpointPreset: breakpointPreset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors),
        "aria-label": label,
        "data-toolbar-type": "primary"
    }, children));
};
module.exports["Toolbar"] = $726c97f63f4e2017$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $726c97f63f4e2017$export$7469f9986edfc2;

});

parcelRegister("gMrzi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $a746760df070e426$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    fullpageUpdated: "_1nfkglyw _wne21ule _aw2dglyw _1gtx1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _1mri1ule _17b71ule _1btx1ule _gbo31ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssueUpdated: "_152xglyw _1cn41ule _1j4d1ule _1n52glyw _1nd71ule _lf431ule _103bglyw _1p0z1ule _g5yu1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmCommentUpdated: "_s2iiglyw _o4331ule _1u301ule _u7j1glyw _c7al1ule _14ob1ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $a746760df070e426$var$presetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpage,
    reduced: $a746760df070e426$var$styles.reduced,
    'jira-issue': $a746760df070e426$var$styles.jiraIssue,
    'jsm-comment': $a746760df070e426$var$styles.jsmComment,
    'confluence-comment': $a746760df070e426$var$styles.confluenceComment
};
const $a746760df070e426$var$updatedPresetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpageUpdated,
    'jira-issue': $a746760df070e426$var$styles.jiraIssueUpdated,
    'jsm-comment': $a746760df070e426$var$styles.jsmCommentUpdated
};
const $a746760df070e426$export$e60a4704009a0009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, breakpointPreset: breakpointPreset } = t0;
    let t1;
    bb0: {
        if (breakpointPreset === "fullpage") {
            t1 = (0, $anBbz.expValEqualsNoExposure)("platform_editor_ai_improve_formatting_toolbar", "isEnabled", true);
            break bb0;
        }
        t1 = (0, $ieeJu.expValEquals)("platform_editor_toolbar_update_jira_config", "isEnabled", true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    }
    const isUpdatedConfig = t1;
    const t2 = breakpointPreset === "fullpage" ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer;
    const t3 = isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset];
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $w6R6I.cx)(t2, t3);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t4
        }, children);
        $[3] = children;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (()=>{
        if (breakpointPreset === 'fullpage') return (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_improve_formatting_toolbar', 'isEnabled', true);
        return (0, $ieeJu.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)(breakpointPreset === 'fullpage' ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer, isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset])
    }, children);
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $a746760df070e426$export$fa6e408d6a7d6214 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $a746760df070e426$var$styles.responsiveRulesWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $a746760df070e426$var$styles.responsiveRulesWrapper
    }, children);
};
module.exports["ResponsiveContainer"] = $a746760df070e426$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $a746760df070e426$export$fa6e408d6a7d6214;

});

parcelRegister("2Wuyj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");

const $171e330111381e98$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $171e330111381e98$export$58d0f383acf77599 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actionSubjectId: actionSubjectId, actionSubject: actionSubject } = t0;
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    let t1;
    let t2;
    if ($[0] !== actionSubject || $[1] !== actionSubjectId || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (isMountedRef.current) return;
            isMountedRef.current = true;
            const payload = {
                action: "viewed",
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                eventType: "ui"
            };
            fireAnalyticsEvent && fireAnalyticsEvent(payload);
        };
        t2 = [
            actionSubjectId,
            actionSubject,
            fireAnalyticsEvent
        ];
        $[0] = actionSubject;
        $[1] = actionSubjectId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    (0, $cozmU.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $171e330111381e98$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $171e330111381e98$export$58d0f383acf77599;

});

parcelRegister("eN8p6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $7WEaj = parcelRequire("7WEaj");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $V3JOP = parcelRequire("V3JOP");


var $cJ0FD = parcelRequire("cJ0FD");


var $1tBud = parcelRequire("1tBud");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jttUL = parcelRequire("jttUL");

// no real auth is needed — a stub is sufficient
const $219913ed5ae9800d$var$mediaClientConfig = {
    authProvider: ()=>Promise.reject(new Error('Not required for external images'))
};
const $219913ed5ae9800d$var$messages = (0, $kSwu1.defineMessages)({
    visitSource: {
        id: "smart-knowledge-cards.images.visit-source",
        defaultMessage: "Visit: {sourceTitle}"
    },
    viewImage: {
        id: "smart-knowledge-cards.images.view-image",
        defaultMessage: "View image: {imageName}"
    }
});
const $219913ed5ae9800d$var$styles = {
    image: "_2rko1mok _1e0c1ule _4t3i1w81 _5ral1dfr _1bsb1osq",
    imageContainer: "_2rko1mok _1reo15vq _18m915vq _kqswh2mm _1hu1v2br _1bsb1osq",
    overlayBlanket: "_2rko1mok _1r04ze3t _bfhk1i5c _lcxvglyw _kqswstnw",
    imageContainerFocusRing: "_17ul1v1w _17gidkaa _103cnqa1 _d60jdkaa",
    imageButton: "_2rko1mok _1dqoglyw _bfhk1j28 _80omtlke _1e0c1ule _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1bsb1osq _ra3xglyw",
    twoImagesButton: "_1o9zidpf _1bsb1rkf",
    threeImagesButton: "_1o9zidpf _1bsbp1bp",
    fourOrMoreImagesButton: "_1o9zidpf _1bsbhut5",
    overlayHidden: "_tzy4idpf _1oec6ebc _k8m0brmi _6fl41ytf _3um015vq",
    overlayVisible: "_tzy4kb7n _3um0ewfl",
    iconButtonOverlay: "_2rko1mok _lcxvglyw _kqswstnw _1xi2u2gc _154iu2gc _1pbykb7n _uzlr1v1w _143jdkaa _l0z0nqa1 _w97zdkaa _7de0glyw",
    iconButtonOverlayVisible: "_bfhkvuon _lcxv1wug",
    bottomBar: "_4cvr1h6o _bfhkvuon _94n5ze3t _1e0c1txw _1ltvze3t _1tkezwfg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _lcxvglyw _kqswstnw _1xi2ze3t _1pbykb7n"
};
const $219913ed5ae9800d$var$ImageButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ImageButton(t0) {
    const $ = (0, $bDgLe.c)(52);
    const { buttonStyle: buttonStyle, identifier: identifier, onClick: onClick, onSourceLinkClick: onSourceLinkClick, sourceTitle: sourceTitle, sourceUrl: sourceUrl } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== identifier || $[1] !== onClick) {
        t1 = ()=>onClick(identifier);
        $[0] = identifier;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const [isOverlayVisible, setIsOverlayVisible] = (0, $cozmU.useState)(false);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsOverlayVisible(true);
        $[3] = t2;
    } else t2 = $[3];
    const showOverlay = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOverlayVisible(false);
        $[4] = t3;
    } else t3 = $[4];
    const hideOverlay = t3;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (event)=>{
            if (event.currentTarget.contains(event.relatedTarget)) return;
            hideOverlay();
        };
        $[5] = t4;
    } else t4 = $[5];
    const handleBlur = t4;
    const t5 = buttonStyle && $219913ed5ae9800d$var$styles[buttonStyle];
    let t6;
    if ($[6] !== t5) {
        t6 = (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.imageContainer, $219913ed5ae9800d$var$styles.imageContainerFocusRing, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const t7 = identifier.name ?? "";
    let t8;
    if ($[8] !== formatMessage || $[9] !== t7) {
        t8 = formatMessage($219913ed5ae9800d$var$messages.viewImage, {
            imageName: t7
        });
        $[8] = formatMessage;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    const t9 = identifier.name;
    const t10 = identifier.dataURI;
    let t11;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            $219913ed5ae9800d$var$styles.image
        ]);
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== identifier.dataURI || $[13] !== identifier.name) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            alt: t9,
            src: t10,
            className: t11
        });
        $[12] = identifier.dataURI;
        $[13] = identifier.name;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== handleClick || $[16] !== t12 || $[17] !== t8) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            xcss: $219913ed5ae9800d$var$styles.imageButton,
            onClick: handleClick,
            "aria-label": t8
        }, t12);
        $[15] = handleClick;
        $[16] = t12;
        $[17] = t8;
        $[18] = t13;
    } else t13 = $[18];
    const t14 = isOverlayVisible && $219913ed5ae9800d$var$styles.overlayVisible;
    let t15;
    if ($[19] !== t14) {
        t15 = (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.overlayBlanket, $219913ed5ae9800d$var$styles.overlayHidden, t14);
        $[19] = t14;
        $[20] = t15;
    } else t15 = $[20];
    let t16;
    if ($[21] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            testId: "image-overlay-blanket",
            xcss: t15
        });
        $[21] = t15;
        $[22] = t16;
    } else t16 = $[22];
    const t17 = isOverlayVisible && $219913ed5ae9800d$var$styles.overlayVisible;
    const t18 = isOverlayVisible && $219913ed5ae9800d$var$styles.iconButtonOverlayVisible;
    let t19;
    if ($[23] !== t17 || $[24] !== t18) {
        t19 = (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.iconButtonOverlay, $219913ed5ae9800d$var$styles.overlayHidden, t17, t18);
        $[23] = t17;
        $[24] = t18;
        $[25] = t19;
    } else t19 = $[25];
    let t20;
    if ($[26] !== formatMessage || $[27] !== sourceTitle) {
        t20 = formatMessage($219913ed5ae9800d$var$messages.visitSource, {
            sourceTitle: sourceTitle
        });
        $[26] = formatMessage;
        $[27] = sourceTitle;
        $[28] = t20;
    } else t20 = $[28];
    let t21;
    if ($[29] !== identifier || $[30] !== onSourceLinkClick) {
        t21 = onSourceLinkClick ? ()=>onSourceLinkClick(identifier) : undefined;
        $[29] = identifier;
        $[30] = onSourceLinkClick;
        $[31] = t21;
    } else t21 = $[31];
    let t22;
    if ($[32] !== sourceUrl || $[33] !== t20 || $[34] !== t21) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $7WEaj.default), {
            href: sourceUrl,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            isTooltipDisabled: false,
            label: t20,
            onClick: t21,
            rel: "noopener noreferrer",
            spacing: "default",
            target: "_blank"
        });
        $[32] = sourceUrl;
        $[33] = t20;
        $[34] = t21;
        $[35] = t22;
    } else t22 = $[35];
    let t23;
    if ($[36] !== t19 || $[37] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            testId: "image-overlay-icon",
            xcss: t19
        }, t22);
        $[36] = t19;
        $[37] = t22;
        $[38] = t23;
    } else t23 = $[38];
    const t24 = isOverlayVisible && $219913ed5ae9800d$var$styles.overlayVisible;
    let t25;
    if ($[39] !== t24) {
        t25 = (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.bottomBar, $219913ed5ae9800d$var$styles.overlayHidden, t24);
        $[39] = t24;
        $[40] = t25;
    } else t25 = $[40];
    let t26;
    if ($[41] !== sourceTitle) {
        t26 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            color: "color.text.subtle",
            maxLines: 1,
            size: "small"
        }, sourceTitle);
        $[41] = sourceTitle;
        $[42] = t26;
    } else t26 = $[42];
    let t27;
    if ($[43] !== t25 || $[44] !== t26) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            "aria-hidden": "true",
            testId: "image-overlay-bottom-bar",
            xcss: t25
        }, t26);
        $[43] = t25;
        $[44] = t26;
        $[45] = t27;
    } else t27 = $[45];
    let t28;
    if ($[46] !== t13 || $[47] !== t16 || $[48] !== t23 || $[49] !== t27 || $[50] !== t6) {
        t28 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: t6,
            onMouseEnter: showOverlay,
            onMouseLeave: hideOverlay,
            onFocus: showOverlay,
            onBlur: handleBlur
        }, t13, t16, t23, t27);
        $[46] = t13;
        $[47] = t16;
        $[48] = t23;
        $[49] = t27;
        $[50] = t6;
        $[51] = t28;
    } else t28 = $[51];
    return t28;
} : function ImageButton({ buttonStyle: buttonStyle, identifier: identifier, onClick: onClick, onSourceLinkClick: onSourceLinkClick, sourceTitle: sourceTitle, sourceUrl: sourceUrl }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)(()=>onClick(identifier), [
        identifier,
        onClick
    ]);
    const [isOverlayVisible, setIsOverlayVisible] = (0, $cozmU.useState)(false);
    const showOverlay = (0, $cozmU.useCallback)(()=>setIsOverlayVisible(true), []);
    const hideOverlay = (0, $cozmU.useCallback)(()=>setIsOverlayVisible(false), []);
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        if (event.currentTarget.contains(event.relatedTarget)) return;
        hideOverlay();
    }, [
        hideOverlay
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.imageContainer, $219913ed5ae9800d$var$styles.imageContainerFocusRing, buttonStyle && $219913ed5ae9800d$var$styles[buttonStyle]),
        onMouseEnter: showOverlay,
        onMouseLeave: hideOverlay,
        onFocus: showOverlay,
        onBlur: handleBlur
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        xcss: $219913ed5ae9800d$var$styles.imageButton,
        onClick: handleClick,
        "aria-label": formatMessage($219913ed5ae9800d$var$messages.viewImage, {
            imageName: identifier.name ?? ''
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        alt: identifier.name,
        src: identifier.dataURI,
        className: (0, $hekY6.default)([
            $219913ed5ae9800d$var$styles.image
        ])
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "image-overlay-blanket",
        xcss: (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.overlayBlanket, $219913ed5ae9800d$var$styles.overlayHidden, isOverlayVisible && $219913ed5ae9800d$var$styles.overlayVisible)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "image-overlay-icon",
        xcss: (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.iconButtonOverlay, $219913ed5ae9800d$var$styles.overlayHidden, isOverlayVisible && $219913ed5ae9800d$var$styles.overlayVisible, isOverlayVisible && $219913ed5ae9800d$var$styles.iconButtonOverlayVisible)
    }, /*#__PURE__*/ $cozmU.createElement((0, $7WEaj.default), {
        href: sourceUrl,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        isTooltipDisabled: false,
        label: formatMessage($219913ed5ae9800d$var$messages.visitSource, {
            sourceTitle: sourceTitle
        }),
        onClick: onSourceLinkClick ? ()=>onSourceLinkClick(identifier) : undefined,
        rel: "noopener noreferrer",
        spacing: "default",
        target: "_blank"
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        "aria-hidden": "true",
        testId: "image-overlay-bottom-bar",
        xcss: (0, $w6R6I.cx)($219913ed5ae9800d$var$styles.bottomBar, $219913ed5ae9800d$var$styles.overlayHidden, isOverlayVisible && $219913ed5ae9800d$var$styles.overlayVisible)
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        color: "color.text.subtle",
        maxLines: 1,
        size: "small"
    }, sourceTitle)));
};
const $219913ed5ae9800d$export$ec7dcaac71d9599d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Images(t0) {
    const $ = (0, $bDgLe.c)(39);
    const { heading: heading, images: images, maxVisibleCount: maxVisibleCount, onImageClick: onImageClick, onSourceLinkClick: onSourceLinkClick } = t0;
    const [selectedItem, setSelectedItem] = (0, $cozmU.useState)(null);
    const triggerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== images) {
        t1 = images.map($219913ed5ae9800d$var$_temp);
        $[0] = images;
        $[1] = t1;
    } else t1 = $[1];
    const identifiers = t1;
    let t2;
    if ($[2] !== identifiers || $[3] !== onImageClick) {
        t2 = (identifier)=>{
            triggerRef.current = (0, $1hQ0e.getDocument)()?.activeElement ?? null;
            setSelectedItem(identifier);
            if (onImageClick) {
                const index = identifiers.indexOf(identifier);
                onImageClick(index, identifier.dataURI ?? "");
            }
        };
        $[2] = identifiers;
        $[3] = onImageClick;
        $[4] = t2;
    } else t2 = $[4];
    const openViewer = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const trigger = triggerRef.current;
            setSelectedItem(null);
            requestAnimationFrame(()=>{
                if (trigger instanceof HTMLElement) trigger.focus();
            });
        };
        $[5] = t3;
    } else t3 = $[5];
    const closeViewer = t3;
    let t4;
    if ($[6] !== identifiers || $[7] !== images || $[8] !== onSourceLinkClick) {
        t4 = (identifier_0)=>{
            if (onSourceLinkClick) {
                const index_0 = identifiers.indexOf(identifier_0);
                onSourceLinkClick(index_0, images[index_0]?.sourceUrl ?? "");
            }
        };
        $[6] = identifiers;
        $[7] = images;
        $[8] = onSourceLinkClick;
        $[9] = t4;
    } else t4 = $[9];
    const handleSourceLinkClick = t4;
    if (images.length === 0) return null;
    const isSingleImage = images.length === 1;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            2: "twoImagesButton",
            3: "threeImagesButton"
        };
        $[10] = t5;
    } else t5 = $[10];
    const buttonStyleByCountMap = t5;
    const effectiveVisibleCount = Math.min(maxVisibleCount ?? images.length, images.length);
    const buttonStyle = isSingleImage ? undefined : buttonStyleByCountMap[effectiveVisibleCount] ?? "fourOrMoreImagesButton";
    let t6;
    if ($[11] !== buttonStyle || $[12] !== handleSourceLinkClick || $[13] !== identifiers || $[14] !== images || $[15] !== onSourceLinkClick || $[16] !== openViewer) {
        let t7;
        if ($[18] !== buttonStyle || $[19] !== handleSourceLinkClick || $[20] !== images || $[21] !== onSourceLinkClick || $[22] !== openViewer) {
            t7 = (identifier_1, index_1)=>/*#__PURE__*/ $cozmU.createElement($219913ed5ae9800d$var$ImageButton, {
                    key: `${identifier_1.dataURI}-${index_1}`,
                    buttonStyle: buttonStyle,
                    identifier: identifier_1,
                    onClick: openViewer,
                    onSourceLinkClick: onSourceLinkClick ? handleSourceLinkClick : undefined,
                    sourceTitle: images[index_1].sourceTitle,
                    sourceUrl: images[index_1].sourceUrl
                });
            $[18] = buttonStyle;
            $[19] = handleSourceLinkClick;
            $[20] = images;
            $[21] = onSourceLinkClick;
            $[22] = openViewer;
            $[23] = t7;
        } else t7 = $[23];
        t6 = identifiers.map(t7);
        $[11] = buttonStyle;
        $[12] = handleSourceLinkClick;
        $[13] = identifiers;
        $[14] = images;
        $[15] = onSourceLinkClick;
        $[16] = openViewer;
        $[17] = t6;
    } else t6 = $[17];
    const imageButtons = t6;
    let t7;
    if ($[24] !== identifiers || $[25] !== selectedItem) {
        t7 = selectedItem && /*#__PURE__*/ $cozmU.createElement((0, $1tBud.default), {
            mediaClientConfig: $219913ed5ae9800d$var$mediaClientConfig,
            selectedItem: selectedItem,
            items: identifiers,
            collectionName: "",
            onClose: closeViewer
        });
        $[24] = identifiers;
        $[25] = selectedItem;
        $[26] = t7;
    } else t7 = $[26];
    const viewer = t7;
    if (isSingleImage) {
        let t8;
        if ($[27] !== heading) {
            t8 = heading ? /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                as: "h2",
                size: "xsmall"
            }, heading) : null;
            $[27] = heading;
            $[28] = t8;
        } else t8 = $[28];
        let t9;
        if ($[29] !== imageButtons || $[30] !== t8 || $[31] !== viewer) {
            t9 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
                space: "space.100"
            }, t8, imageButtons, viewer);
            $[29] = imageButtons;
            $[30] = t8;
            $[31] = viewer;
            $[32] = t9;
        } else t9 = $[32];
        return t9;
    }
    let t8;
    if ($[33] !== heading || $[34] !== imageButtons) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $jttUL.Carousel), {
            heading: heading
        }, imageButtons);
        $[33] = heading;
        $[34] = imageButtons;
        $[35] = t8;
    } else t8 = $[35];
    let t9;
    if ($[36] !== t8 || $[37] !== viewer) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, t8, viewer);
        $[36] = t8;
        $[37] = viewer;
        $[38] = t9;
    } else t9 = $[38];
    return t9;
} : function Images({ heading: heading, images: images, maxVisibleCount: maxVisibleCount, onImageClick: onImageClick, onSourceLinkClick: onSourceLinkClick }) {
    const [selectedItem, setSelectedItem] = (0, $cozmU.useState)(null);
    const triggerRef = (0, $cozmU.useRef)(null);
    const identifiers = (0, $cozmU.useMemo)(()=>images.map((result)=>({
                mediaItemType: 'external-image',
                dataURI: result.imageUrl,
                name: result.altText
            })), [
        images
    ]);
    const openViewer = (0, $cozmU.useCallback)((identifier)=>{
        triggerRef.current = (0, $1hQ0e.getDocument)()?.activeElement ?? null;
        setSelectedItem(identifier);
        if (onImageClick) {
            const index = identifiers.indexOf(identifier);
            onImageClick(index, identifier.dataURI ?? '');
        }
    }, [
        identifiers,
        onImageClick
    ]);
    const closeViewer = (0, $cozmU.useCallback)(()=>{
        const trigger = triggerRef.current;
        setSelectedItem(null); // Restore focus after React re-renders and the MediaViewer unmounts
        requestAnimationFrame(()=>{
            if (trigger instanceof HTMLElement) trigger.focus();
        });
    }, []);
    const handleSourceLinkClick = (0, $cozmU.useCallback)((identifier_0)=>{
        if (onSourceLinkClick) {
            const index_0 = identifiers.indexOf(identifier_0);
            onSourceLinkClick(index_0, images[index_0]?.sourceUrl ?? '');
        }
    }, [
        identifiers,
        images,
        onSourceLinkClick
    ]);
    if (images.length === 0) return null;
    const isSingleImage = images.length === 1;
    const buttonStyleByCountMap = {
        2: 'twoImagesButton',
        3: 'threeImagesButton'
    };
    const effectiveVisibleCount = Math.min(maxVisibleCount ?? images.length, images.length);
    const buttonStyle = isSingleImage ? undefined : buttonStyleByCountMap[effectiveVisibleCount] ?? 'fourOrMoreImagesButton';
    const imageButtons = identifiers.map((identifier_1, index_1)=>/*#__PURE__*/ $cozmU.createElement($219913ed5ae9800d$var$ImageButton, {
            key: `${identifier_1.dataURI}-${index_1}`,
            buttonStyle: buttonStyle,
            identifier: identifier_1,
            onClick: openViewer,
            onSourceLinkClick: onSourceLinkClick ? handleSourceLinkClick : undefined,
            sourceTitle: images[index_1].sourceTitle,
            sourceUrl: images[index_1].sourceUrl
        }));
    const viewer = selectedItem && /*#__PURE__*/ $cozmU.createElement((0, $1tBud.default), {
        mediaClientConfig: $219913ed5ae9800d$var$mediaClientConfig,
        selectedItem: selectedItem,
        items: identifiers,
        collectionName: "",
        onClose: closeViewer
    });
    if (isSingleImage) return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.100"
    }, heading ? /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, heading) : null, imageButtons, viewer);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $jttUL.Carousel), {
        heading: heading
    }, imageButtons), viewer);
};
function $219913ed5ae9800d$var$_temp(result) {
    return {
        mediaItemType: "external-image",
        dataURI: result.imageUrl,
        name: result.altText
    };
}
module.exports["Images"] = $219913ed5ae9800d$export$ec7dcaac71d9599d;

});

parcelRegister("jttUL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5Sv3D = parcelRequire("5Sv3D");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

const $d6271a2b562b1c41$var$messages = (0, $kSwu1.defineMessages)({
    carousel: {
        id: "smart-knowledge-cards.carousel.label",
        defaultMessage: "Images"
    },
    scrollLeft: {
        id: "smart-knowledge-cards.carousel.scroll_left",
        defaultMessage: "Scroll left"
    },
    scrollRight: {
        id: "smart-knowledge-cards.carousel.scroll_right",
        defaultMessage: "Scroll right"
    }
});
const $d6271a2b562b1c41$var$styles = {
    buttonsInline: "_18u01wug",
    headerInline: "_1tke1tcg",
    scrollContainerStyle: "_2rko1mok _zulpu2gc _1rjc1b66 _18zr1b66 _195gr5cr _14hb1b66 _4cvr1fhb _1e0c1txw _2lx2vrvc _1bah1y6m _1reo1wug _rjfvx6dd _1fjgglyw _o5721q9c"
};
const $d6271a2b562b1c41$var$isScrollable = (elem)=>elem ? elem.scrollWidth > elem.clientWidth : false;
const $d6271a2b562b1c41$var$isScrollAtLeftEdge = (elem)=>elem ? elem.scrollLeft <= 1 : false;
const $d6271a2b562b1c41$var$isScrollAtRightEdge = (elem)=>elem ? elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth <= 1 : false;
const $d6271a2b562b1c41$export$144901db2ea8e967 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Carousel(t0) {
    const $ = (0, $bDgLe.c)(33);
    const { children: children, heading: heading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const headingId = (0, $cozmU.useId)();
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const [isContentScrollable, setIsContentScrollable] = (0, $cozmU.useState)(false);
    const [shouldDisableLeftArrowButton, setShouldDisableLeftArrowButton] = (0, $cozmU.useState)(true);
    const [shouldDisableRightArrowButton, setShouldDisableRightArrowButton] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const container = scrollContainerRef.current;
            if (!container) return;
            const updateScrollState = ()=>{
                setIsContentScrollable($d6271a2b562b1c41$var$isScrollable(container));
                setShouldDisableLeftArrowButton($d6271a2b562b1c41$var$isScrollAtLeftEdge(container));
                setShouldDisableRightArrowButton($d6271a2b562b1c41$var$isScrollAtRightEdge(container));
            };
            updateScrollState();
            const resizeObserver = new ResizeObserver(updateScrollState);
            resizeObserver.observe(container);
            Array.from(container.children).forEach((child)=>resizeObserver.observe(child));
            return ()=>resizeObserver.disconnect();
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setShouldDisableLeftArrowButton($d6271a2b562b1c41$var$isScrollAtLeftEdge(scrollContainerRef.current));
            setShouldDisableRightArrowButton($d6271a2b562b1c41$var$isScrollAtRightEdge(scrollContainerRef.current));
        };
        $[2] = t3;
    } else t3 = $[2];
    const [onScroll] = (0, $5Sv3D.default)(t3, 10);
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            const container_0 = scrollContainerRef.current;
            if (!container_0) return;
            setShouldDisableRightArrowButton(false);
            container_0.scrollBy({
                left: -container_0.clientWidth,
                behavior: "smooth"
            });
        };
        $[3] = t4;
    } else t4 = $[3];
    const scrollLeft = t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const container_1 = scrollContainerRef.current;
            if (!container_1) return;
            setShouldDisableLeftArrowButton(false);
            container_1.scrollBy({
                left: container_1.clientWidth,
                behavior: "smooth"
            });
        };
        $[4] = t5;
    } else t5 = $[4];
    const scrollRight = t5;
    const t6 = isContentScrollable ? "region" : undefined;
    const t7 = isContentScrollable ? "carousel" : undefined;
    const t8 = isContentScrollable && heading ? headingId : undefined;
    let t9;
    if ($[5] !== formatMessage || $[6] !== heading || $[7] !== isContentScrollable) {
        t9 = isContentScrollable && !heading ? formatMessage($d6271a2b562b1c41$var$messages.carousel) : undefined;
        $[5] = formatMessage;
        $[6] = heading;
        $[7] = isContentScrollable;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== heading || $[10] !== headingId) {
        t10 = heading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xsmall",
            id: headingId
        }, heading) : null;
        $[9] = heading;
        $[10] = headingId;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== formatMessage || $[13] !== isContentScrollable || $[14] !== shouldDisableLeftArrowButton || $[15] !== shouldDisableRightArrowButton) {
        t11 = isContentScrollable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            isTooltipDisabled: true,
            label: formatMessage($d6271a2b562b1c41$var$messages.scrollLeft),
            onClick: scrollLeft,
            spacing: "compact",
            isDisabled: shouldDisableLeftArrowButton
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
            isTooltipDisabled: true,
            label: formatMessage($d6271a2b562b1c41$var$messages.scrollRight),
            onClick: scrollRight,
            spacing: "compact",
            isDisabled: shouldDisableRightArrowButton
        })) : null;
        $[12] = formatMessage;
        $[13] = isContentScrollable;
        $[14] = shouldDisableLeftArrowButton;
        $[15] = shouldDisableRightArrowButton;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.050",
            xcss: $d6271a2b562b1c41$var$styles.buttonsInline
        }, t11);
        $[17] = t11;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== t10 || $[20] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            spread: "space-between",
            alignBlock: "center",
            xcss: $d6271a2b562b1c41$var$styles.headerInline
        }, t10, t12);
        $[19] = t10;
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    const t14 = isContentScrollable ? 0 : undefined;
    let t15;
    if ($[22] !== children || $[23] !== onScroll || $[24] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            ref: scrollContainerRef,
            onScroll: onScroll,
            xcss: $d6271a2b562b1c41$var$styles.scrollContainerStyle,
            tabIndex: t14
        }, children);
        $[22] = children;
        $[23] = onScroll;
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== t13 || $[27] !== t15 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.100",
            role: t6,
            "aria-roledescription": t7,
            "aria-labelledby": t8,
            "aria-label": t9
        }, t13, t15);
        $[26] = t13;
        $[27] = t15;
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
        $[32] = t16;
    } else t16 = $[32];
    return t16;
} : function Carousel({ children: children, heading: heading }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const headingId = (0, $cozmU.useId)();
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const [isContentScrollable, setIsContentScrollable] = (0, $cozmU.useState)(false);
    const [shouldDisableLeftArrowButton, setShouldDisableLeftArrowButton] = (0, $cozmU.useState)(true);
    const [shouldDisableRightArrowButton, setShouldDisableRightArrowButton] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const container = scrollContainerRef.current;
        if (!container) return;
        const updateScrollState = ()=>{
            setIsContentScrollable($d6271a2b562b1c41$var$isScrollable(container));
            setShouldDisableLeftArrowButton($d6271a2b562b1c41$var$isScrollAtLeftEdge(container));
            setShouldDisableRightArrowButton($d6271a2b562b1c41$var$isScrollAtRightEdge(container));
        };
        updateScrollState();
        const resizeObserver = new ResizeObserver(updateScrollState);
        resizeObserver.observe(container);
        Array.from(container.children).forEach((child)=>resizeObserver.observe(child));
        return ()=>resizeObserver.disconnect();
    }, []);
    const [onScroll] = (0, $5Sv3D.default)(()=>{
        setShouldDisableLeftArrowButton($d6271a2b562b1c41$var$isScrollAtLeftEdge(scrollContainerRef.current));
        setShouldDisableRightArrowButton($d6271a2b562b1c41$var$isScrollAtRightEdge(scrollContainerRef.current));
    }, 10);
    const scrollLeft = ()=>{
        const container_0 = scrollContainerRef.current;
        if (!container_0) return;
         // Scroll roughly one viewport width left — CSS scroll-snap will snap to the nearest item
        setShouldDisableRightArrowButton(false);
        container_0.scrollBy({
            left: -container_0.clientWidth,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        const container_1 = scrollContainerRef.current;
        if (!container_1) return;
         // Scroll roughly one viewport width right — CSS scroll-snap will snap to the nearest item
        setShouldDisableLeftArrowButton(false);
        container_1.scrollBy({
            left: container_1.clientWidth,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        role: isContentScrollable ? 'region' : undefined,
        "aria-roledescription": isContentScrollable ? 'carousel' : undefined,
        "aria-labelledby": isContentScrollable && heading ? headingId : undefined,
        "aria-label": isContentScrollable && !heading ? formatMessage($d6271a2b562b1c41$var$messages.carousel) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $d6271a2b562b1c41$var$styles.headerInline
    }, heading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall",
        id: headingId
    }, heading) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.050",
        xcss: $d6271a2b562b1c41$var$styles.buttonsInline
    }, isContentScrollable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        isTooltipDisabled: true,
        label: formatMessage($d6271a2b562b1c41$var$messages.scrollLeft),
        onClick: scrollLeft,
        spacing: "compact",
        isDisabled: shouldDisableLeftArrowButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        isTooltipDisabled: true,
        label: formatMessage($d6271a2b562b1c41$var$messages.scrollRight),
        onClick: scrollRight,
        spacing: "compact",
        isDisabled: shouldDisableRightArrowButton
    })) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        ref: scrollContainerRef,
        onScroll: onScroll,
        xcss: $d6271a2b562b1c41$var$styles.scrollContainerStyle,
        tabIndex: isContentScrollable ? 0 : undefined
    }, children));
};
module.exports["Carousel"] = $d6271a2b562b1c41$export$144901db2ea8e967;

});

parcelRegister("lU4RT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $acQiA = parcelRequire("acQiA");


var $9d7Pd = parcelRequire("9d7Pd");


var $3jSHR = parcelRequire("3jSHR");


var $43dcO = parcelRequire("43dcO");


var $imIsb = parcelRequire("imIsb");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $6b3a69811500fe11$var$DropdownItemCheckbox = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    let children;
    let defaultSelected;
    let description;
    let id;
    let interactionName;
    let isDisabled;
    let isSelected;
    let rest;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: t1, shouldDescriptionWrap: t2, shouldTitleWrap: t3, testId: testId, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = defaultSelected;
        $[3] = description;
        $[4] = id;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = isSelected;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = testId;
    } else {
        children = $[1];
        defaultSelected = $[2];
        description = $[3];
        id = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        isSelected = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        testId = $[12];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const shouldDescriptionWrap = t2 === undefined ? true : t2;
    const shouldTitleWrap = t3 === undefined ? true : t3;
    typeof $1P2f3;
    let t4;
    if ($[13] !== defaultSelected || $[14] !== id || $[15] !== isSelected) {
        t4 = {
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        };
        $[13] = defaultSelected;
        $[14] = id;
        $[15] = isSelected;
        $[16] = t4;
    } else t4 = $[16];
    const [selected, setSelected] = (0, $43dcO.default)(t4);
    let t5;
    if ($[17] !== providedOnClick || $[18] !== setSelected) {
        t5 = (event)=>{
            setSelected($6b3a69811500fe11$var$_temp);
            providedOnClick(event);
        };
        $[17] = providedOnClick;
        $[18] = setSelected;
        $[19] = t5;
    } else t5 = $[19];
    const onClickHandler = t5;
    const itemRef = (0, $imIsb.default)();
    let t6;
    if ($[20] !== selected) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        });
        $[20] = selected;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== children || $[23] !== description || $[24] !== id || $[25] !== interactionName || $[26] !== isDisabled || $[27] !== itemRef || $[28] !== onClickHandler || $[29] !== rest || $[30] !== selected || $[31] !== shouldDescriptionWrap || $[32] !== shouldTitleWrap || $[33] !== t6 || $[34] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: t6,
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest
        }, children));
        $[22] = children;
        $[23] = description;
        $[24] = id;
        $[25] = interactionName;
        $[26] = isDisabled;
        $[27] = itemRef;
        $[28] = onClickHandler;
        $[29] = rest;
        $[30] = selected;
        $[31] = shouldDescriptionWrap;
        $[32] = shouldTitleWrap;
        $[33] = t6;
        $[34] = testId;
        $[35] = t7;
    } else t7 = $[35];
    return t7;
} : ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $dpsRj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $1P2f3;
    const [selected, setSelected] = (0, $43dcO.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        setSelected((selected_0)=>!selected_0);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $imIsb.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        interactionName: interactionName,
        ...rest
    }, children));
};
var $6b3a69811500fe11$export$2e2bcd8739ae039 = $6b3a69811500fe11$var$DropdownItemCheckbox;
function $6b3a69811500fe11$var$_temp(selected_0) {
    return !selected_0;
}
module.exports["default"] = $6b3a69811500fe11$export$2e2bcd8739ae039;

});

parcelRegister("3jSHR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $a8ec5e894df17170$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $a8ec5e894df17170$var$CheckboxIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { checked: checked } = t0;
    const t1 = checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)";
    const t2 = checked ? "var(--ds-icon-inverse, #FFFFFF)" : "transparent";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            color: t1,
            fill: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    const t5 = checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)";
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            stroke: t5,
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            fillRule: "evenodd"
        }, t6, t7);
        $[7] = t6;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t3 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            style: t3,
            role: "presentation",
            className: t4
        }, t8);
        $[9] = t3;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
var $a8ec5e894df17170$export$2e2bcd8739ae039 = $a8ec5e894df17170$var$CheckboxIcon;
module.exports["default"] = $a8ec5e894df17170$export$2e2bcd8739ae039;

});

parcelRegister("43dcO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hR9fw = parcelRequire("hR9fw");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $e413fac5530a681e$var$useCheckboxState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isSelected: isSelected, id: id, defaultSelected: defaultSelected } = t0;
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    let t1;
    if ($[0] !== getItemState || $[1] !== groupId || $[2] !== id) {
        t1 = getItemState(groupId, id);
        $[0] = getItemState;
        $[1] = groupId;
        $[2] = id;
        $[3] = t1;
    } else t1 = $[3];
    const persistedIsSelected = t1;
    let t2;
    if ($[4] !== defaultSelected || $[5] !== persistedIsSelected) {
        t2 = ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
        $[4] = defaultSelected;
        $[5] = persistedIsSelected;
        $[6] = t2;
    } else t2 = $[6];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[7] !== groupId || $[8] !== id || $[9] !== persistedIsSelected || $[10] !== setItemState) {
        t3 = (newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        };
        $[7] = groupId;
        $[8] = id;
        $[9] = persistedIsSelected;
        $[10] = setItemState;
        $[11] = t3;
    } else t3 = $[11];
    const setLocalState = t3;
    if (typeof isSelected === "boolean") {
        let t4;
        if ($[12] !== isSelected) {
            t4 = [
                isSelected,
                $e413fac5530a681e$var$_temp
            ];
            $[12] = isSelected;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
    let t4;
    if ($[14] !== localIsSelected || $[15] !== setLocalState) {
        t4 = [
            localIsSelected,
            setLocalState
        ];
        $[14] = localIsSelected;
        $[15] = setLocalState;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $cozmU.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $e413fac5530a681e$export$2e2bcd8739ae039 = $e413fac5530a681e$var$useCheckboxState;
function $e413fac5530a681e$var$_temp() {
    return false;
}
module.exports["default"] = $e413fac5530a681e$export$2e2bcd8739ae039;

});

parcelRegister("hR9fw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c7ae6da6a8b76651$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $cozmU.createContext)('');
module.exports["CheckboxGroupContext"] = $c7ae6da6a8b76651$export$baf37c4be89255b8;

});

parcelRegister("7DqNt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");


var $hR9fw = parcelRequire("hR9fw");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== rest || $[18] !== t1 || $[19] !== t2 || $[20] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: t1,
            ...rest
        }, t2, children);
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = rest;
        $[18] = t1;
        $[19] = t2;
        $[20] = testId;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== id || $[23] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
            value: id
        }, t3);
        $[22] = id;
        $[23] = t3;
        $[24] = t4;
    } else t4 = $[24];
    return t4;
} : ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
        id: titleId,
        title: title
    }), children));
};
var $1b4057c4abe15cf7$export$2e2bcd8739ae039 = $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup;
module.exports["default"] = $1b4057c4abe15cf7$export$2e2bcd8739ae039;

});

parcelRegister("eHdk6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jPaq9 = parcelRequire("jPaq9");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $eMlr8 = parcelRequire("eMlr8");

const $4ac3a0d17fe5065f$export$668058776bea98f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const analyticsPropertiesRef = (0, $cozmU.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $cozmU.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPaq9.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref
    }, followUpText);
});
module.exports["FollowUpButton"] = $4ac3a0d17fe5065f$export$668058776bea98f5;

});

parcelRegister("j9SBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df293622502ea433$export$2e2bcd8739ae039);

var $nsx26 = parcelRequire("nsx26");


var $3yGK6 = parcelRequire("3yGK6");

function $df293622502ea433$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $nsx26.default)(dirtyDate, Date.now());
}

});

parcelRegister("dea2s", function(module, exports) {

var $1i7uI = parcelRequire("1i7uI");


var $9joJM = parcelRequire("9joJM");

var $jH9cM = parcelRequire("jH9cM");

var $i3S9F = parcelRequire("i3S9F");

var $8B1kb = parcelRequire("8B1kb");


var $dtuCc = parcelRequire("dtuCc");


var $96X1W = parcelRequire("96X1W");


var $i0ujS = parcelRequire("i0ujS");

// default configs is also config for production env
const $e6ffcbf03ed17a6e$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com'
};
const $e6ffcbf03ed17a6e$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $e6ffcbf03ed17a6e$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $e6ffcbf03ed17a6e$var$isolatedCloudConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    // Note that the env type passed to getUrlForDomainInContext (e.g. prod) doesn't matter
    // in Isolated Cloud, so this will work for staging IC too
    atlassianAccountUrl: (0, $9joJM.getUrlForDomainInContext)('id', 'prod') ?? 'id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: `https://team.${(0, $8B1kb.isolatedCloudDomain)() ?? ''}`
};
const $e6ffcbf03ed17a6e$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralDisabled: true
};
const $e6ffcbf03ed17a6e$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $e6ffcbf03ed17a6e$var$environmentOverrides = {
    'prod-east': $e6ffcbf03ed17a6e$var$productionConfig,
    local: {
        ...(0, $i0ujS.LOCAL_PRODUCTION_BACKEND) ? $e6ffcbf03ed17a6e$var$productionConfig : $e6ffcbf03ed17a6e$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: typeof (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))) !== 'undefined' ? `${(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location.hostname}:3000` : 'localhost:3000'
        }
    },
    test: {
        ...$e6ffcbf03ed17a6e$var$localAndTestConfig
    },
    adev: $e6ffcbf03ed17a6e$var$devAndStagingConfig,
    'stg-east': $e6ffcbf03ed17a6e$var$devAndStagingConfig,
    fedramp: $e6ffcbf03ed17a6e$var$fedrampConfig
};
const $e6ffcbf03ed17a6e$var$cachedConfig = {};
function $e6ffcbf03ed17a6e$export$634ecc602a6871aa() {
    return (0, $jH9cM.isFedRamp)();
}
function $e6ffcbf03ed17a6e$export$44487a86467333c3() {
    const env = $e6ffcbf03ed17a6e$export$634ecc602a6871aa() ? 'fedramp' : (0, $96X1W.getEnv)();
    const appName = (0, $dtuCc.getAppName)();
    const key = `${env}_${appName}`;
    if (!$e6ffcbf03ed17a6e$var$cachedConfig[key]) {
        if ((0, $i3S9F.isIsolatedCloud)()) $e6ffcbf03ed17a6e$var$cachedConfig[key] = $e6ffcbf03ed17a6e$var$isolatedCloudConfig;
        else if ($e6ffcbf03ed17a6e$var$EnvOverrideKeys.includes(env)) $e6ffcbf03ed17a6e$var$cachedConfig[key] = {
            ...$e6ffcbf03ed17a6e$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $e6ffcbf03ed17a6e$var$cachedConfig[key] = {
            ...$e6ffcbf03ed17a6e$var$environmentOverrides['prod-east']
        };
    }
    return $e6ffcbf03ed17a6e$var$cachedConfig[key];
}
module.exports["isFedramp"] = $e6ffcbf03ed17a6e$export$634ecc602a6871aa;
module.exports["getConfig"] = $e6ffcbf03ed17a6e$export$44487a86467333c3;

});

parcelRegister("dtuCc", function(module, exports) {
var $282f5a9d3d0318a9$export$b767e803e7ca9563 = /*#__PURE__*/ function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    return AppNames;
}({});
function $282f5a9d3d0318a9$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}
module.exports["AppNames"] = $282f5a9d3d0318a9$export$b767e803e7ca9563;
module.exports["getAppName"] = $282f5a9d3d0318a9$export$dcecb2dbc7fe753c;

});

parcelRegister("96X1W", function(module, exports) {

var $1i7uI = parcelRequire("1i7uI");


var $i0ujS = parcelRequire("i0ujS");

var $4a797a161d8e3b6b$export$e7dfafc24fab792e = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}({});
const $4a797a161d8e3b6b$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $4a797a161d8e3b6b$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $4a797a161d8e3b6b$var$presetEnv;
const $4a797a161d8e3b6b$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $4a797a161d8e3b6b$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $4a797a161d8e3b6b$var$presetEnv = envOverride;
};
function $4a797a161d8e3b6b$export$4bd44a2aa29d3d6e() {
    if ($4a797a161d8e3b6b$var$presetEnv) return $4a797a161d8e3b6b$var$presetEnv;
    if (0, $i0ujS.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).__env__;
}
function $4a797a161d8e3b6b$export$15b8d8b1ba394f55() {
    return $4a797a161d8e3b6b$export$d76bdf9f4281ae1b[$4a797a161d8e3b6b$export$4bd44a2aa29d3d6e()];
}
module.exports["setEnv"] = $4a797a161d8e3b6b$export$84bc02d3c7a6b55f;
module.exports["getEnv"] = $4a797a161d8e3b6b$export$4bd44a2aa29d3d6e;

});

parcelRegister("i0ujS", function(module, exports) {
// @ts-ignore
const $8e3d726c334133a9$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $8e3d726c334133a9$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;
module.exports["DEV"] = $8e3d726c334133a9$export$404582bc18fe4d9e;
module.exports["LOCAL_PRODUCTION_BACKEND"] = $8e3d726c334133a9$export$771a63345d182ddd;

});

parcelRegister("4bg4c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30b4a7055b26c03d$var$_react = $30b4a7055b26c03d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $30b4a7055b26c03d$var$_baseNew = $30b4a7055b26c03d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $30b4a7055b26c03d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30b4a7055b26c03d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $30b4a7055b26c03d$var$_react.default.createElement($30b4a7055b26c03d$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$30b4a7055b26c03d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $30b4a7055b26c03d$var$_default = module.exports.default = $30b4a7055b26c03d$var$ArrowUpRightIcon;

});

parcelRegister("29vMs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1np6T = parcelRequire("1np6T");


var $hBkQ2 = parcelRequire("hBkQ2");


var $aZXY4 = parcelRequire("aZXY4");

const $61be62ccfa3ec333$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $61be62ccfa3ec333$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $aZXY4.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $61be62ccfa3ec333$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $hBkQ2.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1np6T.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $61be62ccfa3ec333$export$b5d4bc85dfbaa4f8;

});

parcelRegister("6AG3B", function(module, exports) {
const $ad71aceb64f29d5c$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$6c053e1694ef181c = {
    prod: $ad71aceb64f29d5c$export$31048cb2a0753b12,
    staging: $ad71aceb64f29d5c$export$9d8f18312db80469
};
const $ad71aceb64f29d5c$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $ad71aceb64f29d5c$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $ad71aceb64f29d5c$export$54e3fc09a2a3347a;

});

parcelRegister("b5YqG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6AG3B = parcelRequire("6AG3B");


var $hnuQ8 = parcelRequire("hnuQ8");

function $a68332960b9f5309$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $cozmU.useRef)();
    const firedViewedUIEventId = (0, $cozmU.useRef)();
    const mapToCcpProductKeys = (0, $cozmU.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $cozmU.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $a68332960b9f5309$export$c2095165ae2bdcda;

});

parcelRegister("hnuQ8", function(module, exports) {
const $a675bd78c3704abb$export$c536a7e29a0739b8 = 'crossFlow';
var $a675bd78c3704abb$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $a675bd78c3704abb$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $a675bd78c3704abb$export$285f3d0989f9023f;

});

parcelRegister("hpFQM", function(module, exports) {
var $5a473958e6bef57b$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
module.exports["NLPSearchResultFormat"] = $5a473958e6bef57b$export$e20550b618a28239;

});

parcelRegister("hsCD1", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $e508769d540061ba$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $e508769d540061ba$export$5b2a28beea8d66c3 = new (0, $34VCg.UFOExperience)(`${$e508769d540061ba$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $gZFfs.ExperienceTypes).Experience,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $e508769d540061ba$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $e508769d540061ba$export$5b2a28beea8d66c3;

});

parcelRegister("aMSTz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cVV5w = parcelRequire("cVV5w");

const $37fbc78c7fbca379$export$2aadebb53f6015f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isExpanded || $[2] !== shouldFillContainer || $[3] !== style) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVV5w.SearchDialogWrapper), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            "data-test-id": "search-dialog-dialog-wrapper",
            tabIndex: -1,
            style: style
        }, children);
        $[0] = children;
        $[1] = isExpanded;
        $[2] = shouldFillContainer;
        $[3] = style;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVV5w.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children);
module.exports["SearchDialog"] = $37fbc78c7fbca379$export$2aadebb53f6015f6;

});

parcelRegister("cVV5w", function(module, exports) {
parcelRequire("cozmU");


var $6JxPX = parcelRequire("6JxPX");


var $c8XQL = parcelRequire("c8XQL");

const $bbc377120f231710$export$dcefba65c42da69c = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e101cjwc0"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $6JxPX.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $6JxPX.dialogWidth};` : '', " box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);border-radius:var(--ds-radius-large, 8px);background-color:var(--ds-surface-overlay, #FFFFFF);overflow:hidden;margin-top:", (0, $6JxPX.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $6JxPX.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
module.exports["SearchDialogWrapper"] = $bbc377120f231710$export$dcefba65c42da69c;

});

parcelRegister("6JxPX", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $c6e5a8cbbcd4e4d4$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$c6e5a8cbbcd4e4d4$var$AkGrid(multiplier * num),
        half: ()=>$c6e5a8cbbcd4e4d4$var$AkGrid(0.5 * num),
        twice: ()=>$c6e5a8cbbcd4e4d4$var$AkGrid(2 * num)
    });
const $c6e5a8cbbcd4e4d4$export$85fc379452d91af0 = $c6e5a8cbbcd4e4d4$var$AkGrid(1);
const $c6e5a8cbbcd4e4d4$export$b9930dabfa4a3a3 = '56px';
const $c6e5a8cbbcd4e4d4$export$f6af7620e8789c39 = '200px';
const $c6e5a8cbbcd4e4d4$export$64d8573e83b64ff8 = '150px';
const $c6e5a8cbbcd4e4d4$export$a3da89b899389ed8 = '780px';
const $c6e5a8cbbcd4e4d4$export$ce4512df260a325a = 780;
const $c6e5a8cbbcd4e4d4$export$a406031ed42c8e02 = '1130px';
const $c6e5a8cbbcd4e4d4$export$e00021bea368c518 = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0.multiple(4);
const $c6e5a8cbbcd4e4d4$export$30310ee354b45eb0 = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0.multiple(6);
module.exports["grid"] = $c6e5a8cbbcd4e4d4$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $c6e5a8cbbcd4e4d4$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $c6e5a8cbbcd4e4d4$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $c6e5a8cbbcd4e4d4$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $c6e5a8cbbcd4e4d4$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $c6e5a8cbbcd4e4d4$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $c6e5a8cbbcd4e4d4$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $c6e5a8cbbcd4e4d4$export$30310ee354b45eb0;

});

parcelRegister("3UfFE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb4c0b04d74b34ec32eb001d1db58986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d82c1f4c2d6e3fa$var$_react = $2d82c1f4c2d6e3fa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2d82c1f4c2d6e3fa$var$_baseNew = $2d82c1f4c2d6e3fa$var$_interopRequireDefault((parcelRequire("gElAV")));
function $2d82c1f4c2d6e3fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CollapseVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the height of an element to its smallest size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d82c1f4c2d6e3fa$var$CollapseVerticalIcon = (props)=>/*#__PURE__*/ $2d82c1f4c2d6e3fa$var$_react.default.createElement($2d82c1f4c2d6e3fa$var$_baseNew.default, Object.assign({
        name: "CollapseVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 7.25h16v1.5H0zm7.47 2.72a.75.75 0 0 1 1.06 0l3.25 3.25-1.06 1.06-1.97-1.97V16h-1.5v-3.69l-1.97 1.97-1.06-1.06zM5.28 1.72l1.97 1.97V0h1.5v3.69l1.97-1.97 1.06 1.06-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 2.78z"/>`
    }, props));
$2d82c1f4c2d6e3fa$var$CollapseVerticalIcon.displayName = 'CollapseVerticalIcon';
var $2d82c1f4c2d6e3fa$var$_default = module.exports.default = $2d82c1f4c2d6e3fa$var$CollapseVerticalIcon;

});

parcelRegister("cb86z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $333d65624cbc0115$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    /**
   * Messages for the AI Answer Component
   */ ai_answer_component_initial_title_text: {
        id: "search_ai.ai_answer_component.initial_title_text",
        defaultMessage: "Ask questions in search and get answers based on the content you have access to"
    },
    ai_answer_component_beta_status_label: {
        id: "search_ai.ai_answer_component.beta_status_label",
        defaultMessage: "Beta"
    },
    ai_answer_component_title_text: {
        id: "search_ai.ai_answer_component.title_text",
        defaultMessage: "Atlassian Intelligence"
    },
    ai_answer_component_title_text_loading: {
        id: "search_ai.ai_answer_component.title_text_loading",
        defaultMessage: "is working..."
    },
    ai_answer_component_title_text_loading_reading_aids: {
        id: "search_ai.ai_answer_component.title_text_loading_reading_aids",
        defaultMessage: "Generating"
    },
    ai_answer_component_title_text_loaded: {
        id: "search_ai.ai_answer_component.title_text_loaded",
        defaultMessage: "Answered by"
    },
    ai_answer_component_button_text: {
        id: "ai_answer_component_button_text",
        defaultMessage: "Ask AI"
    },
    ai_answer_component_result_error_text: {
        id: "search_ai.ai_answer_component.result_error_text",
        defaultMessage: "{brandName} couldn't generate an answer for you. Try rephrasing or explore using filters in {advancedSearchLink}."
    },
    ai_answer_component_result_error_advanced_search_link: {
        id: "search_ai.ai_answer_component.result_error_advanced_search_link",
        defaultMessage: "advanced search"
    },
    ai_answer_component_source_label: {
        id: "search_ai.ai_answer_component.source_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_reference_label: {
        id: "search_ai.ai_answer_component.reference_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_source_page_icon_label: {
        id: "search_ai.ai_answer_component.source_page_icon_label",
        defaultMessage: "Source Page Icon"
    },
    ai_answer_expand_button_label: {
        id: "search_ai.ai_answer_component.expand_button_label",
        defaultMessage: "Show more"
    },
    ai_answer_collapse_button_label: {
        id: "search_ai.ai_answer_component.collapse_button_label",
        defaultMessage: "Show less"
    },
    ai_answer_component_information_icon_tooltip_text: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_text",
        defaultMessage: "Information quality may vary. {informationLink}"
    },
    ai_answer_component_information_icon_tooltip_link: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_link",
        defaultMessage: "Learn why"
    },
    ai_answer_component_feedback_label: {
        id: "search_ai.ai_answer_component_feedback_label",
        defaultMessage: "Was this helpful?"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_answer_component_report_button: {
        id: "search_ai.ai_answer_component_report_button",
        defaultMessage: "Report this"
    },
    ai_answer_component_report_success_text: {
        id: "search_ai.ai_answer_component_report_success_text",
        defaultMessage: "Report submitted"
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {brandName}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the AI response? Let us know what happened."
    },
    ai_answer_component_report_empty_option_label: {
        id: "search_ai.ai_answer_component_report_empty_option_label",
        defaultMessage: "I want to report..."
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    sac_ai_answer_component_report_relevance_option_label: {
        id: "search_ai.sac_ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t accurate"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    sac_ai_answer_component_report_unhelpful_links_option_label: {
        id: "search_ai.sac_ai_answer_component_report_unhelpful_links_option_label",
        defaultMessage: "Unhelpful links"
    },
    sac_ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.sac_ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "Too slow"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    sac_ai_answer_component_report_other_option_label: {
        id: "search_ai.sac_ai_answer_component_report_other_option_label",
        defaultMessage: "Other"
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_followups_label: {
        id: "search_ai.ai_answer_component_followups_label",
        defaultMessage: "Ask a follow up question"
    },
    ai_answer_component_error_state_subjective_query: {
        id: "search_ai.ai_answer_component_error_state_subjective_query",
        defaultMessage: "That seems like a subjective question, so {brandName} can\u2019t answer it for you right now."
    },
    ai_answer_component_error_state_keyword: {
        id: "search_ai.ai_answer_component_error_state_keyword",
        defaultMessage: "{brandName} couldn\u2019t understand your question, possibly because it didn\u2019t include enough details. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_error_state_acceptable_use: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use",
        defaultMessage: "{brandName} can\u2019t provide you with a response, as it might go against {acceptableUseLink}. Please try asking another question."
    },
    ai_answer_component_error_state_acceptable_use_link: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    ai_answer_component_error_state_network: {
        id: "search_ai.ai_answer_component_error_state_network",
        defaultMessage: "{brandName} can't provide a response right now. Read more in our {supportLink}."
    },
    ai_answer_component_error_state_hipaa: {
        id: "search_ai.ai_answer_component_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    ai_answer_component_error_state_no_answer: {
        id: "search_ai.ai_answer_component_error_state_no_answer",
        defaultMessage: "{brandName} doesn\u2019t have enough data to provide a response right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_open_ai_rate_limit_error: {
        id: "search_ai.ai_answer_component_open_ai_rate_limit_error",
        defaultMessage: "Excessive use has been detected with {brandName}. Try again later. Read more in our {supportLink}."
    },
    ai_answer_component_support_link: {
        id: "search_ai.ai_answer_component_support_link",
        defaultMessage: "support documentation"
    },
    ai_answer_component_hipaa_compliance_link: {
        id: "search_ai.ai_answer_component_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    },
    ai_answer_component_error_state_no_who_is_answer: {
        id: "search_ai.ai_answer_component_error_state_no_who_is_answer",
        defaultMessage: "{brandName} couldn\u2019t find a match for this person in your organisation. It\u2019s possible that there was a misspelling in your search, this person goes by another name, or that this person doesn\u2019t work here."
    },
    ai_answer_component_disclaimer_who_question: {
        id: "search_ai.ai_answer_component_disclaimer_who_question",
        defaultMessage: "This information is solely based on what\u2019s in your knowledge base and may not always be accurate."
    },
    ai_answer_permission_label: {
        id: "search_ai.ai_answer_permission_label",
        defaultMessage: "Answers may include information from pages that are restricted to others but visible to you."
    },
    ai_answer_dialog_cancel_label: {
        id: "search_ai.ai_answer_dialog_cancel_label",
        defaultMessage: "Dive deeper into the {searchResultsLink}"
    },
    ai_answer_dialog_search_results_label: {
        id: "search_ai.ai_answer_dialog_search_results_label",
        defaultMessage: "search results"
    },
    ai_answer_dialog_teams_not_found_message: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message",
        defaultMessage: "Some teams may not be found on this site due to"
    },
    ai_answer_dialog_teams_not_found_message_link: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message_link",
        defaultMessage: "changes in team visibility."
    },
    ai_answer_onboarding_banner_title: {
        id: "search_ai.ai_answer_onboarding_banner_title",
        defaultMessage: "Try Atlassian Intelligence in search"
    },
    ai_answer_onboarding_banner_v1_info: {
        id: "search_ai.ai_answer_onboarding_banner_v1_info",
        defaultMessage: "<b>Example:</b>How do I submit expenses for reimbursement?"
    },
    ai_answer_onboarding_banner_info: {
        id: "search_ai.ai_answer_onboarding_banner_info",
        defaultMessage: "Ask about a project or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_onboarding_banner_tooltip_link: {
        id: "search_ai.ai_answer_onboarding_banner_tooltip_link",
        defaultMessage: "Learn more"
    },
    ai_answer_onboarding_close_button_text: {
        id: "search_ai.ai_answer_onboarding_close_button_text",
        defaultMessage: "Close"
    },
    ai_answer_onboarding_banner_example_query_vacation_policy: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_vacation_policy",
        defaultMessage: "What is the vacation policy?"
    },
    ai_answer_onboarding_banner_example_query_expenses: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_expenses",
        defaultMessage: "How to submit expenses for reimbursement?"
    },
    ai_answer_dialog_loaded_footer_sac: {
        id: "search_ai.ai_answer_dialog_loaded_footer_sac",
        defaultMessage: "Powered by AI"
    },
    ai_answer_dialog_loaded_footer: {
        id: "search_ai.ai_answer_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    ai_answer_dialog_footer_more_options_tooltip: {
        id: "search_ai.ai_answer_dialog_footer_more_options_tooltip",
        defaultMessage: "More options"
    },
    ai_answer_dialog_updated: {
        id: "search_ai.ai_answer_dialog_updated",
        defaultMessage: "Updated"
    },
    ai_answer_who_questions_frequent_locations_header: {
        id: "search_ai.ai_answer_who_questions_frequent_locations_header",
        defaultMessage: "Frequent locations"
    },
    ai_answer_who_questions_frequent_collaborators_header: {
        id: "search_ai.ai_answer_who_questions_frequent_collaborators_header",
        defaultMessage: "Frequent collaborators"
    },
    ai_answer_who_question_team_section_member_count: {
        id: "search_ai.ai_answer_who_question_team_section_member_count",
        defaultMessage: "{count, plural, =0 {No members} one {# member} other {# members}}"
    },
    ai_answer_who_questions_teams_header: {
        id: "search_ai.ai_answer_who_questions_teams_header",
        defaultMessage: "Teams"
    },
    ai_answer_who_questions_view_profile: {
        id: "search_ai.ai_answer_who_questions_view_profile",
        defaultMessage: "View profile"
    },
    ai_answer_who_questions_hover_role_icon: {
        id: "search_ai.ai_answer_who_questions_hover_role_icon",
        defaultMessage: "Role"
    },
    ai_answer_who_questions_hover_department_icon: {
        id: "search_ai.ai_answer_who_questions_hover_department_icon",
        defaultMessage: "Department"
    },
    ai_answer_who_questions_hover_location_icon: {
        id: "search_ai.ai_answer_who_questions_hover_location_icon",
        defaultMessage: "Location"
    },
    ai_answer_who_questions_hover_local_time_icon: {
        id: "search_ai.ai_answer_who_questions_hover_local_time_icon",
        defaultMessage: "Local time"
    },
    ai_answer_who_questions_hover_email_icon: {
        id: "search_ai.ai_answer_who_questions_hover_email_icon",
        defaultMessage: "Email"
    },
    ai_answer_who_questions_footer_header: {
        id: "search_ai.ai_answer_who_questions_footer_header",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numMatches} additional {numMatches, plural, =1 {match} other {matches}}"
    },
    ai_answer_dialog_footer_content_quality_short: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_short",
        defaultMessage: "Uses AI. Verify results."
    },
    ai_answer_dialog_footer_beta_tag: {
        id: "search_ai.ai_answer_dialog_footer_beta_tag",
        defaultMessage: "BETA"
    },
    ai_answer_dialog_footer_content_quality_long: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_long",
        defaultMessage: "Uses AI. Verify results."
    },
    reading_aids_dialog_information_icon_tooltip_link: {
        id: "search_ai.reading_aids_dialog_information_icon_tooltip_link",
        defaultMessage: "Learn more"
    },
    reading_aids_dialog_loaded_footer: {
        id: "search_ai.reading_aids_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    reading_aids_dialog_disclaimer: {
        id: "search_ai.reading_aids_dialog_disclaimer",
        defaultMessage: "Information may vary."
    },
    reading_aids_dialog_disclaimer_link: {
        id: "search_ai.reading_aids_dialog_disclaimer_link",
        defaultMessage: "Learn why"
    },
    reading_aids_defined_by: {
        id: "search_ai.reading_aids_dialog_defined_by",
        defaultMessage: "Defined by"
    },
    reading_aids_see_edit_history: {
        id: "search_ai.reading_aids_dialog_see_edit_history",
        defaultMessage: "See all edit history"
    },
    ai_answer_admin_message: {
        id: "search_ai.ai_answer_admin_message",
        defaultMessage: "Unleash the knowledge in your Confluence by asking questions in search and getting answers from Atlassian Intelligence."
    },
    ai_answer_admin_turn_on_atlassian_intelligence: {
        id: "search_ai.ai_admin_turn_on_atlassian_intelligence",
        defaultMessage: "Turn on Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_header: {
        id: "search_ai.ai_answer_admin_info_popup_header",
        defaultMessage: "Get answers from Atlassian Intelligence in search"
    },
    ai_answer_admin_info_popup_banner_alt_text: {
        id: "search_ai.ai_answer_admin_info_popup_banner_alt_text",
        defaultMessage: "Search input with example query \"What is the vacation policy?\""
    },
    ai_answer_admin_info_popup_link: {
        id: "search_ai.ai_answer_admin_info_popup_link",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_dismiss: {
        id: "search_ai.ai_answer_admin_info_popup_dismiss",
        defaultMessage: "Dismiss"
    },
    ai_answer_generating_text: {
        id: "search_ai.ai_answer_generating_text",
        defaultMessage: "Generating"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_generating_icon_alt_text: {
        id: "search_ai.ai_answer_generating_icon_alt_text",
        defaultMessage: "Generating icon"
    },
    ai_answer_button_tooltip_message: {
        id: "search_ai_answer_prompt.ask_ai_button.tooltip",
        defaultMessage: "Ask a question in search to get an answer from Atlassian Intelligence"
    },
    ai_answer_reading_aids_banner_header: {
        id: "search_ai.reading_aids.banner_header",
        defaultMessage: "Define any term with AI, not just acronyms"
    },
    ai_answer_reading_aids_banner_description: {
        id: "search_ai.reading_aids.banner_description",
        defaultMessage: "Get definitions for project terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    reading_aids_edited_definition_report_modal_title: {
        id: "search_ai.reading_aids_edited_definition_report_modal_title",
        defaultMessage: "Help us improve Definitions"
    },
    reading_aids_edited_definition_report_label: {
        id: "search_ai.reading_aids_edited_definition_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    knowledge_cards_view_team: {
        id: "search_ai.knowledge_cards.view_team",
        defaultMessage: "View team"
    },
    knowledge_cards_team_subheader: {
        id: "search_ai.knowledge_cards.team_subheader",
        defaultMessage: "Team"
    },
    knowledge_cards_copy_email_address: {
        id: "search_ai.knowledge_cards.copy_email_address",
        defaultMessage: "Copy email address"
    },
    knowledge_cards_recent_work_subheader: {
        id: "search_ai.knowledge_cards.recent_work_subheader",
        defaultMessage: "Recent work"
    },
    knowledge_cards_worked_on_subheader: {
        id: "search_ai.knowledge_cards.worked_on_subheader",
        defaultMessage: "Worked on"
    },
    knowledge_cards_collaborators_subheader: {
        id: "search_ai.knowledge_cards.collaborators_subheader",
        defaultMessage: "Collaborators"
    },
    knowledge_cards_recent_work_empty: {
        id: "search_ai.knowledge_cards.recent_work_empty",
        defaultMessage: "No recent work"
    },
    knowledge_cards_collaborators_empty: {
        id: "search_ai.knowledge_cards.collaborators_empty",
        defaultMessage: "No recent collaborators"
    },
    knowledge_cards_teammembers_empty: {
        id: "search_ai.knowledge_cards.teammembers_empty",
        defaultMessage: "No team members"
    },
    knowledge_cards_view_all_link: {
        id: "search_ai.knowledge_cards.view_all_link",
        defaultMessage: "View all"
    },
    knowledge_cards_team_members_subheader: {
        id: "search_ai.knowledge_cards.team_members_subheader",
        defaultMessage: "Team members"
    },
    knowledge_cards_view_agent: {
        id: "search_ai.knowledge_cards.view_agent",
        defaultMessage: "View agent"
    },
    knowledge_cards_agent_subheader: {
        id: "search_ai.knowledge_cards.agent_subheader",
        defaultMessage: "AI Agent"
    },
    knowledge_cards_rovo_agent_by: {
        id: "search_ai.knowledge_cards.rovo_agent_by",
        defaultMessage: "by"
    },
    knowledge_cards_teams_subheader: {
        id: "search_ai.knowledge_cards.teams_subheader",
        defaultMessage: "Teams"
    },
    knowledge_cards_team_member_count: {
        id: "search_ai.knowledge_cards.team_member_count",
        defaultMessage: "{count} members"
    },
    knowledge_cards_person_hover_profile_link: {
        id: "search_ai.knowledge_cards.person_hover_profile_link",
        defaultMessage: "View profile"
    },
    ai_answer_onboarding_banner_info_galaxia: {
        id: "search_ai.ai_answer_onboarding_banner_info-galaxia",
        defaultMessage: "Ask about a space or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_reading_aids_banner_description_galaxia: {
        id: "search_ai.reading_aids.banner_description-galaxia",
        defaultMessage: "Get definitions for space terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    knowledge_cards_person_org_chart_label: {
        id: "search_ai.knowledge_cards_person_org_chart_label",
        defaultMessage: "Reporting line"
    },
    knowledge_cards_person_org_chart_modal_header: {
        id: "search_ai.knowledge_cards_person_org_chart_modal_header",
        defaultMessage: "Reporting Line"
    },
    ai_answer_sac_feedback_option_not_relevant: {
        id: "search_ai.sac_feedback_option_not_relevant",
        defaultMessage: "Wasn't relevant"
    },
    ai_answer_sac_feedback_option_not_accurate: {
        id: "search_ai.sac_feedback_option_not_accurate",
        defaultMessage: "Wasn't accurate"
    },
    ai_answer_sac_feedback_option_too_slow: {
        id: "search_ai.sac_feedback_option_too_slow",
        defaultMessage: "Too slow"
    },
    ai_answer_sac_feedback_option_unhelpful: {
        id: "search_ai.sac_feedback_option_unhelpful",
        defaultMessage: "Unhelpful links"
    },
    ai_answer_sac_feedback_option_other: {
        id: "search_ai.sac_feedback_option_other",
        defaultMessage: "Other"
    }
});
module.exports["messages"] = $333d65624cbc0115$export$defe85febe8b728c;

});

parcelRegister("igsOG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $1LXnB = parcelRequire("1LXnB");


var $7hf4B = parcelRequire("7hf4B");

const $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT = 180;
const $67cd5bff95eb1aaf$var$unbouncedStyles = {
    name: "_11c81qyo _1reo15vq _18m915vq _k48p1wq8 _y3gn1h6o _1bto1l2s _1e0ccj1k _sudp1e54 _1yyjcs5v"
};
const $67cd5bff95eb1aaf$var$styles = {
    emptyLine: "_4t3igktf"
};
const $67cd5bff95eb1aaf$export$4c094c8f61edecb4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PersonCard(t0) {
    const $ = (0, $bDgLe.c)(27);
    const { data: t1 } = t0;
    const { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } = t1;
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
            setWidth: setWidth
        });
        $[0] = t2;
    } else t2 = $[0];
    const t3 = width < $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT ? "xlarge" : "xxlarge";
    let t4;
    if ($[1] !== avatarUrl || $[2] !== name || $[3] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            name: name,
            size: t3
        });
        $[1] = avatarUrl;
        $[2] = name;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== name) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "h2",
            xcss: $67cd5bff95eb1aaf$var$unbouncedStyles.name
        }, name);
        $[5] = name;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== jobTitle) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            maxLines: 2,
            size: "small",
            color: "color.text.subtlest",
            align: "center"
        }, jobTitle);
        $[7] = jobTitle;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== localTime || $[10] !== location) {
        t7 = [
            location,
            localTime
        ].filter(Boolean);
        $[9] = localTime;
        $[10] = location;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = t7.join(" ");
    let t9;
    if ($[12] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            maxLines: 1,
            size: "small",
            color: "color.text.subtlest",
            align: "center"
        }, t8);
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== shouldShowEmptyLine) {
        t10 = shouldShowEmptyLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $67cd5bff95eb1aaf$var$styles.emptyLine
        });
        $[14] = shouldShowEmptyLine;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t5 || $[18] !== t6 || $[19] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.050",
            alignInline: "center"
        }, t5, t6, t9, t10);
        $[16] = t10;
        $[17] = t5;
        $[18] = t6;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t11 || $[22] !== t4) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.150",
            alignInline: "center"
        }, t4, t11);
        $[21] = t11;
        $[22] = t4;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== id || $[25] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hf4B.PersonCardWrapper), {
            id: id
        }, t2, t12);
        $[24] = id;
        $[25] = t12;
        $[26] = t13;
    } else t13 = $[26];
    return t13;
} : function PersonCard({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7hf4B.PersonCardWrapper), {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
        setWidth: setWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.150",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl,
        name: name,
        size: width < $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.050",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "h2",
        xcss: $67cd5bff95eb1aaf$var$unbouncedStyles.name
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        maxLines: 2,
        size: "small",
        color: "color.text.subtlest",
        align: "center"
    }, jobTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        maxLines: 1,
        size: "small",
        color: "color.text.subtlest",
        align: "center"
    }, [
        location,
        localTime
    ].filter(Boolean).join(' ')), shouldShowEmptyLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $67cd5bff95eb1aaf$var$styles.emptyLine
    }))));
};
module.exports["PersonCard"] = $67cd5bff95eb1aaf$export$4c094c8f61edecb4;

});

parcelRegister("7hf4B", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $3a9123b42ae8c5e9$var$wrapperStyles = {
    root: "_2rko1mok _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _4t3i1osq _1ul91lit _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _kqswh2mm _9oik1r31 _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
const $3a9123b42ae8c5e9$export$a3474cd1dd8e70a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { id: id, children: children, testId: testId } = t0;
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($3a9123b42ae8c5e9$var$wrapperStyles.root);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = isHovered ? "elevation.surface.hovered" : "elevation.surface";
    let t3;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsHovered(true);
        t4 = ()=>setIsHovered(false);
        $[1] = t3;
        $[2] = t4;
    } else {
        t3 = $[1];
        t4 = $[2];
    }
    const t5 = testId || `person-card-${id}`;
    let t6;
    if ($[3] !== children || $[4] !== t2 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t1,
            backgroundColor: t2,
            onMouseEnter: t3,
            onMouseLeave: t4,
            testId: t5
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($3a9123b42ae8c5e9$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`
    }, children);
};
module.exports["PersonCardWrapper"] = $3a9123b42ae8c5e9$export$a3474cd1dd8e70a;

});

parcelRegister("jAG9k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63af381965cffd1b2653ae2b97232288>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4321317ce7fd328$var$_react = $e4321317ce7fd328$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e4321317ce7fd328$var$_baseNew = $e4321317ce7fd328$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e4321317ce7fd328$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minimize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4321317ce7fd328$var$MinimizeIcon = (props)=>/*#__PURE__*/ $e4321317ce7fd328$var$_react.default.createElement($e4321317ce7fd328$var$_baseNew.default, Object.assign({
        name: "MinimizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 14H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$e4321317ce7fd328$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $e4321317ce7fd328$var$_default = module.exports.default = $e4321317ce7fd328$var$MinimizeIcon;

});

parcelRegister("6LZT4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $gEyoZ = parcelRequire("gEyoZ");

const $a0ea225299568db3$var$PageObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageObjectTile({ label: label = 'Page', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $a0ea225299568db3$export$2e2bcd8739ae039 = $a0ea225299568db3$var$PageObjectTile;
module.exports["default"] = $a0ea225299568db3$export$2e2bcd8739ae039;

});

parcelRegister("1NXxl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f9c25083e911723e75d25e884618325>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15088ccd837b4adb$var$_react = $15088ccd837b4adb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $15088ccd837b4adb$var$_baseNew = $15088ccd837b4adb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $15088ccd837b4adb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Design task' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $15088ccd837b4adb$var$PenIcon = (props)=>/*#__PURE__*/ $15088ccd837b4adb$var$_react.default.createElement($15088ccd837b4adb$var$_baseNew.default, Object.assign({
        name: "PenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.72.72a.75.75 0 0 1 .73-.194l9.167 2.522a2 2 0 0 1 1.461 1.739l.294 3.083a2 2 0 0 1 2.042.483L15.78 9.72a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-1.366-1.366a2 2 0 0 1-.484-2.042l-3.083-.294a2 2 0 0 1-1.74-1.46L.528 1.448A.75.75 0 0 1 .72.72m12.634 8.694a.5.5 0 0 0-.707 0l-3.233 3.232a.5.5 0 0 0 0 .707l.836.836 3.94-3.94zM6.636 5.575a1.624 1.624 0 0 1 2.114 1.55 1.625 1.625 0 1 1-3.175-.49l-2.85-2.85 1.77 6.435a.5.5 0 0 0 .435.365l4.04.384 1.999-2-.384-4.04a.5.5 0 0 0-.365-.435l-6.435-1.77z" clip-rule="evenodd"/>`
    }, props));
$15088ccd837b4adb$var$PenIcon.displayName = 'PenIcon';
var $15088ccd837b4adb$var$_default = module.exports.default = $15088ccd837b4adb$var$PenIcon;

});

parcelRegister("kYmM6", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $fb284c93f8071f78$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $8lt1a = parcelRequire("8lt1a");


var $cBzEF = parcelRequire("cBzEF");


var $SW3sR = parcelRequire("SW3sR");


var $az1Tm = parcelRequire("az1Tm");


var $ljWtG = parcelRequire("ljWtG");

const $fb284c93f8071f78$var$SpotlightWithVariables = (0, $cBzEF.default)((0, $ljWtG.default));
const $fb284c93f8071f78$export$f57123e11f24bec9 = (0, $SW3sR.default)($fb284c93f8071f78$var$SpotlightWithVariables);
const $fb284c93f8071f78$var$SpotlightWithMessage = (0, $az1Tm.default)($fb284c93f8071f78$export$f57123e11f24bec9, 'spotlight');
function $fb284c93f8071f78$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb284c93f8071f78$var$SpotlightWithMessage, props));
}

});

parcelRegister("cBzEF", function(module, exports) {
$parcel$export(module.exports, "default", () => $34e44422bdcc20b3$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $3DoH3 = parcelRequire("3DoH3");

function $34e44422bdcc20b3$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $cozmU.Component) {
        render() {
            const props = $34e44422bdcc20b3$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $34e44422bdcc20b3$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3DoH3.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3DoH3.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3DoH3.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3DoH3", function(module, exports) {

var $5T3fV = parcelRequire("5T3fV");

var $6TKWB = parcelRequire("6TKWB");

function $13e227600b72e49d$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $13e227600b72e49d$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $6TKWB.runTemplateForUrl)(input, variables) : (0, $6TKWB.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $5T3fV.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $13e227600b72e49d$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $13e227600b72e49d$export$d808999430a3f186;

});

parcelRegister("5T3fV", function(module, exports) {
const $cf093fbc3dc23918$export$e26f00bd90899835 = 'success';
const $cf093fbc3dc23918$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $cf093fbc3dc23918$export$edb46161045fece7;

});

parcelRegister("6TKWB", function(module, exports) {

var $fTjYC = parcelRequire("fTjYC");


var $2EUH3 = parcelRequire("2EUH3");


var $5T3fV = parcelRequire("5T3fV");


var $9cLK6 = parcelRequire("9cLK6");

function $c2fae8ad6770c6bd$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $fTjYC.default)(template);
    return (0, $9cLK6.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $c2fae8ad6770c6bd$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $fTjYC.default)(template);
    return (0, $2EUH3.replaceForUrl)(epTemplate, variables);
}
function $c2fae8ad6770c6bd$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $fTjYC.default)(template);
    return (0, $2EUH3.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $c2fae8ad6770c6bd$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $c2fae8ad6770c6bd$export$5681b97796b74884;

});

parcelRegister("fTjYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $12ece21e986981f0$export$2e2bcd8739ae039);

var $FbqPD = parcelRequire("FbqPD");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $12ece21e986981f0$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $12ece21e986981f0$var$UNESCAPED_MATCH = 1;
const $12ece21e986981f0$var$UNESCAPED_GROUP_CONTENTS = 2;
const $12ece21e986981f0$var$ESCAPED_GROUP_CONTENTS = 5;
function $12ece21e986981f0$export$2e2bcd8739ae039(template) {
    const parts = (0, $FbqPD.regexpParts)(template, $12ece21e986981f0$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$12ece21e986981f0$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$12ece21e986981f0$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$12ece21e986981f0$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("FbqPD", function(module, exports) {
function $f585b099cd109431$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $f585b099cd109431$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $f585b099cd109431$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $f585b099cd109431$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $f585b099cd109431$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $f585b099cd109431$export$b16d411b3b6d6dff;

});

parcelRegister("2EUH3", function(module, exports) {

var $9cLK6 = parcelRequire("9cLK6");


var $ikIHo = parcelRequire("ikIHo");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $ae834a27846d8ae4$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $9cLK6.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $ae834a27846d8ae4$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $ae834a27846d8ae4$var$rawReplaceVariablesForUrl(template, variables) {
    return $ae834a27846d8ae4$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $ae834a27846d8ae4$var$rawReplaceVariablesForHtml(template, variables) {
    return $ae834a27846d8ae4$var$rawReplaceVariables(template, variables, (0, $ikIHo.default));
}
function $ae834a27846d8ae4$export$d10ae881b12b8ef2(template, variables) {
    return $ae834a27846d8ae4$var$withVariableValidation(template, variables, $ae834a27846d8ae4$var$rawReplaceVariablesForUrl);
}
function $ae834a27846d8ae4$export$ca536300dbd6350(template, variables) {
    return $ae834a27846d8ae4$var$withVariableValidation(template, variables, $ae834a27846d8ae4$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $ae834a27846d8ae4$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $ae834a27846d8ae4$export$ca536300dbd6350;

});

parcelRegister("9cLK6", function(module, exports) {

var $9rVH1 = parcelRequire("9rVH1");

function $a419bf8a95fc7381$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $a419bf8a95fc7381$export$4a33186abb06007b(template) {
    const variableParts = $a419bf8a95fc7381$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $9rVH1.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $a419bf8a95fc7381$export$4a33186abb06007b;

});

parcelRegister("9rVH1", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $4baa42b9eaed5d48$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $4baa42b9eaed5d48$export$c150c7c1a29f33d8;

});

parcelRegister("ikIHo", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea26e7ca5d3f216$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $1ea26e7ca5d3f216$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("SW3sR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee887a7f050674ba$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");

var $ee887a7f050674ba$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $cozmU.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $lzgC6.default)()(EngagementEventsWrapper);
};

});

parcelRegister("az1Tm", function(module, exports) {
$parcel$export(module.exports, "default", () => $47a0a8b1c9621cae$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");

var $47a0a8b1c9621cae$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $cozmU.useState)(null);
        const unsubscribeRef = (0, $cozmU.useRef)(null);
        const removeConfigRef = (0, $cozmU.useRef)(null);
        const canSubscribe = (0, $cozmU.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $cozmU.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $cozmU.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $cozmU.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $cozmU.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $cozmU.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $cozmU.useRef)(engagementId);
        const previousMessageType = (0, $cozmU.useRef)(messageType);
        const previousOnMessageDisposition = (0, $cozmU.useRef)(onMessageDisposition);
        (0, $cozmU.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("ljWtG", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $jEK83 = parcelRequire("jEK83");


var $cJ0FD = parcelRequire("cJ0FD");


var $bYkMC = parcelRequire("bYkMC");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $3eYzF = parcelRequire("3eYzF");


var $uyMbP = parcelRequire("uyMbP");


var $gi4qj = parcelRequire("gi4qj");


var $4AC39 = parcelRequire("4AC39");


var $l3ydK = parcelRequire("l3ydK");


var $2Vz7H = parcelRequire("2Vz7H");


var $6VFk2 = parcelRequire("6VFk2");


var $4enp7 = parcelRequire("4enp7");


var $6OwHS = parcelRequire("6OwHS");


var $dOlTT = parcelRequire("dOlTT");


var $2K2hA = parcelRequire("2K2hA");


var $jSxX3 = parcelRequire("jSxX3");


var $6Yblc = parcelRequire("6Yblc");


var $6WiUl = parcelRequire("6WiUl");


var $7W1a8 = parcelRequire("7W1a8");


var $aeF84 = parcelRequire("aeF84");


var $kTn88 = parcelRequire("kTn88");

function $15c742fa8be3ab00$var$_defineProperty(e, r, t) {
    return (r = $15c742fa8be3ab00$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $15c742fa8be3ab00$var$_toPropertyKey(t) {
    var i = $15c742fa8be3ab00$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $15c742fa8be3ab00$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $15c742fa8be3ab00$var$styles = {
    image: "_1bsb1osq"
};
const $15c742fa8be3ab00$export$f14689466e4eca7a = ({ isMigrated: isMigrated = false, ...rest })=>{
    if (isMigrated && (0, $iDrrr.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($15c742fa8be3ab00$var$MigratedAkSpotlight, rest);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($15c742fa8be3ab00$var$DeprecatedAkSpotlight, rest);
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $15c742fa8be3ab00$var$DeprecatedAkSpotlight extends (0, $cozmU.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7W1a8.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYkMC.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kTn88.default), {
            html: body
        }));
    }
}
$15c742fa8be3ab00$var$_defineProperty($15c742fa8be3ab00$var$DeprecatedAkSpotlight, "defaultProps", {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
});
const $15c742fa8be3ab00$var$MigratedAkSpotlight = (props)=>{
    const placement = (0, $aeF84.translations).dialogPlacement(props.dialogPlacement);
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(true);
    const dismiss = (0, $cozmU.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), props.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: props.image,
        alt: "",
        className: (0, $hekY6.default)([
            $15c742fa8be3ab00$var$styles.image
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, props.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, props.secondaryAction && (props.secondaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6WiUl.SpotlightSecondaryLink), {
        onClick: dismiss,
        ...props.secondaryAction.data,
        href: props.secondaryAction.data?.url || '',
        target: props.secondaryAction.data?.target
    }, props.secondaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), {
        onClick: dismiss,
        ...props.secondaryAction.data
    }, props.secondaryText)), props.primaryAction && (props.primaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jSxX3.SpotlightPrimaryLink), {
        onClick: dismiss,
        ...props.primaryAction.data,
        href: props.primaryAction.data?.url || '',
        target: props.primaryAction.data?.target
    }, props.primaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: dismiss,
        ...props.primaryAction.data
    }, props.primaryText))))));
};
var $15c742fa8be3ab00$export$2e2bcd8739ae039 = $15c742fa8be3ab00$export$f14689466e4eca7a;
module.exports["default"] = $15c742fa8be3ab00$export$2e2bcd8739ae039;

});

parcelRegister("jSxX3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");

var $4aRua = parcelRequire("4aRua");

const $8cb020cd2de9ca14$var$styles = {
    root: "_2rko12b0 _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr",
    outline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6d8yml _18zr12x7 _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27",
    primary: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6da755 _18zr12x7 _bfhk1856 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3hf2y _1nrm1r31 _c2waglyw _1iohnqa1 _1di6g6ey"
};
const $8cb020cd2de9ca14$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(16);
    const { "aria-label": ariaLabel, onClick: onClick, children: children, testId: testId, appearance: t1, href: href, target: target, rel: rel } = t0;
    const appearance = t1 === undefined ? "outline" : t1;
    const t2 = $8cb020cd2de9ca14$var$styles[appearance];
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($8cb020cd2de9ca14$var$styles.root, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== onClick) {
        t4 = onClick ? (e, _analyticsEvent)=>onClick(e) : undefined;
        $[2] = onClick;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== children) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            as: "span"
        }, children);
        $[4] = children;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== ariaLabel || $[7] !== href || $[8] !== ref || $[9] !== rel || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== target || $[14] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            "aria-label": ariaLabel,
            ref: ref,
            testId: testId,
            xcss: t3,
            href: href,
            target: target,
            rel: rel,
            onClick: t4,
            componentName: "SpotlightPrimaryLink"
        }, t5);
        $[6] = ariaLabel;
        $[7] = href;
        $[8] = ref;
        $[9] = rel;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = target;
        $[14] = testId;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, appearance: appearance = 'outline', href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $w6R6I.cx)($8cb020cd2de9ca14$var$styles.root, $8cb020cd2de9ca14$var$styles[appearance]),
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "span"
    }, children)));
module.exports["SpotlightPrimaryLink"] = $8cb020cd2de9ca14$export$82ba9bc832fb64;

});

parcelRegister("6WiUl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vK9E = parcelRequire("7vK9E");

var $4aRua = parcelRequire("4aRua");

const $3dd4b7177da38ec2$var$styles = {
    root: "_2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zr12x7 _1rjcv77o _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27"
};
const $3dd4b7177da38ec2$export$797d360648cfd970 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(13);
    const { "aria-label": ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel } = t0;
    let t1;
    if ($[0] !== onClick) {
        t1 = onClick ? (e, _analyticsEvent)=>onClick(e) : undefined;
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            as: "span"
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ariaLabel || $[5] !== href || $[6] !== ref || $[7] !== rel || $[8] !== t1 || $[9] !== t2 || $[10] !== target || $[11] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            "aria-label": ariaLabel,
            ref: ref,
            testId: testId,
            xcss: $3dd4b7177da38ec2$var$styles.root,
            href: href,
            target: target,
            rel: rel,
            onClick: t1,
            componentName: "SpotlightSecondaryLink"
        }, t2);
        $[4] = ariaLabel;
        $[5] = href;
        $[6] = ref;
        $[7] = rel;
        $[8] = t1;
        $[9] = t2;
        $[10] = target;
        $[11] = testId;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $3dd4b7177da38ec2$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "span"
    }, children)));
module.exports["SpotlightSecondaryLink"] = $3dd4b7177da38ec2$export$797d360648cfd970;

});

parcelRegister("7W1a8", function(module, exports) {
const $57ff06a66745a54c$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $57ff06a66745a54c$export$e7d79186651244da;

});

parcelRegister("aeF84", function(module, exports) {
const $a5b3f49738f3da96$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
   * All of the following are actually invalid in CSS selectors.
   * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
   * If it turns out other characters are used, add them as needed.
   *
   * (space) — descendant combinator
   * > — child combinator
   * + — adjacent sibling combinator
   * ~ — general sibling combinator
   * . — class selector
   * # — ID selector
   * : — pseudo-class/element
   * [ ] — attribute selectors
   * ( ) — functional notation
   * , — selector list separator
   * * — universal selector
   * | — namespace separator
   * " ' — string delimiters
   * \ — escape character
   * Characters not allowed in unescaped identifiers:
   * Digits 0-9 cannot be the first character
   * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
   */ return value.replaceAll(' ', '-').replaceAll('/', '-');
};
const $a5b3f49738f3da96$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $a5b3f49738f3da96$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $a5b3f49738f3da96$var$placementMap[value || 'bottom left'];
};
const $a5b3f49738f3da96$export$150b732325d14d04 = {
    target: $a5b3f49738f3da96$export$44271b4f0c6a3563,
    dialogPlacement: $a5b3f49738f3da96$export$608d2c28a2f3926e
};
module.exports["translations"] = $a5b3f49738f3da96$export$150b732325d14d04;

});

parcelRegister("kTn88", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $29867601681dbf75$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $29867601681dbf75$export$2e2bcd8739ae039;

});

parcelRegister("38ARq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $9Zall = parcelRequire("9Zall");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $842f74bab4b85da2$export$e040768d915476be = ({ children: children })=>{
    if ((0, $iDrrr.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
$842f74bab4b85da2$export$e040768d915476be.displayName = 'SpotlightManager';
module.exports["SpotlightManager"] = $842f74bab4b85da2$export$e040768d915476be;

});

parcelRegister("bw8s0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8Iwqw = parcelRequire("8Iwqw");


var $iDrrr = parcelRequire("iDrrr");


var $8jXZv = parcelRequire("8jXZv");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $87e9c8afa59bcb5f$export$e29577842f211e22 = ({ children: children, name: name })=>{
    if ((0, $iDrrr.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: name
    }, children);
};
$87e9c8afa59bcb5f$export$e29577842f211e22.displayName = 'SpotlightTarget';
module.exports["SpotlightTarget"] = $87e9c8afa59bcb5f$export$e29577842f211e22;

});

parcelRegister("iD4ky", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bCECL = parcelRequire("bCECL");


var $1ggpj = parcelRequire("1ggpj");


var $aF4oY = parcelRequire("aF4oY");


var $jghB4 = parcelRequire("jghB4");

const $1bdc45b11c697012$export$c28a8c055ae64bad = (date, isStartOfDay)=>{
    const currentDate = new Date(date);
    return isStartOfDay ? new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()).toISOString().split('Z')[0] : new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), 23, 59, 59, 999).toISOString().split('Z')[0];
};
// generates truncated iso strings for last modified filter defaults (today, yesterday, etc)
// considering the user's locale-based definition of start OR end of day
const $1bdc45b11c697012$var$getUTCDateRange = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        from: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        to: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
const $1bdc45b11c697012$export$416386056bdfd75 = (filters, activationId)=>{
    const confluenceFilters = {};
    const selectedSpaces = filters[(0, $jghB4.FilterIds).SPACES].filter((spaceOption)=>spaceOption.value !== 'default' && spaceOption.isSelected);
    if (selectedSpaces.length > 0) confluenceFilters.spacesFilter = selectedSpaces.map((spaceOption)=>spaceOption.value);
    const selectedContributors = filters[(0, $jghB4.FilterIds).CONTRIBUTORS].filter((contributorOption)=>contributorOption.value !== 'default' && contributorOption.isSelected);
    if (selectedContributors.length > 0) confluenceFilters.contributorsFilter = selectedContributors.map((contributorOption)=>contributorOption.value);
    const selectedLabels = filters[(0, $jghB4.FilterIds).LABELS].filter((labelOption)=>labelOption.isSelected);
    if (selectedLabels.length > 0) confluenceFilters.labelsFilter = selectedLabels.map((labelOption)=>labelOption.value);
    const selectedMoreFilterOptions = filters[(0, $jghB4.FilterIds).MORE].filter((moreFilterOption)=>moreFilterOption.isSelected);
    if (selectedMoreFilterOptions.length > 0) {
        const selectedValues = selectedMoreFilterOptions.map((moreFilterOption)=>moreFilterOption.value);
        if (selectedValues.includes((0, $jghB4.OptionIds).ARCHIVED)) {
            // Casting SearchConfluenceDocumentStatus & SearchContainerStatus as enum[] cannot match string[]
            confluenceFilters.contentStatuses = (0, $jghB4.INCLUDEARCHIVEDSTATUS);
            confluenceFilters.containerStatus = (0, $jghB4.INCLUDEARCHIVEDSTATUS);
        }
        if (selectedValues.includes((0, $jghB4.OptionIds).TITLE)) confluenceFilters.titleMatchOnly = true;
    }
    const selectedAncestorFilterOptions = filters[(0, $jghB4.FilterIds).ANCESTOR].filter((moreFilterOption)=>moreFilterOption.isSelected);
    if (selectedAncestorFilterOptions.length > 0 && selectedAncestorFilterOptions[0].value) confluenceFilters.ancestorIdsFilter = selectedAncestorFilterOptions.map(({ type: type, value: value })=>{
        if (type && (0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(type)) return `activation/${activationId}/${value}`;
        return value;
    });
    const selectedDateFilters = filters[(0, $jghB4.FilterIds).DATE].lastModified.filter((dateOption)=>dateOption.value !== 'default' && dateOption.isSelected);
    if (selectedDateFilters.length > 0) {
        // only one date filter can be applied at a time
        const selectedDateFilter = selectedDateFilters[0];
        const selectedDateFilterType = selectedDateFilter.value;
        let from;
        let to;
        if (selectedDateFilterType !== 'custom') {
            const transformedDateRange = $1bdc45b11c697012$export$36818d8e5e22a67e(selectedDateFilterType);
            const dateRange = $1bdc45b11c697012$export$c36e5c6cc6379ee7[transformedDateRange]?.dateRange;
            from = dateRange?.from || '';
            to = dateRange?.to || '';
        } else {
            from = filters[(0, $jghB4.FilterIds).DATE].from.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].from.value, true) : null;
            to = filters[(0, $jghB4.FilterIds).DATE].to.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].to.value, false) : null;
        }
        if (!(selectedDateFilterType === 'custom' && !from && !to)) {
            const lastModifiedRange = {
                field: (0, $aF4oY.SearchConfluenceRangeField).LASTMODIFIED,
                gt: from,
                lt: to
            };
            confluenceFilters.range = [
                lastModifiedRange
            ];
        }
    }
    const isVerified = filters[(0, $jghB4.FilterIds).VERIFIED].some((option)=>option.value === (0, $jghB4.FilterIds).VERIFIED && option.isSelected);
    if (isVerified) confluenceFilters.isVerified = isVerified;
    return confluenceFilters;
};
const $1bdc45b11c697012$export$c36e5c6cc6379ee7 = {
    [(0, $jghB4.LastModifiedValues).ANY_TIME]: {},
    [(0, $jghB4.LastModifiedValues).TODAY]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(0, 0)
    },
    [(0, $jghB4.LastModifiedValues).YESTERDAY]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(1, 1)
    },
    [(0, $jghB4.LastModifiedValues).PAST_SEVEN_DAYS]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(7, 0)
    },
    [(0, $jghB4.LastModifiedValues).PAST_THIRTY_DAYS]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(30, 0)
    },
    [(0, $jghB4.LastModifiedValues).PAST_YEAR]: {
        dateRange: $1bdc45b11c697012$var$getUTCDateRange(365, 0)
    },
    [(0, $jghB4.LastModifiedValues).CUSTOM]: {}
};
const $1bdc45b11c697012$export$36818d8e5e22a67e = (lastModifiedValue)=>{
    //translates previously-used values ("lastDay", "lastWeek", "lastMonth", "lastYear")
    switch(lastModifiedValue){
        case (0, $jghB4.LastModifiedValues).LAST_DAY:
            return (0, $jghB4.LastModifiedValues).TODAY;
        case (0, $jghB4.LastModifiedValues).LAST_WEEK:
            return (0, $jghB4.LastModifiedValues).PAST_SEVEN_DAYS;
        case (0, $jghB4.LastModifiedValues).LAST_MONTH:
            return (0, $jghB4.LastModifiedValues).PAST_THIRTY_DAYS;
        case (0, $jghB4.LastModifiedValues).LAST_YEAR:
            return (0, $jghB4.LastModifiedValues).PAST_YEAR;
        default:
            return lastModifiedValue;
    }
};
const $1bdc45b11c697012$export$71d48e62a870acb2 = (queryParams, filters)=>({
        contributors: queryParams?.contributors ? queryParams.contributors.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : [],
        spaces: queryParams?.spaces ? queryParams.spaces.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : [],
        contributorsToHydrate: (queryParams?.contributors ? queryParams.contributors.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : []).filter((key)=>!filters[(0, $jghB4.FilterIds).CONTRIBUTORS].some((option)=>option.value === key) || filters[(0, $jghB4.FilterIds).CONTRIBUTORS].some((option)=>option.value === key && option.avatarUrl === undefined)),
        spacesToHydrate: (queryParams?.spaces ? queryParams.spaces.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : []).filter((key)=>!filters[(0, $jghB4.FilterIds).SPACES].some((option)=>option.value === key) || filters[(0, $jghB4.FilterIds).SPACES].some((option)=>option.value === key && option.avatarUrl === undefined)),
        ancestorId: queryParams?.ancestor || '',
        selectedType: queryParams?.type,
        lastModified: queryParams?.lastModified ? $1bdc45b11c697012$export$36818d8e5e22a67e(queryParams.lastModified) : undefined
    });
// This function generates the initial option array for a given filterId
// using the default options (with appropriate isSelected value)
// & any non-default option selections transformed into FilterOption objects
const $1bdc45b11c697012$var$transformQueryParams = (defaultOptions, params)=>{
    const queryParams = [
        ...params
    ];
    const selectedDefaults = defaultOptions.map((option)=>({
            ...option,
            isSelected: queryParams.includes(option.value)
        }));
    const optionsFromParams = queryParams.filter((param)=>param && !selectedDefaults.some(({ value: value })=>value === param)).map((paramValue)=>({
            isSelected: true,
            value: paramValue,
            label: paramValue
        }));
    return [
        ...selectedDefaults,
        ...optionsFromParams
    ];
};
const $1bdc45b11c697012$export$3e02c678c13755e4 = (queryParams)=>{
    const { lastModified: lastModified = '', from: from = '', to: to = '', spaces: spaces = '', contributors: contributors = '', labels: labels = '', type: type = '', verified: verified = '', title: title, archived: archived, ancestor: ancestor } = queryParams;
    return {
        [(0, $jghB4.FilterIds).DATE]: {
            [(0, $jghB4.OptionIds).LAST_MODIFIED]: $1bdc45b11c697012$var$transformQueryParams((0, $jghB4.lastModifiedFilterOptions), [
                $1bdc45b11c697012$export$36818d8e5e22a67e(lastModified.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))[0])
            ]),
            [(0, $jghB4.OptionIds).TO]: {
                ...(0, $jghB4.toFilterOption),
                value: to || '',
                isSelected: !!to
            },
            [(0, $jghB4.OptionIds).FROM]: {
                ...(0, $jghB4.fromFilterOption),
                value: from || '',
                isSelected: !!from
            }
        },
        [(0, $jghB4.FilterIds).SPACES]: $1bdc45b11c697012$var$transformQueryParams([], spaces.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).CONTRIBUTORS]: $1bdc45b11c697012$var$transformQueryParams([], contributors.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).LABELS]: $1bdc45b11c697012$var$transformQueryParams([], labels.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).TYPE]: $1bdc45b11c697012$var$transformQueryParams([], type.split((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR))),
        [(0, $jghB4.FilterIds).ANCESTOR]: ancestor ? [
            {
                label: '',
                value: ancestor || '',
                isSelected: !!ancestor
            }
        ] : [],
        [(0, $jghB4.FilterIds).VERIFIED]: [
            {
                ...(0, $jghB4.verifiedOption),
                isSelected: !!verified
            }
        ],
        [(0, $jghB4.FilterIds).MORE]: [
            {
                ...(0, $jghB4.titleFilterOption),
                isSelected: !!title
            },
            {
                ...(0, $jghB4.archivedFilterOption),
                isSelected: !!archived
            }
        ]
    };
};
const $1bdc45b11c697012$export$be6bb39088374ba = (filters)=>{
    const updatedQueryParams = {};
    Object.entries(filters).forEach(([filterId, filterValues])=>{
        if (filterId === (0, $jghB4.FilterIds).MORE) {
            const selectedValues = filterValues.filter((filter)=>filter && filter.isSelected && filter.value).map((filter)=>filter.value.toString());
            updatedQueryParams[(0, $jghB4.OptionIds).ARCHIVED] = selectedValues.includes((0, $jghB4.OptionIds).ARCHIVED) || undefined;
            updatedQueryParams[(0, $jghB4.OptionIds).TITLE] = selectedValues.includes((0, $jghB4.OptionIds).TITLE) || undefined;
        } else if (filterId === (0, $jghB4.FilterIds).DATE) Object.keys(filterValues).forEach((param)=>{
            if (param === (0, $jghB4.OptionIds).LAST_MODIFIED) {
                const selectedOption = filterValues[param].find((filter)=>filter.isSelected);
                updatedQueryParams[param] = selectedOption ? selectedOption.value.toString() : undefined;
            } else if (param === (0, $jghB4.OptionIds).TO || param === (0, $jghB4.OptionIds).FROM) {
                const isCustom = updatedQueryParams[(0, $jghB4.OptionIds).LAST_MODIFIED] === (0, $jghB4.LastModifiedValues).CUSTOM;
                updatedQueryParams[param] = !!filterValues[param]?.isSelected && isCustom ? filterValues[param].value.toString() : undefined;
            }
        });
        else if (filterId === (0, $jghB4.FilterIds).VERIFIED) {
            const selectedValues = filterValues.filter((filter)=>filter && filter.isSelected && filter.value).map((filter)=>filter.value.toString());
            updatedQueryParams[(0, $jghB4.OptionIds).VERIFIED] = selectedValues.includes('verified') || undefined;
        } else {
            const selectedValues = filterValues.filter((filter)=>filter && filter.isSelected && filter.value).map((filter)=>filter.value.toString());
            updatedQueryParams[filterId] = selectedValues.length ? selectedValues.join((0, $jghB4.QUERY_PARAM_ARRAY_SEPARATOR)) : undefined;
        }
    });
    return {
        ...updatedQueryParams
    };
};
const $1bdc45b11c697012$export$dd5cf00ceb58ef45 = (filterId, filters)=>{
    const options = filters[filterId];
    if (!options) return [];
    if (filterId === (0, $jghB4.FilterIds).DATE) {
        const dateFilterSelections = [];
        if (!!filters[filterId][(0, $jghB4.OptionIds).LAST_MODIFIED].some((option)=>option.isSelected)) dateFilterSelections.push({
            ...filters[filterId][(0, $jghB4.OptionIds).LAST_MODIFIED].find((option)=>option.isSelected)
        });
        if (!!filters[filterId][(0, $jghB4.OptionIds).FROM].isSelected) dateFilterSelections.push(filters[filterId][(0, $jghB4.OptionIds).FROM]);
        if (!!filters[filterId][(0, $jghB4.OptionIds).TO].isSelected) dateFilterSelections.push(filters[filterId][(0, $jghB4.OptionIds).TO]);
        return dateFilterSelections;
    }
    if (!Array.isArray(options)) return !!options?.isSelected ? [
        options
    ] : [];
    return options.filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue)).map((option)=>({
            ...option,
            filterId: filterId
        })) || [];
};
const $1bdc45b11c697012$export$72a062c4cf43576 = (filters)=>{
    const allSelectedOptions = [];
    Object.keys(filters).forEach((filterId)=>{
        const optionSelections = $1bdc45b11c697012$export$dd5cf00ceb58ef45(filterId, filters).map((option)=>({
                value: option.value,
                isSmartDefault: !!option.isSmartDefault,
                filterId: filterId
            }));
        allSelectedOptions.push(optionSelections);
    });
    return allSelectedOptions.flat();
};
const $1bdc45b11c697012$export$5e1edcb3c154ab79 = (filterSelections)=>{
    const transformedFilters = filterSelections.map((option)=>option.filterId === (0, $jghB4.FilterIds).TYPE ? `type.${option.value}` : option.filterId);
    return Array.from(new Set(transformedFilters));
};
const $1bdc45b11c697012$export$7e427c967bc760a = (filters, skipMoreFilters)=>{
    return Object.keys(filters).some((filterId)=>{
        switch(filterId){
            case (0, $jghB4.FilterIds).DATE:
                return filters[filterId][(0, $jghB4.OptionIds).LAST_MODIFIED].some((lastModifiedOption)=>lastModifiedOption.isSelected) || filters[filterId][(0, $jghB4.OptionIds).TO].isSelected || filters[filterId][(0, $jghB4.OptionIds).FROM].isSelected;
            case (0, $jghB4.FilterIds).MORE:
                //we don't count "more" filter option selections as user input when using this function
                //for agg query skip - these selections require additional input to have an effect
                return skipMoreFilters ? false : filters[filterId].some((filterOption)=>!!filterOption?.isSelected);
            default:
                return filters[filterId].some((filterOption)=>!!filterOption?.isSelected);
        }
    });
};
const $1bdc45b11c697012$var$transformAncestorSelection = (option)=>{
    return {
        value: option.value,
        label: option.label,
        isSelected: option.isSelected,
        type: option.type,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
            type: option.type || 'page'
        })
    };
};
const $1bdc45b11c697012$export$99a866ffa3af7d8b = ({ data: data, spaces: spaces, contributors: contributors, contributorsToHydrate: contributorsToHydrate, spacesToHydrate: spacesToHydrate, selectedType: selectedType, defaultTypesFilterOptions: defaultTypesFilterOptions, isWhiteboardsEnabledAS: isWhiteboardsEnabledAS, isDatabasesEnabledAS: isDatabasesEnabledAS, isSlidesEnabledAS: isSlidesEnabledAS, userId: userId })=>{
    const recommendations = data?.getSmartFeatures?.results?.[0]?.result?.[0]?.features;
    const hydratedUsers = (data?.confluenceUsers?.nodes || []).map((user)=>({
            value: user.accountId || '',
            label: user?.displayName || '',
            avatarUrl: user?.profilePicture?.path || '',
            isSelected: true
        }));
    const userRecommendations = (recommendations?.recommendedPeople || []).map((user)=>({
            value: user?.user?.id || '',
            label: user?.user?.displayName || '',
            avatarUrl: user?.user?.photos?.[0]?.value || '',
            isSelected: contributors.includes(user?.user?.id || ''),
            isSmartDefault: true
        })).filter((option)=>!contributorsToHydrate.includes(option.value) || option.value === userId);
    const hydratedSpaces = (data?.spaces?.nodes || []).map((space)=>({
            value: space?.key || '',
            label: space?.name || '',
            avatarUrl: space?.icon?.path || '',
            isSelected: true
        }));
    const spaceRecommendations = (recommendations?.recommendedSpaces || []).map((space)=>({
            value: space?.space?.key || '',
            label: space?.space?.name || '',
            avatarUrl: space?.space?.icon?.path || '',
            isSelected: spaces.includes(space?.space?.key || ''),
            isSmartDefault: true
        })).filter((option)=>!spacesToHydrate.includes(option.value));
    const hydratedTypes = (data?.contentTypes?.cqlContentTypes.filter((contentType)=>defaultTypesFilterOptions.find((defaultType)=>{
            const { type: type } = contentType;
            if (type?.toLowerCase() === 'whiteboard' && !isWhiteboardsEnabledAS) // When FF is off return true to ensure that we do not include whiteboard content type in hydrated list
            return true;
            if (type?.toLowerCase() === 'database' && !isDatabasesEnabledAS) // When FF is off return true to ensure that we do not include database content type in hydrated list
            return true;
            if (type?.toLowerCase() === 'slide' && !isSlidesEnabledAS) // When FF is off return true to ensure that we do not include slide content type in hydrated list
            return true;
            if (type?.toLowerCase() === 'folder') // When FF is off return true to ensure that we do not include folder content type in hydrated list
            return true;
            return defaultType.value === type;
        }) === undefined) || []).map((type)=>({
            value: type?.type || '',
            label: type?.label || '',
            isSelected: type?.type === selectedType
        }));
    const hydratedAncestor = data?.ancestorData?.id ? {
        value: data?.ancestorData?.id || '',
        label: data?.ancestorData?.title || '',
        type: data?.ancestorData?.type || '',
        isSelected: true
    } : undefined;
    const ancestorRecommendations = data?.activity?.myActivity?.all?.edges ? data.activity.myActivity.all.edges.filter((edge)=>edge?.node?.object?.data).map((edge)=>{
        const nodeData = edge?.node?.object?.data;
        const normalizedType = nodeData?.type?.toLowerCase() === 'blog_post' ? 'blogpost' : nodeData?.type || '';
        return {
            value: nodeData?.id || '',
            label: nodeData?.title || '',
            isSelected: false,
            type: normalizedType
        };
    }) : [];
    const ancestorOptions = [
        ...hydratedAncestor ? [
            hydratedAncestor
        ] : [],
        ...ancestorRecommendations
    ].filter((ancestorOption)=>ancestorOption?.value && ancestorOption.value !== '').map((ancestor)=>$1bdc45b11c697012$var$transformAncestorSelection(ancestor));
    const currentUserOption = data?.currentUser?.confluence?.accountId && !contributors.includes(data.currentUser.confluence.accountId) ? {
        value: data.currentUser.confluence.accountId,
        label: data?.currentUser?.displayName || '',
        avatarUrl: data?.currentUser?.photos.find(({ isPrimary: isPrimary })=>isPrimary)?.value || '',
        isSelected: false,
        isSmartDefault: true
    } : undefined;
    return {
        ancestorOptions: ancestorOptions,
        hydratedTypes: hydratedTypes,
        spaceOptions: hydratedSpaces.length < 5 ? [
            ...hydratedSpaces,
            ...spaceRecommendations.slice(0, 5 - hydratedSpaces.length)
        ] : [
            ...hydratedSpaces
        ],
        contributorOptions: hydratedUsers.length < 5 ? [
            ...hydratedUsers,
            ...currentUserOption ? [
                currentUserOption
            ] : [],
            ...userRecommendations.slice(0, 5 - hydratedUsers.length)
        ] : [
            ...hydratedUsers,
            ...currentUserOption ? [
                currentUserOption
            ] : []
        ]
    };
};
const $1bdc45b11c697012$export$2e52d13370d3e128 = (filters, keysFromQueryParams)=>{
    const quickSearchFilters = [
        ...filters[(0, $jghB4.FilterIds).SPACES].filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue)),
        ...filters[(0, $jghB4.FilterIds).CONTRIBUTORS].filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue)),
        ...filters[(0, $jghB4.FilterIds).DATE][(0, $jghB4.OptionIds).LAST_MODIFIED].filter((option)=>option.isSelected && option.value !== (0, $jghB4.defaultOptionValue))
    ].map(({ value: value })=>value);
    return [
        ...quickSearchFilters,
        ...keysFromQueryParams
    ].length === 0 || keysFromQueryParams.every((key)=>quickSearchFilters.includes(key)) && quickSearchFilters.some((selectedValue)=>keysFromQueryParams.includes(selectedValue));
};
const $1bdc45b11c697012$export$1625b883b0fea34d = (filters)=>{
    if (!filters) return [];
    const selectedFilters = [];
    if (filters[(0, $jghB4.FilterIds).SPACES]) {
        const spaceKeys = filters[(0, $jghB4.FilterIds).SPACES].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (spaceKeys.length > 0) selectedFilters.push({
            '@type': 'spaces',
            spaceKeys: spaceKeys
        });
    }
    if (filters[(0, $jghB4.FilterIds).CONTRIBUTORS]) {
        const accountIds = filters[(0, $jghB4.FilterIds).CONTRIBUTORS].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (accountIds.length > 0) selectedFilters.push({
            '@type': 'contributors',
            accountIds: accountIds
        });
    }
    const selectedDateFilters = filters[(0, $jghB4.FilterIds).DATE].lastModified.filter((dateOption)=>dateOption.value !== 'default' && dateOption.isSelected);
    if (selectedDateFilters.length > 0) {
        const selectedDateFilter = selectedDateFilters[0];
        const selectedDateFilterType = selectedDateFilter.value;
        let from;
        let to;
        if (selectedDateFilterType !== 'custom') {
            const transformedDateRange = $1bdc45b11c697012$export$36818d8e5e22a67e(selectedDateFilterType);
            const dateRange = $1bdc45b11c697012$export$c36e5c6cc6379ee7[transformedDateRange]?.dateRange;
            from = dateRange?.from || '';
            to = dateRange?.to || '';
        } else {
            from = filters[(0, $jghB4.FilterIds).DATE].from.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].from.value, true) : null;
            to = filters[(0, $jghB4.FilterIds).DATE].to.value ? $1bdc45b11c697012$export$c28a8c055ae64bad(filters[(0, $jghB4.FilterIds).DATE].to.value, false) : null;
        }
        if (!(selectedDateFilterType === 'custom' && !from && !to)) selectedFilters.push({
            '@type': 'lastModified',
            from: from,
            to: to
        });
    }
    if (filters[(0, $jghB4.FilterIds).LABELS]) {
        const labels = filters[(0, $jghB4.FilterIds).LABELS].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (labels.length > 0) selectedFilters.push({
            '@type': 'labels',
            labels: labels
        });
    }
    if (filters[(0, $jghB4.FilterIds).MORE]) filters[(0, $jghB4.FilterIds).MORE].filter((moreFilterOption)=>moreFilterOption.isSelected).forEach((moreFilterOption)=>{
        if (moreFilterOption.value === (0, $jghB4.OptionIds).TITLE) selectedFilters.push({
            '@type': 'titleMatchOnly',
            titleMatchOnly: true
        });
        if (moreFilterOption.value === (0, $jghB4.OptionIds).ARCHIVED) {
            selectedFilters.push({
                '@type': 'statuses',
                statuses: (0, $jghB4.INCLUDEARCHIVEDSTATUS)
            });
            selectedFilters.push({
                '@type': 'containerStatuses',
                containerStatuses: (0, $jghB4.INCLUDEARCHIVEDSTATUS)
            });
        }
    });
    if (filters[(0, $jghB4.FilterIds).ANCESTOR]) {
        const ancestorIds = filters[(0, $jghB4.FilterIds).ANCESTOR].filter((option)=>!!option.isSelected).map((option)=>option.value);
        if (ancestorIds.length > 0) selectedFilters.push({
            '@type': 'ancestorIds',
            ancestorIds: ancestorIds
        });
    }
    return selectedFilters;
};
module.exports["createAggFilters"] = $1bdc45b11c697012$export$416386056bdfd75;
module.exports["getOptionsToHydrate"] = $1bdc45b11c697012$export$71d48e62a870acb2;
module.exports["initializeFilters"] = $1bdc45b11c697012$export$3e02c678c13755e4;
module.exports["generateUpdatedQueryParams"] = $1bdc45b11c697012$export$be6bb39088374ba;
module.exports["getOptionSelections"] = $1bdc45b11c697012$export$72a062c4cf43576;
module.exports["transformFiltersForAnalytics"] = $1bdc45b11c697012$export$5e1edcb3c154ab79;
module.exports["areFiltersSelected"] = $1bdc45b11c697012$export$7e427c967bc760a;
module.exports["mapDataToOptions"] = $1bdc45b11c697012$export$99a866ffa3af7d8b;
module.exports["areFiltersConsistent"] = $1bdc45b11c697012$export$2e52d13370d3e128;
module.exports["mapFiltersToAggregator"] = $1bdc45b11c697012$export$1625b883b0fea34d;

});

parcelRegister("aF4oY", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $b8f8a57464dd98a0$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["ATTACHMENT"] = "ATTACHMENT";
    ConfluenceContentType["BLOG_POST"] = "BLOG_POST";
    ConfluenceContentType["COMMENT"] = "COMMENT";
    ConfluenceContentType["PAGE"] = "PAGE";
    ConfluenceContentType["WHITEBOARD"] = "WHITEBOARD";
    return ConfluenceContentType;
}({});
var $b8f8a57464dd98a0$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $b8f8a57464dd98a0$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["CURRENT"] = "CURRENT";
    SearchConfluenceDocumentStatus["ARCHIVED"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["DRAFT"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({});
var $b8f8a57464dd98a0$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchConfluenceRangeField["CREATED"] = "CREATED";
    return SearchConfluenceRangeField;
}({});
var $b8f8a57464dd98a0$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["ARCHIVED"] = "ARCHIVED";
    SearchContainerStatus["CURRENT"] = "CURRENT";
    return SearchContainerStatus;
}({});
var $b8f8a57464dd98a0$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["OPEN"] = "OPEN";
    SearchIssueStatusCategory["DONE"] = "DONE";
    return SearchIssueStatusCategory;
}({});
var $b8f8a57464dd98a0$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["software"] = "software";
    SearchProjectType["business"] = "business";
    SearchProjectType["service_desk"] = "service_desk";
    SearchProjectType["product_discovery"] = "product_discovery";
    return SearchProjectType;
}({});
var $b8f8a57464dd98a0$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["database"] = "database";
    SearchResultType["whiteboard"] = "whiteboard";
    SearchResultType["embed"] = "embed";
    SearchResultType["folder"] = "folder";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["dashboard"] = "dashboard";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["goal"] = "goal";
    SearchResultType["project_update"] = "project_update";
    SearchResultType["goal_update"] = "goal_update";
    SearchResultType["tag"] = "tag";
    SearchResultType["focus_area"] = "focus_area";
    SearchResultType["focus_area_status_update"] = "focus_area_status_update";
    SearchResultType["question"] = "question";
    SearchResultType["learning"] = "learning";
    SearchResultType["document"] = "document";
    SearchResultType["repository"] = "repository";
    SearchResultType["component"] = "component";
    SearchResultType["presentation"] = "presentation";
    SearchResultType["spreadsheet"] = "spreadsheet";
    SearchResultType["message"] = "message";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $b8f8a57464dd98a0$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchThirdPartyRangeField["CREATED"] = "CREATED";
    return SearchThirdPartyRangeField;
}({});
 // Note: Original file contained additional custom exports that need manual review:
 // SearchAnalyticsInput, SearchBoardFilter, SearchCommonFilter, SearchCommonRangeFilter, SearchCommonRangeFilterFields, SearchExperimentContextInput, SearchExperimentLayer, SearchExternalContainerFilter, SearchExternalContentFormatFilter, SearchExternalDepthFilter, SearchExternalFilter, SearchFilterInput, SearchJiraFilter, SearchJiraIssueFilter, SearchJiraProjectFilter, SearchLayerDefinition, SearchMercuryFilter, SearchThirdPartyFilter, SearchThirdPartyProduct, SearchThirdPartyRangeFilter, SearchTrelloFilter
 // Please verify these are handled correctly in your codebase.
module.exports["SearchConfluenceRangeField"] = $b8f8a57464dd98a0$export$641731d7c91b88de;

});


//# sourceMappingURL=AdvancedSearch.5da31acb.js.map
